/* eslint-disable prettier/prettier,max-len */

import {
	Entity,
	GALinkStatus,
	confidentialityTypes,
	currencyType,
	gaRegion,
	gaRoleTypes,
	gaScopeType,
	notesFilter,
	pointOfContactTypes,
	validationTypes,
	KnowledgeSectionIds,
	sendInstructionsSwitcherIds,
	accountsFilter,
	scotsFilter
} from '../util/uiconstants';

/**
 * Created by calhosh on 4/14/2017.
 * RU resource file
 */
export const labels = {
	addEvidenceBtn: 'Add evidence Add evidence',
	multipleDocuments: 'Multiple Documents',
	invalidEngagementId:
		'Идентификатор задания недействительный. Обновите страницу и повторите попытку. Если ошибка не устранена, обратитесь в справочную службу.',
	newComponent: 'new component',
	workingOffline: 'Работа в автономном режиме',
	syncInProgress: 'Синхронизация выполняется',
	prepareOffline: 'Подготовка данных для работы в автономном режиме',
	connectionAvailable: 'Подключение доступно',
	training: 'Тренинг',
	clickForOptions: 'Кликните для дополнительных параметров',
	navReviewNotes: 'Проверить заметки',
	navHeaderManageTeam: 'Управление командой',
	navManageGroup: 'Управлять группой',
	manageObjects: 'Управление объектами',
	navCRASummary: 'итог ООР',
	navAuditPlan: 'План аудита',
	navWorkPlan: 'План работы',
	navSEM: 'Матрица оценки',
	navFindings: 'Замечания',
	navContentUpdates: 'Обновление контента',
	navCanvasFormUpdates: 'Обновление Канвас форм',
	navCopyHub: 'Модуль копирования',
	navCopyHubNew: 'Банк для копирования НОВЫЙ',
	navArchiveChecklist: 'Чеклист архивирования',
	navExportHub: 'Модуль экспорта',
	navReporting: 'Отчет',
	navHelp: 'Справка по общим вопросам',
	validationNavHelp: 'Справка по валидации',
	leaveUsFeedback: 'Leave us feedback',
	navDashboard: 'Информационная панель',
	tasksPage: 'Задания',
	documentsPage: 'Документы',
	collaborationPage: 'Сотрудничество',
	automationPage: 'Автоматизация',
	documentHelperConnectionIssue:
		"Проблема была обнаружена Помощником по документам ЭЯ Канвас. Нажмите <a style='color: #467cbe' href='https://eyt.service-now.com/kb_view.do?sysparm_article=KB0486774' target='_blank'>here</a> для инструкций по устранению проблемы",
	noContentAvailable: 'Нет доступного содержания',
	noSectionsAvailable: 'Нет доступных разделов',
	noInformationAvailable: 'Нет информации',
	collapse: 'Свернуть',
	expand: 'Расширить',
	duplicate: 'Дублировать',
	duplicateSection: 'Повторяющийся раздел',
	duplicateSectionHeader: 'Дублировать выбранный раздел?',
	deleteSection: 'Удалить раздел',
	deleteSectionHeader: 'Are you sure you want to delete the selected section?',
	deleteHeader: 'Удалить заголовок',
	deleteHeaderTitle: 'Удалить выбранный заголовок?',
	confirmLabel: 'Подтвердить',
	custom: 'Заказ',
	selectHeader: 'Выбрать заголовок',
	selectSection: 'Выберите раздел',
	noResultsFound: 'Никаких результатов не найдено',
	scot: 'ЗКО',
	scotTypes: 'Тип ЗКО',
	frequency: 'Периодичность',
	SelectFrequency: 'Выбрать периодичность',
	SelectControlType: 'Выбрать тип средства контроля',
	itBadge: 'ИТ',
	soBadge: 'ОО',
	noRecordsAvailable: 'Записи отсутствуют',
	noIncompleteResponseSummaryView: 'Незаполненные ответы отсутствуют',
	noUnresolvedCommentsSummaryView: 'Незакрытые комментарии отсутствуют',
	edit: 'Редактировать',
	editForm: 'Редактировать форму',
	delete: 'Удалить',
	remove: 'Удалить',
	noBodies: 'Текст отсутствует',
	relateDocuments: 'Связать документы',
	relatedDocuments: 'Прикрепленные документы',
	deleteBody: 'Удалить содержимое',
	bodyDescription: 'Are you sure you want to delete the selected body Are you sure you want to delete the selected body?',
	description: 'Наименование',
	maxLengthForEditResponse: 'Body text exceeds maximum allowed length',
	maxLengthForEditResponseWithCount: 'Response contains {#} characters which exceeds the maximum of {##} characters.  Adjust the answer by reducing text or formatting and try again.  If the issue persists, contact the Help Desk.',
	saveResponse: 'При сбросе изменений правки, сделанные в текст ответа, не сохранятся. Закрытые или удаленные комментарии останутся выделенными цветом. Подтвердите, что вы хотите сбросить все изменения.',
	discardChangesModalText: 'Сброс изменений',
	seeBodyDescriptionText: 'См. описание',
	hideBodyDescriptionText: 'Hide description',
	showBodyDescriptionText: 'Show description',
	okLabel: 'Ок',
	addButtonLabel: 'Добавить',
	addEvidence: 'Добавить доказательства',
	addTemporaryFiles: 'Add temporary files',
	notemporaryDocs: 'No temporary files available',
	relateFiles: 'Relate files',
	uploadFiles: 'Upload files',
	cancelButtonLabel: 'Отмена',
	clickEditResponseToContinue: 'Для продолжения нажмите на иконку редактирования',
	editResponse: 'Изменить ответ',
	save: 'Сохранить',
	numericValuePlaceholder: 'Введите сумму',
	saveLabel: 'Сохранить',
	cancelLabel: 'Отмена',
	closeLabel: 'Закрыть',
	editText: 'Редактировать',
	select: 'Выбрать',
	selectScot: 'Select SCOTs',
	clearHoverText: 'Очистить',
	optional: '(дополнительный)',
	nodocumentsAdded: 'Нет доступных документов',
	errorBanner: '{0} Ошибка(и)',
	NetworkErrorMessage: 'В сети приложений произошла ошибка. Обновите страницу и повторите попытку позже. Если ошибка не устранена, обратитесь в справочную службу.',
	of: 'из',
	characters: 'признаки',
	show: 'Показать:',
	views: 'Просмотр:',
	primaryRelated: 'Основные связанные формы Канвас',
	secondaryRelated: 'Вспомогательные связанные формы Канвас',
	singleLineValuePlaceholder: 'Ввести текст',
	paceInputPlaceholder: 'Идентификатор в ПЕЙС',
	multiLineValuePlaceholder: 'Ввести текст',
	riskFactorDescribe: 'Описание',
	riskFactorLabel: 'Relevant event and condition / risk of misstatementRelevant event and condition / risk of misstatement',
	riskFactorEmptyWarning: 'Event and condition / risk of misstatement missing descriptionEvent and condition / risk of misstatement missing description',
	riskFactorNoDescription: 'Create new or select existing relevant event and condition / risk of misstatementCreate new or select existing relevant event and condition / risk of misstatement',
	fraudRiskTagMessage: 'This relevant event and condition / risk of misstatement always gives rise to a fraud risk or, if applicable, should be designated as not a risk of material misstatementThis relevant event and condition / risk of misstatement always gives rise to a fraud risk or, if applicable, should be designated as not a risk of material misstatement',
	significantRiskTagMessage: 'This relevant event and condition / risk of misstatement always gives rise to a significant risk, fraud risk or, if applicable, should be designated as not a risk of material misstatementThis relevant event and condition / risk of misstatement always gives rise to a significant risk, fraud risk or, if applicable, should be designated as not a risk of material misstatement',
	on: 'в',
	sliderDeSelectMessage: 'Drag the circle to assign a value Drag the circle to assign a value',
	yearPlaceholder: 'YYYY YYYY',
	dayPlaceholder: 'DD DD',
	monthPlaceholder: 'MM MM',
	amLabel: 'AM AM',
	pmLabel: 'PM PM',
	relatedEntities: 'Related entities Related entities',
	eyServiceGateway: 'EY Service Gateway EY Service Gateway',
	eyAutomation: 'EY Automation EY Automation',
	eyserviceGatewayAutomation: 'EY Service Gateway & Automation EY Service Gateway & Automation',

	//Create or Associate risks
	createAssociateRisksLabel: 'Create new or associate risks',
	relatedRiskIsMissingWarning: 'Related risk is missing',
	associateRiskDescription: 'Select one or more risks, or create a new risk, to associate to the question response.',
	createNewRiskLabel: 'Create new risk',
	noRiskIdentifiedLabel: 'No risks identified',

	// GuidanceModal
	eyAtlasLink: 'ЭЯ Атлас',
	guidanceHeaderMessage: 'Данный модуль содержит',
	guidanceModalHeader: 'Инструкции',
	guidanceModalLabelText: 'Проводка',
	guidanceFooter: 'для получения более подробной информации.',
	guidanceSeveralEntriesText: 'несколько проводок:',
	guidanceVisitText: 'Посетить',
	guidanceClickText: 'Нажмите',
	guidanceHereText: 'для',
	guidanceFooterText: 'получения более подробной информации.',
	analyticsInconsistencies: 'When reviewing analytics, consider if there are changes or activity that is inconsistent with our expectations. These situations may be indicative of new risks, separate classes of transactions, changes to SCOTs, or risks of management override.',
	analyticsInconsistenciesOSJE: 'OSJE depicts the double-entry accounting for the selected account being analyzed. We look for new or unusual account pairings.',
	analyticsInconsistenciesActivityBySource: 'Activity by source depicts the gross monthly activity and related sources for the selected account. We focus on unusual activity or changes in sources or volume of activity to a source.',
	analyticsInconsistenciesPreparerAnalysis: 'Preparer analysis summarizes the period over period gross activity recorded by preparers for the selected account. We focus on changes to preparers or activity to accounts outside their role.',
	analyticsInconsistenciesAccountMetrics: 'Account metrics summarizes key information about the account which assists in account designation.',
	analyticsLoadingIsInProgress: 'The requested analytic is still being loaded. The tab will be accessible once that completes.',

	aboutDescriptioin: 'Редактировать уровни ГАМ, стандарты или язык. Редактирование приведет к обновлению содержания.',
	aboutContentDescription: 'Edit the content layers, standards, or language.  Edits will trigger a content update.',
	about: 'Около',
	formType: 'Тип формы',
	gamLayer: 'Слои ГАМ',
	contentLayer: 'Content layers',
	standard: 'Стандарт',
	language: 'Язык',
	createdBy: 'Исполнитель',
	createdOn: 'Дата создания',
	contentLastUpdatedBy: 'Последнее обновление содержимого: кем',
	contentLastUpdatedOn: 'Последнее обновление содержания (дата)',
	notModified: 'Не изменено',

	rolesInsufficientTooltip: 'Недостаточно полномочий для редактирования содержания.Для получения дополнительных прав обратитесь к администратору задания.',
	knowledgeFormToolTip: 'Невозможно обновить документы из базы знаний. Для изменения профиля данной формы обновите профиль задания.',
	selectTeamMember: 'ФИО или электронный адрес',

	// SeeMore component
	showMore: 'Показать больше',
	showLess: 'Показать меньше',
	showMoreEllipsis: 'Показать больше…',
	showLessEllipsis: 'Показать меньше…',

	relatedITapplicationSOs: 'Соответствующие ИТ-приложения/СО',
	aggregateITevaluations: 'Общая оценка ИТ',
	lowerRisk: 'Пониженный риск',
	controlLowerRisk: 'Средство контроля с пониженным риском',
	relatedITApplication: 'Связанные ИТ-приложения',
	relatedITSO: 'Связанные СО',
	noITApplicationUsed: 'ИТ-приложение не используется',

	notSel: 'НЕ ВЫБРАНО',
	internal: 'Внутренний',
	external: 'Внешний',
	notSelected: 'Not selected Not selected',
	noOptionSelected: 'Не выбрано',
	tod: 'Тестирование по существу',
	sap: 'САП',
	int: 'ВНУТ',
	ext: 'ВНЕШ',
	toc: 'Тестирование контролей',

	placeholderForSearch: 'Поиск',
	source: 'Источник',
	nature: 'Характер',
	testOfDetail: 'Тестирование по существу',
	testOfControl: 'Тестирование контролей',
	substantiveAnalyticalProcedure: 'Аналитические процедуры по существу',
	expandScot: '1. Расширить ЗКО',
	selectWCGWToDisplayTheResponsiveTask: '2. Выбрать риск существенного искажения для отображения соответствующих задач',
	tasksWithNoRelatedWCGW: 'Задачи, не связанные с риском существенного искажения ',
	noTasksAvailable: 'Нет доступных задач',
	noWCGWAvailableForTask: 'Нет доступных рисков существенного искажения',
	noSubstantiveTasksAvailable: 'Нет связанных задач по существу',
	selectAssertionToRelateWCGW: 'Выберите предпосылку, чтобы связать Риск с ВО',
	significantAccounts: 'Существенные счета',
	riskName: 'Риск:',
	accountName: 'Счет:',
	control: 'Средство контроля',
	controls: 'Controls',
	noScotsFound: 'Нет связанных ЗКОс',
	relatedwcgw: 'Связанные ВОс',
	relatedRisks: 'Связанные Риски:',
	boltIconTitle: 'Связанный Риск',
	relatedITApp: 'Related IT App/SO',
	instructions: 'Инструкции:',
	expandRisk: '1. Расширить риск',
	selectAssertion: '2. Выбрать предпосылку',
	identifyRelatedWCGW: '3. Определите, что ВО связано с риском',
	clickAccount: '1. Нажмите на счет',
	selectWCGW: '2. Выберите ВО',
	identifyRelatedTask: '3. Определите задачи, которые отвечают ВО',
	information: 'Информация',
	requiredAssertions: 'Обязательные предпосылки',
	wcgwWithoutTasks: 'ВО без заданий',
	rommAssociatedWNotRelyAssertion: 'Риск существенного искажения связан с предпосылкой с контрольным риском не полагаться или предпослыкой с неотъемлемым риском выше, когда счет имеет оценочное значение.',
	hasRiskAssociated: 'Связанный риск',
	clearSelections: 'Снять все выделенное',
	romm: 'Риск существенного искажения',
	riskOfMaterialMisstatementsWithoutRelatedTask: 'Риск существенного искажения без связанных заданий',
	selectOneOrMoreTasksToSeeTheRelatedROMM: 'Выберите одно или несколько задач, чтобы посмотреть соответствующий риск существенного искажения',
	invalidRelatedEntity: 'Связанный счет не может быть найден. Обновите страницу и повторите попытку. Если проблема не устранена, обратитесь в справочную службу.',
	noResultsAvailable: 'Никаких результатов не найдено',
	riskOfMaterialMisstatement: 'Риск существенного искажения',
	AccountConclusion: 'Счет Заключение',
	CanvasForm: 'Канвас Форма',
	IndependenceForm: 'Форма по независимости',
	Profile: 'Профайл',
	AccountDetails: 'Детали',
	Conclusions: 'Заключения',
	accountDetailsTab: 'детали',
	conclusionsTab: 'заключения',
	formsNoContentText: 'Никакого доступного содержания.',
	formsDocumentNoRelatedObjects: 'Нет объектов, связанных с документом',
	formsNoRelatedObjects: 'Нет связанных объектов',
	formsBodyHeaderControl: 'Контроли',
	formsBodyDesignEffectiveness: 'Эффективность дизайна',
	formsScotsAndWcgws: 'ЗКО и ВО',
	wcgWAndRelatedControls: 'ВО и соответствующие средства контроля',
	controlAndRelatedItSO: 'Средства контроля и связанные ИТ-приложения/ОО',
	type: 'Тип',
	designEffectiveness: 'Эффективность методики',
	approch: 'Подход',
	controlOpertaingEffectiveness: 'Операционная эффективность',
	iTAppSO: 'ИТ-приложение/СО',
	iTProcess: 'ИТ-процесс',
	iTControl: 'Средство ИТ-контроля',
	iTRisk: 'ИТ-риски',
	aggregateITEvaluation: 'Общая оценка ИТ',
	relatedCanvasForm: 'Связанная форма Канвас',
	relatedSections: 'Связанные разделы',
	validations: 'Подтверждения',
	profileV2Validation: 'Изменения не отправлены',
	profileV2ValidationModalDescription: 'Изменения, которые приведут к обновлению содержания, были сделаны, но не были отправлены. Если изменения преднамеренные, закройте данную форму и отправьте новые ответы для профиля. Если изменения непреднамеренные, проверьте вид «Изменения» и верните предыдущие ответы вручную.',
	profileV2ValidationCount: '1',
	reviewNote: 'Проверить заметки',
	editAssociations: 'Изменить объединения',
	editAssociationsLower: 'редактировать связь',
	riskWCGW: 'Риск: связь ВО',
	wcgwTask: 'ВО: связь задач',
	noAssertionFound: 'No assertions have been associated. Click {here} to associate assertions',
	limitedRiskAccountIdentifier: 'Limited risk account',
	insignificantAccountIdentifier: 'Insignificant account',
	noWCGWFound:
		"Нет ВО, относящихся к этому риску. Нажмите на 'Изменить объединение', чтобы связать один или несколько ВО",
	noRelatedWCGWs: 'Нет связанных ВО',
	noWCGWAvailable: 'Нет доступных рисков существенного искажения для выбранных предпосылок',
	expandCollapse: 'Нажмите сюда, чтобы расширить/свернуть',
	requiredAssertionsInfo: 'Показывать только предпосылки с оценкой риска контроля не полагаться и предпосылки, связанные с более высокими оценками риска',
	wCGWwithoutTasksInfo: 'Показать только ВОс, связанные с предпосылками с оценкой риска контроля не полагаться и предпосылками, связанными с более высокими оценками риска, которые не имеют каких-либо реагирующих связанных задач по существу',
	noBuildStepsAvailable: 'Нет никаких шагов сборки, доступных для представления.',
	risk: 'Риски',
	wcgw: 'ВО',
	riskWcgw: 'Риск: ВО',
	wcgwTasks: 'ВО: Задача',
	riskWcgwLabel: 'Соотнесите Риск и ВО',
	wcgwTasksLabel: 'Соотнесите ВО и Задачу',
	noRiskTypes: 'Типы рисков не обнаружены',
	saveRisk: 'Сохранить',
	noRisksFound: 'Риски не обнаружены',
	haveBeenIdentified: 'Были выявлены',
	noAccountsFound: 'Никаких записей не обнаружено',
	noResponseAvailable: 'Нет ответа',
	noDocumentsAvailable: 'No documents available',
	noValue: 'Значение отсутствует',
	showValidation: 'Подтверждения',
	noAccountsIdentified: 'Счета не были выявлены',
	noAssertionsIdentified: 'Предпослыки не были выявлены',
	noWcgwsIdentified: 'ВО не были выявлены',
	pastingImagesNotAllowed: 'Вставка изображений не допускается. Если требуются изображения, загрузите их в качестве доказательства и сделайте ссылку на них.',
	incompleteResponse: 'Ответы не заполнены',
	unresolvedComments: 'Незакрытые комментарии',
	inconsistentForms: 'Не соответствующие друг другу формы',
	limitedRiskAccount: 'Счет с органиченным риском',
	inherentRiskAssessment: 'Inherent risk assessment',
	task: 'Задача',
	selected: 'Выбранный',
	displaytoc: 'Отображение ТОК',
	workingoffline: 'Работа в автономном режиме',
	syncinprogress: 'Синхронизация выполняется',
	prepareoffline: 'Подготовка данных для работы в автономном режиме',
	connectionavilable: 'Подключение доступно',
	softwareUpdate: 'Обновления программного обеспечения',
	updateLater: 'Обновить позже',
	updateNow: 'Обновить сейчас',
	updateMsg: 'Software updates are available for EY Canvas. Select Update Now to download and install the updates. The page will be refreshed.',
	searchPlaceholder: 'Поиск',
	filter: 'Filter',
	leftNavSearchPlaceholder: 'Поиск заголовков и разделов',
	back: 'Назад',
	updateAvailable: 'Доступно обновление',
	contentUpdateAvailableTooltip:
		"Content update available. Click here to navigate to the 'Canvas form updates' screen to initiate an update.",
	moreMenu: 'Подробное меню',
	signoffPreparer: 'Подписаться как исполнитель',
	signoffReviewer: 'Подписаться как проверяющий',
	pagingShowtext: 'Показать',
	searchDocuments: 'Искать документы',
	noRelatedDocuments: 'Нет связанных документов.',
	noRelatedObjects: 'Связанные объекты отсутствуют.',
	documentName: 'Название документа',
	formDetails: 'Информация о форме',
	questionsAndResponses: 'Questions and responses Questions and responses',
	details: 'Описание',
	trackChanges: 'Track changes Track changes',
	goToTrackChanges: 'Go to Track Changes Go to Track Changes',
	attributes: 'Attributes Attributes',
	relatedActions: 'Related actions',
	createCustom: 'Создать специальную',
	createCustomButtonLabel: 'Create custom header, section, or body Create custom header, section, or body',
	overwriteForm: 'Переписать форму',
	decimalNaN: 'НЧ - не число',
	noRelatedObjectsApplicable: 'Связь объектов с данной формой Канвас не требуется',
	objects: 'Объекты',
	objectName: 'Имя объекта',
	addCustomDescription: 'Выберите тип контента, который нужно добавить в эту форму Канвас, введите данные и нажмите Сохранить',
	headerTitle: 'Заголовок заголовка',
	sectionTitle: 'Название раздела (обязательно)',
	aresSectionTitle: 'Section title Section title',
	customLabel: 'Пользовательская метка (не обязательно)',
	customBodyDescription: 'Описание тела',
	header: 'Заголовок',
	section: 'Раздел',
	body: 'Содержимое',
	requiredWCGW: 'Требуется',
	headerTitleRequired: 'Требуется заголовок.',
	bodyDescriptionRequired: 'Добавьте описание текста',
	bodySectionRequired: 'Добавьте раздел',
	bodyHeaderRequired: 'Добавьте заголовок',
	sectionTitleRequired: 'Укажите название раздела',
	headerRequiredMessage: 'Добавьте заголовок',
	enterDecimalAmount: 'Введите десятичную сумму',
	enterPercentage: 'Enter percentage',
	completeRiskFactorAssessment: 'Complete assessment of identified events and conditions.',

	// Track changes
	trackChangesResponseLabel: 'Track change version response Track change version response',
	trackChangesVersionLabel: 'Track changes version Track changes version',
	noResponseIdentified: 'No response identified No response identified',

	// Compare responses
	compareResponsesLabel: 'Compare responses Compare responses',
	compareResponsesTitle: 'Compare entity responses Compare entity responses',
	compareResponseNoDataPlaceholder: 'No data available, since the engagement has only one document of the same type. No data available, since the engagement has only one document of the same type.',
	labelFor: 'for for',
	questions: 'Questions Questions',
	answers: 'Answers Answers',
	countOfResponses: 'Count of responses Count of responses',
	openNotes: 'Open notes Open notes',
	clearedNotes: 'Cleared notes Cleared notes',
	click: 'Нажмите',
	clickToViewAnswer: 'to view answer to view answer',
	clickToViewQuestionAnswer: 'to view question and answer to view question and answer',
	selectDocuments: 'Select documents Select documents',
	selectedDocumentsCount: '{0} documents selected documents selected',
	selectedDocumentCount: '{0} document selected document selected',
	associatedDocuments: 'Related documents Related documents',
	noAnswerProvided: 'No answer provided No answer provided',

	// Workspace Engagement
	documentLocation: 'Document location',
	otherEngagementsInWorkspace: 'Other engagements in the workspace',
	added: 'Added Added',
	documentIneligibleForSharingMessage: 'Confidential documents are not eligible to be shared.',
	fitDocumentCannotbeSelected: 'FIT documents cannot be shared between engagements.',

	//Helix Configuration
	helixConfigurationTitle: 'Integrate EY Helix data',
	helixConfigurationPageDescription: 'Validate linked EY Helix project and import data to EY Canvas. If you have changed any EY Helix settings below or made changes to your EY Helix data after you have imported the data, you will have to re-import the data for the update to be made.',
	linkedEYHelixProjects: 'Связанные проекты ЭЯ Хеликс:',
	client: 'Клиент:',
	engagement: 'Задание:',
	analysisDate: 'Дата анализа:',
	eyHelixProjects: 'Проекты ЭЯ Хеликс',
	noPrimaryEYHelixproject: 'Основной проект ЭЯ Хеликс не выявлен.',
	here: 'здесь',
	identifyEyHelixProjects: 'чтобы найти проект ЭЯ Хеликс и запустить схему работы.',
	eyHelix: 'ЭЯ Хеликс',
	primary: 'основная',
	helixSettingsDescription:
		'Click Edit to select the settings that will be applied when loading EY Helix Analyzers in the EY Canvas FIT enablement.',
	editButton: 'Редактировать',
	helixSettingsModalTitle: 'Настройки ЭЯ Хеликс',
	currencyType: 'Вид валюты',
	currencyTypeError: 'Невозможно загрузить вид валюты из ЭЯ Хеликс Подтвердите настройки данных в ЭЯ Хеликс и повторите попытку',
	shortNumberFormat: 'Короткий формат числа',
	shortNumberFormatFooter: 'В таблицах ЭЯ Хеликс будет отображаться округление, которое вы собираетесь применить для числовых значений ',
	eyHelixAnalyzerFilterMetadataError: 'Невозможно подключиться к ЭЯ Хеликс. Обновите страницу и повторите попытку. Если проблему не удается устранить, обратитесь в службу технической поддержки.',
	functional: 'Функциональная',
	reporting: 'Валюта отчетности',
	currencyCode: 'Код валюты',
	businessUnit: 'Бизнес-подразделение',
	roundingNumberFormat: 'Формат округления числа',
	eyHelixProjectChangedLine1: 'Связанные проекты ЭЯ Хеликс были изменены после последнего сохранения настроек ЭЯ Хеликс.',
	eyHelixProjectChangedLine2: 'Нажать «Редактировать» для обновления настроек до импорта или повторного импорта из ЭЯ Хеликс.',
	helixSettingsTimeline: 'Настройки ЭЯ Хеликс',
	helixMapEntitiesToBU: 'Map Entities to Business Units',
	helixNumberOfMapEntities: 'Number of mapped Business Units',
	importEYHelixDataTimeline: 'Импорт данных ЭЯ Хеликс',
	mapAccountsHelixTimeline: 'Сопоставить счета',
	setEYHelixSettings: 'Необходимо установить следующие настройки, чтобы задание было корректно обработано ЭЯ Хеликс.',
	eyHelixDataHasChangedLine1: 'Данные были изменены после последнего сохранения настроек ЭЯ Хеликс. Сделайте выбор заново ниже и нажмите',
	eyHelixDataHasChangedLine2: 'для обновления настроек ЭЯ Хеликс.',
	all: 'Все',
	multiple: 'Несколько',
	notApplicableAbbreviation: 'Н/П',
	importEyHelixData: 'Импорт данных ЭЯ Хеликс',
	editScreenshot: 'Редактировать',
	deleteNote: 'Удалить',
	removeAnnotation: 'Remove annotation',
	addAnnotation: 'Add annotation',
	addingBoundingBox: 'Select an area on the screenshot to annotate, confirm the annotation, and click the checkmark to save. ',
	cancelBoundingBox: 'Cancel',
	deleteScreenshot: 'Удалить скриншот',
	openInFullscreen: 'Открыть в полноэкранном режиме',
	helixURLErrorMessage1: 'The configuration for the mapped EY Helix project is incomplete.',
	helixURLErrorMessage2: 'Please go to {0} page to update.',
	helixIsNotEnabledMessage: 'EY Helix is not enabled for your engagement.',
	helixSetup: 'EY Helix setup',
	openAnalysisInHelix: 'Откройте анализ в ЭЯ Хеликс',
	helixInvaliddate: 'Invalid date. Select a period prior to the analysis period. Invalid date. Select a period prior to the analysis period.',
	helixcomparativedateoptional: 'EY Helix comparative date 2 (optional) EY Helix comparative date 2 (optional)',
	helixpriorperioddate: 'EY Helix comparative date 1 EY Helix comparative date 1',
	helixanalysisperiod: 'EY Helix analysis date EY Helix analysis date',
	helixfiscalDropDownLabel: 'Period {0} - {1}',

	helixSettingsEditButtonTitle: 'Возобновить проект выше для редактирования настроек.',
	helixImportDataEditButtonTitle: 'Возобновить проект выше для импорта данных из ЭЯ Хеликс.',
	helixImportInsufficientPermissionsMessage: 'Insufficient permissions to perform Helix data Import. Contact your engagement administrator and request permssion to initiate a Helix data import.',
	helixImportNotAllowed: 'Engagement profile does not permit the import of Helix data',
	helixDeleteImportInsufficientPermissionsMessage: 'Insufficient permissions to delete the EY Helix data Import. Contact your engagement administrator and request permission to delete the EY Helix data.',

	EYAccountMappingStepLabel: 'Manage account mapping',

	EYAccountMappingOptional: 'Optional',
	EYAccountMappingStepTitleSettingsCompleted: 'Perform EY account mapping',
	EYAccountMappingStepTitleSettingsIncomplete: 'Complete EY Helix settings to access the EY Helix Mapping Module',
	EYAccountMappingInstructions: 'Map client accounts to EY accounts and process changes. Once processing completes, import the data below.',
	manageAccountMappingButtonLabel: 'Manage account mapping',

	//EY Helix Setup Card
	EYHelixSetupTitle: 'EY Helix',
	EYHelixSetupSubTitle: 'Configure and import data to EY Canvas',
	LastImported: 'Last imported',
	EYHelixSettings: 'EY Helix setup',
	NoEYHelixProjectLinkedLabel1: 'This engagement is not linked to a Primary EY Helix project. Please visit the',
	NoEYHelixProjectLinkedLabel2: 'page to establish the link.',
	NoEYHelixProjectLinkedHperlink: 'EY Helix Projects',
	NoDataImportedLabel: 'Data has not been imported from EY Helix. Click EY Helix setup to initiate the process.',

	// EY Helix - Map Accounts
	mapAccountsHelixCanvas: 'Нажмите «Редактировать» для сопоставления счетов ЭЯ Канвас со счетами, импортированными из ЭЯ Хеликс',
	mapAccountsHelixCanvasSubtitle: 'Перетащите каждый счет ЭЯ Хеликс, чтобы сопоставить со счетом ЭЯ Канвас. Нажмите «Управление счетами» для создания или редактирования счетов ЭЯ Канвас.',
	mapAccountsHelixHeaderLabel: 'Счета ЭЯ Хеликс',
	mapAccountsCanvasHeaderLabel: 'Счета ЭЯ Канвас',
	mapAccountsConnectedLabel: 'Счета связаны',
	mapAccountsShowMappedLabel: 'Показать сопоставленные счета',
	mapAccountsHideMappedLabel: 'Скрыть сопоставленные счета',
	mapAccountsManageLabel: 'Управление счетами',
	mapAccountsAndDisclosuresManageLabel: 'Manage accounts and disclosures Manage accounts and disclosures',
	mapAccountsNoCanvasAccounts: 'Счета не найдены.',
	mapAccountsNoCanvasAccountsClick: 'Нажмите ',
	mapAccountsNoCanvasAccountGetStarted: ' для начала работы.',
	mapAccountsRemoveAccount: 'Удалить',
	mapAccountsReImportHelixAccounts: 'Импорт данных из ЭЯ Хеликс не выполнен. Импортируйте данные еще раз и повторите попытку.',
	mapAccountsReImportHelixAccountsHelpDesk: 'Если проблему не удается устранить, обратитесь в службу технической поддержки',
	mapAccountsNoHelixAccountHasBeenImported: 'Счета ЭЯ Хеликс не были импортированы.',
	mapAccountsNoHelixAccountHasBeenImportedCheckData: 'Проверьте данные данных в ЭЯ Хеликс и повторите попытку.',

	//Helix Analyzer
	accountNotRelatedToDocumentOnPhaseTwo: 'No account related to this document',

	//PM TE SAD Widget
	materialityWidgetLabel: 'PM/TE/SAD',

	// TE labels
	planningmateriality: 'Плановая существенность',
	requiredTePercentage: 'Required TE',
	suggestedtepercentage: 'Предлагаемая ДО',
	currentperiodte: 'ДО текущего периода',
	priorperiodte: 'ДО предыдущего периода',
	pmPriorPeriod: 'Prior Period PM',
	tepercentage: 'Процент ДО',
	teamount: 'Сумма ДО',
	teLabel: 'Допустимая ошибка',
	sugestedSAD: 'Suggested SAD percentage:',
	priorSAD: 'ПАР предыдущего периода',
	currentPeriodSAD: 'Current period SAD',
	sadPercentage: 'Процент ПАР',
	sadAmount: 'Сумма ПАР',
	rationaleLabel: 'Rationale',
	suggestedTEPercentageInfo: 'If a different percentage is selected based on engagement specific factors, you will be prompted to document those factors below.',
	rationaleTEDescription: 'Enter rationale for TE as a percentage of PM in consideration of attributes selected above.',
	teAmmountInvalid: 'Enter a valid amount, or select 50% or 75%',
	highRiskTEAmmountInvalid: 'Enter a valid amount, or select 50%',
	highRiskTERequired: 'Based on the responses to the considerations above, the TE percentage identified is required and cannot be changed.',

	// EY Helix Map Entities to Business Units Modal
	mapEntitiesModalTitle: 'Manage Entities',
	mapEntitiesModalLeyendDescription: 'Manage the mapping between EY Canvas Entities and Business Units from the EY Helix project below.',
	mapEntitiesModalLeyendNote: 'Note: A Business Unit can be associated to one or multiple EY Canvas Entities. Once saved and data is imported, the data associated to the Business Units in EY Helix will show as mapped to related EY Canvas Entities.',
	mapEntitiesModalEntityCodeLabel: 'Entity code',
	mapEntitiesModalEmptyEntitiesList: 'No entities have been created.',
	mapEntitiesRelatedBusinessUnitDropdownPlaceholder: 'Related Business Unit',
	mapEntitiesSelectedBusinessUnitsCount: '{0} Business Units selected',

	//AdjustedBasis
	enterAmount: 'Ввести сумму',
	basisAmount: 'Сумма основы',
	lowEndOfRange: 'Нижняя граница диапазона',
	highEndOfRange: 'Верхняя граница диапазона',
	suggestedRange: 'С учетом вышеуказанных факторов, использование процентных значений, близких к {0}, в рамках диапазона от {1} до {2} может быть обоснованным. Если выбранное значение находится за пределами данного диапазона, что обусловлено специфическими факторами задания, вы получите сообщение с просьбой указать эти факторы ниже.',
	suggestedRangeLowPMBracket: 'Based on the above factors, a percentage of {0} may be appropriate. If an amount is selected outside of this percentage based on engagement specific factors, you will be prompted to document those factors.',
	middle: 'средняя',
	lowerEnd: 'нижняя граница',
	higherEnd: 'верхняя граница',
	lowEnd: 'low end',
	priorPeriodPm: 'ПС предыдущего периода:',
	suggestedRangeSummary: 'Suggested range',
	loadingMateriality: 'Выполняется загрузка существенности...',
	pmBasisPercentage: 'Процент от основы для ПС',
	pmAmount: 'Сумма ПС',
	pmAmountPlaceholder: 'Enter PM amount',
	currentPeriodPm: 'ПС текущего периода:',
	enterRationale: 'Ввести обоснование',
	rationaleDescription: 'Ввести обоснование для определения процента от основы для ПС с учетом параметров, выбранных выше',
	pmValidationMessage: 'Planning materiality cannot exceed the higher end of the range',
	sadValidationMessage: 'Nominal amount cannot exceed the higher end of the range.',
	sadRationaleDiscription: 'Enter rationale for SAD percentage in consideration of attributes selected above',
	nopriorperiodDocs: 'No prior period documents available',
	addPriorPeriodEvidence: 'Add prior period evidence',
	addToEvidenceLabel: 'Add to evidence',
	moveToEvidenceLabel: 'Move to evidence',
	addToEvidenceModalDescription: 'Create a new name or keep the existing name for the selected document.',
	GoToSource: 'Go to source Go to source',
	controlDesignEffectiveness: {
		[0]: {
			description: 'Не выбрано'
		},
		[1]: {
			description: 'Эффективно'
		},
		[2]: {
			description: 'Не эффективно'
		}
	},
	controlOperationEffectiveness: {
		[0]: {
			description: 'Не выбрано'
		},
		[1]: {
			description: 'Эффективно'
		},
		[2]: {
			description: 'Не эффективно'
		}
	},
	controlTesting: {
		[0]: {
			description: 'Не выбрано'
		},
		[1]: {
			description: 'Да'
		},
		[2]: {
			description: 'Нет'
		}
	},
	itAppTypes: {
		[0]: {
			label: 'ИТ-приложение/СО'
		},
		[1]: {
			label: 'ОО'
		}
	},
	controlType: {
		[0]: {
			controlTypeName: '',
			shortName: 'Не выбрано'
		},
		[1]: {
			controlTypeName: 'Прикладное средство ИТ-контроля',
			shortName: 'Приложение'
		},
		[2]: {
			controlTypeName: 'Ручное средство контроля, зависящее от ИТ',
			shortName: 'РЗИТ'
		},
		[3]: {
			controlTypeName: 'Ручное средство контроля для предотвращения',
			shortName: 'Предотвращение возникновения ошибок в ручном режиме'
		},
		[4]: {
			controlTypeName: 'Ручное средство контроля для обнаружения',
			shortName: 'Обнаружение ошибок в ручном режиме'
		}
	},
	controlTypeEnumLabel: {
		[0]: { controlTypeName: 'Not selected Not selected' },
		[1]: { controlTypeName: 'IT Application Control IT Application Control' },
		[2]: { controlTypeName: 'IT Dependent Manual Control IT Dependent Manual Control' },
		[3]: { controlTypeName: 'Manual Prevent Manual Prevent' },
		[4]: { controlTypeName: 'Manual Detect Manual Detect' }
	},
	controlFrequencyType: {
		[0]: { controlFrequencyTypeName: 'Not selected Not selected' },
		[1]: { controlFrequencyTypeName: 'Many times per day Many times per day' },
		[2]: { controlFrequencyTypeName: 'Daily Daily' },
		[3]: { controlFrequencyTypeName: 'Weekly Weekly' },
		[4]: { controlFrequencyTypeName: 'Monthly Monthly' },
		[5]: { controlFrequencyTypeName: 'Quarterly Quarterly' },
		[6]: { controlFrequencyTypeName: 'Annually Annually' },
		[7]: { controlFrequencyTypeName: 'IT Application Control IT Application Control' },
		[8]: { controlFrequencyTypeName: 'Other Other' }
	},
	strategyType: {
		[0]: {
			strategyTypeName: 'Не выбран'
		},
		[1]: {
			strategyTypeName: 'Средства контроля'
		},
		[2]: {
			strategyTypeName: 'По существу'
		},
		[3]: {
			strategyTypeName: 'Полагаться'
		},
		[4]: {
			strategyTypeName: 'Не полагаться'
		}
	},
	aggregateITEvaluationType: {
		[0]: {
			aggregateITEvaluationTypeName: 'Не Выбрано'
		},
		[1]: {
			aggregateITEvaluationTypeName: 'Поддерживают'
		},
		[2]: {
			aggregateITEvaluationTypeName: 'Не поддерживают'
		},
		[3]: {
			aggregateITEvaluationTypeName: 'Поддержка процесса подготовки ФО и системы ВКФО'
		},
		[4]: {
			aggregateITEvaluationTypeName: 'Исключительно поддержка процесса подготовки ФО'
		}
	},
	stratergyTypeLabels: {
		[0]: {
			label: 'Не Выбрано'
		},
		[1]: {
			label: 'Входит в объем работ'
		},
		[2]: {
			label: 'Не входит в объем работ'
		}
	},

	sampleItemFilterLabels: {
		filterTypeOfTags: "Tags Tags",
		noResults: 'No results found No results found',
		filters: 'FiltersFilters',
		clearAll: 'Clear all Clear all',
		showMore: 'more more',
		noFiltersAvailable: 'No filters available No filters available',
		filterToolTip: 'Filter Filter',
	},
	noChangeReasonCommentAvailable:
		"Нажмите на значок шестеренки и выберите 'Редактирование причины' в параметрах документа для ввода причины изменения.",
	changeReasonModalTitle: 'Изменить причину изменения',
	changeReasonModalText: 'Выберите причину изменений, внесенных в документ после даты отчета. Если было внесено несколько административных изменений, выберите наиболее значительное изменение в раскрывающемся списке ниже. Если были внесены как административные, так и неадминистративные изменения, выберите ниже неадминистративные изменения. ',
	changeReasonUploadModalTitle: 'Причина загрузки документа',
	changeReasonUploadModalText: 'Выберите причину изменений, внесенных в документ после даты отчета. Если было внесено несколько административных изменений, выберите наиболее значительное изменение в раскрывающемся списке ниже. Если были внесены как административные, так и неадминистративные изменения, выберите ниже неадминистративные изменения. ',
	changeReasonModalComboPlaceholder: 'Выбрать',
	changeReasonModalAnnotationText: 'Задокументируйте возникшие обстоятельства и причины добавления информации; новые или дополнительные выполненные аудиторские процедуры, полученные аудиторские доказательства и сделанные выводы, а также их влияние на наш аудиторский отчет',
	changeReasonUploadModalAnnotationText: 'Задокументировать возникшие обстоятельства и причины добавления информации; новые или дополнительные выполненные аудиторские процедуры, полученные аудиторские доказательства и сделанные выводы, а также их влияние на наш аудиторский отчет',
	changeReasonModalAnnotationPlaceHolder: 'Введите причину изменения',
	changeReasonModalChangeReasonRequired: 'Change reason to save',
	reasonColumnTitle: 'Причина',
	shared: 'Общий',
	shareStatusOwned: 'Принадлежит этому обязательству.',
	shareStatusShared: 'Участвовал в этом задании.',
	lastModifiedBy: 'Автор последнего изменения',
	fileSize: ' | {1} KB',
	openedLabelText: 'Открыто',
	currentlyBeingModifiedBy: 'В настоящее время изменяется пользователем',
	OpenGuidedWorkflowDocument: 'Open this document through the EY Canvas FIT enablement',
	submitProfile: 'Активировать профиль',
	submitProfileFit: 'Submit profile Submit profile',
	contentUpdateUnAuthorizedTooltipMessage: 'Недостаточно прав для выполнения обновления содержания. Свяжитесь с администратором задания и запросите права на инициирование обновления содержания.',
	submitProfileValidationErrorMessage: 'Профиль может быть активирован только в случае, если дан ответ на все вопросы. Отфильтруйте незаполненные вопросы, заполните их и отправьте снова. Если проблему не удается устранить, обратитесь в службу технической поддержки.',
	pickADate: 'Select a date',

	/* Sign Offs */
	preparerHoverText: 'Подпись в качестве исполнителя',
	reviewerHoverText: 'Подпись в качестве проверяющего',
	preparerTitle: 'Подписи исполнителя',
	reviewerTitle: 'Подписи проверяющего',
	deleteHoverText: 'Удалить подпись',
	preparer: 'Исполнитель',
	reviewer: 'Проверяющее лицо',
	preparerLabel: 'P',
	reviewerLabel: 'П',
	noSignOffsAvailable: 'Подписи отсутствуют',
	none: 'None None',
	partnerInChargeLabel: 'PIC PIC',
	eqrLabel: 'EQR EQR',
	documentSignoffRequiredLabel: 'Sign-offs required from: Sign-offs required from:',

	relatedDocumentsTitle: 'Связанные документы',
	relatedTasksCount: '{0} Related tasks',
	relatedTasksTitle: 'Related tasks',
	relateTemporaryFiles: 'Relate temporary files Relate temporary files',
	bodyRelatedDocumentsTitle: 'Документы, связанные с текстом',
	relatedObjectsTitle: 'Связанные объекты',
	relateDocumentsTitle: 'Управление связанными документами',
	relateDocumentsToBodyTitle: 'Добавить доказательства',
	relateDocumentsDesc: 'Выбрать документы, которые нужно прикрепить к Форме Канвас.',
	relateDocumentsToBodyDesc: 'Relate a document from this engagement or from another engagement in this workspace Relate a document from this engagement or from another engagement in this workspace',
	relateDocumentsToTheBody: 'Relate a document from this engagement Relate a document from this engagement.',
	priorPeriodEvidencesToTheBody: 'Доказательства за предыдущий период,  связанные с текстом',
	relatedDocunentEngdisabed: 'Документ не находится в общем доступе с данным заданием',
	showOnlyRelatedDocuments: 'Показать только связанные документы',
	manageDocuments: 'Управление документами',
	documentCount: '{0} документ',
	documentsCount: '{0} документы',
	relateDocumentsSearchPlaceholder: 'Поиск документов',
	overwriteFormDesc: 'Выбрать форму для замены ответов данными из текущей формы Канвас. Обратите внимание, что текущая форма Канвас будет перемещена во временные файлы.',
	searchFormPlaceholder: 'Поиск формы',
	overwriteLabel: 'Заменить',
	confirmOverwriteLabel: 'Подтвердить замену',
	confirmOverwriteDesc:
		"Are you sure that you want to copy the content of the '{0}' form to the '{1}' form? Responses will be overwritten in the '{2}' form, but related evidence and objects will not. Applicable related evidence and objects should be re-associated to the '{3}' form after the overwrite has been completed. '{4}' form will retain its existing profiling/GAM layers, therefore, if that profiling is different from '{5}' form, please review and clean up the copied content. \n Do not close the browser or navigate away while the overwrite process is in progress. After the overwrite process has completed, the '{6}' form will be moved to Temporary files and you will be navigated to the '{7}' form. This action cannot be undone.",
	formSelectionRequired: 'Выбрать форму для замены.',

	open: 'Открыть',
	startCoeditMode: 'Start multi-user editing',
	endCoeditMode: 'End multi-user editing',
	openReadOnly: 'Открыть только для чтения',
	copyLink: 'Copy link Copy link',
	rename: 'Переименовать',
	viewHistory: 'Смотреть историю изменений',
	documentOpenModelLabel: 'Документ редактируется',
	modelUserOpenedTheDocumentText: 'Данный пользователь открыл документ',
	modelDocumentOpenedText: 'Документ редактируется (кем)',
	modelOpenedDocumentConflictText: 'Открытие документа может вызвать конфликт, мы рекомендуем открыть его в режиме для чтения. Если вы хотите отредактировать данный документ, то',
	clickHereEnabledText: 'нажмите сюда',
	documentOptions: 'Параметры документа',
	accountDetails: 'Сведения о счете',

	// DAAS labels
	coEditModeIsEnding: 'Multi-user editing is ending',
	coEditMode: 'Multi-user editing',
	checkInInProgressMessage: 'Check-in in progress. It may take up to 20 minutes for the document to be checked in. Please refresh for updates',
	checkOutInProgressMessage: 'Check-out in progress. It may take up to 20 minutes for the document to be checked out. Please refresh for updates',
	daasErrorMessage: 'Operation cannot be complete at this time. Refresh the page and try again. If the issue persists contact the Help Desk',
	coEditModeIsStarting: 'Multi-user editing is starting',
	daasOpenDocumentWarning: 'Multi-user editing may have been ended by another user. Refresh the page and try again. Multi-user editing may have been ended by another user. Refresh the page and try again.',
	beingEditedInCoeditMode: 'Being edited in multi-user edit. Edit started by {0} Being edited in multi-user edit. Edit started by {0} ',
	beingEditedInCoeditModeOn: 'on {0}. on {0}.',
	beingEditedInCoeditModeError: 'Being edited in multi-user edit Being edited in multi-user edit',
	coEditModeAutomaticallyEnds: 'Document is in multi-user edit mode, which will end in {0} days. Document is in multi-user edit mode, which will end in {0} days.',
	daasStartCollaborationModeWarning: 'Collaboration mode may have been started by another user. Refresh the page and try again. Collaboration mode may have been started by another user. Refresh the page and try again.',
	documentCurrentlyBeingModifiedTitle: 'Document currently being modified Document currently being modified',
	documentCurrentlyBeingModifiedHeader: 'This document is currently being modified by {0}. This user opened the document This document is currently being modified by {0}. This user opened the document',
	documentCurrentlyBeingModifiedBody: 'Starting multi-user edit mode could cause conflicts, so we recommend discussing with {0} before proceeding. Select {1} to start the multi-user edit mode or {2} to return without starting multi-user edit mode. Starting multi-user edit mode could cause conflicts, so we recommend discussing with {0} before proceeding. Select {1} to start the multi-user edit mode or {2} to return without starting multi-user edit mode.',
	documentEndMultiUserEditingTitle: 'Confirm you want to end multi-user editing Confirm you want to end multi-user editing',
	documentEndMultiUserEditingHeader: 'Warning: Other users may be actively editing this document.  This can be checked by opening the document and seeing if other users are currently in the file. Please confirm that all changes are complete before ending multi-user mode. File changes in multi-user mode may take up to 1 minute to be processed. Therefore, please wait at least 1 minute after exiting the file before ending multi-user mode.',
	documentEndMultiUserEditingBody: 'Select {0} to end the multi-user edit mode or {1} to return without ending multi-user edit mode. Select {0} to end the multi-user edit mode or {1} to return without ending multi-user edit mode.',
	startMultiuserEditing: 'Start Start',
	/* Engagement Comments */
	clear: 'Очистить',
	close: 'Закрыть',
	reOpen: 'Заново открыть',
	reply: 'Добавить ответ',
	replyLabel: 'Ответ',
	unselectComment: 'Отменить выбор комментария',
	commentText: 'Enter text',
	replyText: 'Текст ответа',
	openStatus: 'Открыть',
	clearedStatus: 'Выполнено',
	closedStatus: 'Закрыто',
	chartCommentsTitle: 'Review notes',
	showComments: 'Показать комментарии',
	noRecordsFound: 'Данных не обнаружено',
	noCommentsFound: 'Leave a comment by using the inputs below. Assign the comment to a user and specify priority and due date.',
	newComment: 'Добавить комментарий',
	addNoteTitle: 'Add note',
	editComment: 'Редактировать комментарий',
	newReply: 'Добавить ответ',
	editReply: 'Редактировать ответ',
	commentTextRequired: 'Добавьте текст комментария',
	replyTextRequired: 'Требуется текст ответа',
	myComments: 'Мои комментарии',
	assignTo: 'Распределить для выполнения',
	theCommentMustBeAssigned: 'Поле «Кому распределено» является обязательным',
	priorityRequired: 'Необходимо указать приоритет',
	dueDateRequired: 'Необходимо указать срок выполнения',
	assignedTo: 'Распределено (кому)',
	allComments: 'Все комментарии',
	assignedToMe: 'Распределенные мне',
	unassigned: 'Не распределено',
	draggableCommentsPlaceholder: 'Введите текст, чтобы добавить новый комментарий',
	draggableNotesPlaceholder: 'Enter text to add a new note',
	enterReply: 'Введите ответ',
	dueDate: 'Срок выполнения',
	commentsAmmount: '{count} комментариев',
	singleCommentAmmount: '{count} комментарий',
	eyInternal: 'ЭЯ',
	noneAvailable: 'Отсутствуют',

	navHelixProjects: 'EY Helix connections EY Helix connections',

	evidence: 'Evidence Evidence',
	priorPeriod: 'Предыдущий период',
	temporaryFiles: 'Temporary files',
	priorPeriodEvidence: 'Prior period Prior period',
	closed: 'All assignments closed',

	/*Delete*/
	deleteFileTitle: 'Удаление документа',
	deleteFileCloseBtnTitle: 'Отменить',
	deleteFileConfirmBtnTitle: 'Удалить',
	deleteFileCloseTitle: 'Закрыть',
	deleteFileModalMessage: 'Удалить выбранный документ?',
	/*Rename*/
	editCanvasformObjects: 'Отредактируйте параметры и нажмите <b>Сохранить</b>.',
	renameFileModalMessage: 'Переименуйте документ и нажмите «Сохранить».',
	renameScreenshotModalMessage: "Переименуйте скриншот и нажмите 'Подтвердить'.",

	renameFileTitle: 'Переименовать документ',
	fileNameRequired: 'Укажите наименование файла',
	invalidCharacters: 'Наименование файла не может включать: */:<>\\?|"',
	existingFileName: 'Наименование файла уже существует. Обновите страницу или переименуйте файл, чтобы убрать данное сообщение.',
	maxLengthExceeded: 'Наименование документа не может превышать 115 символов.',

	STEntityProfileBannerMessage: 'Changes have been made to one or more of the entity profiles that will result in content updates. Navigate back to the Profile entities page and click "Import content" to receive the new content applicable to the entity\'s profile or revert the answers to a previous state.',
	independenceValidationForOwnForm: 'Изменения были внесены в ответы на вопросы по независимости, но не были отправлены. Если изменения носят преднамеренный характер, убедитесь, что ответы отправлены. Если изменения непреднамеренные, проверьте вид «Изменения» и верните предыдущие ответы вручную.',
	independenceValidationForOthersForm: 'Изменения были внесены в ответы на вопросы по независимости, но не были отправлены членом команды. Убедитесь, что член команды просматривает изменения и отправляет их, если они были намеренными.',
	insufficientRightsForIndependenceSubmission: 'Insufficient permissions to edit content. Contact your engagement administrator and request permission to edit content. Insufficient permissions to edit content. Contact your engagement administrator and request permission to edit content.',
	submitIndependenceProfileV2Message:
		'Please review the profile and confirm that the responses are accurate. If it is, please provide sign-offs and continue onto the engagement.',
	submitIndependenceProfileV2EditMessage:
		'No changes have been made to the profile that would result in engagement content changing. Use the Engagement content update page to perform a content update if necessary.',
	insufficientRightsForProfileV2Submission: 'Недостаточно прав для отправки профиля, изменения все еще могут быть внесены, а авторизованный пользователь может отправить изменения. Проверка профиля может быть задокументирована подписанием  документа. Обратитесь к члену аудиторской команды, обладающему соответствующими правами, для выполнения данной операции.',
	returnToDashboard: 'Вернитесь на информационную панель',
	returnToDashboardFit: 'Return to dashboard Return to dashboard',
	profileV2ChangeNotSubmittedBannerMessage: 'В профиль внесены изменения, которые могут привести к обновлению контента задания. Отправьте профиль, чтобы получить новый контент или вернуть ответы в предыдущее состояние.',
	independenceChangeNotSubmittedBannerMessage: 'В форму подтверждения независимости были внесены изменения, которые требуют повторной отправки. Повторно отправьте форму подтверждения независимости или отключите этого пользователя, чтобы пройти валидацию.',
	multiEntityIndividualProfileBannerMessage:
		'Insufficient permissions to edit the profile. Contact your engagement administrator and request permission to edit the profile. Insufficient permissions to edit the profile. Contact your engagement administrator and request permission to edit the profile.',

	scotStrategy: 'Стратегия по ЗКО',
	wcgwStrategy: 'Стратегия по ВО',
	itProcessStrategy: 'Стратегия по ИТ процессам',

	/*Edit Wcgw*/
	editWcgw: 'Редактировать ВО',
	viewWcgw: 'Просмотр ВО',
	editScot: 'Редактировать ЗКО',
	viewScot: 'Просмотреть ЗКО',
	showIncomplete: 'Показать незавершенные',
	forms: 'Формы',
	form: 'Form',
	comments: 'Замечания',
	changes: 'Изменения',
	editHeader: 'Редактировать заголовок',
	editSection: 'Edit section Edit section',
	editBody: 'Редактировать текст',
	editSectionDescription: "Edit the details for the section and click 'Save' Edit the details for the section and click 'Save'.",
	editHeaderDescription: "Edit the details for the header and click 'Save' Edit the details for the header and click 'Save'.",
	editBodyDescription: "Edit the details for the body and click 'Save' Edit the details for the body and click 'Save'.",
	manageObject: 'Управление объектом',
	relatedObjects: 'Связанные объекты',

	/* Manage body objects */
	bro_manage_WCGWTask_title: 'Привязать ВО',
	bro_manage_WCGWTask_instructions: 'Управление применимыми ВО',
	bro_manage_WCGWTask_noDataLabel: 'Результаты не найдены',

	/*Add/Edit ITGC*/
	addITGC: 'Добавить ОКИС',
	addNewITGC: 'Добавить новое ОКИС',
	addExistingITGC: 'Добавить существующее ОКИС',
	addITGCDescription: 'Добавить описание ОКИС.',
	itControlNameRequired: 'Необходимо указать наименование ОКИС',
	frequencyRequired: 'Необходимо указать периодичность',
	frequencyITGC: 'Выбрать периодичность',
	nameITGC: 'Необходимо указать наименование ОКИС',
	iTProcesslabel: 'ИТ-процесс',
	editITGC: 'Редактировать ОКИС',
	editITSP: 'Редактировать ИТППС',
	editITGCDescription: 'Редактировать ОКИС и связанные с ним признаки',
	editITSPDescription: 'Редактировать ИТППС и связанные с ним признаки',
	viewITGC: 'Просмотреть ОКИС',
	viewITSP: 'Просмотреть ИТППС',
	itgcTaskDescription: 'Выполнить разработанное нами тестирование ОКИС для того, чтобы получить достаточное надлежащее аудиторское доказательство их операционной эффективности в течение периода, когда мы на них полагаемся.',
	/**
	 * Add Edit ITGC
	 */
	addITSPDescription: 'Введите описание ИТППС.',
	selectITRisk: 'Выберите ИТ-риск (обязательно)',
	itRiskRequired: 'ИТ-риск (обязательно)',
	itspNameRequired: 'Наименование ИТППС (обязательно)',
	itspTaskDescription: 'Адаптируйте описание этой задачи таким образом, чтобы определить характер, сроки и объем процедур проверки по существу для ИТ-систем, чтобы получить достаточные надлежащие аудиторские доказательств того, что ИТ-риски эффективно снижены в течение периода, когда мы полагаемся на ИТ-системы.<br />Если процедура процедур проверки по существу для ИТ-систем будет выполнена на промежуточную дату, разработайте и выполните процедуры для получения дополнительных доказательств того, что ИТ-риски снижены в течение периода, охватываемого нашими промежуточными процедурами до конца периода.<br />Мы делаем вывод по результатам наших процедур проверки по существу для ИТ-систем.',
	itspRequired: 'Необходимо указать наименование ИТППС',
	selectTestingStrategy: 'Определить характер, сроки и объем наших процедур тестирования средств контроля в целях получения достаточных надлежащих аудиторских доказательств относительно функциональной эффективности средства контроля в соответствии с установленными требованиями на протяжении всего рассматриваемого периода в части предотвращения, выявления и исправления существенных искажений на уровне предпосылок. Сделать вывод относительно операционной эффективности средств контроля по итогам оценки результатов проведенного нами тестирования средств контроля, в том числе в тех случаях, когда мы увеличили объем выборки и протестировали компенсирующие средства контроля.',
	itControlNameTest: 'Тест {0}',

	/*Edit ITControl*/
	editITControl: 'Редактировать ОКИС/ИТППС',
	viewITControl: 'Просмотр ОКИС/ИТППС',

	/*Add/Edit ITRisk*/
	editITRisk: 'Редактировать ИТ-риск',
	editITRiskDescription: 'Редактировать ИТ-риск',
	viewITRisk: 'Просмотреть ИТ-риск',
	addITRisk: 'Добавить ИТ-риск',
	addITRiskDescription: 'Добавить описание ИТ-риска ',
	selectITProcess: 'Необходимо выбрать ИТ-процесс',
	itRiskName: 'ИТ-риск',
	itRiskNameRequired: 'ИТ-риск (необходимо выбрать)',
	riskNameRequired: 'Необходимо выбрать ИТ-риск',
	processIdRequired: 'Необходимо выбрать ИТ-процесс',
	itProcessRequired: 'ИТ-процесс (необходимо выбрать)',
	hasNoITGC: 'ОКИС для ИТ-риска отсутствуют',

	/*Edit Risk*/
	editRisk: 'Редактировать риск',
	viewRisk: 'Просмотр риска',

	/*Edit Control*/
	editControl: 'Редактировать средство контроля',
	viewControl: 'Просмотреть средство контроля',
	scotRelatedControls: 'Средства контроля, относящиеся к ',
	applicationControl: 'Прикладное средство контроля',
	iTDependentManualControl: 'ИТ-зависимое ручное средство контроля',
	noAapplicationControlAvailable: 'Прикладные средства контроля отсутствуют',
	noITDependentManualControlAvailable: 'ИТ-зависимые ручные средства контроля отсутствуют',
	isIPEManuallyTested: 'Автоматизированная часть этого РЗИТ средства контроля – это только использование системных отчетов, которые были протестированы по существу',

	/*Edit ITProcess*/
	editITSOProcess: 'Редактировать ИТ-/СО-процесс',
	viewITSOProcess: 'Просмотреть ИТ-/СО-процесс',

	/*Edit ITApplication*/
	viewITAppSO: 'Просмотреть ИТ-приложение/СО',
	editITAppSO: 'Редактировать ИТ-приложение/СО',
	strategy: 'Стратегия',
	nameRequired: 'Необходимо указать имя',
	name: 'Name Name',

	/*Snap shot*/
	currentVersion: 'Текущая версия',
	compareVersion: 'Выбрать версию для сравнения',
	snapshotVersionNotAvailable: 'Версии для сравнения отсутствуют',
	snapshots: 'Снимки экрана',
	sharedFormWarning:
		"Эта форма Канвас в общем доступе. Объекты и доказательства находятся в первоначальном задании и не будут добавлены в данное задание при удалении привязки. См. <a style='color: #467cbe' href='https://live.atlas.ey.com/#library/104/p/SL33184174-396647/C_33404446/C_38129691' target='_blank'>enablement here</a> для получения информации.",
	fullView: 'Полный вид',
	defaultView: 'Вид по умолчанию',
	print: 'Печать',
	version: 'Версия',
	navigationUnavailable:
		"Navigation is unavailable in Track changes & Attributes view. View 'Questions and responses' to enable navigation again.",
	snapshotUpdate: 'Обновлено',
	snapshotNew: 'Новое',
	snapshotRemoved: 'Удалено',
	snapshotRollforward: 'Created at time of Roll-Forward',
	snapshotRestore: 'Created at time of Restore',
	snapshotCopy: 'Created at time of Copy',

	/*Special Body*/
	priorPeriodAmount: 'Сумма за прошлый период',

	// Helix special body:
	helixScreenshotListLoading: 'Идет загрузка скриншотов...',
	helixScreenshotLoading: 'Идет загрузка картинки скриншота...',
	helixScreenshotDeleting: 'Идет удаление скриншота...',
	helixNotesLoading: 'Loading tickmarks...',
	helixNotesBoundingBoxShow: 'Показать аннотации',
	helixNotesBoundingBoxHide: 'Скрыть аннотации',
	helixNoteReferenceNumber: '№',
	helixNoteReferenceNumberPlaceholder: 'Ввести исходный номер',
	helixNoteText: 'Примечание',
	helixNoteTextPlaceholder: 'Enter tickmark text',
	helixNoteAnnotate: 'Комментировать',
	helixNoteAnnotateMessage:
		'Выберите область на скриншоте для комментария, подтвердите комментарий и нажмите на галочку, чтобы сохранить.',
	helixRemoveAnnotation: 'Удалить комментарий',

	/* User lookup body */
	userLookupInstructionalText: 'Введите имя или электронный адрес и нажмите «Ввод» для вывода результатов.',
	userLookupShortInstructionalText: 'Enter name or email and press enter',

	/*Guidance*/
	guidance: 'Инструкция',
	noIncompleteBodies: 'Выберите заголовок раздела из меню навигации для просмотра содержания',
	noUnresolvedComments: 'Выберите заголовок раздела из меню навигации для просмотра содержания',
	addComment: 'Добавить комментарий',

	/*Independence*/
	otherFormIndependenceMessage: 'Содержание данной формы для подтверждения независимости было обновлено и пользователь не вошел в систему после этого. В результате некоторые ответы могут быть неполными. Предыдущий статус проверки независимости был сохранен справочно.',
	override: 'Принудительное изменение',
	grantAccess: 'Предоставить доступ',
	denyAccess: 'Запрет доступа',
	overrideSmall: 'изменение',
	grantAccessSmall: 'предоставление доступа',
	denyAccessSmall: 'запрет доступа',
	status: 'Статус',
	undefined: 'Не определено',
	noMattersIdentified: 'Вопросы не выявлены',
	matterIdentifiedPendingAction: 'Вопрос выявлен - в ожидании рассмотрения',
	matterResolvedDeniedAccess: 'Вопрос решен - доступ запрещен',
	matterResolvedGrantedAccess: 'Вопрос решен - доступ получен',
	notApplicable: 'Не применимо',
	restored: 'Восстановлено',
	overridden: 'Принудительно изменено',
	priorNoMattersIdentified: 'Предыдущий - Вопросы не выявлены',
	priorMatterIdentifiedPendingAction: 'Предыдущий - Вопрос выявлен - в ожидании действия',
	priorMatterResolvedGrantedAccess: 'Предыдущий - Вопрос решен - доступ получен',
	priorMatterResolvedDeniedAccess: 'Предыдущий - Вопрос решен - доступ запрещен',
	byOn: 'кем {0} дата',
	modifiedBy: 'Modified by  Modified by',
	reason: 'Причина',
	submit: 'Отправить',
	submitTemplate: 'Отправить шаблон',
	independenceHoverText: 'Для предоставления доступа, отказа в доступе или изменения доступа для данного пользователя ваша должность должна быть не ниже партнера, ответственного за аудиторское задание, партнера по проекту или исполнительного директора.',
	enterRationaleText: 'Дать обоснование для',
	enterRationalePlaceholderText: 'Ввести текст обоснования',
	requiredRationaleText: 'Обоснование (необходимо указать)',
	rationaleTextRequired: 'Необходимо указать обоснование',

	sharedExternalWarning: 'Данная форма находится в общем доступе на Клиентском портале Канвас и доступна внешним членам команды. Ввести только те ответы и комментарии, которые появятся в общем со внешними членами команды доступе.',
	independenceViewTemplateMessage: 'Настоящая форма используется в качестве шаблона для составления опроса о подтверждении независимости каждого члена команды. <br /> При заполнении данного опроса все члены команды должны ответить на ряд вопросов о соблюдении требований к независимости по отношению к аудируемым организациям. Выберите подходящие ответы на такие вопросы. Ответы в данном опросе будут синхронизированы с индивидуальными опросниками, заполненными каждым членом команды. Если какой-либо из членов команды выбрал другой ответ, ему/ей необходимо повторно подтвердить свою независимость при повторном входе в задание. Если не выполнить повторный вход в задание, статус проверки независимости и ответы на вопросы останутся прежними. <br /> Изменения в форму подтверждения независимости могут вносить только авторизованные пользователи. Свяжитесь с администратором задания. Необходимо предоставить информацию обо всех внесенных изменениях, даже если перед архивированием они были отменены в ручном режиме.',

	/**
	 * FORM OBJECTS: SCOT-WCGW-CONTROL
	 */
	fo_instructionalText: 'Выбрать объекты для документирования в данной форме Канвас',
	fsro_instructionalText: 'Управлять объектами, относящимися к данному разделу',
	relObj_title_risk: 'Risks Risks',
	relObj_title_riskType: 'Тип риска',
	fo_showOnlyRelated: 'Показать только связанные объекты',
	scotsCount: '{0} ЗКО',
	wcgwsCount: '{0} ВО',
	itsoCount: '{0} ИТ-приложения/ сервисные организации',
	controlsCount: '{0} Средства контроля',
	itControlsCount: '{0} Средства ИТ-контроля',
	itGcCount: '{0} ОКИС',
	itSpCount: '{0} ИТППС',
	itProcessesCount: '{0} ИТ-процессы',
	risksCount: '{0} Риски',
	accountsCount: '{0} Accounts',
	stEntitiesCount: '{0} STEntities',
	componentsCount: '{0} Components',
	view: 'View View',
	searchByScotName: 'Поиск ЗКО по наименованию ',
	searchByWcgwName: 'Поиск по наименованию ВО',
	searchByITSOAppName: 'Поиск ИТ-приложения/СО по наименованию',
	searchByControlName: 'Поиск средства контроля по наименованию',
	searchByItControlName: 'Поиск средства ИТ-контроля по наименованию',
	searchByItProcessName: 'Поиск ИТ-процесса по наименованию',
	searchByRiskName: 'Поиск по наименованию риска',
	searchByAccountName: 'Search by Account name',
	searchBySTEntityName: 'Search by STEntity name',
	searchByEstimateName: 'Search by estimate name Search by estimate name',
	searchByComponentName: 'Search by Component name',
	noScotsAvailable: 'В данном задании отсутствуют ЗКО.',
	noRisksAvailable: 'В данном задании отсутствуют риски.',
	noControlsAvailable: 'В данном задании отсутствуют средства контроля.',
	noItControlsAvailable: 'В данном задании отсутствуют средства ИТ-контроля.',
	noItProcessesAvailable: 'В данном задании отсутствуют ИТ-процессы.',
	noItApplicationsAvailable: 'В данном задании отсутствуют ИТ-приложения.',
	noAccountsAvailableLabel: 'No Accounts are available in this engagement.',
	noObjectsRelatedToForm: 'К данной форме Канвас объекты не прикреплены',
	noDocumentControlsAvailable: 'Средства контроля не связаны с данным документом.',
	noDocumentScotsAvailable: 'ЗКО не связаны с данным документом.',
	noSTEntitiesAvailable: 'No STEntities are available in this engagement.',
	noComponentsAvailable: 'No Components are available in this engagement.',
	editObjectDescription: 'Edit the association of objects to this form Edit the association of objects to this form',
	editObjectsLabel: 'Edit objects Edit objects',
	noITGCsOrITSPsHaveBeenIdentified: 'No ITGCs or ITSPs have been identified',
	noItProcessIdentified: 'No IT Process have been identified',
	noControlsIdentified: 'No controls have been identified',
	noRelatedRisksIdentified: 'No related significant or fraud risks have been identified',
	noItApplicationsIdentified: 'No IT Applications have been identified',
	noSCOTIdentified: 'No SCOTs have been identified',
	noWCGWIdentified: 'No WCGWs have been identified',
	maxLimitLabel: 'Maximum number of objects have been selected.',
	minLimitLabel: 'Minimum number of objects have been selected.',

	relatedITAppsTitle: 'ИТ-процессы и связанные ИТ-приложения',
	relatedWCGWTasksTitle: 'ВО и связанные задачи',
	noRelatedTasks: 'Связанные задачи отсутствуют',
	noRelatedWcgw: 'Связанные ВО отсутствуют',
	noRelatedControls: 'Связанные средства контроля отсутствуют',
	controlRelatedRisksTitle: 'Средства контроля и связанные риски',
	sCOTRelatedRisksTitle: 'ЗКО и связанные риски',
	scotRelatedItApp: 'SCOT related IT apps',
	relatedItApps: 'Связанные ИТ-приложения',
	relatedRisksTitle: 'Связанные риски',
	relatedItRisksItProcessesTitle: 'ОКИС и связанные ИТ-процессы и ИТ-риски',
	testingTitle: 'Тестирование',
	strategyTitle: 'Стратегия',
	yes: 'Да',
	no: 'Нет',
	noRelatedRisks: 'Связанные значительные риски или риски недобросовестных действий отсутствуют',
	closeAllComments: 'Закрыть все комментарии',
	closeComments: 'Закрыть комментарии',
	closeCommentsDescription:
		'All open and cleared comments will be closed. Are you sure that you want to close all of the comments for this {0}?',
	addCanvasFormDigital: 'Цифровая ',
	addCanvasFormCore: 'Основная',
	addCanvasFormNonComplex: 'Простая',
	addCanvasFormComplex: 'Сложная',
	addCanvasFormListed: 'Зарегистрированная на бирже',
	addCanvasFormGroupAudit: 'Аудит группы',
	addCanvasFormPCAOBFS: 'ПСАОБ-ФО',
	addCanvasFormPCAOBIA: 'ПСАОБ-ИА',
	addCanvasFormStandards: 'Стандарты',
	addCanvasFormLanguage: 'Язык',
	addCanvasFormNoResultFound: 'Результаты не найдены',
	addCanvasFormStandardsNotSelectedMessage: 'Поле «Стандарт» является обязательным для заполнения',
	addCanvasFormLanguageNotSelectedMessage: 'Поле «Язык» является обязательным для заполнения',

	/* Confidentiality */
	confidentialityPlaceholder: 'Select confidentiality',
	confidentiality: 'Конфиденциальность',
	confidentialityTitle: 'Конфиденциальность документа',
	confidentialityText: 'Установить уровень доступа, требуемый для открытия данного документа. Уровни доступа устанавливаются администраторами задания на странице управления командой. Если уровень конфиденциальности уже был установлен для данного документа, его смогут редактировать только те, кто может его открыть.',
	confidentialityNotOpenable: 'Невозможно открыть документ, поскольку ваших прав в задании недостаточно. Уровни доступа устанавливаются администраторами задания в разделе управления командой.',
	confidentialityTargetNotOpenable: 'Конфиденциальные документы можно открыть только из первоначального задания.',
	backToCCP: 'Назад к Клиентскому порталу ЭЯ Канвас',
	guidanceMessageBackToCCP: 'После использования фильтров в данной форме вернитесь на Клиентский портал ЭЯ Канвас и отправьте запрос в ЭЯ.',
	noProfileInformationFound: 'Информация в профиле не найдена. Обновите страницу и повторите попытку. Если проблему не удается устранить, обратитесь в службу технической поддержки.',
	confirmUpdate: 'Confirm update',
	keepVersion: 'Сохранить данную версию',
	conflictDescription: '{0} отредактировал(а) данный текст {1} с момента открытия. Выбрать версию, которую необходимо сохранить.',
	currentConflictVersion: 'Текущая версия',
	serverConflictVersion: 'Версия на сервере',
	conflictShowChanges: 'Отображать изменения',
	sectionViewTrackChangesDropdownPlaceholder: 'Select version',
	verifyingIndependence: 'Проверка статуса независимости, пожалуйста, подождите.',
	creatingIndependenceForm: 'Создание формы подтверждения независимости в процессе.',
	meCallFailed: 'Не удалось получить информацию о пользователе. Обновите страницу и повторите попытку. Если проблему не удалось устранить обратитесь в службу технической поддержки.',
	getUserByIdFailed: 'Не удалось получить статус подтверждения независимости пользователя. Обновите страницу и повторите попытку. Если проблему не удалось устранить обратитесь в службу технической поддержки.',
	independenceFormCreationFailed: 'Не удалось создать форму подтверждения независимости пользователя. Обновите страницу и повторите попытку. Если проблему не удалось устранить обратитесь в службу технической поддержки.',
	gettingProfile: 'Идет сбор информации в профиле пожалуйста, подождите.',
	invalidDocumentId: 'Неверный идентификатор документа. Обновите страницу и повторите попытку. Если ошибку не удается устранить, обратитесь в службу технической поддержки.',
	returnToEditMode: 'Вернуться в режим редактирования',
	saveAndCloseButtonTitle: 'Сохранить и закрыть',
	formCreationFailed: 'Failed to create form. Please refresh the page and try again. If the issue persists, contact Help Desk.',

	/*Sign-off requirements*/
	signOffRequirements: 'Sign-off requirements Sign-off requirements',
	signoffRequirementsModalTitle: 'Sign-off requirements Sign-off requirements',
	signoffRequirementsModalDescription1: "Adjust this document's executive sign-off requirements below. Adjust this document's executive sign-off requirements below.",
	signoffRequirementsModalDescription2: 'Some sign-off requirements cannot be adjusted because they are required by EY Canvas. Some sign-off requirements cannot be adjusted because they are required by EY Canvas.',
	signoffRequirementsModalSaveLabel: 'Save Save',
	signoffRequirementsModalCancelLabel: 'Cancel Cancel',
	signoffRequirementsModalCloseLabel: 'Close Close',
	signoffRequirementsModalPICLabel: 'PIC PIC',
	signoffRequirementsModalEQRLabel: 'EQR EQR',

	/*<Ares>*/
	/* View changes */
	viewChanges: 'Просмотреть изменения',
	viewChangesModalTitle: 'Просмотреть изменения',
	documentModificationAlert: 'This activity was last modified by ',
	dismiss: 'Dismiss',

	/*Task List*/
	aresPageTitle: 'EY Canvas FIT enablement EY Canvas FIT enablement',
	aresPageSubtitle: 'Complete the steps below with the requested information about your audit. Complete the steps below with the requested information about your audit.',
	summary: 'Общая информация',
	aresNoDocumentFound: 'Прочая информации для выбранного действия отсутствует',
	taskSubTitleNoValue: 'Описание отсутствует',
	mainActivities: 'Основные мероприятия',
	unmarkComplete: 'Unmark Complete Unmark Complete',
	markCompleteTitleTip: 'Mark complete Mark complete',
	disableMarkCompleteTitleTip:
		'Ensure that all related documents are signed off by at least one preparer and one reviewer to mark this activity complete Ensure that all related documents are signed off by at least one preparer and one reviewer to mark this activity complete',
	/*Activity Summary*/
	activitySummary: 'Описание мероприятий',
	selectedAnswers: 'Выбранные ответы',
	allAnswers: 'Все ответы',
	incompleteResponses: 'Незаполенные ответы',
	previous: 'Назад',
	next: 'Вперед',
	viewAsLabel: 'View as View as',
	rolePreparerLabel: 'Preparer Preparer',
	roleDetailedReviewerLabel: 'Detailed Reviewer Detailed Reviewer',
	roleGeneralReviewerLabel: 'General Reviewer General Reviewer',
	roleEQRLabel: 'EQR EQR',
	/*Simple Helix*/
	helixPlaceholder: 'Guidance type 7 with guidanceurl is required for helix screenshots. Guidance type 7 with guidanceurl is required for helix screenshots.',
	noNotesAvailable: 'No tickmarks created No tickmarks created',
	addScreenshot: 'Add screenshot Add screenshot',
	replaceScreenshot: 'Replace screenshot Replace screenshot',
	replaceFrameDescription: `Review the below analytic and click on 'Replace' to replace the existing screenshot. Review the below analytic and click on 'Replace' to replace the existing screenshot.`,
	addNote: 'Add tickmark Add tickmark',
	notes: 'Tickmarks Tickmarks',
	noScreenshotsAvailable: 'Для того, чтобы начать работу, нажмите {viewDataAnalytic}',
	viewDataAnalytic: 'Просмотреть анализ данных',
	/* Delete modal Helix screenshot*/
	modalTitle: 'Удалить скриншот',
	sureDeleteBeforeName: 'Удалить скриншот?',
	sureDeleteAfterName: 'On deletion of the screenshot, all associated tickmarks will also be deleted and this action cannot be undone.',

	/*uploadDocument body type */
	relateExistingDocuments: 'Прикрепить существующие документы',
	fromEngagementOr: 'from this/other engagement(s) or',
	browse: 'просмотреть файлы',
	toUpload: 'для загрузки',
	signoffs: 'Подписи',
	addDocument: 'Добавить документ',
	uploadDocument: 'Загрузить документ',
	relateDocument: 'Relate existing documents Relate existing documents',
	generateAccountRiskAssessmentPackage: 'Создать группу ALRA',
	relateDocumentsToBodyAresTitle: 'Прикрепить документы',
	discardLabel: 'Отменить',
	uploadDocumentLabel: 'Загрузить документ',
	confirm: 'Подтвердить',
	duplicateDocumentHeader: 'В данном задании уже имеется один или несколько документов с таким названием (в Доказательствах или Временных файлах).',
	duplicateDocumentInstruction: 'Выберите ‘Заменить’ для загрузки документа и замены существующего файла или ‘Отменить’ для отмены загрузки. Если существующий файл хранится в Доказательствах, документ также будет загружен в Доказательства. Если существующий файл хранится во Временных файлах, документ также будет загружен во Временные файлы.',
	maxUploadFilesError: 'System can upload a maximum of 10 documents at the same time',
	/*</Ares>*/
	noTaskRelatedToThisDocument: 'No task related to this document',
	uncheckTrackChangesToSave: 'Снимите флажок с кнопки «Показывать в режиме редактирования», чтобы сохранить версию',
	reviewRoleCloseCommentsTitle: 'Незакрытые комментарии',
	reviewRoleCloseCommentsDesc: 'Есть незакрытые комментарии, которые необходимо рассмотреть. Используйте фильтр, чтобы легко идентифицировать незакрытые комментарии.',

	/*Document Upload - PIC/EQR Required Body type*/
	requirementDetails: 'Requirement details',

	//Risk Factors
	riskFactor: 'Relevant event and condition / risk of misstatement',
	manageRisk: 'Управлять рисками',
	noRiskFactors: 'No relevant events and conditions / risks of misstatement have been identified',
	relateRiskFactorsToRisks: 'Determine the significance of events and conditions Determine the significance of events and conditions',
	riskType: 'Тип риска',
	relateToRisk: 'Связать с риском',
	noRisksIdentified: 'Рисков не выявлено',
	notDefined: 'Не определено',
	selectValidRiskType: 'Please select valid risk type',
	newRisk: 'Добавить новый риск',
	notAROMM: 'Not a Risk of material misstatement',
	describeRationale: 'Опишите обоснование',
	noRisksIdentifiedForTheSpecificRiskType: '{0} не выявлено',
	addAnAccount: 'Добавьте счет',
	selectAnAccount: 'Выбрать счет',
	noAccountsHaveBeenIdentified: 'Счета не найдены',
	accountSelected: 'Счет',
	statementType: 'Тип отчета',
	selectAssertions: 'Выбрать одну или более предпосылок',
	noAssertionsIdentifiedForAccount: 'Предпосылки для данного счета не найдены',
	relatedAssertions: 'Связанные предпосылки',
	editAccount: 'Edit account & disclosure',
	addNewDescription: 'Add new description',
	editRiskFactorDescription: 'Edit description',
	enterRiskFactorDescription: 'Enter description for the relevant event and condition / risk of misstatement',
	riskFactorDescriptionRequired: 'Relevant event and condition / risk of misstatement description required',
	riskFactorDescription: 'Relevant event and condition / risk of misstatement description',
	createNewAccount: 'Create new account',
	createAccountLabel: 'Successfully created the account {0}',
	updateAccountLabel: 'Successfully saved edits to the account {0}',
	deleteAccountLabel: ' has been successfully deleted',
	significanceLabel: 'Significance',
	provideRationale: 'Please provide a rationale in order to save your selection',
	clearRiskSignificance: 'Clear Risk Significance and Description',
	clearSignificance: 'Clear significance and description',

	// Account Summary
	unavailable: 'Unavailable',
	notAvailable: 'Не доступно',
	fraudRisk: 'Fraud Risk',
	significantRisk: 'Significant Risk',
	significantRiskIndicator: 'ЗР',
	fraudRiskIndicator: 'РНД',
	inherentRisk: 'ROMM',
	inherentRiskIndicator: 'ROMM',
	prioryearbalance: 'Prior period balance:',
	accounts: 'Счета',
	accountsOther: 'Account - Other',
	accountsSignDis: 'Significant disclosure',
	xMateriality: 'Значения ПС',
	xTEMateriality: 'x TE',
	estimateAssociated: 'Estimate associated',
	designation: 'Назначение',
	noAccountshasbeenIdentified: 'No accounts has been identified.',
	noAccountsOtherhasbeenIdentified: 'No other accounts identified.',
	noAccountsSigfhasbeenIdentified: 'No significant disclosures identified.',
	addOtherAccounts: 'Add account - Other',
	addSignificantDisclosure: 'Add significant disclosure',
	pydesignation: 'Предыдущее назначение:',
	notapplicable: 'Н/д',
	noApplicable: 'Not applicable',
	changeDesignationMessage: 'Вы пытаетесь изменить назначение счета',
	changeDesignationTitle: 'Изменить назначение счета',
	continue: 'Продолжить',
	currentYearBalance: 'Current period Current period',
	currentPeriodBalance: 'Current Period',
	priorYear: 'Предыдущий год',
	priorYearDesignation: 'Prior period designation',
	priorYearEstimation: 'Prior period estimation',
	priorPeriodChange: '% change',
	analytics: 'Analytics',
	notROMMHeader: 'Not a Risk of material misstatement',
	manageEyCanvasAccounts: 'Manage EY Canvas accounts',
	manageAccountMapping: 'Manage account mapping',
	manageAccountMappingCloseButton: 'Use the button at the bottom of the page to close.',
	manageAccountMappingToasterMessage: 'Could not connect to EY Helix. Refresh the page and try again. If the issue persists, contact the Help desk.',
	inherentRiskTypeChangeMessage: 'By changing account assertion(s) from relevant to not relevant, certain associations in Canvas, including WCGWs to Assertions, will be removed and PSPs will be demoted to OSPs. Click “Confirm” if you would like to proceed. Click “Cancel” to return without changes.',

	analyticsIconDisabled: 'EY Helix is not enabled for your engagement.',
	//Estimate
	estimatesTitle: 'Estimates Estimates',
	relatedAccount: 'Related Accounts',
	currentBalance: 'Current Balance',
	priorBalance: 'Prior Balance',
	unrelateEstimates: 'unrelated estimate account',
	manageEstimates: 'Manage estimates Manage estimates',
	noEstimatesCreated: 'No estimates have been created.',
	createEstimates: 'Create estimate',
	estimateStarted: 'to get started',
	createEstimateDocument: 'Create estimation documentation',
	noEstimatesFound: 'No estimates have been identified No estimates have been identified',
	relateEstimateLink: 'Relate estimates Relate estimates',

	//Journal Source
	noJournalEntrySourcesAreAvailable: 'No journal entry sources are available.',
	jeSourceName: 'JE source',
	jeSourceNameTooltip: 'JE source',
	changeInUse: 'Change in use',
	grossValue: 'Gross value of related transactions',
	relatedTransactions: 'Number of related transactions',
	relevantTransactions: 'Relevant to significant class of transactions',
	expandAll: 'Expand all',
	collapseAll: 'Collapse all',
	descriptionLabel: 'Provide a brief description of the purpose of this source',
	jeSourceTypesLabel: 'Are the journal entries recorded through this source, system generated or manual?',
	journalEntries: 'Is this source used to record non-standard journal entries (i.e. non-recurring, unusual transactions or adjustments)?',
	identifySCOTsLabel: 'Identify the SCOTs associated to the JE source (select all that apply)',
	systemGeneratedLabel: 'System generated',
	manualLabel: 'Manual',
	bothLabel: 'Both',
	accountEstimateLabel: 'Est',
	addSCOTLabel: 'Add SCOT',
	addSCOTModalDescription: 'You can create SCOTs. Changes will be applied once saved.',
	scotnameRequired: 'SCOT name is required.',
	scotCategoryRequired: 'SCOT category is required.',
	estimateRequired: 'Estimate is required.',

	jeSourcesLabel: 'JE sources',
	jeSourcesToSCOTs: 'JE sources to SCOTs',
	scotsToSignificantAccounts: 'SCOTs to significant accounts',

	//Modal common labels.
	modalCloseTitle: 'Закрыть',
	modalConfirmButton: 'Сохранить изменения',
	modalCancelTitle: 'Отменить',
	modalSave: 'Save Save',
	modalSaveAndClose: 'Save and close Save and close',
	modalSaveAndAdd: 'Save and add',
	modalSaveAndCreateAnother: 'Save and create another Save and create another',

	//Add & Manage Risks
	addNewRiskModalTitle: 'Добавить новый риск',
	manageRisksListModalTitle: 'Управлять рисками',
	riskInfoMessage: 'Изменения будут применены после сохранения.',
	risksListInstructionalText: 'Вы можете изменять и удалять существующие риски. Вы также можете добавить новый риск при необходимости.',
	risksListEmptyArray: 'No risks available. Add new risk to get started',
	addNewRiskButtonLabel: 'Добавить новый риск',
	labelRiskName: 'Наименование риска',
	riskDescriptionLabel: 'Risk description',
	selectRiskType: 'Тип риска',
	requiredRiskName: 'Необходимо указать наименование риска',
	requiredRiskType: 'Необходимо указать тип риска',
	deleteRiskTrashLabel: 'Удалить риск',
	undoDeleteRiskTrashLabel: 'Отменить удаление',
	notARommLabel: 'Риск существенного искажения отсутствует',
	identifiedRiskFactors: 'Identified events/conditions/risks of misstatement, risks of material misstatement, significant risks, and fraud risks.',
	noneIdentified: 'Не выявлены',
	countUnassociatedRisk: "Events/conditions/risks of misstatement are unrelated/not marked as 'Not a risk of material misstatement/ Risk of material misstatement'.",

	// Bar Chart / Account Summary
	accountsTotal: 'Итого {0} счетов',
	accountSummary: 'Сводные данные по счетам',
	allAccounts: 'Все счета',
	significantAccountsBarChart: 'Значительные счета',
	limitedAccounts: 'Счета с ограниченным уровнем риска',
	insignificantAccounts: 'Незначительные счета',
	noAccountsHasBeenIdentifiedBarChart: 'No {0} have been identified.',
	selectedTotalAccountsCounter: '{0}/{1} Бухгалтерский учет',
	identifyInsignificantAccounts: 'Выявить незначительные счета',
	identifySignificantAccounts: 'Определение значительных счетов',
	identifyLimitedAccounts: 'Определите счета с ограниченным риском',
	preInsigniAccounts: 'Счет, который ранее был признан незначительным и сумма которого в текущем периоде равна или превышает сумму ДО.',
	nonDesignatedInsignificant: 'Данный счет не может быть отнесен в категорию незначительных. Нажмите на выпадающий список для изменения назначения данного счета.',
	tolerableError: 'Информация о допустимой ошибке недоступна. Обновить информацию об уровне существенности и повторить попытку.',
	documentContainerLabel: 'Документ',
	clickcreateformtogenerate: 'Нажмите {0} для создания документации по счету с ограниченным риском.',
	createform: 'Создать форму',
	createLimitedRiskAccountDocumentation: 'Create Limited risk account documentation',
	limitedAccountDocumentName: 'Limited risk account documentation',

	//Modal Confirm Switch account
	modalSwitchTitle: 'Unsaved changes',
	modalConfirmSwitch: 'Confirm',
	modalConfirmSwitchDescription:
		'The changes are not saved and will be lost if you decide to continue. Do you want to continue?',

	//Modal Edit Account
	manageAccountsModalTitle: 'Управление счетами',
	editAccountLinkLabel: 'Изменить счет',
	editAccountInstructionalText:
		'You can edit or delete existing EY Canvas accounts, or create new ones. Changes will be applied once saved.',
	selectAnAccountLabel: 'Выбрать счет',
	accountNameLabel: 'Наименование счета',
	accountLabel: 'Счет',
	accountDesignationLabel: 'Назначение счета',
	accountStatementTypeLabel: 'Тип отчета',
	accountRelatedAssertionsLabel: 'Связанные предпосылки',
	accountHasEstimateLabel: 'Влияет ли оценка на счет?',
	requiredAccountName: 'Необходимо указать наименование счета',
	requiredAccountDesignation: 'Необходимо указать назначение счета',
	requiredStatementType: 'Необходимо указать тип отчета',
	requiredRelatedAssertions: 'Выбрать предпосылку',
	pspIndexDropdownLabel: 'Выбрать индекс БППС',
	removePSPIndexLabel: 'Удалить индекс БППС',
	addPSPIndexLink: 'Добавить индекс БППС',
	pspIsRequired: 'Необходимо указать индекс БППС',

	//Delete account modal
	deleteAccount: 'Удалить счет',
	deleteAccountModalMessage: 'Вы уверены, что хотите удалить выбранный счет?',
	cannotBeUndone: 'Данная операция не может быть отменена.',
	guidedWorkflow: 'EY Canvas FIT enablement',
	scotSummary: 'Сводные данные по ЗКО',
	scopeAndStrategy: 'Объем и стратегия',
	ToggleSwitch: {
		Inquire: 'Запрос',
		Completed: 'Выполнено',
		isOn: 'Да',
		isOff: 'Нет'
	},
	navExecution: 'Выполнение',
	navCanvasEconomics: 'EY Canvas Economics',
	navOversight: 'Надзор за ЭЯ Канвас',
	navConclusion: 'Вывод',
	navTeamMemberIndependence: 'Подтверждения независимости участников команды',
	navGroupAudit: 'Руководство группы',
	navGroupActivityFeed: 'Информация о деятельности группы',
	navPrimaryStatus: 'Статус основной команды',
	navComponentStatus: 'Статус команды компонента',
	navGroupStatus: 'Статус группы',
	navEngagementManagement: 'Управление заданием',
	navProfile: 'Профиль',
	navItSummary: 'Сводные данные по ИТ',
	nav440GL: 'Изменения после даты заключения',
	navGroupStructureSummary: 'Group structure',
	navGroupInstructionSummary: 'Group instructions',
	navGroupInvolvement: 'Group involvement',
	navNotApplicable: 'Не применимо',
	cropScreenshot: 'Обрезать скриншот',
	cropScreenshotModalDescription:
		'Crop the screenshot to only include relevant portions.  Cropping will remove existing annotations,  the tickmarks will be retained and can be annotated again.  Cropping cannot be undone.',
	crop: 'Обрезать',
	replace: 'Replace',
	nameTheScreenshot: 'Наименование скриншота',
	nameLabel: 'Наименование',
	takeScreenshot: 'Добавить скриншот',
	measurementBasis: 'Основа для расчета',
	MeasurementBasisMessage: 'Based on the underlying EY Helix data mapping, it appears the measurement basis selected is not in the expected position (e.g., pretax income in a debit position). Consider whether:',
	measurementBasisProjectMappedCorrectly: 'The data in the EY Helix project is mapped correctly,',
	measurementBasisAppropriateValue: 'A different measurement basis may be appropriate, or',
	measurementBasisAdjustValue: 'It may be appropriate to adjust the measurement basis value as provided below',
	basisValueFromHelix: 'Показатель оборотно-сальдовой ведомости',
	rationaleDeterminationLabel: 'Обоснование расчета данной суммы',
	loginInstructions: 'Выполните вход в учетную запись и следуйте инструкциям для открытия счета. ',
	gotoText: 'Перейти,',
	asOfDate: 'По состоянию на дату',
	annualizedBasisValue: 'Среднегодовое базовое значение',
	basisValue: 'Базовое значение',
	isAnnualizedAmountRepresentative: 'Отражает ли среднегодовое базовое значение ожидаемую сумму, которая должна быть представлена в отчетности на конец периода?',
	isAnnualizedAmountRepresentativeForAssetsOrEquity: 'Отражает ли значение ожидаемую сумму, которая должна быть представлена в отчетности на конец периода аудита?',

	enterExpectedFinancialPerioadAmount: 'Введите ожидаемую сумму на конец аудируемого периода',
	enterRationaleAmountDetermined: 'Предоставить обоснование расчета ожидаемой суммы',
	printNotAvailable: '{0} has no content and therefore no information is shown',
	canvasFormPrintNotAvailable: 'Canvas Form Print is not currently available. Please try again or contact the Help Desk if the error persists.',
	saving: 'Сохранение...',
	removing: 'Выполняется удаление..',
	activitySummaryTitle: 'Информация о движении средств по счету',
	currentLabel: 'За текущий период',
	PMLabel: 'ПС',
	planningMaterialityLabel: 'Плановая существенность',
	TELabel: 'ДО',
	tolerableErrorLabel: 'Допустимая ошибка',
	SADLabel: 'ПАР',
	SADNominalAmountLabel: 'Номинальная сумма для включения в ПАР',
	PriorLabel: 'За предыдущий период',
	editRichText: 'Редактировать текст',
	noTypeTwoResponseAvailable: 'No response available. <br /> Click {clickHere} to respond. No response available. <br /> Click {clickHere} to respond.',
	clickHere: 'здесь',
	helixNavigationTitle: 'Перейдите на страницу конфигурации ЭЯ Хеликс для привязки или настройки параметров проекта ЭЯ Хеликс ',
	helixNavigationLink: 'Перейти в ЭЯ Хеликс',
	measurementBasisValue: 'Оценка базового значения',
	inlineSaveUnsavedChanges: 'Остались несохраненные изменения. Продолжить?',
	rationaleIncomplete: 'Обоснование не заполнено',
	projectMismatchDisplayMessageOnDataImport:
		'Your primary EY Helix project has been changed. Please confirm EY Helix Settings and import data from the new project.',
	importSuccess: 'EY Helix data successfully imported.',
	importHelix: 'Нажать «Импорт» для импорта данных главной книги из ЭЯ Хеликс.',
	importLabel: 'Импорт',
	reImportLabel: 'Повторный импорт',
	lastImportedBy: 'Последний импорт выполнен (кем)',
	lastImportedOn: 'Последний импорт выполнен (дата)',
	dataImportedFromProjec: 'Данные импортированы из проекта',
	reImportConfirmationTitle: 'Повторный импорт из ЭЯ Хеликс в процессе',
	reImportConfirmationMessagePart1: 'Re-importing data from EY Helix will change existing data or add new data within relevant activities and this cannot be undone.',
	reImportConfirmationMessagePart2: 'For more information and a summary of how the re-import data process affects EY Canvas FIT enablement, please refer to EY Atlas.',
	defineRisksTitle: 'Определить риски',
	assessAndDefineRisksTitle: 'Оценить и определить риски',
	identifiedRiskFactorsTitle: 'Identified events/conditions and related risks:',
	descriptionIncompleteLabel: 'Описание не заполнено',
	noRiskHasBeenRelatedMsg: 'Не прикреплено ни одного риска',
	rationaleIncompleteMsg: 'Обоснование не заполнено',
	loading: 'Идет загрузка...',
	importInProgressLabel:
		'Import in progress. This could take several minutes. Please refresh the page to see updated status.',
	importInProgressMessage: 'Helix data import in progress. Refresh the page to see import status.',
	importHelixProjectError: 'An error occurred importing data from EY Helix. Check that the status of the EY Helix project is showing as Analytics available, refresh the page, and click Import or Re-import again. If the issue persists contact the Help Desk.',
	importDeletionConfirmationMsg: 'Are you sure you want to delete the import of EY Helix data? Delete import will delete existing data within relevant activities and this cannot be undone.',
	deletePreviousImport: 'Delete EY Helix import',
	//Assess Risks - Summary Page
	assessRisksAccordionLabel: 'Связать риски',
	assessRisksNoItemsFound: 'Не выявлено ни одного риска',
	assessRiskAccountsAndRelatedAssertions: 'Счета и связанные предпосылки',
	assessRiskNoAccountsLinked: 'Не связано ни с одним счетом',
	accountRiskAssessmentSummary: 'Accounts and disclosures',
	// Flow chart
	flowchartTitle: 'Flowchart Flowchart',
	launchFlowchart: 'Launch Flowchart Launch Flowchart',
	orderToCashPlacement: 'Order to cash placement Order to cash placement',
	orderToCashPlacementMessage: 'the Program Dept. negotiates agrements with new customers and negotiates renewing contracts and/or modifying contracts with exting customers. A contract holds details such as: pricing, terms and warranties',
	saveFlowChart: 'Save Save',
	newstep: 'New step New step',
	zoomIn: 'Zoom in Zoom in',
	zoomOut: 'Zoom out Zoom out',
	resetZoom: 'Reset zoom Reset zoom',
	toogleInteractivity: 'Toogle interactivity Toogle interactivity',
	fitView: 'Fit view Fit view',
	numberOfSteps: 'Number of steps Number of steps',
	flowchartSuccessfullyCreated: 'Flowchart successfully created Flowchart successfully created',
	flowchartLinkedEvidenceMessage: 'This flowchart has been created in another engagement.  Access to the flowchart in this engagement will be removed when the evidence is unlinke. This flowchart has been created in another engagement.  Access to the flowchart in this engagement will be removed when the evidence is unlinke.',
	flowchartStepMoremenu: 'More menu More menu',
	flowchartEditSteps: {
		nextStep: "Next step Next step",
		previousStep: "Previous step Previous step",
		editStepTitle: "Edit step Edit step",
		editPlaceholderText_1: "Edit steps details and related objects below. Click Edit steps details and related objects below. Click ",
		editPlaceholderText_2: "'Save and close' 'Save and close' ",
		editPlaceholderText_3: "to save and return to the flowchart. Navigating to other steps using the options below will save your updates. to save and return to the flowchart. Navigating to other steps using the options below will save your updates.",
		draftEditStepFailMessage: "Unable to create flowchart step. Refresh the page and try again. Contact the Help Desk if the error persists. Unable to create flowchart step. Refresh the page and try again. Contact the Help Desk if the error persists.",
	},
	flowchartSmartEvidenceSourceIdNullMessage: 'No SCOT available. No SCOT available.',

	flowChartStepmoreMenu: {
		edit: "Edit Edit",
		delete: "Delete Delete"
	},

	flowChartStepIcons: {
		wcgws: "WCGWs WCGWs",
		controls: "Controls Controls",
		iTApps: "IT applications IT applications",
		serviceOrganisations: "Service Organizations Service Organizations"
	},

	flowChartStepIcon: {
		wcgw: "WCGW WCGW",
		control: "Control Control",
		iTApp: "IT application IT application",
		serviceOrganisation: "Service Organization Service Organization",
		evidence: "Evidence Evidence"
	},
	relatedStepObjects: {
		relatedWCGWs: 'Related WCGWs Related WCGWs',
		relatedControls: 'Related controls Related controls',
		relatedDocuments: 'Related evidence Related evidence',
		relatedITApplications: 'Related IT applications Related IT applications',
		relatedSOs: 'Related service organizations Related service organizations'
	},

	flowChartControl: {
		controlsCounter: " {0} Controls {0} Controls",
		headerName: "Relate controls Relate controls",
		showOnlyRelatedText: "Show only related Show only related ",
		noResultsFound: "No results found No results found",
		noWCGWs: "No controls have been created No controls have been created"
	},

	/*CRA Badge*/
	ir: 'IR',
	cr: 'CR',
	cra: 'CRA',
	incompleteCra: 'Incomplete CRA',
	incomplete: 'Не завершено',

	//Progess bar labels
	savingProgress: 'Сохранение...',
	discardChangesLabel: 'Сброс изменений',
	removeFromBody: 'Удалить из текста',
	uploading: 'Выполняется выгрузка...',
	uploadComplete: 'Выгрузка завершена',
	downloadComplete: 'Загрузка завершена',
	processing: 'Выполняется обработка...',

	/* ISA BODIES */
	/* Common */
	deleteEntityConfirmation: 'Удалить <b>{0}</b>? Данная операция не может быть отменена.',
	/* ITAPP-SCOT */
	searchScot: 'Поиск ЗКО',
	addITApp: 'Добавить ИТ-приложение',
	relatedItApp: 'Related IT Apps',
	itApplicationHeader: 'ИТ-приложения',
	scotNoDataPlaceholder: 'Нет информации',
	noScotsOrControlsPlaceholder: 'Отсутствуют связанные ЗКО или средства контроля; {noScotsOrControlsPlaceholderEditAssoc}.',
	noScotsOrControlsPlaceholderEditAssoc: 'редактировать связь',
	noScotsOrControlsPlaceholderTarget: 'Связанные ЗКО или средства контроля отсутствуют.',
	scotHeader: 'ЗКО',
	controlsHeader: 'Средства контроля',
	controlsApplicationHeader: 'Приложение',
	controlsITDMHeader: 'РЗИТ',
	itAppScotNoDataPlaceholderLabel: 'No IT applications have been added. No IT applications have been added.',
	itAppScotNoDataPlaceholder: 'Нет добавленных ИТ-приложений.<br /> Для начала работы нажмите {itAppScotNoDataPlaceholderAddItApp}',
	itAppScotNoDataPlaceholderAddItApp: 'Добавить ИТ-приложение',
	editItAppOption: 'Редактировать ИТ-приложение',
	removeItAppOption: 'Удалить ИТ-приложение',
	viewItAppOption: 'Просмотреть ИТ-приложение',
	editScotsISA: 'Редактировать ЗКО',
	viewScotISA: 'Просмотреть ЗКО',
	viewControlISA: 'Просмотреть средства контроля',
	scotAndRelatedControls: 'ЗКО и средства контроля',
	otherControls: 'Прочие средства контроля',
	controlTypeLabel: 'Тип средства контроля',

	/*SCOT-ITAPP*/
	addOrRelateItAppPlaceholder: '{identifyRelatedItApps} или задокументируйте {documentScotHasNoItApps}.',
	identifyRelatedItApps: 'Определить связанные ИТ-приложения',
	documentScotHasNoItApps: 'Отсутствуют ИТ-приложения, связанные с ЗКО',
	correctScotDocumentationPlaceholderLabel: 'The SCOT has been designated as not being supported by an IT application. Application and/or a ITDM control(s) have been associated to this SCOT',
	correctScotDocumentationPlaceholder: 'Этот ЗКО не поддерживается ИТ-приложением. Приложение и/или РЗИТ средства контроля были связаны с данным ЗКО {correctScotDocumentation}.',
	correctScotDocumentation: 'пересмотрите обозначение, что ни одно ИТ-приложение не поддерживает этот ЗКО',
	controlsWithoutRelatedItApps: 'Средства контроля без связанного ИТ-приложения',
	controlsWithRelatedItApps: 'Средства контроля со связанными ИТ-приложениями',

	/*AddEditITApplication */
	saveAndCreateNewButtonTitle: 'Сохранить и создать новое',
	instructionalMessage: 'Добавьте ИТ-приложение и выберите соответствующие ЗКО. Привяжите средства контроля, относящиеся к ИТ-приложению, если применимо.',
	ITApplicationNamePlaceholder: 'Необходимо указать наименование ИТ-приложения',
	scotDropdownPlaceholderText: 'Выберите ЗКО для привязки к ИТ-приложению',
	selectScotPlaceholderText: 'Выберите ЗКО для привязки к ИТ-приложению',
	selectControlPlaceholderText: 'Выберите средства контроля для привязки к ИТ-приложению',
	noRelatedScotsPlaceholderText: 'Связанные ЗКО отсутствуют ',
	noRelatedControlsPlaceholderText: 'Связанные средства контроля отсутствуют',
	CreateSOModelTitle: 'Добавить обслуживающую организацию',
	CreateSOInstructionalMessage: `Enter the new service organization details below and select '<b>{0}</b>' to finish. To create another service organization, select '<b>{1}</b>'.`,//'Create a new service organization and associate SCOTs and Controls related to it.',
	saveAndCloseLabel: 'Save and close',
	saveAndCreateLabel: 'Save and create another',
	SONamePlaceholder: 'Необходимо указать наименование сервисной организации',
	SOSelectScotPlaceholderText: 'Выберите ЗКО, связанные с обслуживающей организацией',
	SOSelectControlPlaceholderText: 'Выберите средства контроля, связанные с обслуживающей организацией',
	CreatedSOLabel: 'ОО добавлена',
	createdITAppLabel: 'ИТ-приложение добавлено',
	searchNoResultFoundText: 'Результат не обнаружен',
	searchNoResultsFoundText: 'No results found',
	iTApplicationNameRequired: 'Необходимо указать наименование ИТ-приложения',
	soNameRequired: 'Необходимо указать наименование сервисной организации',
	editITAppDesctiptionLabel: 'Редактировать ИТ-приложение и связанные с ним ЗКО и средства контроля',
	editSODescriptionLabel: `Edit the service organization details below and select <b>'Save'</b> to finish.`,
	viewITApplication: 'Просмотреть ИТ-приложение',
	itApplicationName: 'Наименование ИТ-приложения',
	serviceOrganizationName: 'Наименование обслуживающей организации',
	newItApplication: 'New IT application New IT application',

	/*Add/Edit ITProcess*/
	itProcessName: 'Наименование ИТ-процесса',
	addItProcessDescription: 'Создать ИТ-процесс ',
	addItProcess: 'Добавить ИТ-процесс',
	itProcessNameRequired: 'Необходимо указать наименование ИТ-процесса',
	editItProcess: 'Редактировать ИТ-процесс',
	editItProcessDescription: 'Редактировать ИТ-процесс',
	viewItProcess: 'Просмотреть ИТ-процесс',
	taskTitle: 'Задокументировать понимание ИТ-процесса: {0}',
	taskDescription:
		'Document our understanding of the IT process. Attach the relevant form as evidence to support our understanding of the IT process.<br />When ITGCs appear in the Task Attributes section, perform walkthrough procedures to confirm our understanding of the ITGCs and evaluate their design and implementation. Attach evidence of our procedures.',
	newItProcess: 'New IT process New IT process',

	/* IT Process - Task */
	itProcessSearchPlaceholder: 'Искать ИТ-процесс',
	itProcessHeader: 'ИТ-процесс',
	itProcessTasksHeader: 'Задачи',
	itProcessAddUPD: 'Добавить протокол пользовательских датаграмм',
	itProcessEditItProcess: 'Редактировать ИТ-процесс',
	itProcessRelateUDP: 'Прикрепить протокол пользовательских датаграмм',
	itProcessViewProcess: 'Просмотреть ИТ-процесс',
	itProcessNoDataPlaceholder: 'ИТ-процессы не добавлены.<br /> Для начала работы нажмите {addItProcess}.',
	itProcessSourceInstructionalText: 'At least one UDP must be related to the IT process. {itProcessSourceInstructionalTextCreateUdp} or {itProcessSourceInstructionalTextRelateUdp}',
	itProcessSourceInstructionalTextCreateUdp: 'Создать новый ППД',
	itProcessSourceInstructionalTextRelateUdp: 'привязать существующий ППД.',
	itProcessTargetInstructionalText: 'Ни один ППД не привязан к ИТ-процессу.',

	/* IT APP IT PROCESSES RELATION*/
	itApplicationHeaderRelate: 'ИТ-приложения',
	itProcessesHeaderRelate: 'ИТ-процессы',
	itAppNoDataPlaceHolderLabel: 'No IT applications have been identified. No IT applications have been identified.',
	itAppNoDataPlaceHolder: 'ИТ-приложения не указаны.<br />{identifyItApp}',
	identifyItApp: 'Выявить ИТ-приложение.',
	itProcessNoDataPlaceHolderRelationLabel: 'No IT processes have been identified. No IT processes have been identified.',
	itProcessNoDataPlaceHolderRelation: 'ИТ-процессы не указаны. <br /> {identifyItProcess}',
	identifyItProcess: 'Выявить ИТ-процесс.',
	editItApp: 'Редактировать ИТ-приложение',
	deleteItApp: 'Удалить ИТ-приложение',
	drag: 'Переместите ИТ-процесс  в соответствующие ИТ-приложения',
	// editItProcess: 'Редактировать ИТ-процесс',
	deleteItProcess: 'Удалить ИТ-процесс',
	unassociatedProcess: 'Количество несвязанных процессов - {0}',
	unassociatedItApplications: '{0} несвязанных ИТ-приложений',
	showOnlyUnrelated: 'Показать только несвязанные - {0}',
	searchItProcess: 'Поиск ИТ-процесса',
	searchItApplication: 'Искать ИТ-приложение',
	itProcessesLabel: 'ИТ-процессы',
	itApplicationsLabel: 'ИТ-приложения',
	showAllItAplications: 'Отобразить все ИТ-приложения ',
	showAllItProcesses: 'Отобразить все ИТ-процессы',
	relatedToLabel:
		"Список всех <span class='child-entity-count'>{count}</span> <span class='child-entity-name'>{child}</span>, связанных с <span class='parent-entity-object-name'>{parent}</span>",

	/* IT Process > IT Risk */
	itProcessItRiskNoDataPlaceholder: 'ИТ-процесс не указан.<br/>{identifyItProcess}',
	itProcessItRiskNoDataPlaceholderTarget: 'ИТ-процесс не найден.',
	itApplication: 'ИТ-приложения',
	itGC: 'ОКИС',
	addItRiskBtnTitle: 'Добавить ИТ-риск',
	itProcessItRiskUnrelatedITGC: 'несвязанные ОКИС',
	itProcessItRiskUnrelatedITGCUppercase: 'Несвязанные ОКИС',
	itProcessItRiskNoRisksNoControlsPlaceholder: 'Привязка ИТ-рисков или ОКИС к данному ИТ-процессу не требуется в связи с отсутствием прикладных или ручных средств контроля, зависящих от ИТ, с эффективной оценкой методики, которые связаны с ИТ-приложениями, относящимися в данному ИТ-процессу.',
	itProcessItRiskNoRisksControlsPlaceholder: 'На основании выявленных прикладных и ручных средств контроля, зависящих от ИТ {itRiskIdentify} для данного ИТ-процесса',
	itRiskIdentify: 'Необходимо выявить ИТ-риски',
	itProcessItRiskItProcessContentTitle: 'ИТ-риски и ОКИС',
	itProcessItRiskItRiskNoItgcRequiredPlaceholder: 'ОКИС для ИТ-риска отсутствуют.',
	itProcessItRiskItRiskItgcRequiredPlaceholder: 'У всех выявленных рисков должно быть хотя бы одно выявленное ОКИС, либо обозначение, что ОКИС для ИТ-риска отсутствует.<br/>Выявить {newITGC} или {existingITGC} для ИТ-риска или указать, что {noItRisksIdentified} для ИТ-риска.',
	noItRisksIdentified: 'ОКИС отсутствуют',
	newITGC: 'новое ОКИС',
	existingITGC: 'существующее ОКИС',
	unrelatedItGCModalMessage: 'Удалить несвязанные ОКИС, которые больше не нужны.',
	unrelatedItGCModalNoDataPlaceholder: 'Связанные ОКИС отсутствуют',
	removeItRisk: 'Удалить ИТ-риск',
	deleteItRiskConfirmation: 'Вы уверены, что хотите удалить ИТ-риск <br/> <b>{0}</b>? Это действие удалит ИТ-риск и не может быть отменено.',
	relateItGcTitle: 'Связанные ОКИС',
	relateItGcEntityTitle: 'ИТ-риск',
	relateItGcDescription: 'Выберите ОКИС, относящиеся к ИТ-риску.',
	relateItGcSearchPlaceholder: 'Поиск ОКИС',
	relateItGcShowSelectedOnlyText: 'Показать только связанные ОКИС',
	relateItGcNoDataPlaceholder: 'Нет доступных ОКИС. Чтобы продолжить, создайте новый ОКИС.',
	relateITSPTitle: 'Связать ИТППС',
	relateITSPDescription: 'Выберите ИТППС, относящиеся к ИТ-риску.',
	relateITSPSearchPlaceholder: 'Поиск ИТППС по наименованию',
	relateITSPShowSelectedOnlyText: 'Показать только связанные ИТППС',
	relateITSPNoDataPlaceholder: 'Нет доступных ИТППС. Чтобы продолжить, создайте новую ИТППС.',

	/* IT Process Task Relationship */
	relateUDP: 'Прикрепить ПДП',
	relateUDPDescription: 'Выберите задачи ПДП, относящиеся к ИТ-процессу.',
	relateUDPListHeaderItemName: 'Наименование задачи',
	relateUDPSearchPlaceholder: 'Поиск по наименованию задачи',
	relateUDPNoResultsFoundPlaceholder: 'Результаты не обнаружены',
	relateUDPCountLabel: '{0} задач',
	relateUDPClose: 'Закрыть',
	relateUDPShowOnlyRelatedTasks: 'Показать только связанные задачи',
	relateUDPNoDataFoundPlaceholder: 'Задачи отсутствуют.',
	relateUDPNoDataPlaceHolder: 'ИТ-процесс не указан',

	/* ITGC test strategy */
	itProcessItRiskItGcWithoutDesignEffectiveness: 'ОКИС без эффективности методики',
	searchItGC: 'Искать ИТ-процесс',
	itGCNoDataPlaceHolder: 'ИТ-процесс не указан',
	addItRisks: 'Добавить ИТ-риски',
	itDMHeader: 'ИТЗР',
	itAppHeader: 'ИТ-приложение',
	itTestHeader: 'Протестировать',
	itTestingHeader: 'Тестирование',
	itgcHeader: 'ОКИС',
	controlsSelectedHeader: 'Средства контроля, выбранные для тестирования',
	iTRisksAndITGCs: 'ИТ-риски и ОКИС',
	NoITGCForITRiskPlaceholder: 'No ITGCs exist in the IT environment to address this IT risk',
	ITGCsNotIdentifiedRiskNoITGCs: 'ITGCs have not been identified for this risk. {identifyAnITGC} or designate that the {itRiskHasNoITGCs}.',
	identifyAnITGC: 'Выявить ОКИС',
	itRiskHasNoITGCs: 'В отношении ИТ-риска ОКИС отсутствуют',

	/**
	 * IT SO > SCOT
	 */
	searchItSO: 'Искать сервисную организацию',
	addItSOBtnTitle: 'Добавить сервисную организацию',
	itSoNoDataPlaceHolder: 'No service organizations have been identified.<br/><a>{identifyAnSo}<a/>',
	noItSoDataPlaceHolder: 'No service organizations have been identified.',
	identifyAnSo: 'Identify a service organization',
	soHeader: 'Сервисная организация',
	editSO: 'Изменить сервисную организацию',
	deleteSO: 'Удалить сервисную организацию',
	viewSO: 'View service organization',
	controlRelatedToSO: 'Средства контроля, связанные с ОО',

	/**
	 * Manage IT SP
	 */
	addITSP: 'Добавить ИТППС',
	searchPlaceholderManageITSP: 'Искать ИТ-процесс',
	noManageITSPDataPlaceholder: 'ИТ-процесс не найден',
	itRiskColumnHeader: 'ИТ-риски',
	itDesignEffectivenessHeader: 'Эффективность структуры',
	itTestingColumnHeader: 'Тестирование',
	itGCColumnHeader: 'ОКИС',
	itSPColumnHeader: 'ИТППС',
	searchClearButtonTitle: 'Очистить',
	itProcessItRiskUnrelatedITSP: ' несвязанные ИТППС ',
	manageITSPUnrelatedITSPUppercase: 'Несвязанные ИТППС',
	unrelatedITSPModalMessage: 'Удалить несвязанные ИТППС, которые больше не нужны.',
	unrelatedITSPModalNoDataPlaceholder: 'Отсутствуют несвязанные ИТППС',
	noITGCPlaceholderMessageFragment1: 'Все выявленные риски должны быть связаны как минимум с одним выявленным ОКИС, либо необходимо указать, что риск не связан с ОКИС:',
	noITGCPlaceholderMessageFragment2: 'Найти ',
	noITGCPlaceholderMessageFragment3: 'новое ОКИС ',
	noITGCPlaceholderMessageFragment4: 'или ',
	noITGCPlaceholderMessageFragment5: 'существующее ОКИС ',
	noITGCPlaceholderMessageFragment6: 'в отношении ИТ-риска или укажите, что ',
	noITGCPlaceholderMessageFragment7: 'ОКИС отсутствуют ',
	noITGCPlaceholderMessageFragment8: 'в отношении ИТ-риска',
	addNewITSP: 'Добавить новую ИТППС',
	addExistingITSP: 'Добавить текущую ИТППС',
	noITSPPlaceholderMessageFragment1: 'Если мы оцениваем, что ОКИС являются неэффективными, либо определяем, что ОКИС для данного ИТ-риска отсутствуют, мы выполняем ИТ-процедуры тестирования по существу (ИТППС) для получения разумной уверенности в отсутствии ИТ-риска в рамках ИТ-процесса, связанного с неэффективными ОКИС.',
	noITSPPlaceholderMessageFragment2: 'Определите новую ИТППС',
	noITSPPlaceholderMessageFragment3: 'или',
	noITSPPlaceholderMessageFragment4: 'привязать текущую ИТППС',
	noITSPPlaceholderMessageFragment5: '.',
	noITGCsExitForITRisk: 'ОКИС для данного ИТ-риска отсутствуют.',
	noITSPExitForITRisk: 'Для данного ИТ-риска не выявлено ИТППС.',
	manageITSPItemExpansionMessage: 'ИТ-риски',
	noITGCExists: 'ОКИС для ИТ-риска отсутствуют.',
	iTGCName: 'Наименование ОКИС',
	itSPName: 'Наименование ИТППС',
	operationEffectiveness: 'Операционная эффективность',
	savingLabel: 'Сохранение',
	deletingLabel: 'Удаление',
	removingLabel: 'Выполняется удаление',
	itFlowModalDescription: 'Перейдите к {itSummaryLink}, чтобы изменить или удалить объекты, которые больше не применимы для задания.',
	itSummaryLink: 'окно Сводный отчет по ИТ',
	manageITSPYes: 'Да',
	manageITSPNo: 'Нет',

	understandITProcess: 'Understand IT processes',
	activity: 'Activity',
	unsavedPageChangesMessage:
		'You have unsaved changes that will be lost if you choose to continue. Are you sure you want to leave this page?',
	unsavedChangesTitle: 'Unsaved changes',
	unsavedChangesLeave: 'Leave this page',
	unsavedChangesStay: 'Stay on this page',

	notificationDownErrorMessage: 'The Notifications feature is temporarily unavailable. Refresh the page and try again. If this message persists, contact the Help Desk.',
	notificationUpbutSomeLoadingErrorMessage: 'A technical error has occurred that is preventing the Notifications feature from working. Refresh the page and try again.',
	markCompleteError: 'All documents presented require at least one preparer and one reviewer sign-off.',
	markCompleteDescription: 'All documents must be signed-off by at least one preparer and one reviewer to mark the activity as complete.',
	lessthan: 'Less than',
	openingFitGuidedWorkflowForm: 'Loading, please wait.',
	openingFitGuidedWorkflowFormError: 'Unable to open EY Canvas FIT enablement form',
	timeTrackerErrorFallBackMessage: 'The Time Tracking feature is temporarily unavailable. Refresh the page and try again. If this message persists, contact the Help Desk.',
	timeTrackerLoadingFallbackMessage: 'The Time Tracking feature is temporarily unavailable. It will be available shortly.',
	priorPeriodRelateDocument: 'Relate prior period evidence',
	selectedValue: 'Selected value',
	serviceGateway: 'Service Gateway',
	docNameRequired: 'Name cannot be empty',
	docInvalidCharacters: 'Name cannot include: */:<>\\?|"',
	invalidComment:
		'Comment could not be added. If selecting multiple items in a list, only select a single item and try again. If the issue persists, refresh the page and try again or contact the Help Desk.',
	inputInvaildCharacters: 'Input cannot include the following string of characters: */:<>\\?|"',

	// FIT Navigation panel
	relatedActivities: 'Related activities Related activities',
	backToRelatedActivities: 'Back to related activities Back to related activities',
	backToMainActivities: 'Back to main activities Back to main activities',
	formOptions: 'Form options Form options',

	// FIT Sharing
	shareActivity: 'Share activityShare activity',
	shareLabel: 'ShareShare',
	shareInProgress: 'Sharing in progressSharing in progress',
	manageSharing:
		"Sharing of this activity requires the 'Manage sharing of EY Canvas FIT enablement' user permission. Navigate to the 'Manage team' page to manage permissions or contact another member of the teamSharing of this activity requires the 'Manage sharing of EY Canvas FIT enablement' user permission. Navigate to the 'Manage team' page to manage permissions or contact another member of the team",
	dropdownPlaceholderSA: 'Select the engagement to share withSelect the engagement to share with',
	fitSharingModalInfo:
		'Share this activity with one or more activities from the same engagement or from another engagement in the same workspace. If the activities selected are not already shared, then the responses in the activities selected below will be overwritten. If the activity is shared, then only one can be selected and the responses in this activity will be overwritten. Share this activity with one or more activities from the same engagement or from another engagement in the same workspace. If the activities selected are not already shared, then the responses in the activities selected below will be overwritten. If the activity is shared, then only one can be selected and the responses in this activity will be overwritten.',
	lastModifiedDate: 'Last modified on:Last modified on:',
	noActivityToShare: 'No activity available to shareNo activity available to share',
	activityNotShared: '{0} was not shared{0} was not shared',
	activityShareSuccessfull: '{0} shared successfully{0} shared successfully',
	sharedWithAnotherFITActivity: 'This activity is shared with another activityThis activity is shared with another activity',
	sharedActivityWithAnotherCanvas: 'Share activity with another EY Canvas FIT enablementShare activity with another EY Canvas FIT enablement',
	shareActivityModalTitle: 'Share activityShare activity',
	showRelationshipsTitle: 'Show relationshipsShow relationships',
	shareActivityEngagement: 'EngagementEngagement',
	shareActivityRelationshipsModalTitle: 'Shared activity relationshipsShared activity relationships',
	shareActivityWorkspaceHeading: 'This activity is being shared with the below engagement(s) and related activity(ies) within the same workspace.',
	shareModalOkTitle: 'ShareShare',
	shareModalContinueLabel: 'ContinueContinue',
	selectedActivityInfoLabel: 'in the selected engagement was last modified on:in the selected engagement was last modified on:',
	noSharedActivityInfoLabel: 'This engagement does not have another document of this same type to share with.This engagement does not have another document of this same type to share with.',
	alreadyHasSharedActivityInfoLabel: 'The selected activity is already shared with other activities. Sharing the current activity will sync the responses from the selected activity to the current activity.The selected activity is already shared with other activities. Sharing the current activity will sync the responses from the selected activity to the current activity.',
	selectActivityResponsesForSharingLabel: "Select which document's responses should replace the other: Select which document's responses should replace the other: ",
	selectActivityResponsesForCurrentRadioLabel: 'Share responses from current document to the above selected documentShare responses from current document to the above selected document',
	selectActivityResponsesForSelectedRadioLabel: 'Share responses from the above selected document to the current documentShare responses from the above selected document to the current document',
	selectActivityResponsesWarningEarlierTimeLabel: "The current activity was modified at an earlier time compared to the selected engagement's activity.Please consider this before confirming the sharing option's below the table.The current activity was modified at an earlier time compared to the selected engagement's activity.Please consider this before confirming the sharing option's below the table.",
	selectActivityResponsesWarningModifiedMoreRecentlyLabel: "The current activity was modified more recently compared to the selected document's activity.Please consider this before confirming the sharing option above.The current activity was modified more recently compared to the selected document's activity.Please consider this before confirming the sharing option above.",
	selectActivityUnsuccessfulMessage: 'Failed to share. Please retry. If issue persists, contact the EY Help desk.Failed to share. Please retry. If issue persists, contact the EY Help desk.',
	otherEngagemntDropdownlabel: 'Other engagements in the workspace:Other engagements in the workspace:',
	documentSearchPlaceholder: 'Search documentSearch document',
	showOnlySelected: 'Show only selectedShow only selected',

	//FIT Copy
	copyLabel: 'Copy Copy',
	copyActivity: 'Copy activity',
	copyInProgress: 'Copy in progress',
	fitCopyModalInfo: 'Copy responses from this activity to one or more activities from the same engagement or from another engagement in the same workspace.',
	dropdownPlaceholderCA: 'Select the engagement to copy to',
	noCopyActivityInfoLabel: 'This engagement does not have document of this same type to copy to.',
	copyActivityHoverLabel: 'This activity is already shared with other activities and cannot be copied into',
	copyActivityWarningEarlierTimeLabel: "The current activity was modified at an earlier time compared to the selected engagement's activity.Please consider this before confirming the copy options.",

	//Unlink
	unlinkModalTitle: 'Unlink activityUnlink activity',
	unlinkModalDescription: 'Are you sure that you want to unlink the selected activity?Are you sure that you want to unlink the selected activity?',
	unlinkLabel: 'UnlinkUnlink',
	insufficientPermissionsLabel: 'Insufficient permissionInsufficient permission',
	unlinkFailMessage: 'Unlink failed. Please refresh and try again. If issue persists, contact the EY Help desk.Unlink failed. Please refresh and try again. If issue persists, contact the EY Help desk.',
	unlinkSuccessfulMessage: 'Unlink successfulUnlink successful',
	unlinkInProgressLabel: 'Unlink in progressUnlink in progress',
	unlinkError: 'Unlink errorUnlink error',
	unlinkInProgressInfo: 'Unlink in progress. This may take up to fifteen minutes. After the unlink is complete, this form will need to be closed and opened again.Unlink in progress. This may take up to fifteen minutes. After the unlink is complete, this form will need to be closed and opened again.',

	/** Manage scot modal labels */
	scotName: 'SCOT nameSCOT name',
	scotCategory: 'SCOT categorySCOT category',
	estimate: 'Estimate Estimate',
	noScotsAvailablePlaceHolder: 'No SCOT available. Add new SCOT to get startedNo SCOT available. Add new SCOT to get started',
	addScotDisableTitle: 'Fill all the details for the SCOT to add a new SCOTFill all the details for the SCOT to add a new SCOT',
	deleteScotTrashLabel: 'Delete scotDelete scot',
	undoDeleteScotTrashLabel: 'UndoUndo delete delete',
	scotNameValidationMessage: 'SCOT name is requiredSCOT name is required',
	scotCategoryValidationMessage: 'SCOT category is requiredSCOT category is required',
	scotWTTaskDescription: '<p>For all routine and non-routine SCOTs and significant disclosure processes, we confirm our understanding every period by performing walkthrough procedures. In addition, for PCAOB audits, we perform walkthrough procedures of estimation SCOTs.<br/>For all SCOTs when we take a controls reliance strategy, and for controls that address significant risks, we confirm that relevant controls have been appropriately designed and implemented. We confirm that our decision to take a controls reliance strategy is still appropriate.<br/><br/>We conclude that our documentation accurately describes the operation of the SCOT and we have identified all appropriate WCGWs, including risks that arise from using IT, and relevant controls (when applicable).<br/><br/> For estimation SCOTs when we use a substantive only strategy, we determine whether our understanding of the estimation SCOT is appropriate based on our substantive procedures.</p><p>For all routine and non-routine SCOTs and significant disclosure processes, we confirm our understanding every period by performing walkthrough procedures. In addition, for PCAOB audits, we perform walkthrough procedures of estimation SCOTs.<br/>For all SCOTs when we take a controls reliance strategy, and for controls that address significant risks, we confirm that relevant controls have been appropriately designed and implemented. We confirm that our decision to take a controls reliance strategy is still appropriate.<br/><br/>We conclude that our documentation accurately describes the operation of the SCOT and we have identified all appropriate WCGWs, including risks that arise from using IT, and relevant controls (when applicable).<br/><br/> For estimation SCOTs when we use a substantive only strategy, we determine whether our understanding of the estimation SCOT is appropriate based on our substantive procedures.</p>',

	relate: 'RelateRelate',
	unrelate: 'UnrelateUnrelate',
	related: 'RelatedRelated',
	relatedSCOTs: 'Related SCOTsRelated SCOTs',
	thereAreNoSCOTsIdentified: 'There are no SCOTs identifiedThere are no SCOTs identified',
	selectSCOTsToBeRelated: 'Select SCOTs to be relatedSelect SCOTs to be related',

	//OAR Tables
	OARBalanceSheet: 'Balance sheetBalance sheet',
	OARIncomeStatement: 'Income statementIncome statement',
	OARCurrentPeriod: 'Analysis date Analysis date',
	OARAmountChangeFrom: 'Change fromChange from',
	OARPercentageChangeFrom: '% change from% change from',
	OARNoDataAvailable: 'No data available. Review the {0} page and import the data to proceed further.No data available. Review the {0} page and import the data to proceed further.',
	OARAnnotationLabel: 'Click to review reason for unexpected changes or lack of expected changesClick to review reason for unexpected changes or lack of expected changes',
	OARAnnotationSelectedIcon: 'Document reason for unexpected changes or lack of expected changesDocument reason for unexpected changes or lack of expected changes',
	OARAnnotationModalTitle: 'Annotation Annotation',
	OARAnnotationModalPlaceholder: 'Document items that appear unusual, unexpected changes or lack of expected changes.Document items that appear unusual, unexpected changes or lack of expected changes.',
	OARWithAnnotationLabel: 'Documentation of unexpected changesDocumentation of unexpected changes',
	OARAnnotation: 'Annotation Annotation',
	OARAccTypeWithAnnotationCountLabel: '{0} annotations within the account type{0} annotations within the account type',
	OARSubAccTypeWithAnnotationCountLabel: '{0} annotations within the account sub-type{0} annotations within the account sub-type',
	OARColumnA: 'AA',
	OARColumnB: 'BB',
	OARColumnC: 'CC',
	OARComparative1Period: 'Comparative date 1 Comparative date 1',
	OARComparative2Period: 'Comparative date 2 Comparative date 2',
	OARExpand: 'Expand account class Expand account class',
	OARCollapse: 'Collapse account class Collapse account class',
	OARHelixNavigationLink: 'Go to EY Helix for additional information Go to EY Helix for additional information',
	OARPrintNoDataAvailable: 'No data available No data available',

	//OAR Helix integration
	helixIntegrationModalDescription: 'This is a text pending to be defined',
	OSJETabText: 'Other side of the journal entry',
	activityAnalysisTabText: 'Activity analysis',
	preparerAnalysisTabText: 'Preparer analysis',
	accountMetricsTabText: 'Account metrics',
	noAnalyticsData: 'No analytics available to display',

	printActivitiesTitle: 'Print ActivitiesPrint Activities',
	printActivitiesModalInfo: 'Please select which activities you would like to include. Please select which activities you would like to include.',
	printActivitiesModalConfirmButton: 'Compile PDF Compile PDF',
	printActivitiesDropdownLabel: 'FIT Activities FIT Activities',
	printActivitiesAll: 'All All',
	oarSetupText: 'Go to {0} page to link or configure an EY Helix project Go to {0} page to link or configure an EY Helix project',
	helixNotAvailable: 'EY Helix is not available for your engagement. EY Helix is not available for your engagement.',
	dragDropUploadPlaceholder: 'Drag and drop one or more documents or click <span>{addDocument}</span> Drag and drop one or more documents or click <span>{addDocument}</span>',

	noTaskAssociatedToastMessage: 'Since the Canvas form is in Temporary files the added document(s) have also been added to Temporary files Since the Canvas form is in Temporary files the added document(s) have also been added to Temporary files',

	// chart labels.
	assets: 'Assets Assets',
	liabilities: 'Liabilities Liabilities',
	equity: 'Equity Equity',
	revenues: 'Revenues Revenues',
	expenses: 'Expenses Expenses',
	noAccountsAvailable: 'No accounts available No accounts available',

	// ALRA
	ALRAFilterByAccount: 'Filter by account Filter by account',
	ALRANoRecords: 'No results found No results found',
	ALRAAssertions: 'Assertions Assertions',
	ALRAInherent: 'Inherent risk factors Inherent risk factors',
	ALRAHigher: 'Higher risks factors Higher risks factors',
	ALRAAccountDisclosure: 'Accounts/Disclosures Accounts/Disclosures',
	ALRAType: 'Type Type',
	ALRAName: 'Name Name',
	ALRARisks: 'Risks Risks',
	ALRAC: 'C C',
	ALRAEO: 'E/O E/O',
	ALRAMV: 'M/V M/V',
	ALRARO: 'R&O R&O',
	ALRAPD: 'P&D P&D',
	ALRAR: 'R R',
	ALRANoRisksAssociated: 'No risk related to this account No risk related to this account',
	ALRAAccountsDisclosureName: 'Accounts/Disclosure name Accounts/Disclosure name',
	ALRAHigherRisk: 'Higher risk Higher risk',
	ALRAHigherInherentRisk: 'Higher inherent risk Higher inherent risk',
	ALRAHigherRiskCode: 'H H',
	ALRALowerRisk: 'Lower risk Lower risk',
	ALRALowerInherentRisk: 'Lower inherent risk Lower inherent risk',
	ALRALowerRiskCode: 'L L',
	ALRALimitedRiskAccount: 'The account has been identified as limited risk The account has been identified as limited risk',
	ALRAInsignificantRiskAccount: 'The account has been identified as insignificant The account has been identified as insignificant',
	ALRADesignations: 'Designations Designations',
	ALRABalances: 'Balances Balances',
	ALRADesignation: 'Designation Designation',
	ALRAAnalysisPeriod: 'Analysis date Analysis date',
	ALRAxTE: 'xTE xTE',
	ALRAPercentageChangeFrom: '% change from % change from',
	ALRAPriorPeriodDesignation: 'Prior period designation Prior period designation',
	ALRAPriorPeriodEstimate: 'Prior period estimate Prior period estimate',
	ALRAComparativePeriod1: 'Comparative date 1 Comparative date 1',
	ALRAComparativePeriod2: 'Comparative date 2 Comparative date 2',
	ALRASelectUpToThreeOptions: 'Select up to 3 optionsSelect up to 3 options',
	ALRASelectUpToTwoOptions: 'Select up to 2 options Select up to 2 options',
	ALRAValidations: 'Validations Validations',
	ALRANoSignOffs: 'No sign-offs No sign-offs',
	ALRAIncompleteInherentRisk: 'Incomplete inherent risk Incomplete inherent risk',
	ALRARelatedDocuments: 'Related Documents Related Documents',
	ALRAGreaterExtent: 'Greater extent Greater extent',
	ALRALesserExtent: 'Lesser extent Lesser extent',
	ALRARiskRelatedToAssertion: 'Risk associated Risk associated',
	ALRAContributesToHigherInherentRisk: 'Risk associated and contributes to the higher inherent risk Risk associated and contributes to the higher inherent risk',

	// Assess inherent risk
	HigherRiskAssertionWithoutRisksThatContributesToTheHigherInherentRisk: "Assertion is identified as higher inherent risk without at least one risk that contributes to the higher inherent risk. Associate risk(s) and identify which risk(s) contribute to the assertion's higher inherent risk.Assertion is identified as higher inherent risk without at least one risk that contributes to the higher inherent risk. Associate risk(s) and identify which risk(s) contribute to the assertion's higher inherent risk.",

	//MEST - Multi-entity account Execution Type selection listing
	account: 'Account Account',
	taskByEntity: 'Task by entity Task by entity',
	bodyInformation: 'You must click Import Content below in order to save any changes. You must click Import Content below in order to save any changes.',

	/*user search component*/
	seachInputRequired: 'Search input required Search input required',
	nameOrEmail: 'Name or email Name or email',
	emailForExternal: 'Email Email',
	noRecord: 'No results found No results found',
	userSearchPlaceholder: 'Enter name or email and press enter to see results. Enter name or email and press enter to see results.',
	userSearchPlaceholderForExternal: 'Enter email and press enter to see results. Enter email and press enter to see results.',
	clearAllValues: 'Clear all values Clear all values',
	inValidEmail: 'Please enter valid email Please enter valid email',

	//reactive frame
	maxTabsLocked: 'Maximum allowed tabs reached. Unpin and close one of the tabs to open a new one. Maximum allowed tabs reached. Unpin and close one of the tabs to open a new one.',
	openInNewTab: 'Open in new tab Open in new tab',
	unPinTab: 'Unpin tab Unpin tab',
	pinTab: 'Pin tab Pin tab',
	closeDrawer: 'Close Drawer Close Drawer',
	minimize: 'Minimize Minimize',

	// Display Account Balances
	currentPeriodAccountBalance: 'Current period account balance:',
	priorPeriodAccountBalance: 'Prior period account balance:',

	ALRANoResults: 'No results found. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	associatedRomsCount: 'Total number of associated Risks: {0}',
	alraMessage: "Account designation response not aligned to designation in 'Edit account & disclosure'",
	estimateCategoryResponseNotAlignedToDesignation: "Estimate category response not aligned to designation in 'Edit estimate' Estimate category response not aligned to designation in 'Edit estimate'",

	// Analytics Overview
	analyticsOverviewTitle: 'Analytics Overview Analytics Overview',
	noSignificantAccountRecords: 'No significant accounts have been created. No significant accounts have been created.',
	openAnalyticDocumentation: 'Open analytic documentation Open analytic documentation',
	openLimitedRiskAccountDocumentation: 'Open limited risk account documentation Open limited risk account documentation',
	associatedSCOTs: 'Associated SCOTSs: Associated SCOTSs: ',
	analysisPeriodLabel: 'Analysis date {0} Analysis date {0}',
	analysisPeriodChangeLabel: '% change from {0} % change from {0}',
	xTELabel: 'xTE xTE',
	risksLabel: 'Risks Risks',
	comparativePeriod1: 'Comparative date 1 {0} Comparative date 1 {0}',
	analysisPeriodTitle: 'Analysis date Analysis date',
	analysisPeriodChangeTitle: '% change from % change from',
	comparativePeriodTitle: 'Comparative date 1 Comparative date 1',
	noAccountAvailable: 'No account available No account available',

	// Estimates
	titleEstimateCategory: 'Estimate category Estimate category',
	titleRisks: 'Risks Risks',

	voiceNoteNotAvailable: 'RA RU Voice note and screen recording is not available in drawer view. Switch to full screen view to use these features.',

	financialStatementType: {
		[1]: {
			label: 'Asset Asset'
		},
		[2]: {
			label: 'Current Asset Current Asset'
		},
		[3]: {
			label: 'Non-Current Asset Non-Current Asset'
		},
		[4]: {
			label: 'Liability Liability'
		},
		[5]: {
			label: 'Current Liability Current Liability'
		},
		[6]: {
			label: 'Non-Current Liability Non-Current Liability'
		},
		[7]: {
			label: 'Equity Equity'
		},
		[8]: {
			label: 'Revenue Revenue'
		},
		[9]: {
			label: 'Expense Expense'
		},
		[10]: {
			label: 'Non-Operating Income/(Expense) Non-Operating Income/(Expense)'
		},
		[11]: {
			label: 'Other Comprehensive Income (OCI) Other Comprehensive Income (OCI)'
		},
		[12]: {
			label: 'Other Other'
		},
		[13]: {
			label: 'Account Type Account Type'
		},
		[14]: {
			label: 'Account Sub-Type Account Sub-Type'
		},
		[15]: {
			label: 'Account Class Account Class'
		},
		[16]: {
			label: 'Account Sub-Class Account Sub-Class'
		},
		[17]: {
			label: 'Net (Income) / Expense Net (Income) / Expense'
		}
	},
	accountTypes: {
		[1]: {
			label: 'Significant account Significant account'
		},
		[2]: {
			label: 'Limited risk account Limited risk account'
		},
		[3]: {
			label: 'Insignificant account Insignificant account'
		},
		[4]: {
			label: 'Other account Other account'
		},
		[5]: {
			label: 'Significant Disclosure Significant Disclosure'
		}
	},
	noClientDataAvailable: 'No data available No data available',

	analysisPeriod: 'Analysis date Analysis date',
	comparativePeriod: 'Comparative date Comparative date',
	perchangeLabel: '% change % change',

	entityCreateAccountLabel: 'Create account & disclosure Create account & disclosure',
	insignificantAccount: 'Insignificant account Insignificant account',
	noAccountRecords: 'No accounts have been identified No accounts have been identified',
	noAccountsForEntity: 'No accounts or disclosures are mapped to the selected entity. No accounts or disclosures are mapped to the selected entity.',
	noLimitedRiskAccountRecords: 'No Limited Risk Accounts available. No Limited Risk Accounts available.',
	createAccount: 'Create account Create account',
	createDocument: 'Create document Create document',
	noAccountResults: 'No accounts identified. No accounts identified.',
	createGroupInvolvementDocument: 'Create involvement form Create involvement form',
	chooseVersionsToCompare: 'Choose version to compare Choose version to compare',
	noTrackChangesOption: 'No track changes versions available No track changes versions available',
	trackChangesDefaultMessage: "Select a version from the 'Choose version to compare' drop down to proceed. Select a version from the 'Choose version to compare' drop down to proceed.",
	whichRiskContributeToHigherRisk: 'Which risk(s) contribute to the higher risk assertion? Which risk(s) contribute to the higher risk assertion?',

	//multi-entity Entity List
	createMultiEntity: 'New entity New entity',
	editMultiEntity: 'Edit entity Edit entity',
	noEntitiesAvailableCreateNewLink: 'Click here Click here',
	noEntitiesAvailable: 'No entities have been created. {noEntitiesAvailableCreateNewLink} to get startedNo entities have been created. {noEntitiesAvailableCreateNewLink} to get started',
	noEntitiesFound: 'No results found No results found',
	createMultiEntityProfile: 'Create entity profile Create entity profile',
	//multi-entity table
	multiEntityCode: 'Entity standard index Entity standard index',
	multiEntityName: 'Entity name Entity name',
	multiEntityGroup: 'Entity group Entity group',
	multiEntityActions: 'Actions Actions',
	relateMultiEntityUngrouped: 'Ungrouped Ungrouped',
	selectAll: 'Select all Select all',
	entitiesSelected: 'entities selected entities selected',
	entitySelected: 'entity selected entity selected',
	meNoEntitiesAvailable: 'No entities available No entities available',
	meSwitchEntities: 'Switch entities Switch entities',
	meSelectEntity: 'Select entity Select entity',
	allEntities: 'All entities All entities',
	noEntitiesIdentified: 'No entities identified No entities identified',
	contentDeliveryInProcessMessage: 'Content delivery in progress.  It may take up to ten minutes for the content to be delivered.Content delivery in progress.  It may take up to ten minutes for the content to be delivered.',
	importContent: 'Import content Import content',
	profileSubmit: 'Profile submit Profile submit',
	importPSPs: 'Import PSPs Import PSPs',
	contentUpdateInsufficienRolesLabel: 'Insufficient roles to update content. Work with an engagement administrator to get sufficient rights. Insufficient roles to update content. Work with an engagement administrator to get sufficient rights.',
	// MEST Switcher
	meEntitySwitcher: 'Entity switcher Entity switcher',

	//Control Attributes
	controlAttributes: 'Control attributes control attributes',
	noControlAttributes: 'No control available No control available',
	createControlAttributes: 'No control attributes available.<br />Click {clickHere} to create a new control attribute. <br />No control attributes available.<br />Click {clickHere} to create a new control attribute.',
	createNewControlAttribute: 'New attribute new attribute',
	editControlAttribute: 'Edit attribute edit attribute',
	createControlAtttributeInstructions: 'Enter attribute details below and select <b>\'Save and close\'</b> to finish. To create another attribute, select <b>\'Save and create another\'.</b> Attributes will be sorted based on attribute index. Enter attribute details below and select <b>\'Save and close\'</b> to finish. To create another attribute, select <b>\'Save and create another\'.</b> Attributes will be sorted based on attribute index.',
	editControlAttributeInstructions: 'Edit the attribute details below and select <b>\'Save\'</b> to finish.  Attributes will be sorted based on attribute index. Edit the attribute details below and select <b>\'Save\'</b> to finish.  Attributes will be sorted based on attribute index.',
	editAttributeButtonLabel: 'Edit attribute Edit attribute',
	deleteAttributeButtonLabel: 'Delete attribute Delete attribute',
	deleteControlAttributeInstructions: 'Are you sure that you want to delete the selected attribute? This action cannot be undone. Are you sure that you want to delete the selected attribute? This action cannot be undone.',
	// Control Attributes Form
	requiredAttributeIndexLabel: 'Attribute index (required) Attribute index (required)',
	requiredAttributeDescriptionLabel: 'Attribute description (required) Attribute description (required)',
	errorMessageAttributeIndexRequired: 'Required Required',
	errorMessageAttributeDescriptionRequired: 'Required Required',
	errorMessageAttributeDescriptionMaxLength:
		'Response contains {#} characters which exceeds the maximum of {##} characters.  Adjust the description by reducing text or formatting and try again.  If the issue persists, contact the Help Desk. Response contains {#} characters which exceeds the maximum of {##} characters.  Adjust the description by reducing text or formatting and try again.  If the issue persists, contact the Help Desk.',
	errorMessageAttributeTestingTypesRequired: 'Required Required',
	proceduresLabel: 'Procedures to be performed Procedures to be performed',
	modalRequiredProceduresLabel: 'Procedures to be performed (required) Procedures to be performed (required)',
	attributeTestingTypesLabel: {
		inquiry: 'Inquiry Inquiry',
		observation: 'Observation Observation',
		inspection: 'Inspection Inspection',
		reperformance: 'Reperformance/recalculation Reperformance/recalculation'
	},
	//Error Boundary
	errorBoundaryMessage: 'An error has occurred. Please refresh the page and try again. If the issue persists, contact the Help Desk.',
	sectionName: 'Section name',
	maxLength: 'Text cannot exceed {number} characters.',
	required: 'RU Required.',
	yearAgo: 'year ago',
	yearsAgo: 'years ago',
	monthAgo: 'month ago',
	monthsAgo: 'months ago',
	weekAgo: 'week ago',
	weeksAgo: 'weeks ago',
	daysAgo: 'days ago',
	dayAgo: 'day ago',
	today: 'Today',
	yesterday: 'Yesterday',

	associatedToInherentRiskFactor: 'Associated to Inherent risk factor',

	createMissingDocument: 'Create missing document',
	createMissingDocumentBody: "Click 'Confirm' to create the document for the related items currently missing a document.",
	documentCreationSuccessMsg: 'Document creation in progress. Refresh the page for updates.',

	noRisksRelatedToAssertion: 'No risk related to this account assertion.',

	noAssertionsRelatedToAccount: 'No assertions related to this account',

	sharing: 'Sharing',

	risksUnrelatedToAccountAssertion: 'Risks unrelated to account assertion',
	cantCompleteTask: 'Documents associated to the related task are missing sign-offs. Open the task, complete the missing documents, and then try Mark Complete again.',
	cantCompleteTasksTitle: 'Unable to mark complete',
	ok: 'OK',
	documentsEngagementShareLabel: 'Select the document within the engagement to share with',
	documentsEngagementCopyLabel: 'Select the document within the engagement to copy',
	lastModifiedon: 'Last modified on',
	newAccountAndDisclosure: 'New account & disclosure',
	newAccountORDisclosure: 'New account or disclosure',

	externalDocuments: 'External Documents',
	noExternalDocumentsAvailable: 'No external documents available',
	addExternalDocuments: 'Add external documents',
	relateExternalDocuments: 'Relate external documents',

	helixNotMappedToAccount: 'EY Helix data is not mapped to this account. Please update mapping and re-import data to proceed.',
	trackChangesNotAvailableForSpecialBodyDisplayMessage: 'Tracked changes functionality is not available for the response(s) below.',
	noDocumentRelatedObjectsApplicable: 'Objects are not required to be associated to this guided workflow form',
	helixViewerLoader: 'Loading Helix Viewer...',
	trackChangesViewDefaultMessage: "Certain responses do not have track change functionality. This will be indicated with the following message in the underlying activity details: 'Tracked changes functionality is not available for the response(s) below.'  Accordingly, lack of notification of changes below is not indicative of whether changes have been made.",

	//Relate task modal
	relateTasksTitle: 'Relate tasks',
	taskLocationLabel: 'Task location',
	relateTaskInstructionalText: 'Add or remove tasks that the document should be related to. If the document is evidence, removing it from the last task will move it to temporary files.',
	noResultFound: 'No results found.',
	relatedTaskCounter: '{0} task',
	relatedTasksCounter: '{0} tasks',
	thisEngagement: 'This engagement',
	onlyShowRelatedTasks: 'Only show related tasks',
	relateTaskName: 'Task name',
	relateTaskType: 'Type',

	/*Relate Entities*/
	relateEntitiesTitle: 'Relate entities Relate entities',
	relateEntitiesSearchPlaceholder: 'Enter to search by name Enter to search by name',
	relateEntitiesName: 'Entity name Entity name',
	relateEntitiesIndex: 'Entity standard index Entity standard index',
	relatedEntitiesCounter: '{0} entities {0} entities',
	relatedEntityCounter: '{0} entities {0} entities',
	onlyShowRelatedEntities: 'Only show related entities Only show related entities',
	entity: 'Entity Entity',

	step01: 'Step 01',
	step02: 'Step 02',
	shareActivityStep1Description: 'Select engagement and document',
	shareActivityStep2Description: 'Choose which document responses should replace the other',
	documentsShareLabel: 'Share response from the below selected document to the rest of the documents.',
	selectedActivity: 'Selected activity',
	sharedHoverLabel: 'This activity is already shared with other activites. Sharing this activity will sync the responses from this activity to all the shared activity',
	noAssertionsRelatedLabel: 'No assertions related.',


	bulkMarkCompleteInstructionalText: 'Below are all the tasks related to this form. In order to mark complete the selected tasks, all documents must be signed-off by at least one preparer and one reviewer.Below are all the tasks related to this form. In order to mark complete the selected tasks, all documents must be signed-off by at least one preparer and one reviewer.',
	bulkMarkCompleteEngagementColumn: 'EngagementEngagement',
	bulkMarkCompleteDocumentsMissingSignOffs: 'Missing sign-offs. Click {bulkMarkCompleteMissingSignOffsClickableText} to sign-off.Missing sign-offs. Click {bulkMarkCompleteMissingSignOffsClickableText} to sign-off.',
	bulkMarkCompleteMissingSignOffsClickableText: 'herehere',
	bulkMarkCompleteNoAccessToEngagement: 'You do not have access to the engagement this task is inYou do not have access to the engagement this task is in',
	bulkMarkCompleteInProgressMessage: 'Process is in progress. It may take up to ten minutes. Please refresh for updatesProcess is in progress. It may take up to ten minutes. Please refresh for updates',
	bulkMarkCompleteRelatedDocumentsModalTitle: 'Document sign-offsDocument sign-offs',
	bulkMarkCompleteFilterUnreadyTasks: 'Show only tasks with missing document sign-offs.Show only tasks with missing document sign-offs.',
	bulkMarkCompleteNotAllowedModalTitle: 'Unable to mark completeUnable to mark complete',
	bulkMarkCompleteNotAllowedModalDescription: 'You need to select at least one task to mark completeYou need to select at least one task to mark complete',
	bulkMarkCompleteRelatedDocumentsModalDescription: 'In order to mark complete the selected task, all documents must be signed off by at least one preparer and one reviewer.In order to mark complete the selected task, all documents must be signed off by at least one preparer and one reviewer.',
	bulkMarkCompleteRelatedDocumentsModalRefreshSignoffs: 'Refresh sign-offs and notesRefresh sign-offs and notes',
	selectedTaskCounter: '({0}) selected task() selected task',
	selectedTasksCounter: '({0}) selected tasks() selected tasks',


	markCompleteNotAllowedModalDescription: 'Documents associated to the related task are missing sign-offs. Open the task, complete the missing documents, and then try Mark Complete again',
	markCompleteInstructionalText: 'All documents must be signed-off by atleast one preparer and one reviewer to mark the activity as complete',

	// Adobe Analytics
	aaCookieConsentTitle: 'Welcome to',
	aaCookieContentPrompt: 'Do you want to allow cookies?',
	aaCookieConsentExplanation: "<p>In addition to cookies that are strictly necessary to operate this website, we use the following types of cookies to improve your experience and our services: <strong>Functional cookies</strong> to enhance your experience (e.g. remember settings), <strong>Performance cookies</strong> to measure the website\'s performance and improve your experience, <strong>Advertising/Targeting cookies</strong>, which are set by third parties with whom we execute advertising campaigns and allow us to provide you with advertisements relevant to you.</p><p>Review our <a target='_blank' href='https://www.ey.com/en_us/cookie-policy'>cookie policy</a> for more information.</p>",
	aaCookieConsentExplanationWithDoNotTrack: "<p>In addition to cookies that are strictly necessary to operate this website, we use the following types of cookies to improve your experience and our services: <strong>Functional cookies</strong> to enhance your experience (e.g. remember settings), <strong>Performance cookies</strong> to measure the website\'s performance and improve your experience, <strong>Advertising/Targeting cookies</strong>, which are set by third parties with whom we execute advertising campaigns and allow us to provide you with advertisements relevant to you.</p><p>We have detected that you have enabled the Do Not Track setting in your browser; as a result, Advertising/Targeting cookies are automatically disabled.</p><p>Review our <a target='_blank' href='https://www.ey.com/en_us/cookie-policy'>cookie policy</a> for more information.</p>",
	aaCookieConsentDeclineOptionalAction: 'I decline optional cookies',
	aaCookieConsentAcceptAllAction: 'I accept all cookies',
	aaCookieConsentCustomizeAction: 'Customize cookies',
	aaCookieConsentCustomizeURL: 'https://www.ey.com/en_us/cookie-settings',

	// Cookie Settings
	cookieSettings: {
		title: 'Cookie Settings',
		explanation: 'Please provide your consent for cookie usage on ey.com and the My EY platform. Select one or more of the cookie types listed below, and then save your selection(s). Refer to the listing below for details on the types of cookies and their purpose.',
		emptyCookieListNotice: 'Cookies from this category are not used in this app',
		nameTableHeader: 'Name of cookie',
		providerTableHeader: 'Cookie provider',
		purposeTableHeader: 'Purpose of cookie',
		typeTableHeader: 'Type of cookie',
		durationTableHeader: 'Duration of cookie',
		formSubmit: 'Save my selection',
		requiredCookieListTitle: 'Required Cookies',
		functionalCookieListTitle: 'Functional Cookies',
		functionalCookieAcceptance: 'I accept the functional cookies below',
		functionalCookieExplanation: 'Functionality cookies, which allow us to enhance your experience (for example by remembering any settings you may have selected).',
		performanceCookieListTitle: 'Performance Cookies',
		performanceCookieAcceptance: 'I accept the performance cookies below',
		performanceCookieExplanation: 'Performance cookies, which help us measure the website’s performance and improve your experience. In using performance cookies we do not store any personal data, and only use the information collected through these cookies in aggregated and anonymised form.',
		advertisingCookieListTitle: 'Targeting Cookies',
		advertisingCookieAcceptance: 'I accept the advertising/targeting cookies below',
		advertisingCookieExplanation: 'Advertising/targeting cookies, which we use to track user activity and sessions so that we can deliver a more personalized service, and (in the case of advertising cookies) which are set by the third parties with whom we execute advertising campaigns and allow us to provide advertisements relevant to you.',
		doNotTrackNotice: 'We have detected that you have enabled the Do Not Track setting in your browser; as a result, advertising/targeting cookies are automatically disabled.',
	},
	accountFormsMissing: 'Account forms missing for {0} account(s)Account forms missing for {0} account(s)',
	createAccountForms: 'Create account form(s)Create account form(s)',
	createAccountFormsDescription: "Click 'Confirm' to create the document for the related items currently missing a document.Click 'Confirm' to create the document for the related items currently missing a document.",
	createMissingDocuments: 'Related accounts currently missing document(s)Related accounts currently missing document(s)',
	accountDocumentsCreated: 'Content delivery in progress.  It may take up to ten minutes for the content to be delivered.Content delivery in progress.  It may take up to ten minutes for the content to be delivered.',

	evidenceMissingPICSignoffs: 'Evidence missing PIC sign-off(s)Evidence missing PIC sign-off(s)',
	evidenceMissingEQRSignoffs: 'Evidence missing EQR sign-off(s)Evidence missing EQR sign-off(s)',
	evidenceMissingPICEQRSignoffs: 'Evidence missing PIC and/or EQR sign-off(s)Evidence missing PIC and/or EQR sign-off(s)',
	evidenceMissingPICSignoffRequirements: 'Evidence missing PIC sign-off requirement(s)Evidence missing PIC sign-off requirement(s)',
	evidenceMissingEQRSignoffRequirements: 'Evidence missing EQR sign-off requirement(s)Evidence missing EQR sign-off requirement(s)',
	evidenceMissingPICEQRSignoffRequirements: 'Evidence missing PIC and/or EQR sign-off requirement(s)Evidence missing PIC and/or EQR sign-off requirement(s)',
	evidenceMissingSignoffs: 'Evidence missing sign-off(s)Evidence missing sign-off(s)',

	// Bulk task relate
	bulkTaskRelateFailureMessage: 'Some of the documents selected were not able to be associated to the selected task(s).Some of the documents selected were not able to be associated to the selected task(s).',
	/*endoflabels*/
	evidenceMissingPreparerOrReviwerSignoffs: 'Document upload - Missing Preparer or Reviewer Sign-offsDocument upload - Missing Preparer or Reviewer Sign-offs',

	manageITProcess: 'Manage IT process Manage IT process',
	manageITRisk: 'Manage IT risk Manage IT risk',
	manageITControl: 'Manage IT control Manage IT control',
	manageITSP: 'Manage ITSP Manage ITSP',
	manageITApp: 'Manage IT application Manage IT application',
	manageSCOT: 'Manage SCOT Manage SCOT',

	addAresCustomDescription: 'Select the content type to be added to this guided workflow form, input details, and click save. Select the content type to be added to this guided workflow form, input details, and click save.',

	documentImportSuccess: '{0} has been successfully created. It may take up to ten minutes for the content to be delivered.{0} has been successfully created. It may take up to ten minutes for the content to be delivered.',
	documentImportFailure: 'Document creation failed. Please refresh or try again after some time. If the issue persists, contact the Help desk.Document creation failed. Please refresh or try again after some time. If the issue persists, contact the Help desk.',
	formNotAvailable: 'No matching Canvas Form found. No matching Canvas Form found.',
	selectTask: 'Select Task to relate to guidance Select Task to relate to guidance',
	canvas: 'CanvasCanvas',
	selectEngagement: 'Select engagement Select engagement',

	//Modal Manage sub-scope
	manageSubScopeTitle: 'RU Manage sub-scope',
	manageSubScopeDescription: 'RU Create new sub-scopes or edit or delete existing sub-scopes below.',
	addSubScope: 'RU Add a sub-scope',
	subScopeName: 'RU Sub-scope name',
	knowledgeScope: 'RU Knowledge scope',
	subScopeAlreadyExist: 'RU Sub-scope name already exist',
	subScopes: 'RU Sub-scopes',
	notAvailableSubScopes: 'RU There are no sub-scopes available.',
	SubScopeNameValidation: 'RU Sub scope name length exceeds more than 255 characters.',

	//Add New Flow Chart Steps
	flowChartNewSteps: {
		newStepTitle: "New step New step",
		placeholderText_1: "Enter step details below and select Enter step details below and select",
		placeholderText_2: " 'Save and close' 'Save and close'",
		placeholderText_3: " to finish. To create another step, select  to finish. To create another step, select",
		placeholderText_4: " 'Save and create another'.  'Save and create another'.",
		columnLabel: "Column (required) Column (required)",
		counterOf: "of of",
		counterChar: "characters characters",
		stepNameLabel: "Step name (required) Step name (required)",
		errorMsgStepNameRequired: "Step name is required Step name is required",
		stepDescLabel: "Step description (required) Step description (required)",
		stepDescPlaceholder: "Enter step description Enter step description",
		errorMsgStepDescRequired: "Step description is required Step description is required",
		required: 'Required',
		errorMsgStepDescExceedMaxLength: "Step description exceeds the maximum allowed characters Step description exceeds the maximum allowed characters",
		buttonCancel: "Cancel Cancel",
		buttonSaveAndClose: "Save and close Save and close",
		buttonSaveAndCreateAnother: "Save and create another Save and create another",
		errorMsgColumnRequired: "Column is required Column is required",
		headerNameForWCGW: "WCGW name WCGW name",
		headerNameForControl: "Control name Control name",
		headerNameForITApp: "IT application name IT application name",
		headerNameForServiceOrganisation: "Service organization name Service organization name",
		relateLabelForWCGW: "Relate WCGWs Relate WCGWs",
		relateLabelForControl: "Relate controls Relate controls",
		relateLabelForITApp: "Relate IT applications Relate IT applications",
		relateLabelForServiceOrganisation: "Relate service organizations Relate service organizations",
		designEffectiveness: "Design effectiveness Design effectiveness",
		testing: "Testing Testing",
		lowerRisk: "Lower risk Lower risk",
		wcgwNoRowsMessage: 'No WCGWs have been related. Click {0} to get started No WCGWs have been related Click {0} to get started',
		controlNoRowsMessage: 'No controls have been related. Click {0} to get started No controls have been related Click {0} to get started',
		itAppNoRowsMessage: 'No IT applications have been related. Click {0} to get started No IT applications have been related. Click {0} to get started',
		serviceOrganisationNoRowsMessage: 'No relate service organizations have been related. Click {0} to get started No service organizations have been related. Click {0} to get started',
		wgcwTabLabel: "WCGWs WCGWs",
		controlsTabLabel: "Controls Controls",
		itAppsTabLabel: "IT applications IT applications",
		serviceOrganisationTabLabel: "Service organizations Service organizations",
		connectionSuccessMessage: "Connection created successfully. Connection created successfully.",
		connectionFailedMessage: "Couldnt establish a connection. Please try again. Couldnt establish a connection. Please try again.",
		selfConnectFailMessage: "Source and Target cannot be the same. Source and Target cannot be the same.",
		connectionDuplicateMessage: "Connection already exists. Connection already exists.",
		connectionDeleteSuccessMessage: "Connection deleted successfully. Connection deleted successfully.",
		connectionDeleteFailMessage: "Couldnt delete the connection. Please try again. Couldnt delete the connection. Please try again.",
		editStepFailMessage: "Couldn't edit the step. Please try again. Couldn't edit the step. Please try again.",
		flowchartStepGetByIdFailMessage: "Invalid step, please refresh and try again. Invalid step, please refresh and try again.",
		flowchartStepGetByIdFailureMessage : "This flowchart step is no longer available. Refresh the page and try again. Contact the Help Desk if the error persists. This flowchart step is no longer available. Refresh the page and try again. Contact the Help Desk if the error persists.",
		newStepFailureMessage: "Couldn't create new step. Please try again. Couldn't create new step. Please try again.",
		deleteConnector: 'Delete connector Delete connector',
		edgeConnectorOptions: 'Connector options Connector options',
		edgeStartPoint: 'Start Point Start Point',
		edgeEndPoint: 'End Point End Point'
	},

	flowChartWCGW: {
		wcgwsCounter: "{0} WCGWs {0} WCGWs",
		wcgwCounter: " {0} WCGW {0} WCGW",
		headerName: "Relate WCGWs Relate WCGWs",
		showOnlyRelatedText: "Show only related Show only related"
	},

	flowchartITAPPSO: {
		showOnlyRelatedText: "Show only related Show only related",
		noResultsFound: "No results found No results found"
	},

	flowChartITApplication: {
		itApplicationsCounter: "{0} IT applications {0} IT applications",
		itApplicationCounter: "{0} IT application {0} IT application",
		headerName: "Relate IT applications Relate IT applications",
		columnName: "IT application name IT application name",
		noDataFound: "No IT applications found No IT applications found"
	},

	flowChartITSO: {
		itSOsCounter: "{0} Service organizations {0} Service organizations",
		itSOCounter: "{0} Service organization {0} Service organization",
		headerName: "Relate service organizations Relate service organizations",
		columnName: "Service organization name Service organization name",
		noDataFound: "No service organizations found No service organizations found"
	},

	relateSCOT: {
		header: "Relate SCOTs Relate SCOTs",
		estimate: "Estimate Estimate",
		scotsCounter: "{0} SCOTs {0} SCOTs",
		scotCounter: "{0} SCOT {0} SCOT",
		headerName: "SCOT name SCOT name",
		showOnlyRelated: "Show only related Show only related",
		noResultsFound: "No results found No results found",
		noScotCreated: "No SCOTs created in the engagement No SCOTs created in the engagement"
	},

	relateEstimate: {
		scot: "SCOTs SCOTs",
		strategy: "SCOT strategy SCOT strategy",
		type: "Type Type",
		noSCOT: "Each estimate must be related to at least one SCOT. Click Each estimate must be related to at least one SCOT. Click ",
		noSCOTmsg: " to get started to get started",
		estimate: "Estimate Estimate",
		routine: "Routine Routine",
		nonRoutine: "Non Routine Non Routine",
		notSelected: "Not selected Not selected",
		relateSCOTs: "Relate SCOTs Relate SCOTs",
		remove: "Remove Remove",
		noEstimate: "No estimate available No estimate available",
	},

	//Delete Flow Chart Steps
	flowChartStepsDelete: {
		deletestep: "Delete step Delete step",
		deleteStepModalMessage: "Are you sure you want to delete this step? All WCGWs, controls, IT applications, service organisations and evidence related to the deleted step will be unrelated. Are you sure you want to delete this step? All WCGWs, controls, IT applications, service organisations and evidence related to the deleted step will be unrelated.",
		cannotBeUndone: "New or renewed customer contracts New or renewed customer contracts",
		deleteStepFailMessage: "Failed to delete the step. Please try again Failed to delete the step. Please try again",
		deleteDraftStepErrorMessage: "The step created in draft was not deleted. To delete this step, please select the step and action the delete again. The step created in draft was not deleted. To delete this step, please select the step and action the delete again.",
	},

	notEntered: 'Not entered Not entered',
	estimateCategory: 'Estimate category Estimate category',
	noResultsFoundWithPeriod: 'No results found No results found',
	noEstimateAvailable: 'No estimate available No estimate available',
	noRelatedObject: 'No related object. No related object.',
	relateAnObject: 'Relate an object Relate an object',
	copyrightMessage: 'Copyright © <year> all rights reservedCopyright © <year> all rights reserved',
	leadsheet: 'Leadsheet Leadsheet',
	controlName: 'Control name Control name',
	noControlAvailable: 'No control available No control available',
	independenceError: 'All incomplete responses must be completed prior to submitting independence All incomplete responses must be completed prior to submitting independence.. All incomplete responses must be completed prior to submitting independence All incomplete responses must be completed prior to submitting independence..',
	riskTypeNotAssociated: 'Newly added risk does not match the allowed risk type(s) and therefore does not appear below. Add another risk of the allowed type or select from the below list Newly added risk does not match the allowed risk type(s) and therefore does not appear below. Add another risk of the allowed type or select from the below list',
	accountsAndRelatedEstimates: 'Accounts and related estimates Accounts and related estimates',
	noEstimatesAssociated: 'No estimates associated No estimates associated',
	noAssertionsAvailable: 'No assertions available No assertions available',
	noAccountsOrDisclosuresAvailable: 'No accounts or disclosures available No accounts or disclosures available',

	relateEstimateToRisk: {
		riskType: "Risk type Risk type",
		risk: "Risk Risk",
		hasestimate: "Has estimate? Has estimate?",
		accounts: "Accounts Accounts",
		isItRelevant: "Is it relevant? Is it relevant?",
		assertions: "Assertions Assertions",
		invalidRiskParentRiskErrMsg: "Record not found. Please refresh the page to continue. Record not found. Please refresh the page to continue.",
		noEstimate: "No estimate available No estimate available",
		invalidRelateRiskOrEstimateRelationErrMsg: "The object has already been related. Please refresh the page to continue. The object has already been related. Please refresh the page to continue.",
		invalidUnRelateRiskOrEstimateRelationErrMsg: "The object has already been unrelated. Please refresh the page to continue. The object has already been unrelated. Please refresh the page to continue."
	},

	savingChanges: 'Saving changes Saving changes',
	showEstimateAccountsWithoutEstimates: 'Show estimate accounts without estimates Show estimate accounts without estimates',
	showEstimateSCOTsWithoutEstimates: 'Show estimate SCOTs without estimates Show estimate SCOTs without estimates',
	manageSCOTs: 'Manage SCOTs Manage SCOTs',
	sCOTsAndRelatedEstimates: 'SCOTs and related estimates SCOTs and related estimates',
	relateEstimateToRiskNoDataMessage: 'No records available, please relate at least one account and assertion with a risk associated if applicable No records available, please relate at least one account and assertion with a risk associated if applicable',
	maps: 'MapsMaps',
	financialStatements: 'Financial StatementsFinancial Statements',
	serviceGatewayAutomation: 'Service Gateway & AutomationService Gateway & Automation',
	priorPeriodCategory: 'Prior period category Prior period category',
	relatedAccountWithColon: 'Related accounts Related accounts: ',
	noRelatedAccount: 'No related accounts No related accounts',
	noRetionaleAvailable: 'No rationale available No rationale available',
	leftNavIconApprovals: 'Approvals Approvals',
	editDuplicateSectionHeader: "Edit the details for the Section and click 'Save'. Edit the details for the Section and click 'Save'.",

	relatedEvidences: 'Relate evidence Relate evidence',
	relatedEvidencesInstruction: 'Relate an evidence from this engagement Relate an evidence from this engagement.',
	relatedTemporaryFilesInstruction: 'Relate a temporary document from this engagement. Relate a temporary document from this engagement.',
	noDataLabel: 'No data found No data found',
	editDuplicateSection: 'Edit section Edit section',
	showOnlyRelated: 'Show only related Show only related',
	aiChatbot: 'EYQ Assurance KnowledgeEYQ Assurance Knowledge',
	StEntityNoRecords:'No accounts or disclosures are mapped to the selected entity.No accounts or disclosures are mapped to the selected entity.',
	versionLabel: 'VersionVersion',
	relatedEstimates:'Related estimates Related estimates',
	viewEvidenceRelatedToBody: 'View evidence related to the bodyView evidence related to the body',
	selectHeaderFromRail: 'Select a header from left navigation pane to proceedSelect a header from left navigation pane to proceed'
};

export const groupStructure = {
	createComponent: 'New component',
	deleteComponent: 'Delete component',
	manageComponents: 'Manage components',
	emptyComponents: 'No components have been created. Create a {newComponent} to get started.',
	scope: 'Scope',
	role: 'Role',
	pointOfContact: 'Point of contact',
	linkRequest: 'Link request',
	instructions: 'Instructions',
	instructionsSent: 'Instructions Sent',
	status: 'Статус',
	createComponentInstructionalText:
		"Enter component details below and select <b>'Save and close'</b> to finish. To create another component, select <b>'Save and create another'.<br/>",
	componentName: 'Component name',
	region: 'Region',
	notUsingCanvas: 'Not using EY Canvas',
	referenceOnly: 'Reference only',
	saveAndCreateAnother: 'Save and create another',
	dueDate: 'Срок выполнения',
	components: 'Components',
	allocation: 'Allocation',
	documents: 'RU - Документы',
	discussions: 'Discussions',
	EDAP: 'EDAPs',
	siteVisits: 'Site visits',
	reviewWorkComponent: 'Review work performed',
	other: 'Other',
	significantUpdates: 'Significant updates',
	executionComplete: 'Execution complete',
	gaRoleTypesLabel: [{
		id: 1,
		displayName: 'Primary'
	},
	{
		id: 2,
		displayName: 'Regional'
	},
	{
		id: 3,
		displayName: 'Component'
	}
	],
	gaLinkStatusLabel: [{
		id: GALinkStatus.NotSent,
		displayName: 'Send'
	},
	{
		id: GALinkStatus.Sent,
		displayName: 'Sent/Not accepted'
	},
	{
		id: GALinkStatus.ComponentNotUsingCanvas,
		displayName: 'Not using EY Canvas'
	},
	{
		id: GALinkStatus.ReferenceOnly,
		displayName: 'Reference only'
	},
	{
		id: GALinkStatus.Accepted,
		displayName: 'Accepted'
	},
	{
		id: GALinkStatus.Rejected,
		displayName: 'Rejected'
	},
	{
		id: GALinkStatus.Unlinked,
		displayName: 'Unlinked'
	},
	{
		id: GALinkStatus.Pending,
		displayName: 'Sent/Not accepted'
	}
	],
	notAvailable: 'Не доступно',
	search: labels.searchPlaceholder,
	noResultsFound: 'Никаких результатов не найдено.',
	noComponentsFound: 'No components found.',
	contentSwitcher: [{
		id: gaRoleTypes.primary,
		displayName: 'Primary'
	},
	{
		id: gaRoleTypes.component,
		displayName: 'Component'
	},
	{
		id: gaRoleTypes.regional,
		displayName: 'Region'
	}
	],
	gaRegionTypesLabel: {
		id: gaRegion.notApplicable,
		displayName: 'Not applicable'
	},
	//TODO: To be removed
	pointOfContactValues: [{
		id: pointOfContactTypes.EYcontact,
		displayName: 'EY Contact'
	},
	{
		id: pointOfContactTypes.externalContact,
		displayName: 'External contact'
	}
	],
	saveAndClose: labels.modalSaveAndClose,
	cancelBtn: labels.modalCancelTitle,
	gaScopesValues: [{
		id: gaScopeType.full,
		displayName: 'Full'
	},
	{
		id: gaScopeType.specific,
		displayName: 'Specific'
	},
	{
		id: gaScopeType.specifiedAuditProcedures,
		displayName: 'Specified procedures'
	},
	{
		id: gaScopeType.review,
		displayName: 'Review'
	}
	],
	edit: labels.edit,
	delete: labels.delete,
	tooltipIcon: 'Select this option if the component is not using EY Canvas to receive Group audit instructions and submit interoffice deliverables.',
	tooltipReferenceIcon: 'Components designated as <b>Reference only</b> are used for organizational purposes only. These component engagements will not receive link requests, instructions or tasks and this primary team engagement will also not receive a group task.',
	modalCancelBtnLabel: labels.cancelLabel,
	modalCloseBtnTitletip: labels.closeLabel,
	modalConfirmBtnLabel: labels.confirmLabel,
	clear: 'clear',
	clearUpper: labels.clear,
	nameOrEmail: 'Enter EY point of contact email',
	editComponent: 'Edit component',
	editComponentInstructionalText: "Edit component details below and select <b>'Save'</b> to finish.",
	linkAlreadyAcceptedInfo: 'Only the email field can be edited as the link request has already been sent to the Component team.',
	sendAll: 'Send all',
	send: 'Send',
	resend: 'Resend',
	scopeAndStrategy: 'Объем и стратегия',
	execution: 'Execution',
	conclusion: 'Conclusion',
	reportingForms: 'Reporting Forms',
	manageGroupPermission: 'You do not have the <b>Manage group</b> permission to take this action. Request the <b>Manage group</b> permission from an Engagement Administrator.',
	manageComponentModalDesc: 'Create new components or edit and delete existing components below.',
	editLinkInfo: 'Only the email field can be edited as the link request has already been sent to the Component team.',
	invalidPointOfContact: 'A point of contact is needed in order to send the link request. Edit component to add a point of contact.',
	manageComponentModalActions: 'Actions',
	manageComponentModalComponents: 'Components',
	manageComponentModalDelete: 'Delete',
	noThereAtLeastOneComponentToSendAll: 'There are no components with eligible statuses to send a link request. The status of a component must be <b>Send</b> or <b>Resend</b> in order to send a link request.',
	showKnowledgeDescription: 'Show title and description from Knowledge',
	hideKnowledgeDescription: 'Hide title and description from Knowledge',
	instructionName: 'Enter instruction name',
	instructionDescriptionPlaceholder: 'Enter instruction description',
	selectDueDate: 'Due date (required)',
	show: 'Показать',
	allocationHeader: 'Allocation',
	allocationInstructionForKnowledge: 'Knowledge instructions can only be allocated by scope. Select the relevant scope(s) below.',
	allocationInstructionForCustom: 'Custom instructions can be allocated by scope or by component. Select the instruction allocation below, then allocate to the relevant scope(s) or component(s).',
	allocateScope: 'Allocate to scopes',
	allocateComponent: 'Allocate to components',
	pillScopesPlural: 'scopes',
	pillScopesSingular: 'scope',
	pillComponentsPlural: 'components',
	pillComponentsSingular: 'component',
	selectScopesPlaceholder: 'Select scopes',
	selectComponentsPlaceholder: 'Select components',
	searchNoResultFoundText: labels.searchNoResultFoundText,
	newCustomInstruction: 'New custom instruction',
	instructionNameNewCustomInstruction: 'Instruction name',
	addCustom: 'Add custom',
	custom: 'Заказ',
	required: 'Требуется',
	remove: 'Удалить',
	selectAll: 'Select all',
	unselectAll: 'Unselect all',
	lowerPoC: 'point of contact',
	editPoCTooltip: 'Invalid or no point of contact. Edit point of contact in order to send a link request.',
	recomendationType: [{
		id: 1,
		label: 'Required'
	},
	{
		id: 2,
		label: 'Optional'
	},
	{
		id: 3,
		label: 'Not applicable'
	}
	],
	confirmLabel: labels.confirmLabel,
	deleteComponentInstructionalText: '<b>Are you sure that you want to delete this component from the Group structure?</b><br />When the component is deleted, the link to the component will be removed and the engagements will no longer be able to exchange documentation. Additionally, all associations between the component and its accounts and instructions will be deleted.',
	noActivitiesAvailable: 'No activities available.',
	relatedComponents: 'Related components',
	relatedComponentsSingular: 'related component',
	relatedComponentsPlural: 'related components',
	publish: 'Publish',
	publishModalHeader: 'RA RU Publish changes',
	publishChangesInstructional: '<b>RA RU Are you sure that you want to publish changes to the group instruction summary?</b><br />The previous set of group instructions will be overwritten.  Once the changes are published, the updated instructions can be sent from the group instruction summary.',
	publishManageGroupPermission: 'You must have the Manage group permission to take this action. Request permission from an Engagement Administrator.',
	lastPublished: 'Last published:',
	publishChangesNotAvailable: 'Not available yet',
	noRecordsFound: labels.noRecordsFound,
	deleteInstruction: 'Delete instruction',
	deleteInstructionInstructionalText: '<b>Are you sure that you want to delete the instruction? </b><br />This action cannot be undone.',
	sendInstructionsTitle: 'Send instructions',
	sendInstructionsInstructionalText: "RA RU Ensure the latest instructions have been published by clicking 'Publish' on the underlying page. Then, review the component's instructions below and select 'Send' to send the instructions to the component engagement.",
	instructionsAlreadySent: 'The latest version of instructions have already been sent.',
	missingDueDates: 'Reporting form due date missing.',
	createInstructionsModalButton: 'Create instructions',
	createInstructionsModalActionToastMessageStart: 'Group risk assessment instructions are missing for ',
	createInstructionsModalActionToastMessageEnd: ' components.',
	createInstructionsModalDescription: 'The following Full and Specific scope components do not have Group risk assessment instructions allocated to them. Selecting <b>Create</b> will create a Group risk assessment instruction for each component listed below.',
	createInstructionsModalScope: ' Scope',
	createInstructionsModalHeader: 'Create instructions',
	createInstructionsModalmodalConfirmBtnLabel: 'Create',
	createInstructionsModalmodalCancelBtnLabel: 'Cancel',
	createInstructionsModalmodalCloseBtnTitletip: 'Close',
	createInstructionsModalNewGraInstructionDescription: 'Enclosed is the risk assessment for accounts relevant for your component.  Review the risk assessment and ensure that your engagement has those accounts and risks identified.  Any additional risks that are identified locally or where the component team does not agree should be communicated with the primary team so that the risk assessment can be adjusted by both the primary team and component team accordingly.',
	createInstructionsModalErrorMessage: 'Group risk assessment instruction creation failed for the following components: <b>{0}</b>. Please refresh the page and try again.',
	createInstructionsDuplicatedModalErrorMessage: 'Group risk assessment instruction creation failed. Instruction name cannot be duplicated.',
	gaLinkActionTooltip: {
		NotUsingCanvasLabel: 'Not using EY Canvas',
		NotUsingCanvas: 'Clicking <b>Send</b> will create the Primary <br/> Group tasks for this component but <br/> no instructions will be sent.',
		NotLinkedLabel: 'Not linked',
		NotLinked: 'The link request has not been sent to <br/> the Component team. Send the link <br/> request in order to send instructions.',
		Unlinked: 'Unlinked'
	},
	viewHistory: 'View history',
	viewSentInstructionsTitle: 'View sent instructions',
	save: labels.saveLabel,
	cancel: labels.cancelLabel,
	viewHistoryInstructionalText: 'Select instruction to view previous version(s) of instructions sent to the Component team.',
	viewHistorySelectInstruction: 'Select instruction',
	viewHistoryDateSent: 'Date sent: ',
	viewHistoryStatus: 'Status: ',
	viewHistoryStatusAccepted: 'Accepted',
	viewHistoryStatusPending: 'Pending',
	viewHistoryStatusRejected: 'Rejected',
	viewHistoryStatusSystemError: 'RU System error',
	viewHistorySelectVersion: 'Select version',
	noAccountsFound: 'No accounts or disclosures have been found in this or other engagements. <br />Select {link} to create new or edit existing accounts or disclosures.',
	generalCommunications: 'General communications',
	reportingDeliverables: 'Reporting deliverables',
	changesPublishedNotSent: 'Changes not sent',
	changesPublishedBrNotSent: 'Changes<br/>not sent',
	changesPublishedNotSentYes: 'Yes',
	deleteSubScopeInstructionalTextModal: 'Вы уверены, что хотите удалить <br/> выбранный поддиапазон?',
	deleteSubScopeTitleModal: 'Удалить поддиапазон',
	riskAssessmentModal: {
		headerText: 'RU Оценка риска',
		modalCloseBtnTitletip: labels.close,
		manageAndDisclosures: 'RU Ссылка «Управление учетными записями и раскрытием информации»',
		next: 'RU Следующий компонент',
		back: 'RU Предыдущий компонент'
	},
	riskAssessment: 'RU Оценка риска',
	preview: 'RU предварительный просмотр',
	accountsAndDisclosureSummary: "RU Account and disclosure",
	noAccountSnapshotPlaceholder: "RU There is no account data to display for this component.",
	createOversightProjectButtonLabel: 'RU Create EY Canvas Oversight project',
	createOversightProjectTitle: 'RU Do you want an EY Canvas Oversight project to be created with this primary engagement?',
	createOversightProjectDescription: 'RU Regional and/or component EY Canvas engagement(s) identified in this group structure will automatically be populated as part of the EY Canvas Oversight project setup.',
	createOversightModalHeader: 'RU EY Canvas Oversight project name',
	createOversightModalDescription: 'Enter the name of the EY Canvas Oversight project.',
	createOversightModalTextLabel: 'RU Project name',
	projectRedirectionButtonLabel: 'RU EY Canvas Oversight projects',
	projectAssociationTextLabel: 'RU There are EY Canvas Oversight projects connected to this engagement.',
	sendLinkDisableTooltip:'RU This engagement was copied, including components in the Group audit flow. Links cannot be re-sent. Create a new component and send a link, as necessary.',
	instructionsCannotBeSentUntilPublished: 'RU - Инструкции не могут быть отправлены до их публикации.'
};

export const sampleList = {
	newSample: 'New sample New sample',
	createSampleModalDescription: `Enter sample details below and select '<b>{0}</b>' to finish. To create another sample, select '<b>{1}</b>'. Enter sample details below and select '<b>{0}</b>' to finish. To create another sample, select '<b>{1}</b>'.`,
	saveAndCreateAnother: 'Save and create another Save and create another',
	saveAndClose: 'Save and close Save and close',
	sampleDescription: 'Sample description (required) Sample description (required)',
	sampleDate: 'Sample date (required) Sample date (required)',
	sampleListId: 'Sample List Id Sample List Id',
	ok: 'Ok Ok',
	addSample: 'Add Sample Add Sample',
	cancel: 'Cancel Cancel',
	saveAndCloseForHeader: 'Save and close',
	saveAndCreateAnotherHeader: 'Save and create another',
	required: 'Required Required',
	description: 'Sample description Sample description',
	date: 'Date Date',
	attributeStatus: 'Attributes Attributes',
	tags: 'Tags Tags',
	open: 'Open Open',
	notApplicableLabel: 'Not applicable Not applicable',
	notPresent: 'Not present Not present',
	present: 'Present Present',
	pagingShowtext: 'Show Show',
	placeHolderMessage: 'No samples available. Click {clickHere} to get started. No samples available. Click {clickHere} to get started.',
	noSampleListAvailable: 'No sample list available No sample list available',
	editSample: 'Edit sample Edit sample',
	editSampleDescription: `Edit sample details below and select '<b>{0}</b>' to finish. Edit sample details below and select '<b>{0}</b>' to finish.`,
	editSampleSave: 'Save Save',
	sampleCanNotBeCreated: 'Samples cannot be created for this document. Samples cannot be created for this document.',
	noRelatedObject: 'No related object.  Relate an object to get started. No related object.  Relate an object to get started.',
	noResultsFound: 'No results found No results found',
};

export const AdditionDocumentationLabels = {
	addAdditionalDocumentation: 'Add additional documentation Add additional documentation',
	editAdditionalDocTitle: 'Edit Additional documentation Edit Additional documentation',
	removeAdditionalDocumentation: 'Remove additional documentation Remove additional documentation',
	cancel: 'Cancel Cancel',
	save: 'Save Save',
	of: 'of of',
	additionalDocTitlePlaceholder: 'Additional documentation (required) Additional documentation (required)',
	additionalDocTitle: 'Additional documentation (required) Additional documentation (required)',
	remove: 'Remove Remove',
	enterAdditionalDocTitle: "Enter additional documentation below and select <b>'{0}'</b> to finish. Enter additional documentation below and select <b>'{0}'</b> to finish.",
	editAdditionalDocDesc : "Edit additional documentation below and select <b>'{0}'</b> to finish. Edit additional documentation below and select <b>'{0}'</b> to finish.",
	characters: 'characters characters',
	required: 'Required Required',
	descriptionMaxLengthError: 'Response exceeds maximum allowed. Response exceeds maximum allowed.',
	attributeIndexLabel: 'Attribute index Attribute index',
};


export const sampletAttributeConstants = [
	{ id: 1, label: 'Open Open' },
	{ id: 3, label: 'Present Present' },
	{ id: 7, label: 'Present with comments Present with comments' },
	{ id: 5, label: 'Not present Not present' },
	{ id: 4, label: 'Not applicable Not applicable' },
];

export const groupInvolvement = {
	NoComponentsAvailables: 'No component has been created. <b>Manage components</b> to get started.',
	GroupInvolvementToastMsgStart: 'Group involvement form is missing for ',
	GroupInvolvementToastMsgEnd: ' component(s).',
	CreateGroupInvolvementHeader: 'Create involvement form(s)',
	GroupInvolvementInstructionalText: 'The following component(s) do not have Group involvement form(s) allocated to them.<br/> Selecting &#39;<b>Create</b>&#39; will create a Group involvement form for each component listed below.',
	createGroupInvolvementDocumentErrorMessage: 'Group involvement document creation failed for the following components: <b>{0}</b>. Please refresh the page and try again.',
	createGroupInvolvementDocumentSuccessMessage: 'Group involvement form(s) created successfully. Refresh page in 30 seconds to see available documents.',
	involvementTypePlanned: 'Involvement type planned',
	significantUpdatesToPlannedInvolvement: 'Significant updates to planned involvement',
	executionComplete: 'Execution complete',
	generateGroupInvolvementCommunications: 'RU Распечатать форму участия',
	generateGroupInvolvementInstructionalText: 'The following component(s) have Group involvement form(s) associated to them. Select which component&#39;s group involvement forms to be included in one document below.<br /><br /> Once the components have been selected, selecting <b>&#39;Create&#39;</b> will create one Group involvement document with each component&#39;s group involvement document listed below.',
	componentTeams: 'Component teams',
	noComponentsSelectedErrorMessage: 'Select components to create a Group involvement communication.',
	documentName: '{taskName} group involvement package',
	selectAll: groupStructure.selectAll,
	unselectAll: groupStructure.unselectAll,
	modalConfirmBtnLabel: groupStructure.createInstructionsModalmodalConfirmBtnLabel,
	modalCancelBtnLabel: groupStructure.cancelBtn,
	modalCloseBtnTitletip: groupStructure.modalCloseBtnTitletip
};

export const groupInstructions = {
	ALRAPackageModalTitle: 'ALRA package name',
	ALRAPackageModalInstructionalText: 'Enter the name of the ALRA package that you are adding to Evidence.',
	ALRAPackageModalNameField: 'Enter name',
	ALRAPackageSuccessToastMessage: 'The package creation process has been started. It may take up to ten minutes for it to be completed.',
	ALRAPackageInProgressToastMessage: 'The package creation process is in progress, It may take up to ten minutes for it to be completed.',
	delete: labels.delete,
	deleteSectionModalTitle: labels.deleteSection,
	deleteSectionInstructionalText: '<b>Are you sure that you want to delete the section?</b><br />This action cannot be undone.',
	deleteSectionTooltipText: 'Instructions must be deleted<br />before section can be deleted.',
	modalConfirmBtnLabel: labels.confirmLabel,
	modalCancelBtnLabel: labels.cancelLabel,
	modalCloseBtnTitletip: labels.closeLabel,
	missing: 'Missing',
	sendAllModalTriggerButton: 'Send All',
	sendAllModalTooltipText: 'There are no instructions available to send to component teams.',
	publishModalTooltipText: 'RA RU Group instructions need to be published before they are sent. When instructions are published, any changes are saved as new instructions, overriding the previous version of instructions. These new instructions can then be sent to component teams.',
	sendAllModalErrorMessage: 'RU Group instructions for the following Components were not sent because one or more documents are in multi-user edit mode. End multi-editing mode and try to send instructions again. If the problem persists, contact EY Help Desk. <br /> <b>{0}</b>',
	sendAllModalHeaderText: 'Send all instructions',
	sendAllModalConfirmBtnLabel: 'Send',
	sendAllModalCancelBtnLabel: 'Cancel',
	sendAllModalCloseBtnTitletip: 'Close',
	sendAllModalDescription: 'Selecting <b>Send</b> will send instructions to the following component teams.',
	generateGroupRiskAssessmentCommunications: 'RU Создать группу ALRA',
	bulkALRAPackageName: '{instructionName} account level risk assessment package',
	groupInstructionSummaryReport: 'Group instruction summary report',
	groupInstructionSummaryReportTitletip: 'View and export Group instruction details, instruction history and changes to Component/Account mapping.',
	exportGroupRiskAssessment: 'RU Сводка экспорта',
	reportingDeliverables: groupStructure.reportingDeliverables,
	groupRiskAssessment: 'Group risk assessment'
};

export const sectionTitles = [{
	id: KnowledgeSectionIds.GeneralCommunications,
	sectionTitle: groupStructure.generalCommunications
},
{
	id: KnowledgeSectionIds.ScopeOfWork,
	sectionTitle: 'Scope of work'
},
{
	id: KnowledgeSectionIds.ReportingForms,
	sectionTitle: groupStructure.reportingDeliverables
},
{
	id: KnowledgeSectionIds.ProceduresPerformedCentrally,
	sectionTitle: 'Procedures performed centrally'
},
{
	id: KnowledgeSectionIds.GroupRiskAssessment,
	sectionTitle: groupInstructions.groupRiskAssessment
},
{
	id: KnowledgeSectionIds.OtherCommunications,
	sectionTitle: 'Other communications'
}
];

export const groupAuditToolbar = {
	search: labels.placeholderForSearch
};

export const AccountType = [{
	id: 1,
	accounttypename: 'Significant account Significant account'
},
{
	id: 2,
	accounttypename: 'Limited risk account Limited risk account'
},
{
	id: 3,
	accounttypename: 'Insignificant account Insignificant account'
},
{
	id: 4,
	accounttypename: 'Other account Other account'
},
{
	id: 5,
	accounttypename: 'Significant disclosure Significant disclosure'
}
];


export const PriorityType = [{
	value: 1,
	label: 'Низкий'
},
{
	value: 2,
	label: 'Средний'
},
{
	value: 3,
	label: 'Высокий'
},
{
	value: 4,
	label: 'Критический'
}
];

export const AccountSummaryAccountType = [{
	id: '0',
	accounttypename: 'Все счета'
},
{
	id: '1',
	accounttypename: 'Значительные счета'
},
{
	id: '2',
	accounttypename: 'Счета с ограниченным риском'
},
{
	id: '3',
	accounttypename: 'Незначительные счета'
},
{
	id: '4',
	accounttypename: 'Account - Others'
},
{
	id: '5',
	accounttypename: 'Significant disclosures'
}
];

export const TaskStatus = [{
	id: 1,
	status: 'Открыто'
},
{
	id: 2,
	status: 'В процессе'
},
{
	id: 3,
	status: 'На стадии проверки'
},
{
	id: 4,
	status: 'Выполнено'
},
{
	id: 5,
	status: 'Удалено'
}
];

export const reviewNoteLabels = {
	/*Review Notes*/
	emptyNoteDetailsMessage:
		'Выберите замечание для просмотра подробной информации. Для использования средств контроля массивов данных выберите несколько замечаний по результатам проверки, используя клавишу управления или смены регистра. Для работы с отдельным замечанием выберите его из списка.',
	documentReviewNotesLabel: 'Замечания по документу',
	addNewReviewNoteButtonText: 'Добавить замечание',
	noNotesAssociatedWithDocumentLabel: 'Для данного документа нет замечаний',
	allNotesLabel: 'Все замечания',
	charactersLabel: 'символы',
	myNotesLabel: 'Мои замечания',
	showClearedLabel: 'Показать исправленные',
	showClosedLabel: 'Показать закрытые',
	toLabel: 'кому',
	toUserLabel: 'по',
	ofLabel: 'от',
	textAreaPlaceholder: 'Ввести замечание',
	addNewNoteModalClose: 'Закрыть',
	addNewNoteModalTitleLabel: 'Добавить новое замечание',
	editNoteModalTitleLabel: 'Редактировать замечание',
	deleteIconHoverText: 'Удалить',
	deleteIconModalAcceptText: 'Удалить',
	deleteIconModalConfirmMessage: 'Удалить ваш ответ на данное замечание?',
	deleteIconModalConfirmMessageParent: 'Удалить выбранное замечание?',
	deleteIconModalTitleLabel: 'Удалить замечание',
	deleteReplyIconModalTitle: 'Удалить ответ',
	emptyRepliesMessage: 'Нет ответов',
	replyInputPlaceholder: 'Ответить на данное замечание',
	replyText: 'Текст ответа',
	editReplyModelTitle: 'Редактировать ответ',
	noteDueDateLabel: 'Срок',
	fromUserLabel: 'с',
	priorityLabel: 'Приоритет',
	dueDateLabel: 'Срок исполнения',
	dueLabel: 'Выполнить до',
	status: 'Статус',
	noteModifiedDateLabel: 'Изменено',
	cancelLabel: 'Отмена',
	saveLabel: 'Сохранить',
	clearedBy: 'Исправлено (кем)',
	closedBy: 'Закрыто (кем)',
	reopenedBy: 'Повторно открыто (кем)',
	reply: 'Ответ',
	editIconHoverTextLabel: 'Редактировать',
	required: 'Требуется',
	closeTitle: 'Закрыть',
	otherEngagementNotes: 'Прочие примечания по заданию',
	closeLabel: 'Закрыть',
	showMore: 'Показать больше',
	showLess: 'Показать меньше',
	showMoreEllipsis: 'Показать больше…',
	showLessEllipsis: 'Показать меньше…',
	noResultFound: 'Результаты не обнаружены',
	engagementNameLabel: 'Наименование задания:',
	drag: 'Перетащить',
	formMaxLength: 'RA RU Text cannot exceed {number} characters.',
	voiceNoteButtonLabel: 'RA RU Voice note',
	stopRecordingButtonLabel: 'RA RU Stop',
	reopen: 'RA RU Reopen',
	noNotesFound: 'RA RU No notes found',
	noNotesFoundInstructional: 'RA RU Leave a note by using the inputs below. Assign the note to a user and specify the priority and due date.',
	microphoneBlockedMessage: 'RA RU Allow browser to access your microphone to use voice notes. If already allowed, please refresh and try again.',
	microphoneBlockedOnVideoMessage: 'RA RU Allow browser to access your microphone to use voice in screen recording. If already allowed, please refresh and try again.',
	notInMainWindowVoice: 'RA RU Voice recordings are not allowed inside the drawer, please open the document in a new tab to perform the action.',
	notInMainWindowScreen: 'RA RU Screen recordings are not allowed inside the drawer, please open the document in a new tab to perform the action.',
	voiceNoteNotAvailable: 'RA RU Voice note and screen recording is not available in drawer view. Switch to full screen view to use these features.',
	playButtonTitle: 'RA RU Play',
	deleteButtonTitle: 'RA RU Delete',
	pauseButtonTitle: 'RA RU Pause',
	screenRecord: 'RA RU Screen record',
	playbackReview: 'RA RU Playback review'
};

export const entities = [{
	id: 0,
	name: 'Все'
},
{
	id: 1,
	name: 'Документ'
},
{
	id: 2,
	name: 'Сводный рабочий документ'
},
{
	id: 3,
	name: 'Счет'
},
{
	id: 4,
	name: 'ЗКО'
},
{
	id: 5,
	name: 'ИТ-процесс'
},
{
	id: 6,
	name: 'План аудита'
},
{
	id: 7,
	name: 'Риск'
},
{
	id: 8,
	name: 'Задача'
},
{
	id: 9,
	name: 'Искажение'
},
{
	id: 10,
	name: 'Недостаток'
},
{
	id: 11,
	name: 'АГ Компонент'
},
{
	id: 12,
	name: 'АГ Инструкция для компонента'
},
{
	id: 13,
	name: 'АГ Доказательства компонента'
},
{
	id: 14,
	name: 'АГ Объем работ'
},
{
	id: 15,
	name: 'АГ Инструкция для основной команды'
},
{
	id: 16,
	name: 'АГ Основная'
},
{
	id: 17,
	name: 'Запрос клиента'
},
{
	id: 18,
	name: 'ВО'
},
{
	id: 19,
	name: 'Средство контроля'
},
{
	id: 20,
	name: 'ИТ-приложение'
},
{
	id: 21,
	name: 'Форма Канвас'
},
{
	id: 22,
	name: 'Раздел формы'
},
{
	id: 23,
	name: 'Текст формы'
},
{
	id: 24,
	name: 'Предпосылка'
},
{
	id: 25,
	name: 'Задание по клиенту'
},
{
	id: 26,
	name: 'Группа клиента'
},
{
	id: 27,
	name: 'Тег задания'
},
{
	id: 28,
	name: 'Задание'
},
{
	id: 29,
	name: 'Заголовок формы'
},
{
	id: 30,
	name: 'Статус формы'
},
{
	id: 31,
	name: 'Пользователь задания'
},
{
	id: 32,
	name: 'Пользователь группы клиента'
},
{
	id: 33,
	name: 'Индекс БППС'
},
{
	id: 34,
	name: 'ОКИС'
},
{
	id: 35,
	name: 'ИТ-риск'
},
{
	id: 36,
	name: 'Статья автоматизации'
}
];

export const PaceType = [{
	id: 1,
	paceTypename: 'Low'
},
{
	id: 2,
	paceTypename: 'Moderate'
},
{
	id: 3,
	paceTypename: 'High'
},
{
	id: 4,
	paceTypename: 'Close Monitoring'
}
];

export const DocumentHelper = {
	401: 'Unable to complete the operation. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	413: 'Document exceeds the maximum allowable file size (250mb) and cannot be uploaded. Reduce the file size and try again.',
	412: 'A Document with name already exists in this engagement',
	414: 'Имя превышает максимальную длину (120 символов).',
	410: 'This document has been deleted and therefore it cannot be opened.',
	411: 'Empty documents are not permitted.'
};

export const Errors = {
	/*Doc Helper Custom Messages */
	0: 'Соединение потеряно. Снова подключитесь и повторите попытку. Если проблема не устранена, обратитесь в Службу поддержки.',
	101: 'Неверный статус задания',
	102: 'Актуальный пользователь задания не найден',
	103: 'Отсутствует соблюдение независимости пользователей задания.',
	104: 'Отсутствуют необходимые области Азуре АД',
	105: 'An error occurred obtaining engagement permissions. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	106: "You don't have the required permissions to perform this action.",
	107: 'Действующий пользователь не найден. Обновите страницу и повторите попытку. Если проблему не удается устранить, обратитесь в службу технической поддержки.',
	108: 'Профиль задания не заполнен. Перейдите на главную страницу и заполните профиль.',
	303: 'В настоящее время загружается документ с таким же именем.',
	403: 'это неподдерживаемый формат файла, который не был загружен. Повторно сохраните документ в допустимом формате файла и повторите попытку. Если проблема не устранена, обратитесь в Службу поддержки.',
	406: 'Document cannot be empty.',
	412: 'A document with the same name already exists in this engagement.',
	414: 'Имя превышает максимальную длину (120 символов).',
	411: 'Empty documents are not permitted.',
	500: 'Соединение потеряно. Снова подключитесь и повторите попытку. Если проблема не устранена, обратитесь в Службу поддержки.',
	600: 'Operation cannot be complete at this time. Refresh the page and try again. If the issue persists contact the Help Desk.',
    601: 'Error downloading the screenshot. Refresh the page and try again. If the issue persists, contact the Help desk.',
	602: 'Document is already in collaboration',
	zip: 'Архивный файл не может быть загружен, поскольку он содержит один или несколько неподдерживаемых типов файлов или содержит больше максимального количества встроенных архивных файлов.',
	401000: 'Обнаружено изменение сети и, пожалуйста, перезагрузите страницу, чтобы продолжить',

	/*Accounts*/
	1001: 'Создать счет не получилось.',
	1002: 'Отсутствует наименование счета.',
	1003: 'The selected account has been deleted. Close this modal to see the updated list. The selected account has been deleted. Close this modal to see the updated list.',
	1004: 'No results found. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	1005: 'Неверный идентификатор задания',
	1006: 'Неверный тип счета',
	1007: 'Неверный тип отчета',
	1008: 'The selected account has been deleted. Close this modal to see the updated list. The selected account has been deleted. Close this modal to see the updated list.',
	1009: 'Получить счет по идентификатору вызова не удалось.',
	1010: 'Получить счет по заданию не удалось.',
	1011: 'Получить счет по идентификатору вызова не удалось.',
	1012: 'Недопустимый тип сокращения',
	1013: 'Не удалось выполнить вызов проверки создания счета.',
	1014: 'Не удалось выполнить вызов проверки удаления счета.',
	1015: 'Неверный запрос на создание проверки счета.',
	1016: 'Неверный идентификатор проверки счета.',
	1017: 'Счет не является частью этого обязательства или он был удален.',
	1018: 'Проверка счета была создана другим пользователем.',
	1019: 'Счет был удален другим пользователем. Обновите страницу и повторите попытку.',
	1020: 'Account need PSP to update',
	1024: 'Account name is more than 500 characters.',
	1025: 'Limited Risk or Insignificant account can not be estimated',
	1026: 'Account cannot have duplicate assertions',
	1027: 'Invalid assertion id',
	1037: 'Can not have duplicate PSP Indexes',
	1039: 'Account has been deleted by another user. Refresh the page and try again.',
	1048: 'Account has been invalid execution type.',
	1053: 'Account has Risk or Estimate associated, can not set to Limited Risk Account or Insignificant Account.',
	1054: 'Assertions to be deleted have associated with Risk or Estimate',
	1065: 'You cannot make changes to assertion(s) that have a Significant risk, or Fraud risk, or Risk of material misstatement or an estimate related.You need to remove these relations first.You cannot make changes to assertion(s) that have a Significant risk, or Fraud risk, or Risk of material misstatement or an estimate related.You need to remove these relations first.',

	1266: 'Engagement has reached maximum number of multi-edit mode documents.  Check some documents back in and try again.  If the issue persists contact the Help DeskEngagement has reached maximum number of multi-edit mode documents.  Check some documents back in and try again.  If the issue persists contact the Help Desk',
	1267: 'Document is conflicted. Resolve conflicts and try again.  If the issue persists, contact the Help Desk.Document is conflicted. Resolve conflicts and try again.  If the issue persists, contact the Help Desk.',
	1268: 'Document is already in co-edit mode. end co-edit mode and try again.  If the issue persists, contact the Help Desk.Document is already in co-edit mode. end co-edit mode and try again.  If the issue persists, contact the Help Desk.',
	1269: 'Document is a shared evidence. Unlink and try again.  If the issue persists, contact the Help Desk.Document is a shared evidence. Unlink and try again.  If the issue persists, contact the Help Desk.',

	/*Assertions*/
	2001: 'Недопустимый запрос на создание.',
	2002: 'Отсутствует название предпосылки.',
	2003: 'Отсутствует предпосылка.',
	2004: 'Получить предпосылку не получилось.',
	2005: 'Неверный идентификатор задания.',
	2006: "Выполнить команду 'Получить предпосылку по идентификатору' не удалось.",
	2007: "Выполнить команду 'Получить предпосылку ВО' не удалось.",

	/*Risks*/
	4001: 'Операция не может быть выполнена в данный момент. Обновите страницу и повторите попытку. Если проблему не удастся устранить, обратитесь в службу технической поддержки.',
	4002: 'Отсутсвует название риска',
	4003: 'Отсутсвует Риск',
	4004: "Выполнить команду 'Получить риск' не удалось.",
	4005: 'Неверный идентификатор задания.',
	4006: "Выполнить команду 'Получить риск по идентификатору' не удалось.",
	4007: 'Неверный запрос.',
	4008: 'This estimate is no longer available. Refresh the page and try again. Contact the Help Desk if the error persists.',
	4009: 'Неверный запрос на обновление',
	4010: 'Конкретная ВО уже отнесена к этому риску',
	4011: 'Список ВО не может быть нулевым',
	4012: 'Не удалось получить типы рисков.',
	4013: 'Недопустимый запрос на создание.',
	4014: 'Соответствующая предпосылка не является действительной. Обновите страницу и повторите попытку. Если эта ошибка повторяется, обратитесь в Службу поддержки.',
	4015: 'ВО не является действительным. Обновите страницу и повторите попытку. Если эта ошибка повторяется, обратитесь в Службу поддержки.',
	4016: 'The selected Risk has been deleted. Close this modal to see the updated list. The selected Risk has been deleted. Close this modal to see the updated list.',
	4017: 'Предпосылка не является действительной. Обновите страницу и повторите попытку. Если эта ошибка повторяется, обратитесь в Службу поддержки.',
	4018: 'Введенный идентификатор типа риска является недопустимым.',
	4019: 'Неверное наименование риска.',
	4020: 'Неверный идентификатор документа.',
	4021: 'Наименование риска не должно превышать 500 символов.',
	4023: 'Список идентификаторов предпосылок не может быть пустым.',
	4024: 'Невозможно создать форму для документации по счету с ограниченным риском из-за ошибки. Обновите страницу и повторите попытку. Если проблему не удается устранить, обратитесь в службу технической поддержки.',
	4025: 'Invalid account id.',
	4026: 'Invalid assertion id.',
	4027: 'AssertionRisk Model cannot be empty',
	4031: 'Invalid Risk or Form Body option.',
	4035: 'Cannot edit IsHigherRisk for Significant or Fraud Risks.',
	4036: 'KnowledgeAssertionId cannot be empty if no AssertionId is passed in. KnowledgeAssertionId must be in enums',
	4037: 'KnowledgeAssertionId already exists for this account.',
	4038: 'RiskTypeId does not match permissible options.',
	4062: 'This SCOT is no longer available. Refresh the page and try again. Contact the Help Desk if the error persists.',
	4063: 'SCOT relation cannot be edited. Refresh the page and try again. If the issue persists, contact the Help Desk.',

	/*TASK*/
	5001: 'Получить все не удалось.',
	5002: 'Эта задача больше не доступна в данном задании.',
	5003: 'Получить документы для задачи не удалось. Неверные параметры запроса.',
	5004: 'Получить документы, соответствующие задаче, не удалось. Неверные параметры запроса.',
	5005: 'Получить задачу по идентификатору не удалось.',
	5006: "Выполнить команду 'Получить категории задачи' не удалось.",
	5007: "Выполнить команду 'Получить подкатегории задачи' не удалось.",
	5008: "Выполнить команду 'Получить описание задачи' не удалось.",
	5009: "Выполнить команду 'Получить задачу по запросу' не удалось.",
	5010: "Выполнить команду 'Сохранить задачу по запросу' не удалось.",
	5011: 'Задача, с которой вы пытаетесь связать элементы, была удалена или отклонена.',
	5012: 'Элемент, который вы пытаетесь связать, был удален.',
	5013: 'Задача, с которой вы пытаетесь связать элементы, была удалена или отклонена.',
	5014: 'Документ, который вы пытаетесь связать, был удален.',
	5015: "Выполнить команду 'Получить доказательства задачи' не удалось.",
	5016: "Выполнить команду 'Получить задачу ВО' не удалось.",
	5017: 'Идентификатор задания должен быть больше чем ноль.',
	5018: 'Невозможно завершить привязку. Обновите страницу и повторите попытку. Если проблему не удается устранить, обратитесь в службу технической поддержки.',
	5019: 'Описание задачи пустое.',
	5020: 'Выбранная задача была удалена или отклонена. Таким образом, это действие не может быть завершено в настоящее время.',
	5021: 'Источник идентификатора задания отсутстсвует',
	5022: 'Сохранить примечание не удалось.',
	5023: 'Пользователь задания не найден',
	5024: 'Удалить задачу не получилось.',
	5025: 'Удалить задачи не получилось.',
	5026: 'Список задач пустой',
	5027: 'Проверка не найдена',
	5028: 'Требуется имя файла.',
	5029: 'Требуется расширение файла.',
	5030: 'Имя файла не может включать в себя: */:<>\\?|"',
	5031: 'Ошибка обновления имени документа.',
	5032: 'Неверный идентификатор документа.',
	5033: 'Тип операции не найден.',
	5034: 'Изменить Статус задачи не удалось.',
	5035: 'Действие, которое вы пытаетесь выполнить, не может быть завершено в данный момент. Пожалуйста, попробуйте еще раз позже. Если эта ошибка повторится, обратитесь в справочную службу.',
	5036: 'Содержание не может быть нулевым или пустым в вызове.',
	5037: 'Запрос не может быть нулевым в вызове.',
	5038: 'Введите уникальное имя файла, чтобы продолжить работу.',
	5039: 'Требуется имя файла.',
	5040: 'Имя файла ограничено 100 символами.',
	5041: 'Имя файла не может включать в себя: */:<>\\?|"',
	5042: 'Выбранная задача отклоняется.',
	5043: 'Эта задача является задачей этапа сборки.',
	5044: 'Эта задача является задача ключевого этапа.',
	5045: 'Задача не является ни ПСП или ОСП типа.',
	5046: 'Лимит символов превышен.',
	5047: 'Лимит символов превышен.',
	5048: 'Обязательное поле.',
	5049: 'Выбранный документ не может быть удален из этой задачи. Обновите страницу и повторите попытку. Если проблема не устранена, обратитесь в Службу поддержки.',
	5050: 'Идентификатор группы задач не должен быть нулевым или недействительным',
	5051: 'Идентификатор раздела задачи не должен быть равен нулю или недействителен',
	5052: 'Ошибка при попытке добавить этот документ в текущую задачу. Вызов не удался.',
	5053: 'Ошибка при попытке обновить этот документ в текущей задаче. Вызов не удался.',
	5054: 'Ошибка при попытке добавить копию этого документа в текущую задачу. Вызов не удался.',
	5055: 'Ошибка при попытке переименовать документ. Вызов не удался.',
	5056: 'Невозможно изменить название задачи для задачи знаний или групповой задачи',
	5057: 'Тип задания должен быть типа ОСТ',
	5058: 'Этот документ не может быть удален из задачи, поскольку он связан с системой.',
	5059: 'Недопустимое значение фазы времени.',
	5060: 'Ошибка добавления к доказательству.',
	5061: 'Другой пользователь обновил представленную информацию. Обновите страницу и повторите попытку. Если ошибка не устранена, обратитесь в справочную службу.',
	5062: 'Запрошенный документ недоступен для выбранного вами канала заданием в ЭЯ Атлас. Пожалуйста, свяжитесь со службой поддержки, чтобы предоставить информацию авторам контента для дальнейшего включения в него.',
	5063: 'Недопустимая Операция Исправления.',
	5064: 'Выбранная задача была удалена или отклонена. Таким образом, это действие не может быть завершено в настоящее время.',
	5065: 'Не удается обновить тип источника задачи. Запрос недействителен.',
	5066: 'Ошибка получения руководства.',
	5067: 'Невозможно обновить тип природы задачи. Запрос недействителен.',
	5068: 'Невозможно обновить тип природы задачи. Запрос недействителен.',
	5069: "Выполнить команду 'Удалить постановку задачи' не удалось.",
	5070: 'Одна или несколько выбранных задач были удалены. Пожалуйста, повторите попытку или обратитесь в справочную службу, если ошибка не устранена.',
	5071: 'Невозможно обновить задание. Запрос недействителен.',
	5072: 'Исполнитель не найден. Запрос недействителен.',
	5073: 'Задание не найдено.',
	5074: 'Сохранить постановку задачи не удалось',
	5075: 'Один и тот же член команды может быть назначен только на одно задание, отличное от Исполнителя. Пожалуйста, повторите попытку или обратитесь в справочную службу, если ошибка не устранена.',
	5076: 'Выбранный член команды не является активным участником этого задания. Пожалуйста, повторите попытку или обратитесь в справочную службу, если ошибка не устранена.',
	5077: 'Одна или несколько выбранных задач были удалены. Пожалуйста, повторите попытку или обратитесь в справочную службу, если ошибка не устранена.',
	5078: 'Некоторые задания были удалены. Пожалуйста, повторите попытку или обратитесь в справочную службу, если ошибка не устранена.',
	5079: 'Одна или несколько выбранных задач были удалены. Пожалуйста, повторите попытку или обратитесь в справочную службу, если ошибка не устранена.',
	5080: 'Запись версии документа не существует.',
	5081: 'Пользователь, которому в данный момент назначена эта задача, не может быть переназначен в качестве исполнителя. Пожалуйста, повторите попытку или обратитесь в справочную службу, если ошибка не устранена.',
	5082: 'Обновление не удалось. Имя документа должно быть уникальным для задания. Обновите страницу, чтобы удалить это сообщение.',
	5083: 'Превышен лимит символов детализации задачи.',
	5084: "Выполнить команду 'Создать документ задачи' не удалось.",
	5085: "Выполнить команду 'Удалить документ задачи' не удалось.",
	5086: "Выполнить команду 'Создать передачу задачи' не удалось.",
	5087: "Выполнить команду 'Исправить задачу' не удалось.",
	5088: 'Задача должна содержать доказательства для передачи. Повторите попытку или обратитесь в справочную службу.',
	5089: "Все доказательства, связанные с этой задачей (за исключением бумажных профилей), должны иметь по крайней мере одного испольнителя и проверяющего для отметки 'завершено'. Повторите попытку и обратитесь в Службу поддержки, если ошибка не устранена.",
	5091: 'Имя профиля бумаги уже существует в задании.',
	5092: 'Название не может содержать следующие символы: */:<>\\?|\\',
	5093: 'Наименование профиля бумажного документа превышает допустимую длину (100 символов).',
	5111: 'Выбранный счет, предпосылка или счет с ограниченным риском удален(-а). Обновите страницу и повторите попытку. Если ошибку не удается устранить, обратитесь в службу технической поддержки.',
	5116: 'Неверный тип документа.',
	5139: 'Cannot complete association. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	5131: 'Cannot complete association. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	5146: 'Task cannot be marked completed.',
	5156: 'Cannot complete removal. Refresh the page and try again. If the issue persists, contact the Help Desk.',

	/*WCGW*/
	6001: "Выполнить команду 'Создать ВО' не удалось.",
	6002: 'Отсутсвует название ВО.',
	6003: 'Отсутсвует ВО.',
	6004: "Выполнить команду 'Получить ВО' не удалось.",
	6005: 'Неверный идентификатор задания.',
	6006: 'Неверный идентификатор предпосылки.',
	6007: "Выполнить команду 'Получить ВО по идентификатору' не удалось.",
	6008: 'Неверный запрос.',
	6009: 'Неверный идентификатор ВО.',
	6010: 'Задача не может быть связана с ВО.',
	6011: 'Выбранный ВО удаляется.',
	6012: 'Задача и ВО не связаны с одной и той же предпосылкой.',
	6013: 'Выбранная задача не относится к одному и тому же заданию.',
	6014: 'Задача не может быть отделена от данного ВО.',
	6015: 'Задача не может быть связана с данным ВО.',
	6016: 'Задача отклоняется и не может быть связана с ВО.',
	6017: 'Эта задача не является контрольной задачей и не может быть связана с ВО.',
	6018: 'Эта задача не является задачей сборки и не может быть связана с ВО.',
	6019: 'Задача не является ПСП или ОСП и не может быть связана с ВО.',
	6020: 'Задача и ВО связаны с одним и тем же предпосылками и не могут быть связаны с ВО.',

	/*Engagement*/
	7001: 'Получить по идентификатору не найден.',
	7002: "Выполнить команду 'Получить задание по идентификатору рабочего места' не удалось.",
	7003: 'Получить все задания по компании не получилось.',
	7004: 'Получить задание по идентификатору не получилось.',
	7005: 'Получить всех пользователей по заданию не получилось.',
	7006: 'Фамилия не должна превышать 250 знаков.',
	7007: 'Недопустимая ошибка типа пользователя.',
	7008: 'Имя не должно превышать 250 знаков.',
	7009: 'Пользователь ГУИ не может быть нулевым.',
	7010: 'Недопустимая ошибка статуса пользователя.',
	7011: "Выполнить команду 'Создать пользователя задания' не удалось.",
	7012: '{0} {1} не могут быть приглашены, потому что он/она уже является активным или ожидающим членом команды.',
	7013: 'Инициалы не должны превышать 3 знаков.',
	7014: 'Начальная страница EY Canvas в настоящее время недоступна. Повторите попытку и, если проблема не устранена, обратитесь в Службу поддержки.',
	7015: '{0} {1} не могут быть приглашены, так как следующие группы доступа: {2} были удалены из задания. Обновите и повторите попытку.',
	7016: '{0} {1} не могут быть приглашены, так как пользователь уже является активным членом команды в следующих группах доступа: {2}',
	7017: 'Домен не разрешен для выбранных групп: {0}',
	7018: 'Адрес электронной почты не должен быть нулевым.',
	7019: 'Имя не должно быть нулевым.',
	7020: 'Фамилия не должна быть нулевой',
	7021: 'Инициал пользователя не должен быть нулевым.',
	7022: 'Главный офис пользователя не должен быть нулевым.',
	7023: 'Имя пользователя для входа в систему не должно быть нулевым.',
	7024: 'ЭЯРоль пользователя не должна быть нулевой.',
	7025: 'Роль пользователя задания не должна быть нулевой.',
	7026: 'Не удалось завершить операцию. Повторите попытку и, если проблема не устранена, обратитесь в Службу поддержки.',
	7027: 'Неверный адрес электронной почты',
	7028: "Выполнить команду 'Исправить пользователя задания' не удалось.",
	7029: 'Пользователи задания - Неверный идентификатор статуса пользователя задания',
	7030: 'Пользователи задания - Неверный идентификатор роли пользователя задания',
	7031: 'Один или несколько пользовательских идентификаторов задания не найдены.',
	7032: 'Адрес электронной почты не должен превышать 250 символов.',
	7033: 'Запрошенный пользователь не может быть нулевым.',
	7034: 'Сбой Очереди Универсального Процессора Сообщений.',
	7035: 'Инициалы не должны превышать 3 знаков.',
	7036: 'Имя не должно превышать 250 знаков.',
	7037: 'Фамилия не должна превышать 250 знаков.',
	7038: "Выполнить команду 'Создать внешнего пользователя' не удалось.",
	7039: 'Один или несколько пользователей не могут быть приглашены, поскольку они уже являются активным или ожидающим членом команды. Обновите страницу и повторите попытку, если проблема не устранена, обратитесь в справочную службу',
	7040: 'Имя не должно превышать 250 знаков.',
	7041: 'Фамилия не должна превышать 250 знаков.',
	7042: 'Инициалы не должны превышать 3 знаков.',
	7043: 'ДжиПиЭн не должен превышать 250 символов.',
	7044: 'Графический интерфейс не должен превышать 250 символов.',
	7045: 'Получить внешнего пользователя по идентификатору не удалось.',
	7046: 'Пользователь не должен быть нулевым.',
	7047: 'В данный момент невозможно сохранить изменения. Повторите попытку и, если проблема не устранена, обратитесь в Службу поддержки.',
	7048: 'Целевая страница ЭЯ Канвас в настоящее время недоступна и требуется редактирование. Повторите попытку и, если проблема не устранена, обратитесь в Службу поддержки.',
	7049: "Выполнить команду 'Обновить пользователя задания' не удалось.",
	7050: 'Участники не могут быть деактивированы. Задание должно иметь по крайней мере одного участника, имеющего разрешения на администрирование задание. Обновите свой выбор и повторите попытку. Если проблема не устранена, обратитесь в Службу поддержки.',
	7051: 'Получить внутреннего пользователя по идентификатору не удалось.',
	7052: 'Пользователь не найден.',
	7053: "получить по идентификатору' не удалось.",
	7054: "Выполнить команду 'Получить быстрые ссылки по идентификатору задания' не удалось.",
	7055: 'Недостаточные права для добавления предыдущих членов. Поговорите с членом команды по заданию, которые имеют соответствующие права для выполнения этого действия.',
	7056: 'ЭЯ Канвас не смог сохранить изменения в это время. Повторите попытку и, если проблема не устранена, обратитесь в Службу поддержки.',
	7057: 'Недостаточно прав для добавления новых членов. Поговорите с членом команды по заданю, имеющим соответствующие права для выполнения этого действия.',
	7058: 'Статус пользователя изменился. Обновите страницу и повторите попытку. Если проблема не устранена, обратитесь в Службу поддержки.',
	7062: 'Клиентский портал ЭЯ Канвас в настоящее время недоступен и необходимо обновить существующую информацию о членах. Повторите попытку и, если проблема не устранена, обратитесь в Службу поддержки.',
	7063: 'Невозможно деактивировать внешних членов. Обновите страницу и повторите попытку. Если проблема не устранена, обратитесь в Службу поддержки.',
	7064: 'Невозможно деактивировать внешние элементы. Обновите страницу и повторите попытку. Если проблема не устранена, обратитесь в Службу поддержки.',
	7065: '{0} {1} не могут быть активированы в одной или нескольких группах доступа. Домен не разрешен для выбранных групп: {2}.',
	7066: '{0} не является допустимым пользователем.',
	7067: "Выполнить команду 'Поставить внешнего пользователя' не удалось.",
	7068: 'Клиентский портал ЭЯ Канвас в настоящее время недоступен и необходимо Обновить существующую информацию о членах. Повторите попытку и, если проблема не устранена, обратитесь в Службу поддержки.',
	7069: 'Выбранные группы доступа не активны: {0}. Удалите и повторите попытку.',
	7072: 'Во время процесса разрыва связи задания произошла ошибка. Обновите страницу и повторите попытку. Если ошибка не устранена, обратитесь в справочную службу.',
	7074: 'Изменения не могут быть сохранены. Задание должно иметь по крайней мере одного активного участника, который имеет разрешения на администрирование задания и разрешил независимость. Если проблема не устранена, обратитесь в Службу поддержки.',
	7079: 'Не удалось отправить запрос о независимости.',
	7080: 'Неверный идентификатор пользователя или отправка формы подтверждения независимости запрещена, так как идентификатор пользователя не принадлежит авторизованному пользователю.',
	7081: 'Предоставьте ответы на все вопросы до нажатия на кнопку «Отправить». Использовать функцию «Показать неотвеченные» для поиска неотвеченных вопросов. Если проблему не удается устранить, обратитесь в службу технической поддержки.',
	7082: 'По данному запросу не найден документ в отношении независимости.',
	7083: 'Запрос на краткий обзор СДМ не выполнен.',
	7084: 'Неверный идентификатор пользователя или действие в отношении независимости запрещено для авторизованного пользователя.',
	7085: 'Комментарий в отношении независимости не должен превышать 4 000 символов.',
	7086: 'Запрос на действие в отношении независимости не выполнен.',
	7087: 'Для предоставления доступа, отказа в доступе или изменения доступа для данного пользователя ваша должность должна быть не ниже партнера, ответственного за аудиторское задание, партнера по проекту или исполнительного директора.',
	7088: 'Не удалось отправить изменения в отношении независимости, повторите попытку позже.',
	7098: 'Invalid Pacetype Id.',
	7099: 'Форма для подтверждения независимости недоступна, повторите попытку и, если проблему не удается устранить, обратитесь в службу технической поддержки.',
	7154: 'Пользователи для текущей формы Канвас не найдены',
	7155: 'Отправка профиля не разрешена для восстановленных заданий.',
	7156: 'Содержимое обновляется. Повторите попытку позже. Если проблема сохраняется в течение длительного времени, обратитесь в службу технической поддержки.',
	7158: 'Документ недоступен. Обновите страницу и повторите попытку. Если проблему не удается устранить, обратитесь в службу технической поддержки',

	/*SCOT*/
	8001: "Выполнить команду 'Создать ЗКО' не удалось.",
	8002: 'Отсутсвует название ЗКО.',
	8003: 'Отсутсвует ЗКО.',
	8004: "Выполнить команду 'Получить ЗКО' не удалось.",
	8005: 'Неверный идентификатор задания.',
	8006: 'Неверный идентификатор предпосылки.',
	8007: "Выполнить команду 'Получить ЗКО по идентификатору' не удалось.",
	8008: 'Неверный запрос.',
	8009: 'The selected SCOT has been deleted. Close this modal to see the updated list. The selected SCOT has been deleted. Close this modal to see the updated list.',
	8010: 'Идентификатор ЗКО не может быть равен нулю или содержать пустые значения.',
	8011: 'Идентификатор ЗКО должен быть больше нуля.',
	8012: 'Идентификатор документа недействителен.',
	8013: 'Запрос на обновление ЗКО не выполнен.',
	8014: 'Поле наименования ЗКО не может оставаться пустым или содержать нулевое значение.',
	8015: 'Наименование ЗКО не должно превышать 500 символов.',
	8016: 'Тип стратегии ЗКО является недействительным.',
	8017: 'Тип ЗКО является недействительным.',
	8018: 'ИТ-приложение ЗКО является недействительным.',
	8019: 'Строка «ИТ-приложение для ЗКО» должна быть пустой при отсутствии ИТ-приложения. ',
	8028: 'The selected SCOT has been deleted. Close this modal to see the updated list. The selected SCOT has been deleted. Close this modal to see the updated list. ',

	/*User*/
	10001: 'Вошедший в систему пользователь не найден.',
	10002: 'Получить все не удалось.',
	10003: 'Получить данные о присутствии не удалось.',
	10005: 'Не удалось извлечь информацию о пользователе',

	/*Risk Type*/
	11001: 'Недопустимый запрос на создание.',
	11002: 'Отсутствует название Типа Риска.',
	11003: 'Отсутствует Тип Риска.',
	11004: "Выполнить команду 'Получить Тип Риска' не удалось.",
	11005: 'Неверный идентификатор задания.',

	/*Edit Control*/
	83001: 'Не удалось найти средства контроля.',
	83002: 'Не удалось найти средство контроля по идентификатору.',
	83003: 'Идентификатор средства контроля не может быть равен нулю или содержать пустые значения.',
	83004: 'Неверный идентификатор средства контроля.',
	83005: 'Неверный идентификатор документа.',
	83006: 'Отсутствует наименование средства контроля.',
	83007: 'Неверная длина наименования средства контроля.',
	83008: 'Invalid request.',
	83009: 'Invalid Control FrequencyId.',
	83010: 'Invalid Control TypeId.',
	83011: 'Invalid Control ITApplications.',
	83012: 'Invalid Control DesignEffectivenessTypeId.',
	83013: 'Invalid ITApplicationIds.',
	83014: 'Допустимы только ИТ-приложения с типом ОО, если тип средства контроля - ручное для предотвращения или ручное для обнаружения',
	83015: 'Only ITDM may have manual IPE testing selected.',
	83016: 'Lower Risk controls are not allowed for engagements with this profile.',
	83017: 'Duplicate FilterSCOTs.',
	83018: 'Control name is more than 500 characters.',
	83019: 'Invalid WCGW Ids.',
	83020: 'Duplicate WCGW Ids are not allowed.',
	83021: 'Duplicate ITApplication Ids are not allowed.',
	83022: 'Parameter {0} is not valid.',
	83023: 'Invalid current page.',
	83024: 'Invalid page size.',
	83025: 'Search String should not be more than 100 characters.',
	83026: 'IT APP without service organisation can only be associated to control of type ITDependentManualControl or ITApplicationControl',
	83027: 'Duplicate FilterWCGWs.',
	83028: 'Invalid knowledge control Id.',

	/*MissingDocument*/
	116004: 'Document creation failed. Please refresh or try again after some time. If the issue persists, contact the Help desk.',

	112000: 'No documents found for source and target doucments.',
	112001: 'Unable to perform call because the request is null.',
	112002: 'Request body cannot be null or empty in the call.',
	112003: 'Source and target documentId should not be equal.',
	112004: 'Source documentId should not be null or empty.',
	112005: 'Target documentId should not be null or empty.',
	112006: 'Source EngagementId should not be null or empty.',
	112007: 'Target EngagementId should not be null or empty.',
	112008: 'Source document is not valid for given engagement.',
	112009: 'Target document is not valid for given engagement.',
	112010: 'Target engagementId not found.',
	112011: 'Insufficient roles to link forms for source enagagment.  Work with an engagement administrator to get sufficient rights.',
	112012: 'Insufficient roles to link forms for target enagagment.  Work with an engagement administrator to get sufficient rights.',
	112013: 'Invalid user for source engagement.',
	112014: 'Invalid user for target engagement.',
	112015: 'Invalid source document type for sharing.',
	112016: 'Invalid target document type for sharing.',
	112017: 'Source and target document types are not matched.',
	112018: "Source and target knowledge formId's are not matched.",
	112019: 'Sharing link already exists for source and destination documents.',
	112020: 'Source and target engagements workspace not matched.',
	112021: 'Target document cannot be a target.',
	112022: 'The selected activity is already shared with other activities, and it cannot be further selected for sharing.',
	112023: 'Source document cannot be a target.',
	112024: 'Cannot find engagement Id of target documentId.',
	112025: 'Cannot find engagement Id of source documentId.',
	112026: 'Source document of source and target documentId should not be equal.',
	112027: 'Cannot proceed with submission of profile since the engagement has shared EY Canvas FIT enablement activities. Unlink the activities in order to proceed.',
	112028: 'Source and target EngagementId should not be equal.',
	112029: 'Source or Target EngagementId and documentId should match with route EngagementId and documentId.',
	112030: 'Document is not valid for given engagement.',
	112031: 'DocumentId should not be null or empty.',
	112032: 'EngagementId should not be null or empty.',
	112033: 'Target Document IDs Should Be Unique Target Document IDs Should Be Unique',
	112034: 'Target or source document(s) already shared Target or source document(s) already shared.',
	112035: 'For existing linked response relataion document there can only be single target For existing linked response relataion document there can only be single target.',

	/* Annotation Errors*/
	12001: 'Неверные параметры запроса.',
	12002: "Выполнить команду 'Создать комментарий' не удалось.",
	12003: 'Получить комментарий не удалось.',
	12004: 'Неверный идентификатор задания.',
	12005: 'Идентификаторы в коллекции должны быть больше нуля.',
	12006: 'Коллекция идентификаторов не может быть пустой.',
	12007: 'Неверный идентификатор задачи.',
	12008: 'Неверный идентификатор документа.',
	12009: 'Должен иметь действительный идентификатор документа или задачи.',
	12010: 'Ответы требуют источника.',
	12011: 'Неверный идентификатор статуса.',
	12012: 'Тип документа должен быть в 440ГЛ',
	12013: 'Недопустимый тип примечания.',
	12014: 'Недопустимый Пользователь Задания.',
	12015: 'Этот документ был удален другим пользователем.',
	12016: "Выполнить команду 'Обновить комментарий' не удалось.",
	12017: 'Вы пытаетесь ответить на комментарий, которая больше не существует. Обновите страницу и повторите попытку.',
	12018: 'Тип действия изменения комментария не должен быть нулевым.',
	12019: 'Комментарий по проверке удален.',
	12020: 'Недопустимое действие для выполнения.',
	12021: 'Пользователь не является автором комментария.',
	12022: 'Авторизация пользователя отсутствует.',
	12023: 'Авторский пользователь не существует и не принадлежит к заданию.',
	12024: 'Требуется назначенный пользователь.',
	12025: 'Назначенный пользователь не существует и не принадлежит к данному заданию.',
	12026: 'Недопустимые комментарии.',
	12027: 'Комментарии не должны быть пустыми.',
	12028: 'Требуется Срок окончания.',
	12029: 'Требуется действительный приоритетная задача.',
	12030: 'Статус этой заметки изменился. Вы больше не можете редактировать заметку или отвечать на нее. Пожалуйста, закройте и снова откройте окно, чтобы увидеть обновленные данные и продолжить редактирование.',
	12031: 'Комментарий должен быть верхнего уровня.',
	12032: 'Комментарий не должен быть верхнего уровня.',
	12033: 'По крайней мере одно из следующих значений не должно быть пустым: тип приоритета, срок выполнения, статус или назначенный пользователь.',
	12034: 'Комментарий превышает максимальную длину (4000 символов).',
	12035: 'Поисковая строка превышает максимальную длину (500 символов).',
	12036: 'Только идентификатор задачи или документ должен быть принят, оба не допускаются.',
	12037: 'Недопустимая Операция Исправления.',
	12038: 'Вы пытаетесь отредактировать заметку, которая больше не существует. Обновите страницу и повторите попытку.',
	12039: 'Вы пытаетесь отредактировать ту же заметку, что и другой член команды. Обновите страницу и повторите попытку.',
	12040: "Выполнить команду 'Получить комментарий по пользователям' не удалось.",
	12041: "Получить комментарий по пользователям' не удалось. Недопустимое значение запроса.",
	12042: 'Тип документа недопустим для создания комментария.',
	12043: 'Вы пытаетесь добавить заметку к задаче или документу, которые больше не существуют. Обновите страницу и повторите попытку.',
	12044: 'Вы пытаетесь отредактировать ответ на заметку, которая больше не существует. Обновите страницу и повторите попытку.',
	12045: 'Обзорная заметка не найдена.',
	12046: 'Выбранное примечание было уже удалено другим пользователем.',
	12047: "Вы можете удалять ответы только на заметки, которые находятся в статусе 'открыто'. Обновите страницу и повторите попытку.",
	12048: 'Вы пытаетесь изменить статус заметки, которая больше не существует. Обновите страницу и повторите попытку.',
	12049: 'Вы пытаетесь удалить ответ на заметку, которая уже была удалена другим членом команды. Обновите страницу и повторите попытку.',
	12050: "Вы можете удалить только те заметки, которые находятся в статусе 'Закрыто'.",
	12051: 'Примечания в виде комментариев можно создать только для действительных документов Хеликс.',
	12052: 'Примечание в виде комментария, которое вы ищете, удалено.',
	12060: 'Необходим входящий номер, должен быть больше 0 и меньше 1000.',
	12061: 'Reference number must be null.',
	12062: 'Annotations can only create to a comment.',
	12066: 'You are trying to reply to a note that is not open.',
	12067: 'You are trying to delete a reply to a comment that has already been deleted by another team member. Refresh the page and try again.',
	12068: 'You are trying to add a note with a recording that is invalid or no longer exists. Refresh the page and try again.',
	12069: 'You are trying to update a note with a recording that is invalid or no longer exists. Refresh the page and try again.',
	12070: 'You can only add one comment per financial statement. Please edit the existing.',
	12071: 'Failed to delete the information. Please try again. If the issue persists, contact the help desk.',

	/*Configuration*/
	13001: 'Конфигурации не найдены.',
	13002: "Выполнить команду 'Получить Конфигурации АПИ' не удалось.",

	/*Documents*/
	14001: 'Невозможно выполнить вызов, так как запрос равен нулю.',
	14002: 'Документ не найден. Сбой вызова.',
	14003: 'Идентификатор задания должен быть больше нуля.',
	14004: 'Идентификатор документа не должен быть нулевым или пустым.',
	14005: 'Ошибка при попытке получить связанные задачи. Сбой вызова.',
	14006: 'Выбранный документ не может быть удален. Попробуйте еще раз позже. Если проблема не устранена, обратитесь в Службу поддержки.',
	14007: 'Произошла непредвиденная ошибка.',
	14008: 'Во время выхода из системы произошла непредвиденная ошибка.',
	14009: 'При добавлении знака выключения произошла ошибка.',
	14010: 'Идентификатор утверждения должен быть больше нуля.',
	14011: 'При удалении знака выключения произошла ошибка.',
	14012: 'Содержание не может быть пустым.',
	14013: 'Выбранный документ не может быть разорван. Попробуйте еще раз позже. Если проблема не устранена, обратитесь в Службу поддержки.',
	14014: "Выполнить команду 'Получить счет по идентификатору документа' не удалось.",
	14015: 'Неверный связанный субъект.',
	14016: 'Получить одобрение документа не удалось.',
	14017: 'Получить все замечания по документам не удалось.',
	14018: 'Получить все документы не удалось. ',
	14019: 'Sign-off not found.',
	14020: 'Недопустимое значение действия.',
	14021: 'Недопустимый тип ошибки.',
	14022: 'Этот документ не относится к заданию.',
	14023: 'Тип изменения документа недопустим.',
	14024: 'Получить все документы не удалось. Параметры не верны.',
	14025: 'При создании обзора документа произошла ошибка. Вызов АПИ не удался.',
	14026: 'При удалении обзора документа произошла ошибка. Вызов АПИ не удался.',
	14027: 'Идентификатор задания не должен быть пустым или нулевым.',
	14028: 'Идентификатор пользователя недействителен.',
	14029: 'Пользователь не имеет права выполнять это действие.',
	14030: 'Никакого документа с пропущенным идентификатором в задании обнаружено не было.',
	14031: 'Идентификатор проверки документа недействителен.',
	14032: 'Обзор документа не был найден.',
	14033: 'Документ уже утвержден.',
	14034: 'Выполняется процесс отсоединения для другого задания в рабочей области или этот документ уже был отсоединен. Обновите страницу и повторите попытку. Если проблема не устранена, обратитесь в Службу поддержки.',
	14035: 'Этот документ не является общим для данного задания.',
	14036: 'Номер версии должен быть больше нуля.',
	14037: 'Операция не может быть завершена в настоящее время. Обновите страницу и повторите попытку. Если проблема не устранена обратитесь в справочную службу',
	14038: 'Не удалось получить причины изменения документа.',
	14039: 'Не удалось получить причину изменения документа по идентификатору.',
	14040: 'Не удалось обновить причину изменения.',
	14041: 'Недопустимая причина изменения.',
	14042: 'Обновить причину изменения не удалось.',
	14043: 'Не удалось создать причину изменения.',
	14044: 'Не удалось удалить причину изменения.',
	14045: 'Недопустимый идентификатор причины изменения.',
	14046: 'Документ недоступен. Обновите страницу и повторите попытку. Если проблема не устранена, обратитесь в Службу поддержки.',
	14047: 'Документ уже имеет назначенную причину изменения.',
	14048: 'Документ имеет конфликт, пожалуйста, разрешите его, прежде чем продолжить.',
	14049: 'Недопустимые данные для проверки того, добавлен ли документ в команду или пользователю.',
	14050: 'Ошибка при удалении справочного документа.',
	14052: 'Search text exceeds the maximum permitted length (500 characters).Search text exceeds the maximum permitted length (500 characters).',
	14053: 'Unable to perform call because the request is null.Unable to perform call because the request is null.',
	14054: 'Invalid Patch Operation.Invalid Patch Operation.',
	14055: 'Resolve Document history call failed.Resolve Document history call failed.',
	14056: 'An error has occurred when trying to queue the message.An error has occurred when trying to queue the message.',
	14057: 'A document with the same name already exists in the engagement.A document with the same name already exists in the engagement.',
	14058: 'More than one document version with the same number has been found. Please contact Help Desk for further assistance.More than one document version with the same number has been found. Please contact Help Desk for further assistance.',
	14059: 'The selected document version couldnt be found. Please refresh the page and try again. If the issue persists, please contact Help Desk for further assistance.The selected document version couldnt be found. Please refresh the page and try again. If the issue persists, please contact Help Desk for further assistance.',
	14060: 'The operation couldnt be completed at the time. Please try again later. If the issue persists, please contact Help Desk for further assistance.The operation couldnt be completed at the time. Please try again later. If the issue persists, please contact Help Desk for further assistance.',
	14061: 'Document is not shared, cant unlink the document. If the issue persists, please contact Help Desk for further assistance.Document is not shared, cant unlink the document. If the issue persists, please contact Help Desk for further assistance.',
	14062: 'The document confidentiality type id is not valid.The document confidentiality type id is not valid.',
	14063: 'Cannot change confidentiality type of this document type.Cannot change confidentiality type of this document type.',
	14064: 'User doesnt have permission.User doesnt have permission.',
	14065: 'Invalid custom description.Invalid custom description.',
	14066: 'Failed to update extension.Failed to update extension.',
	14067: 'Invalid extension.Invalid extension.',
	14068: 'Failed to get document extensions.Failed to get document extensions.',
	14069: 'This document has already been unlinked by another team member. Refresh the page and contact the Help Desk if the error persists.This document has already been unlinked by another team member. Refresh the page and contact the Help Desk if the error persists.',
	14070: 'Invalid file type.Invalid file type.',
	14071: 'The selected document version is no longer available. Please close and reopen this window to see the latest set of historical versions for the document.The selected document version is no longer available. Please close and reopen this window to see the latest set of historical versions for the document.',
	14072: 'Source document Id should not be null or empty.Source document Id should not be null or empty.',
	14073: 'Canvas form ids should not be null or empty.Canvas form ids should not be null or empty.',
	14074: "Canvas form ID's should not be duplicates.Canvas form ID's should not be duplicates.",
	14075: 'Failed to associate document to canvas forms.Failed to associate document to canvas forms.',
	14076: 'Source document associated Canvas forms not found.Source document associated Canvas forms not found.',
	14077: 'Source document not found. Call failed.Source document not found. Call failed.',
	14078: 'Current document is already associated with given canvas forms.Current document is already associated with given canvas forms.',
	14079: 'This document has been deleted and therefore it cannot be opened.This document has been deleted and therefore it cannot be opened.',
	14080: 'The source approval user id is invalid.The source approval user id is invalid.',
	14081: 'The source approval user id should valid GUID and must not be empty GUID.The source approval user id should valid GUID and must not be empty GUID.',
	14082: 'The modify user id is invalid.The modify user id is invalid.',
	14083: 'The modify user id should be a valid GUID and must not be empty GUID.The modify user id should be a valid GUID and must not be empty GUID.',
	14084: 'File name cannot include: */:<>\\?|""File name cannot include: */:<>\\?|""',
	14085: 'The document name exceeded maximum length allowed.The document name exceeded maximum length allowed.',
	14086: 'DocService failed while updating document details.DocService failed while updating document details.',
	14087: 'The input is not valid.The input is not valid.',
	14088: 'A input has duplicate document names.A input has duplicate document names.',
	14089: 'The bookmark observation is not valid.The bookmark observation is not valid.',
	14090: 'Request status has changed. Please refresh the page and try again if required. If the issue persists, contact the help desk.Request status has changed. Please refresh the page and try again if required. If the issue persists, contact the help desk.',
	14091: 'This request has been deleted. Refresh the page to view updated data. If the issue persists, contact the Help Desk.This request has been deleted. Refresh the page to view updated data. If the issue persists, contact the Help Desk.',
	14092: 'Document not eligible for update. Refresh the page and try again.  If the issue persists, contact the Help Desk.Document not eligible for update. Refresh the page and try again.  If the issue persists, contact the Help Desk.',

	/*SEM*/
	15001: "Выполнить команду 'Получить свод матрицы по существу для идентификатора счета' не удалось из-за недопустимого запроса.",
	15002: 'Неверный идентификатор счета.',
	15003: 'Неверный идентификатор задания.',
	15004: 'Недопустимый тип сводки.',
	15005: 'Связанный счет не может быть найден. Обновите страницу и повторите попытку. Если проблема не устранена, обратитесь в справочную службу.',

	/*Timephase*/
	16001: 'Получить временные фазы не удалось.',
	16002: 'Задание должно быть больше чем ноль.',
	16003: 'Временная фаза должна быть больше чем ноль.',
	16004: 'Недопустимое значение идентификатора задачи.',
	16005: 'Недопустимое значение фазы времени.',

	/*Validations*/
	17001: 'Отсутствует идентификатор шага сборки или идентификатор типа документа.',
	17003: 'The document could not be found. Refresh the page and try again. If the issue persists, contact Help Desk.',

	/*TaskGroupSection*/
	18001: 'Получить все группы задач не удалось.',

	/*Assignments*/
	19001: "Выполнить команду 'Создать задание' не удалось.",
	19002: "Выполнить команду 'Получить задание' не удалось.",

	/*Client Request*/
	21001: 'Связать запрос не удалось.',

	/*Related Components*/
	22001: "Выполнить команду 'Получить связанные элементы' не удалось.",

	/*Component Ceation*/
	22022: 'Component name already exists in this engagement',
	22024: 'The component that you are trying to send instructions to is not available or has already been deleted.',
	22027: 'Group Instruction found with no due date.',
	22028: 'Scope instruction is not yet published for the component.',
	22029: 'No new instruction published for the component to send.',

	22040: 'Instructions could not be sent. Check engagement type is correct.',
	22048: 'The component you are trying to update is copied from another engagement while copy engagement.',

	/*Send Instruction*/
	22049: 'RU Group instructions cannot be sent because one or more documents are in multi-user edit mode. End multi-editing mode and try to send instructions again. If the problem persists, contact EY Help Desk.',

	/*User Presence*/
	23001: 'Пользователи не найдены.',
	23002: 'Присутствие пользователя не подтверждено.',
	23003: 'Присутствие пользователя в документе не подтвеждено.',
	23004: 'Присутствие пользователя при удалении не подтверждено.',
	23005: 'Документ больше не открывается другими пользователями. Обновите страницу и повторите попытку. Если проблема не устранена, обратитесь в справочную службу.',

	/* Forms */
	24001: "Выполнить команду 'Получить форму' не удалось.",
	24002: 'Неверный идентификатор задания.',
	24003: 'Идентификатор документа не должен быть нулевым или пустым.',
	24005: 'Form header not found Form header not found.',
	24004: 'The document could not be found. Refresh the page and try again. If the issue persists, contact Help Desk. The document could not be found. Refresh the page and try again. If the issue persists, contact Help Desk.',
	24006: 'Section is not available. Refresh the page and try again. If the issue persists, contact the Help Desk Section is not available. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	24007: 'Неверные параметры запроса.',
	24008: 'Header id should not be null or empty.',
	24009: 'Section id should not be null or empty.',
	24010: 'Не удалось выполнить операцию обновления ответа содержания формы.',
	24011: 'Invalid request for form body response update.',
	24012: 'Body is not available. Refresh the page and try again. If the issue persists, contact the Help Desk Body is not available. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	24013: 'Invalid form body option id.',
	24014: 'Invalid form body type id.',
	24015: 'Invalid request body for given body type id.',
	24016: 'Invalid free text for given body type id.',
	24017: 'Максимальное количество символов, включая теги РТФ форматирования. Либо уменьшите длину, либо удалите ненужное форматирование и повторите попытку.',
	24018: 'For given body type id response is not allowed.',
	24019: 'Body id should not be null or empty.',
	24020: 'Недопустимое Содержание Запроса.',
	24021: 'Содержание удалено.',
	24022: 'Поле Страна не может быть нулевым или пустым.',
	24023: 'Язык не должен быть нулевым или пустым.',
	24024: 'Поле Вспомогательная сервисная линия не может быть нулевым или пустым.',
	24025: 'Слои ГАМ не должны быть нулевыми или пустыми.',
	24026: 'Ошибка вызова создания заголовка.',
	24027: 'Invalid request for header creation.',
	24028: 'Ошибка вызова создания дублирующего объекта.',
	24029: 'Неверный тип блока формы.',
	24030: 'Section has been deleted. Refresh the page and try again.If the issue persists, contact the Help Desk.',
	24031: 'Содержимое не редактируется.',
	24032: 'Недействительный запрос на создание заголовка.',
	24033: 'Supplied document entity id is not valid.',
	24034: 'Supplied entity id is not valid.',
	24035: 'An error occurred on creating related document.',
	24036: 'An error occurred on deleting related document.',
	24037: "Связанный документ не может быть равен нулю или содержать пустые значения',",
	24038: 'Неверный документ или документ не существует',
	24039: 'Related document is not valid or does not exist.',
	24040: 'Custom body creation failed.',
	24041: 'Неверный запрос на создание текстовой части',
	24042: 'Неверный запрос на создание раздела',
	24043: 'Запрос на поиск раздела по идентификатору не выполнен.',
	24044: 'Раздел не создан',
	24045: 'Неверный номер текущей страницы',
	24046: 'Неверный размер страницы',
	24047: 'Invalid document related object id.',
	24048: 'Объект уже прикреплен к форме Канвас.',
	24049: 'Объект не найден.',
	24050: 'Неверный уникальный идентификатор, принятый в компании.',
	24051: 'Если есть идентификатор компании, он должен быть представлен и наоборот.',
	24052: 'Canvas form snapshot creation failed.',
	24053: 'Запрос на поиск Заголовка по идентификатору не выполнен.',
	24054: 'Запрос на поиск Текста по идентификатору не выполнен.',
	24055: 'An error occurred on form profile create.',
	24056: 'Документ Форма профиля уже существует.',
	24057: 'Неудачная попытка валидации документа Форма профиля.',
	24058: 'Документа Форма профиля не существует.',
	24059: 'Раздел не подлежит адаптации.',
	24060: 'Неудачная попытка валидации документа Форма профиля. Если значение ПСАОБ-ИА верно, то ПСАОБ-ФО должно быть верно.',
	24061: 'Неудачная попытка валидации документа Форма профиля. Если значение ПСАОБ-ФО неверно, то ПСАОБ-ИА должно быть неверно.',
	24062: 'Неудачная попытка валидации документа Форма профиля. Если Несложная, то ПСАОБ-ФО/ПСАОБ-ИА должно быть неверно.',
	24063: 'Неверный идентификатор страны.',
	24064: 'Неверный идентификатор языка.',
	24065: 'Заголовок не подлежит адаптации.',
	24066: 'Неудачная попытка создания объекта, прикрепленного к разделу формы.',
	24067: 'Объект не найден.',
	24068: 'ВО не прикреплены к ЗКО.',
	24069: 'Неверный параметр {0}.',
	24070: 'Неверный уникальный идентификатор, принятый в материнской компании.',
	24071: 'Неудачная попытка поиска объекта, прикрепленного к разделу формы.',
	24072: 'Раздел недоступен. Обновите страницу и повторите попытку. Если проблему не удается устранить, обратитесь в службу технической поддержки.',
	24073: 'Невозможно получить снимок. Обновите страницу и повторите попытку. Если проблему не удается устранить, обратитесь в службу технической поддержки.',
	24074: 'Для выбранного документа снимки недоступны. Обновите страницу и повторите попытку. Если проблему не удается устранить, обратитесь в службу технической поддержки.',
	24075: 'Неверный идентификатор снимка.',
	24076: 'Идентификатор компании не может быть равен нулю или содержать пустые значения',
	24077: 'Идентификатор объекта, относящийся к разделу формы, является недействительным.',
	24078: 'Поле идентификатора объекта, относящегося к разделу формы, не может оставаться пустым или содержать нулевое значение.',
	24079: 'Предоставленный идентификатор материнской компании является недействительным.',
	24080: 'Объект, относящийся к разделу формы : запись о материнской компании не найдена.',
	24081: 'Объект не найден.',
	24082: 'Объект не найден.',
	24083: 'Произошла ошибка при обновлении профиля формы.',
	24084: 'Профиль формы документа не существует.',
	24085: 'Значение идентификатора языка должно быть больше нуля.',
	24086: 'Значение идентификатора страны должно быть больше нуля.',
	24087: 'Невозможно обновить документы из базы знаний. Для изменения профиля данной формы обновите профиль задания.',
	24088: 'Недостаточно полномочий для редактирования содержания. Для получения дополнительных прав обратитесь к администратору задания.',
	24089: 'Наименование настраиваемого заголовка документа превышает допустимую длину (500 символов). Исправьте наименование и повторите попытку.',
	24090: 'Наименование настраиваемого раздела превышает допустимую длину (500 символов). Исправьте наименование и повторите попытку.',
	24091: 'Ярлык настраиваемого раздела превышает допустимую длину (100 символов). Исправьте наименование и повторите попытку.',
	24092: 'Наименование настраиваемого текста превышает допустимую длину (500 символов). Исправьте наименование и повторите попытку.',
	24093: 'Поле имени настраиваемого раздела не может оставаться пустым или содержать нулевое значение.',
	24094: 'Поле имени текста не может оставаться пустым или содержать нулевое значение.',
	24096: 'Поле имени настраиваемого заголовка не может оставаться пустым или содержать нулевое значение.',
	24097: 'В настоящий момент процесс замены не может быть завершен.',
	24098: 'Идентификатор типа исходного или конечного документа является недействительным.',
	24099: 'Идентификатор исходного и конечного документа информационной формы не совпадает.',
	24100: 'Идентификатор исходного документа не может быть равен нулю или содержать пустые значения.',
	24101: 'Идентификатор конечного документа не может быть равен нулю или содержать пустые значения.',
	24103: 'Заголовок удален. Обновите страницу и повторите попытку. Если проблему не удается устранить, обратитесь в службу технической поддержки. ',
	24104: 'Заголовок не подлежит редактированию.',
	24105: 'Текст не подлежит редактированию.',
	24106: 'Обновление не допустимо.',
	24107: 'Неудачная попытка валидации профиля формы документа.Если значение ПСАОБ-ФО верно, то «Сложная модель» должно быть верно.',
	24108: 'Неудачная попытка валидации профиля формы документа.Если значение ПСАОБ-ИА верно, то ПСАОБ-ФО должно быть верно.',
	24110: 'Выполняется обновление содержания. Вручную обновите содержание данной формы на странице обновления содержания формы Канвас после завершения обновления текущего содержания. ',
	24111: 'Значения схемы и разъединения не могут совпадать.',
	24112: 'Невозможно предоставить доступ к исходному документу.',
	24114: 'Не удалось прикрепить доказательства. Обновите страницу и повторите попытку.',
	24115: 'Не удалось удалить доказательства.Обновите страницу и повторите попытку.',
	24116: 'Не удалось активировать профиль. Обновите страницу и повторите попытку.',
	24117: 'В форме присутствуют незаполненные ответы. Обновите страницу и повторите попытку.',
	24118: 'Идентификатор документа и идентификатор связанного документа не могут быть одинаковыми.',
	24119: 'Не удалось отредактировать объекты, связанные с текстом.',
	24120: 'Идентификатор объекта, связанного с текстом, не может быть равен нулю или содержать пустые значения.',
	24121: 'Объект не найден.',
	24122: 'Отсутствует символ параллельного доступа',
	24124: 'Найден(-ы) недопустимый(-ые) целевой(-ые) документ(-ы).',
	24125: 'Целевая(-ые) форма(-ы) Канвас не найдена(-ы).',
	24126: 'Поле для запроса не должно быть пустым.',
	24127: 'Импорт данных из ЭЯ Хеликс не выполнен. Установите настройки ЭЯ Хеликс для импорта данных и повторите попытку. Если проблему не удается устранить, обратитесь в службу технической поддержки.',
	24155: 'Отправка профиля не разрешена для восстановленных заданий.',
	24164: 'У вас нет достаточных прав для внесения изменений в шаблон.',
	24166: 'Save profile is not permitted. Form is not available for this profile.',
	24167: 'Body type cannot be updated',
	24168: 'Modify User Id should not be null or empty',
	24169: 'Modify User Id can only have value when linkedResponseUpdate is false',
	24170: 'Invalid task id in request',
	24171: 'Duplicate body ids in request',
	24172: 'Section compare call failed',
	24173: 'Document Ids cannot be empty. As well it cannot exceed distinct 50 documents at a time',
	24174: 'Route document should be part of request body documentids',
	24175: 'Invalid smart evidence entity id in request body',
	24176: 'Body documentids should have same knowledge form id',
	24177: 'Invalid section id',
	24178: 'Invalid combination of DocumentID and DocumentIDList',
	24179: 'DocumentIds list cannot be greater than 50',
	24180: 'Materiality could not be updated',
	24181: 'Invalid Form Body Id',
	24182: 'Invalid Knowledge FormId Or Knowledge FormBody Id',
	24183: 'An error has occurred while relating the document to this form. Please refresh the page and try again. If the issue persists, contact Help Desk',
	24184: 'User is not active for this EY Canvas engagement. Invite the user via manage team and then try again. If the issue persists contact the Help DeskUser is not active for this EY Canvas engagement. Invite the user via manage team and then try again. If the issue persists contact the Help Desk',

	/*Document Change Types*/
	25001: 'Получить типы изменения документа не удалось.',
	25002: 'Неверный идентификатор задания.',
	25003: 'Неверный запрос.',

	/* Manage team */
	26001: 'Не удалось получить группы пользователей.',
	26002: 'Не удалось создать группу клиента / домен электронной почты.',
	26003: 'Название Группы не должно быть нулевым.',
	26004: 'Почта домена не должна быть нулевой.',
	26005: '{0} метка домена электронной почты не должна превышать 263 символов.',
	26006: '{0} домен электронной почты не должен превышать 263 символов.',
	26007: '{0} первая часть домена электронной почты может быть * или буквенно-цифровой, другие специальные символы не допускаются.',
	26008: '{{0} Если первая часть является уникальным символом, то за ней должны следовать две или более частей.',
	26009: '{0} первая часть может быть * или буквенно-цифровой, в других частях домена специальные символы не допускаются.',
	26010: 'Домен электронной почты должен быть уникальным.',
	26011: 'Предоставленный идентификатор группы клиентского доступа недопустим.',
	26012: 'При удалении группы доступа произошла ошибка. Убедитесь, что нет никаких запросов/внешних задач, назначенных этой группе или членам этой группы, и повторите попытку.',
	26013: 'Группа доступа уже удалена, пожалуйста, обновите страницу, чтобы получить последние данные.',
	26014: 'Требуется хотя бы один домен электронной почты.',
	26015: 'Клиентский портал ЭЯ Канвас в настоящее время недоступен и необходимо обновить существующую информацию о членах. Повторите попытку и, если проблема не устранена, обратитесь в Службу поддержки.',
	26016: 'Ошибка во время операции удаления.',
	26017: 'Операция получения данных не удалась.',
	26018: 'Проблема согласованности, группа доступа больше не активна.',
	26019: 'Операция сохранения не удалась.',
	26020: 'Домены электронной почты не могут быть удалены, если им назначены активные пользователи. Изменения не были сохранены.',

	/* TimePhaseTypes - Milestones */
	27001: 'Получить сведения о контрольной точке не удалось.',

	/*Client Request Counts*/
	28001: "Выполнение команды 'Получить запросы на клиентскую информцию' не принес никаких результатов.",

	/*Content updates Error messages*/
	29001: 'Не удалось получить по идентификатору.',
	29002: 'Тип действия не найден.',
	29003: 'Содержание идентификатор (ов) не найдено.',
	29004: 'Не удалось обновить контент.',
	29005: 'Обновление контента в процессе. Попробуйте позже и, если проблема сохраняется, свяжитесь с администратором.',
	29006: 'Неверные параметры запроса.',

	/*IT Process*/
	30001: 'Получить все ИТ-процессы не удалось.',
	30002: 'Получить все ИТ-процессы - некорректный идентификатор задания.',
	30003: 'Поле с наименованием ИТ-процесса не может оставаться пустым.',
	30004: 'Наименование ИТ-процесса не должно превышать 500 символов.',
	30005: 'Не удалось выполнить операцию. Обновите страницу и повторите попытку. Если проблему не удается устранить, обратитесь в службу технической поддержки.',
	30006: 'Не удалось найти ИТ-процесс по идентификатору.',
	30007: 'Неверный запрос.',
	30008: 'ИТ-процесс не найден.',
	30009: 'Документ не найден.',
	30010: 'Не удалось удалить. Обновите страницу и повторите попытку. Если проблему не удается устранить, обратитесь в службу технической поддержки.',
	30012: 'Не удалось удалить. Обновите страницу и повторите попытку. Если проблему не удается устранить, обратитесь в службу технической поддержки.',

	/*Checklist*/
	31001: 'Получить все чеклисты не удалось.',
	31002: 'Не удалось установить чеклисты.',
	31003: 'Неверный параметр контрольного листа.',
	31004: 'Недопустимая Ошибка Задания.',
	31005: 'Недопустимая Ошибка Параметров Запроса.',
	31006: 'Недопустимая ошибка параметра запроса проверки.',

	/*Archive*/
	32001: 'Идентификатор статуса задания недействителен.',
	32002: 'Архивирование не удалось.',
	32003: 'Вызов АРК не удался, обновите страницу, разрешите проверки и повторите попытку архивирования. Если ошибка не устранена, обратитесь в справочную службу.',
	32004: 'Обновление статуса задания в ЛДС не удалось.',
	32005: 'Аннулировать Ошибку Кэша Взаимодействия.',
	32006: 'Идет обновление контента. Вы не можете архивировать это задание до тех пор, пока не будет завершено обновление контента. Повторите попытку позже и обратитесь в Службу поддержки, если ошибка не устранена.',
	32007: 'АркГУИД является нулевым или пустым.',
	32008: 'ФайлГУИД является нулевым или пустым.',
	32009: 'ФайлСторХостТсп является нулевым или пустым.',
	32200: 'В этом задании есть нерешенные утверждения. Обновите страницу, разрешите проверки и повторите попытку архивирования. Если ошибка не устранена, обратитесь в справочную службу.',
	32300: 'В этом задании есть нерешенные утверждения. Обновите страницу, разрешите проверки и повторите попытку архивирования. Если ошибка не устранена, обратитесь в справочную службу.',

	/*RBAC*/
	33001: 'Идентификатор задания не найден.',
	33002: 'Идентификатор пользователя не найден.',

	/*Helix Linked Projects*/
	34001: 'Невозможно выполнить вызов, так как запрос равен нулю.',
	34002: 'Идентификатор задания не может быть нулевым или пустым.',
	34003: 'Содержание не может быть нулевым или пустым в данном вызове.',
	34004: 'Идентификатор проекта не может быть нулевым или пустым.',
	34005: 'Наменование проекта не может быть нулевым или пустым.',
	34006: 'Проект уже был связан, обновите страницу и повторите попытку.',
	34007: "Выполнить команду 'Получить все Хеликс проекты' не удалось.",
	34008: 'Идентификатор задания должен быть больше чем ноль.',
	34010: 'Сохранение не может быть завершено. Обновите страницу и повторите попытку. Если проблему не удается устранить, обратитесь в службу технической поддержки.',
	34009: 'Идентификатор проекта изменен. Обновите страницу и повторите попытку.',
	34011: 'Вид валюты в запросе не может быть равен нулю.',
	34012: 'Код валюты в запросе не может быть равен нулю.',
	34013: 'Бизнес-подразделение в запросе не может быть равно нулю или содержать пустые значения.',
	34014: 'Связанный проект ЭЯ Хеликс изменен, невозможно обновить настройки.',
	34017: 'Невозможно подключиться к ЭЯ Хеликс. Обновите страницу и повторите попытку. Если проблему не удается устранить, обратитесь в службу технической поддержки.',
	34018: 'Невозможно завершить операцию. Обновите страницу и повторите попытку. Если проблему не удается устранить, обратитесь в службу технической поддержки.',
	34019: 'Импорт завершен, но данные недействительны. Обновите страницу и нажмите на кнопку «Импорт», чтобы повторить попытку.',
	34027: 'Helix Project is in progress.',
	34036: 'Could not connect to EY Helix. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	34039: 'This EY Helix project is no longer the primary project for your engagement. Please refresh the page and try again.',
	34040: 'You must have the <b>EY Helix Import</b> permission to take this action. Speak with an engagement administrator to gain access.',

	/* PAANS */
	35001: 'В настоящее время служба разработки, утверждения и уведомления политики ЭЯ недоступна. Мы не можем подтвердить, что все соответствующие политики были завершены. Если вы еще не ознакомились с соответствующими политиками, обновите страницу и повторите попытку. Если проблема не устранена, обратитесь в Службу поддержки.',

	/*Engagement Comments*/
	38001: 'Невозможно выполнить данное действие. Обновите страницу и повторите попытку. Если ошибку не удается устранить, обратитесь в службу технической поддержки',
	38002: 'Невозможно выполнить данное действие. Обновите страницу и повторите попытку. Если ошибку не удается устранить, обратитесь в службу технической поддержки',
	38003: 'Невозможно выполнить данное действие. Обновите страницу и повторите попытку. Если ошибку не удается устранить, обратитесь в службу технической поддержки',
	38004: 'Невозможно выполнить данное действие. Обновите страницу и повторите попытку. Если ошибку не удается устранить, обратитесь в службу технической поддержки',
	38005: 'Невозможно выполнить данное действие. Обновите страницу и повторите попытку. Если ошибку не удается устранить, обратитесь в службу технической поддержки',
	38006: 'Невозможно выполнить данное действие. Обновите страницу и повторите попытку. Если ошибку не удается устранить, обратитесь в службу технической поддержки',
	38007: 'Невозможно выполнить данное действие. Обновите страницу и повторите попытку. Если ошибку не удается устранить, обратитесь в службу технической поддержки',
	38008: 'Невозможно выполнить данное действие. Обновите страницу и повторите попытку. Если ошибку не удается устранить, обратитесь в службу технической поддержки',
	38009: 'Невозможно выполнить данное действие. Обновите страницу и повторите попытку. Если ошибку не удается устранить, обратитесь в службу технической поддержки',
	38010: 'Невозможно выполнить данное действие. Обновите страницу и повторите попытку. Если ошибку не удается устранить, обратитесь в службу технической поддержки',
	38011: 'Невозможно выполнить данное действие. Обновите страницу и повторите попытку. Если ошибку не удается устранить, обратитесь в службу технической поддержки',
	38012: 'Невозможно выполнить данное действие. Обновите страницу и повторите попытку. Если ошибку не удается устранить, обратитесь в службу технической поддержки',
	38013: 'Невозможно выполнить данное действие. Обновите страницу и повторите попытку. Если ошибку не удается устранить, обратитесь в службу технической поддержки',
	38014: 'Невозможно выполнить данное действие. Обновите страницу и повторите попытку. Если ошибку не удается устранить, обратитесь в службу технической поддержки',
	38015: 'Невозможно выполнить данное действие. Обновите страницу и повторите попытку. Если ошибку не удается устранить, обратитесь в службу технической поддержки',
	38016: 'The note that you are replying to has been deleted by another team member. Refresh the page and try again',
	38017: 'Невозможно выполнить данное действие. Обновите страницу и повторите попытку. Если ошибку не удается устранить, обратитесь в службу технической поддержки',
	38018: 'Невозможно выполнить данное действие. Обновите страницу и повторите попытку. Если ошибку не удается устранить, обратитесь в службу технической поддержки',
	38019: 'Невозможно выполнить данное действие. Обновите страницу и повторите попытку. Если ошибку не удается устранить, обратитесь в службу технической поддержки',
	38020: 'Невозможно выполнить данное действие. Обновите страницу и повторите попытку. Если ошибку не удается устранить, обратитесь в службу технической поддержки',
	38021: 'Невозможно выполнить данное действие. Обновите страницу и повторите попытку. Если ошибку не удается устранить, обратитесь в службу технической поддержки',
	38022: 'Невозможно выполнить данное действие. Обновите страницу и повторите попытку. Если ошибку не удается устранить, обратитесь в службу технической поддержки',
	38023: 'Невозможно выполнить данное действие. Обновите страницу и повторите попытку. Если ошибку не удается устранить, обратитесь в службу технической поддержки',
	38024: 'Невозможно выполнить данное действие. Обновите страницу и повторите попытку. Если ошибку не удается устранить, обратитесь в службу технической поддержки',
	38025: 'The note status has changed. Refresh the page and try again.',
	38026: 'Невозможно выполнить данное действие. Обновите страницу и повторите попытку. Если ошибку не удается устранить, обратитесь в службу технической поддержки',
	38027: 'Невозможно выполнить данное действие. Обновите страницу и повторите попытку. Если ошибку не удается устранить, обратитесь в службу технической поддержки',
	38028: 'Невозможно выполнить данное действие. Обновите страницу и повторите попытку. Если ошибку не удается устранить, обратитесь в службу технической поддержки',
	38029: "Only the author can change the comment's text",
	38030: 'Невозможно выполнить данное действие. Обновите страницу и повторите попытку. Если ошибку не удается устранить, обратитесь в службу технической поддержки',
	38031: 'Связь потеряна. Переподключитесь и повторите попытку. Если проблема не устранена, обратитесь в Службу поддержки.',
	38032: 'There was no relationship record between the requested user and the engagement. Refresh the page and try again. If the error persists contact the Help Desk',
	38033: 'Невозможно выполнить данное действие. Обновите страницу и повторите попытку. Если ошибку не удается устранить обратитесь в службу технической поддержки',
	38034: 'Невозможно выполнить данное действие. Обновите страницу и повторите попытку. Если ошибку не удается устранить обратитесь в службу технической поддержки',
	38035: 'Невозможно выполнить данное действие. Обновите страницу и повторите попытку. Если проблему не удается устранить обратитесь в службу технической поддержки',
	38036: 'Document Id should not be null or empty',
	38037: 'The Id of the user the comment will be assigned to should not be null',
	38038: 'The comment should not be reassigned while opening it or closing it',
	38039: 'The note that you are deleting a reply from has already been deleted. Refresh the page and try again',
	38040: 'Reply should not have due date',
	38041: 'Reply should not have priority',
	38042: 'Comment should have due date',
	38043: 'Comment should have priority',
	38044: 'You are trying to edit a reply to a comment that no longer exists. Refresh the page and try again',
	38045: 'Невозможно выполнить данное действие. Обновите страницу и повторите попытку. Если проблему не удается устранить, обратитесь в службу технической поддержки',
	38046: 'Update EngagementComments call failed',
	38047: 'You can only reply to open notes',

	39004: 'This tag group is no longer available. Refresh the page and try again. If the issue persists, contact the Help Desk. This tag group is no longer available. Refresh the page and try again. If the issue persists, contact the Help Desk.',

	/*IT App/SO*/
	81001: 'Не удалось найти все ИТ-приложения.',
	81002: 'Найти все ИТ-приложения - недопустимый идентификатор задания.',
	81003: 'ИТ-приложение/ОО не найдены.',
	81004: 'Операция не может быть выполнена. Обновите страницу и повторите попытку. Если проблему не удается устранить, обратитесь в службу технической поддержки.',
	81005: 'Операция не может быть выполнена. Обновите страницу и повторите попытку. Если проблему не удается устранить, обратитесь в службу технической поддержки.',
	81006: 'Недопустимый тип стратегии.',
	81007: 'Недопустимый идентификатор документа.',
	81008: 'Не удалось найти ИТ-приложение по идентификатору.',
	81009: 'Операция не может быть выполнена. Обновите страницу и повторите попытку. Если проблему не удается устранить, обратитесь в службу технической поддержки.',
	81010: 'Операция не может быть выполнена. Обновите страницу и повторите попытку. Если проблему не удается устранить, обратитесь в службу технической поддержки.',
	81011: 'Операция не может быть выполнена. Обновите страницу и повторите попытку. Если проблему не удается устранить, обратитесь в службу технической поддержки.',
	81012: 'Поле для идентификатора ИТ-приложения не может быть пустым.',
	81013: 'Операция не может быть выполнена. Обновите страницу и повторите попытку. Если проблему не удается устранить, обратитесь в службу технической поддержки.',
	81014: 'Не удалось удалить ИТ-процесс в рамках ИТ-приложения.',
	81015: 'Поле для идентификатора ИТ-процесса в рамках ИТ-приложения не может быть пустым.',
	81016: 'Недопустимый идентификатор ИТ-процесса в рамках ИТ-приложения.',
	81017: 'Невозможно завершить удаление. Обновите страницу и повторите попытку. Если проблему не удается устранить, обратитесь в службу технической поддержки.',
	81018: 'Не удалось создать ИТ-процесс в рамках ИТ-приложения.',
	81019: 'Вместо ИТ-приложения указана сервисная организация.',
	81020: 'Удаление невозможно. Обновите страницу и повторите попытку. Если проблему не удается устранить, обратитесь в службу технической поддержки.',

	/* ITControl */
	84001: 'Не удалось найти средства ИТ-контроля.',
	84002: 'Не удалось найти средство ИТ-контроля по идентификатору.',
	84003: 'Идентификатор средства ИТ-контроля не указан.',
	84004: 'Недопустимый идентификатор средства ИТ-контроля.',
	84005: 'Недопустимый идентификатор документа.',
	84006: 'Наименование средства ИТ-контроля отсутствует.',
	84007: 'Недопустимая длина наименования средства ИТ-контроля.',
	84008: 'Недопустимый идентификатор периодичности использования средства ИТ-контроля.',
	84009: 'Недопустимый идентификатор типа подхода к использованию средства ИТ-контроля.',
	84010: 'Недопустимый идентификатор типа эффективности структуры средства ИТ-контроля.',
	84011: 'Недопустимое значение тестирования средства ИТ-контроля.',
	84012: 'Недопустимый идентификатор типа операционной эффективности средства ИТ-контроля.',
	84013: 'Данные о периодичности использования средства ИТ-контроля отсутствуют.',
	84014: 'Не удалось удалить средство ИТ-контроля.',
	84015: 'Строка поиска не может содержать более 100 символов.',
	84016: 'Невозможно завершить операцию. Обновите страницу и повторите попытку. Если проблему не удается устранить, обратитесь в службу технической поддержки.',
	84018: 'Невозможно завершить операцию. Обновите страницу и повторите попытку. Если проблему не удается устранить, обратитесь в службу технической поддержки.',
	84019: 'Невозможно завершить обновление. Обновите страницу и повторите попытку. Если проблему не удается устранить, обратитесь в службу технической поддержки.',

	/*ITRisk*/
	86001: 'Поле с наименованием ИТ-риска не может оставаться пустым.',
	86002: 'Наименованием ИТ-риска не должно превышать 500 символов.',
	86003: 'Невозможно завершить привязку. Обновите страницу и повторите попытку. Если проблему не удается устранить, обратитесь в службу технической поддержки.',
	86004: 'Не удалось найти ИТ-процесс по идентификатору.',
	86005: 'Не удалось выполнить операцию. Обновите страницу и повторите попытку. Если проблему не удается устранить, обратитесь в службу технической поддержки.',
	86006: 'Невозможно завершить привязку. Обновите страницу и повторите попытку. Если проблему не удается устранить, обратитесь в службу технической поддержки.',
	86007: 'Невозможно завершить удаление. Обновите страницу и повторите попытку. Если проблему не удается устранить, обратитесь в службу технической поддержки.',
	86008: 'Невозможно завершить привязку. Обновите страницу и повторите попытку. Если проблему не удается устранить, обратитесь в службу технической поддержки.',
	86009: 'Невозможно завершить удаление. Обновите страницу и повторите попытку. Если проблему не удается устранить, обратитесь в службу технической поддержки.',
	86010: 'Не удалось удалить ИТ-риск.',

	/*RiskFactorFormHeaders*/
	89001: 'Связь факторов риска не выявлена.',
	89002: 'Документ не найден.',
	89003: 'Идентификатор документа отсутствует.',
	89004: 'Длина обоснования превышает допустимое значение (4 000 символов).',
	89005: 'Риск не может быть привязан к выбранному фактору риска. Обновите страницу и повторите попытку. Если проблему не удастся устранить, обратитесь в службу технической поддержки.',
	89014: 'The risk id is not valid',
	89020: 'Фактор риска не может быть сохранен.  Обновите страницу и повторите попытку.  Если проблему не удается устранить обратитесь в службу технической поддержки',

	/*Materiality*/
	91001: 'Информация об уровне существенности не обнаружена.',
	91002: 'Данные не могут быть сохранены. Обновите страницу и повторите попытку. Если проблему не удается устранить, обратитесь в службу технической поддержки.',
	91003: 'Неверный запрос на обновление информации об уровне существенности.',
	91004: 'Информация об ожидаемой среднегодовой сумме, которая должна быть представлена в отчетности, отсутствует. ',
	91005: 'При обновлении информации об ожидаемой среднегодовой сумме, которая должна быть представлена в отчетности, необходимо указать прогнозную базовую сумму. ',
	91006: 'Прогнозная базовая сумма не должна содержать более 15 цифр и может быть представлена только в виде целого числа.',
	91007: 'При обновлении информации об ожидаемой среднегодовой сумме, которая должна быть представлена в отчетности, обоснование расчета прогнозной базовой суммы должно быть принято равным нулю. ',
	91008: 'The basis forecast amount rationale is either too short or too long.',
	91009: 'Invalid materiality id',
	91010: 'Invalid materiality body type id',
	91011: 'Nominal amount cannot exceed the higher end of the range',
	91012: 'Materiality amount should not be more than 15 digits and 4 decimals',

	/*Group Structure - Sub Scopes */
	92013: 'RU Подобласть не может быть удалена, поскольку существует как минимум одна связанная с ней региональная/компонентная группа.',
	92016: 'RU Sub-scope name already exist',

	/*Helix Account Mappings */
	94001: 'Невозможно сохранить проверку соответствия счетов. Обновите страницу и повторите попытку. Если проблему не удается устранить, обратитесь в службу технической поддержки.',
	94004: 'Один или несколько счетов ЭЯ Канвас были удалены и не могут быть сопоставлены. Обновите страницу и повторите попытку.',
	94005: 'Невозможно возобновить проект. Обновите страницу и повторите попытку. Если проблему не удается устранить, обратитесь в службу технической поддержки.',

	/*Group Instructions */
	98001: 'An error occurred retrieving group instructions. Refresh the page and try again. If the issue persists, contact the Help desk.',
	98002: 'One or more Knowledge instruction section IDs is not valid.',
	98003: 'An error occurred creating group instructions. Refresh the page and try again. If the issue persists, contact the Help desk.',
	98004: 'Instruction name cannot be empty.',
	98005: 'Instruction name cannot have more than 500 characters.',
	98006: 'Instruction description cannot be empty.',
	98007: 'Instruction description cannot have more than 30,000 characters.',
	98009: 'Instruction name cannot be duplicated.',
	98010: 'Due date cannot be empty.',
	98011: 'Instruction already deleted.',
	98012: 'Instruction not found.',
	98013: 'Instruction ID must be greater than zero.',
	98014: 'An error occurred saving group instructions. Refresh the page and try again. If the issue persists, contact the Help desk.',
	98015: 'Instruction mandatory scopes cannot be deleted.',
	98016: 'Instruction has been deleted',
	98017: 'Group task already deleted.',
	98018: 'Edit group task after delete.',
	98019: 'Entity not found.',

	98020: 'Unable to generate the risk assessment package. Refresh the page and try again. If the issue persists, please contact the Help Desk.',

	98021: 'Document name cannot be empty.',
	98022: 'Document name cannot have more than 115 characters.',
	98023: 'Document name cannot have invalid XML characters.',
	98024: 'The package creation process is in progress, it may take up to ten minutes for it to be completed',
	98025: 'Some instruction(s) do not have related component(s). Allocate component(s) to instructions and then Generate Group risk assessment communications again.',
	98026: 'Some component(s) do not have related account(s). Relate account(s) to component(s) and then Generate Group risk assessment communications again.',
	98027: 'Some Account(s) do not have Account document(s). Create Account document and then Generate Group risk assessment communications again.',
	98028: 'This Canvas Form is not associated to a valid task.',
	98029: 'One or more components are reference only.',
	98030: "One or more components aren't from this primary team engagement.",
	98031: 'One or more scopes are not from this primary team engagement.',
	98032: 'Document count has exceeded the limit.',
	98033: 'Required scopes cannot be deleted from the instruction.',

	/*Estimate */
	115017: 'Estimate not found',

	/* Group Audit */
	106003: 'Error. Please refresh and try again.',

	/* TasksOverview */
	117001: 'Get all TaskOverview call failed.',
	117002: 'Get all TaskOverview request cannot be empty.',
	117003: 'Invalid engagement ID.',
	117004: 'Invalid TaskCategory value.',
	117005: 'Invalid View value.',
	117006: 'Invalid DocumentCategorySearch value.',
	117007: 'Duplicate TaskCategory IDs.',
	117008: 'Duplicate TimePhase IDs.',
	117009: 'Duplicate Task IDs.',
	117010: 'Duplicate Document IDs.',
	117011: 'Duplicate AssignedToUser IDs.',

	/* Multientity */
	114001: 'Get all MultiEntity failed.',
	114002: 'STEntityName cannot be empty.',
	114003: 'STEntityName should not be more than 500 characters.',
	114004: 'STLegalName cannot be empty.',
	114005: 'STLegalName should not be more than 500 characters.',
	114006: 'Multi Entity can be created only with MEST Engagements.',
	114007: 'Create Multi Entity Account call failed.',
	114008: 'The selected STEntity has been deleted. Close this modal to see the updated list. The selected STEntity has been deleted. Close this modal to see the updated list.',
	114009: 'Invalid account id.',
	114010: 'STEntityShortName should not be more than 100 characters.',
	114011: 'STEntity submit profile request is invalid.',
	114012: 'STEntity submit profile request body is invalid.',
	114013: 'STEntity submit profile request body should have distinct STEntityIDs.',
	114014: 'STEntityIDs for submit profile request are invalid.',
	114015: 'Form has incomplete responses. Refresh the page and try again.',
	114016: 'The content update is disabled for this.',
	114017: 'Engagement has no Multi Entity Individual Profile document.',
	114018: 'STEntity IDs missing Multi entity individual profile.',
	114019: 'One or more entity that you are mapping no longer exists in the engagement. Please refresh the page and try again.',
	114020: 'STEntityShortName cannot be empty.',
	114021: 'Invalid DocumentId. Invalid DocumentId.',
	114022: 'Invalid EngagementId. Invalid EngagementId.',
	114023: 'STEntityDocument record already exists. STEntityDocument record already exists.',
	114024: 'STEntityDocument record does not exist. STEntityDocument record does not exist.',
	114025: 'STEntityDocument record IsSystemAssociated. STEntityDocument record IsSystemAssociated.',
	114026: 'Invalid Request Body. Invalid Request Body.',

	/* Sample List */
	121101: 'Invalid Sample List ID. Invalid Sample List ID.',
	121008: 'Invalid Sample List ID. Invalid Sample List ID.',
	121011: 'This sample is no longer available. Refresh the page and try again. Contact the Help Desk if the error persists This sample is no longer available. Refresh the page and try again. Contact the Help Desk if the error persists.',
	121013: 'This sample is no longer available in this engagement. Refresh the page and try again. Contact the Help Desk if the error persists. This sample is no longer available in this engagement. Refresh the page and try again. Contact the Help Desk if the error persists.',
	121016: 'This sample is no longer available. Refresh the page and try again. Contact the Help Desk if the error persists. This sample is no longer available. Refresh the page and try again. Contact the Help Desk if the error persists.',
	121037: 'An error occurred while taking this action. Refresh the page and try again. Contact the Help Desk if the error persists. An error occurred while taking this action. Refresh the page and try again. Contact the Help Desk if the error persists.',
	121012: 'Attribute status cannot be updated. Refresh the page and try again. Contact the Help Desk if the error persists. Attribute status cannot be updated. Refresh the page and try again. Contact the Help Desk if the error persists.',
	121025: 'This document is no longer available. Refresh the page and try again. Contact the Help Desk if the error persists.This document is no longer available. Refresh the page and try again. Contact the Help Desk if the error persists.',
	121027: 'Document relation cannot be edited. Refresh the page and try again. If the issue persists, contact the Help Desk.Document relation cannot be edited. Refresh the page and try again. If the issue persists, contact the Help Desk.',
    121028: 'Document relation cannot be edited. Refresh the page and try again. If the issue persists, contact the Help Desk.Document relation cannot be edited. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	121014: 'Attribute status cannot be updated. Refresh the page and try again. Contact the Help Desk if the error persists. Attribute status cannot be updated. Refresh the page and try again. Contact the Help Desk if the error persists.',
	121029: "This attribute is no longer available. Refresh the page and try again. Contact the Help Desk if the error persists. This attribute is no longer available. Refresh the page and try again. Contact the Help Desk if the error persists.",
	121021: "Attribute status cannot be updated. Refresh the page and try again. Contact the Help Desk if the error persists. Attribute status cannot be updated. Refresh the page and try again. Contact the Help Desk if the error persists.",

	/*Control Attributes */
	122018: 'Could not complete action. Refresh the page and try again. If the issue persists contact the Help Desk. Could not complete action. Refresh the page and try again. If the issue persists contact the Help Desk.',
	122021: 'An error occurred while taking this action. Refresh the page and try again. Contact the Help Desk if the error persists. An error occurred while taking this action. Refresh the page and try again. Contact the Help Desk if the error persists.',

	/*Flow chart*/
	123031: 'Form Body Id cannot not be linked to more than one flowcharts. Form Body Id cannot not be linked to more than one flowcharts.',

	/*FlowchartStepControl*/
	123054: 'Control relation cannot be edited. Refresh the page and try again. Contact the Help Desk if the error persists. Control relation cannot be edited. Refresh the page and try again. Contact the Help Desk if the error persists.',
	123045: 'This control is no longer available. Refresh the page and try again. Contact the Help Desk if the error persists. This control is no longer available. Refresh the page and try again. Contact the Help Desk if the error persists.',

	/*FlowchartStepWCGW*/
	123022 : 'This flowchart step is no longer available. Refresh the page and try again. Contact the Help Desk if the error persists. This flowchart step is no longer available. Refresh the page and try again. Contact the Help Desk if the error persists.',
	123023 : 'This flowchart step is no longer available. Refresh the page and try again. Contact the Help Desk if the error persists. This flowchart step is no longer available. Refresh the page and try again. Contact the Help Desk if the error persists.',
	123055 : 'WCGW relation cannot be edited. Refresh the page and try again. Contact the Help Desk if the error persists. WCGW relation cannot be edited. Refresh the page and try again. Contact the Help Desk if the error persists.',

	/*FlowchartStepITApplicationSO*/
	123056 : 'IT Application / service organization relation cannot be edited. Refresh the page and try again. Contact the Help Desk if the issue persists. IT Application / service organization relation cannot be edited. Refresh the page and try again. Contact the Help Desk if the issue persists.',



	/*FlowchartStepDocument*/
	123048: 'Document relation cannot be edited. Refresh the page and try again. Contact the Help Desk if the error persists. Document relation cannot be edited. Refresh the page and try again. Contact the Help Desk if the error persists.',
	123033: 'This flowchart step is no longer available. Refresh the page and try again. Contact the Help Desk if the error persists. This flowchart step is no longer available. Refresh the page and try again. Contact the Help Desk if the error persists.',
	123002: 'This document is no longer available. Refresh the page and try again. Contact the Help Desk if the error persists. This document is no longer available. Refresh the page and try again. Contact the Help Desk if the error persists.',

	/*Risk-Estimate*/
	4064:'This risk is no longer available. Refresh the page and try again. Contact the Help Desk if the error persists. This risk is no longer available. Refresh the page and try again. Contact the Help Desk if the error persists.',
	4065:'Risk relation cannot be edited. Refresh the page and try again. If the issue persists, contact the Help Desk. Risk relation cannot be edited. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	4066:'This estimate is no longer available. Refresh the page and try again. Contact the Help Desk if the error persists. This estimate is no longer available. Refresh the page and try again. Contact the Help Desk if the error persists.',

	/*Group Instructions */
	196033: 'Instructions cannot have 0 allocation items, they must have at least 1.',

	/*Information Security */
	200001: 'The action taken was forbidden by EY Information Security.  Refresh the page and try again. If the issue persists contact the Help Desk.',

	/*Tags*/
	40007: 'This tag is no longer available. Refresh the page and try again. If the issue persists, contact the Help Desk. This tag is no longer available. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	40029: 'Tag relation cannot be edited. Refresh the page and try again. If the issue persists, contact the Help Desk. Tag relation cannot be edited. Refresh the page and try again. If the issue persists, contact the Help Desk.',
};


export const roleForMember = [{
	id: 1,
	role: 'Ответсвенный партнер',
	roleAbbreviation: 'PIC'
},
{
	id: 2,
	role: 'Руководитель аудиторской проверки',
	roleAbbreviation: 'ЕП'
},
{
	id: 3,
	role: 'Исполнительный директор',
	roleAbbreviation: 'Исп Дир'
},
{
	id: 4,
	role: 'Руководящий сотрудник',
	roleAbbreviation: 'Руководящий сотрудник'
},
{
	id: 5,
	role: 'Старший Менеджер',
	roleAbbreviation: 'Ст.МЕНЕДЖЕР'
},
{
	id: 6,
	role: 'Менеджер',
	roleAbbreviation: 'МЕНЕДЖЕР'
},
{
	id: 7,
	role: 'Старший эксперт',
	roleAbbreviation: 'Старший эксперт'
},
{
	id: 8,
	role: 'Специалист',
	roleAbbreviation: 'Специалист'
},
{
	id: 9,
	role: 'Стажер',
	roleAbbreviation: 'Стжр'
},
{
	id: 10,
	role: 'Контролер Качества задания',
	roleAbbreviation: 'EQR'
},
{
	id: 11,
	role: 'Прочий Партнер',
	roleAbbreviation: 'Прочий ПТР'
},
{
	id: 12,
	role: 'ГДС-Стафф',
	roleAbbreviation: 'ГДС-Стафф'
},
{
	id: 13,
	role: 'Консультационные услуги (ИТРА, ТАС, Человеческий Капитал и прочее)',
	roleAbbreviation: 'АДВ'
},
{
	id: 14,
	role: 'Налоговые услуги',
	roleAbbreviation: 'Налоговые услуги'
},
{
	id: 15,
	role: 'Служба поддержки выполнения',
	roleAbbreviation: 'СПВ'
},
{
	id: 16,
	role: 'Юридический консультант',
	roleAbbreviation: 'ЮК'
},
{
	id: 17,
	role: 'Проверяющий качество аудита',
	roleAbbreviation: 'ПКАЗ'
},
{
	id: 18,
	role: 'Команда компонента',
	roleAbbreviation: 'КК'
},
{
	id: 19,
	role: 'Контролер Клиента',
	roleAbbreviation: 'КлКонтр'
},
{
	id: 20,
	role: 'Сотрудник Клиента',
	roleAbbreviation: 'КлСотр'
},
{
	id: 21,
	role: 'Контролер внутреннего аудита',
	roleAbbreviation: 'ВАКонтр'
},
{
	id: 22,
	role: 'Сотрудник внутреннего аудита',
	roleAbbreviation: 'ВАСотр'
},
{
	id: 23,
	role: 'Регулятор',
	roleAbbreviation: 'Рег'
},
{
	id: 24,
	role: 'Другие (например, проверка экспертизы соответствия)',
	roleAbbreviation: 'Другие'
},
{
	id: 25,
	role: 'Офис',
	roleAbbreviation: 'Оф'
},
{
	id: 26,
	role: 'Область',
	roleAbbreviation: 'Область'
},
{
	id: 27,
	role: 'Индустрия',
	roleAbbreviation: 'ИНД'
},
{
	id: 28,
	role: 'Национальный',
	roleAbbreviation: 'НАЦ'
},
{
	id: 29,
	role: 'Глобальный',
	roleAbbreviation: 'ГЛБ'
},
{
	id: 30,
	role: 'ГДС-синиор',
	roleAbbreviation: 'ГДС-синиор'
},
{
	id: 31,
	role: 'ГДС-менеджер',
	roleAbbreviation: 'ГДС-менеджер'
}
];

export const accountConclusionTabs = {
	conclusions: 'Выводы'
};

export const assertions = [{
	id: 1,
	assertionname: 'Полнота',
	assertionabbreviation: 'П',
	statementtypeid: 2,
	displayorder: 1
},
{
	id: 2,
	assertionname: 'Существование',
	assertionabbreviation: 'С',
	statementtypeid: 2,
	displayorder: 2
},
{
	id: 3,
	assertionname: 'Оценка',
	assertionabbreviation: 'О',
	statementtypeid: 2,
	displayorder: 3
},
{
	id: 4,
	assertionname: 'Права и обязательства',
	assertionabbreviation: 'ПиО',
	statementtypeid: 2,
	displayorder: 4
},
{
	id: 5,
	assertionname: 'Представление и раскрытие',
	assertionabbreviation: 'ПиР',
	statementtypeid: 2,
	displayorder: 5
},
{
	id: 6,
	assertionname: 'Полнота',
	assertionabbreviation: 'П',
	statementtypeid: 1,
	displayorder: 6
},
{
	id: 7,
	assertionname: 'Возникновение',
	assertionabbreviation: 'В',
	statementtypeid: 1,
	displayorder: 7
},
{
	id: 8,
	assertionname: 'Оценка',
	assertionabbreviation: 'О',
	statementtypeid: 1,
	displayorder: 8
},
{
	id: 9,
	assertionname: 'Представление и раскрытие',
	assertionabbreviation: 'ПиР',
	statementtypeid: 1,
	displayorder: 9
},
{
	id: 10,
	assertionname: 'Полнота',
	assertionabbreviation: 'П',
	statementtypeid: 3,
	displayorder: 10
},
{
	id: 11,
	assertionname: 'Существование/Возникновение',
	assertionabbreviation: 'С/В',
	statementtypeid: 3,
	displayorder: 11
},
{
	id: 12,
	assertionname: 'Измерение/оценка',
	assertionabbreviation: 'И/О',
	statementtypeid: 3,
	displayorder: 12
},
{
	id: 13,
	assertionname: 'Права и обязательства',
	assertionabbreviation: 'ПиО',
	statementtypeid: 3,
	displayorder: 13
},
{
	id: 14,
	assertionname: 'Представление и раскрытие',
	assertionabbreviation: 'ПиР',
	statementtypeid: 3,
	displayorder: 14
}
];

export const documentChangeTypesOptions = [{
	value: 1,
	label: 'Неадминистративное изменение'
},
{
	value: 2,
	label: 'Принятие исправлений при использовании функции отслеживания изменений'
},
{
	value: 3,
	label: 'Добавление дополнительных перекрестных ссылок на уже существующие доказательства'
},
{
	value: 4,
	label: 'Добавление исходного подтверждающего ответа, полученного ранее по факсу или электронной почте'
},
{
	value: 5,
	label: 'Косметическое изменение'
},
{
	value: 6,
	label: 'Completing Form AP and substantial role evaluation'
},
{
	value: 7,
	label: 'Удаление или отказ от замененной документации'
},
{
	value: 8,
	label: 'В процессе подготовки письма руководства'
},
{
	value: 9,
	label: 'Подписание контрольных чеклистов, относящихся к процессу архивирования'
},
{
	value: 10,
	label: 'Сортировка, сопоставление и перекрестные ссылки в окончательных документах',
},
{
	value: 12,
	label: 'Только МЕСТ: изменение доказательств, относящихся к объектам, дата отчета которых позже отчетной даты в ЭЯ Канвас'
},
{
	value: 11,
	label: 'При настройке на местный часовой пояс изменение происходит не позднее отчетной даты (только для Северной и Южной Америки)',
}
];

export const KnowledgeFormProfileAnswer = [{
	value: 1,
	label: 'Complex',
	display: true
},
{
	value: 2,
	label: 'Non-complex',
	display: true
},
{
	value: 3,
	label: 'Listed',
	display: true
},
{
	value: 4,
	label: 'Non-listed',
	display: false
},
{
	value: 5,
	label: 'PCAOB - IA',
	display: true
},
{
	value: 6,
	label: 'Non-PCAOB-IA',
	display: false
},
{
	value: 7,
	label: 'PCAOB - FS',
	display: true
},
{
	value: 8,
	label: 'Non-PCAOB-FS',
	display: false
},
{
	value: 9,
	label: 'Group Audit',
	display: true
},
{
	value: 10,
	label: 'Non-Group Audit',
	display: false
},
{
	value: 11,
	label: 'Digital',
	display: true
},
{
	value: 12,
	label: 'Core',
	display: true
}
];

export const strategyType = [{
	StrategyTypeId: 1,
	StrategyTypeName: 'Средства контроля'
},
{
	StrategyTypeId: 2,
	StrategyTypeName: 'По существу'
}
];

export const controlTypeName = {
	1: 'Приложение',
	2: 'РЗИТ',
	3: 'Ручное средство контроля для предотвращения',
	4: 'Ручное средство контроля для обнаружения'
};

export const inCompleteList = [{
	value: 1,
	label: 'Не завершено',
	title: 'Не завершено'
}];

export const scotTypes = [{
	value: 1,
	label: 'Рутинные',
	title: 'Рутинные',
	isDisabled: false
},
{
	value: 2,
	label: 'Нерутинные',
	title: 'Нерутинные',
	isDisabled: false
},
{
	value: 3,
	label: 'Оценочные',
	title: 'Оценочные',
	isDisabled: false
}
];

export const scotTypesNew = [{
	value: 1,
	label: 'Routine Routine',
	title: 'Routine Routine',
	isDisabled: false
},
{
	value: 2,
	label: 'Non routine Non routine',
	title: 'Non routine Non routine',
	isDisabled: false
},
{
	value: 3,
	label: 'Estimation Estimation',
	title: 'Estimation Estimation',
	isDisabled: false
},
{
	value: 4,
	label: 'FSCP',
	title: 'FSCP',
	isDisabled: false
}
];

export const estimationTypes = [{
	value: 1,
	label: 'No',
	title: 'No',
	isDisabled: false
},
{
	value: 2,
	label: 'Yes',
	title: 'Yes',
	isDisabled: false
}
];

/* IT Control */
export const itApproachType = [{
	ITApproachTypeId: 1,
	ITApproachTypeName: 'Средства контроля'
},
{
	ITApproachTypeId: 2,
	ITApproachTypeName: 'По существу'
}
];

/*Controls */
export const controlFrequencyType = [{
	value: 1,
	label: 'Многократно в течение дня',
	title: 'Многократно в течение дня'
},
{
	value: 2,
	label: 'Ежедневно',
	title: 'Ежедневно'
},
{
	value: 3,
	label: 'Еженедельно',
	title: 'Еженедельно'
},
{
	value: 4,
	label: 'Ежемесячно',
	title: 'Ежемесячно'
},
{
	value: 5,
	label: 'Ежеквартально',
	title: 'Ежеквартально'
},
{
	value: 6,
	label: 'Ежегодно',
	title: 'Ежегодно'
},
{
	value: 8,
	label: 'Прочее',
	title: 'Прочее'
}
];

export const controlTypes = [{
	value: 1,
	label: 'IT application control'
},
{
	value: 2,
	label: 'IT dependent manual control'
},
{
	value: 3,
	label: 'Manual prevent'
},
{
	value: 4,
	label: 'Manual detect'
}
];

export const designEffectivenessType = [{
	DesignEffectivenessTypeId: 1,
	DesignEffectivenessTypeName: 'Эффективное'
},
{
	DesignEffectivenessTypeId: 2,
	DesignEffectivenessTypeName: 'Неэффективное'
}
];

export const controlEffectivenessType = [{
	ControlEffectivenessTypeId: 1,
	ControlEffectivenessTypeName: 'Эффективное'
},
{
	ControlEffectivenessTypeId: 2,
	ControlEffectivenessTypeName: 'Неэффективное'
}
];

export const strategyTypeCheck = {
	1: 'Controls Controls',
	2: 'Substantive Substantive'
};

export const testing = [{
	testingId: 1,
	testingDescription: 'Да'
},
{
	testingId: 2,
	testingDescription: 'Нет'
}
];

export const controlType = [{
	value: 1,
	label: 'Прикладное средство ИТ-контроля',
	title: 'Прикладное средство ИТ-контроля'
},
{
	value: 2,
	label: 'Ручное средство контроля, зависящее от ИТ',
	title: 'Ручное средство контроля, зависящее от ИТ'
},
{
	value: 3,
	label: 'Ручное средство контроля для предотвращения',
	title: 'Ручное средство контроля для предотвращения'
},
{
	value: 4,
	label: 'Ручное средство контроля для обнаружения',
	title: 'Ручное средство контроля для обнаружения'
}
];

export const aggregateITEvaluationType = [{
	value: 1,
	label: 'Поддерживают',
	title: 'Поддерживают'
},
{
	value: 2,
	label: 'Не поддерживают',
	title: 'Не поддерживают'
},
{
	value: 3,
	label: 'Поддержка процесса подготовки ФО и системы ВКФО',
	title: 'Поддержка процесса подготовки ФО и системы ВКФО'
},
{
	value: 4,
	label: 'Исключительно поддержка процесса подготовки ФО',
	title: 'Исключительно поддержка процесса подготовки ФО'
}
];

export const KnowledgeFormProfileQuestion = [{
	value: 1,
	label: 'Сложная модель'
},
{
	value: 2,
	label: 'Зарегистрированная на бирже'
},
{
	value: 3,
	label: 'ПСАОБ - ВА'
},
{
	value: 4,
	label: 'ПСАОБ - ФО'
},
{
	value: 5,
	label: 'Местонахождение'
},
{
	value: 6,
	label: 'Язык'
},
{
	value: 7,
	label: 'Аудит Группы'
}
];

export const KnowledgeLanguage = [{
	value: 1,
	label: 'Английский'
},
{
	value: 2,
	label: 'Испанский (Латинская Америка)'
},
{
	value: 3,
	label: 'Французский (Канада)'
},
{
	value: 4,
	label: 'Нидерландский'
},
{
	value: 5,
	label: 'Хорватский'
},
{
	value: 6,
	label: 'Чешский'
},
{
	value: 7,
	label: 'Датский'
},
{
	value: 8,
	label: 'Финский'
},
{
	value: 9,
	label: 'Немецкий (Германия, Австрия)'
},
{
	value: 10,
	label: 'Венгерский'
},
{
	value: 11,
	label: 'Итальянский'
},
{
	value: 12,
	label: 'Японский (Япония)'
},
{
	value: 13,
	label: 'Норвежский (Норвегия)'
},
{
	value: 14,
	label: 'Польский'
},
{
	value: 15,
	label: 'Словацкий'
},
{
	value: 16,
	label: 'Словенский'
},
{
	value: 17,
	label: 'Шведский'
},
{
	value: 18,
	label: 'Арабский'
},
{
	value: 19,
	label: 'Упрощенный китайский (Китай)'
},
{
	value: 20,
	label: 'Традиционный китайский (Тайвань)'
},
{
	value: 21,
	label: 'Греческий'
},
{
	value: 22,
	label: 'Иврит (Израиль)'
},
{
	value: 23,
	label: 'Индонезийский'
},
{
	value: 24,
	label: 'Корейский (Республика Корея)'
},
{
	value: 25,
	label: 'Португальский (Бразилия)'
},
{
	value: 26,
	label: 'Румынский'
},
{
	value: 27,
	label: 'Русский (Россия)'
},
{
	value: 28,
	label: 'Тайский'
},
{
	value: 29,
	label: 'Турецкий'
},
{
	value: 30,
	label: 'Вьетнамский'
},
{
	value: 31,
	label: 'PCAOB - English PCAOB - English'
},
{
	value: 32,
	label: 'PCAOB - Spanish (Latin America) PCAOB - Spanish (Latin America)'
},
{
	value: 33,
	label: 'PCAOB - French (Canada) PCAOB - French (Canada)'
},
{
	value: 34,
	label: 'PCAOB - Dutch PCAOB - Dutch'
},
{
	value: 35,
	label: 'PCAOB - Croatian PCAOB - Croatian'
},
{
	value: 36,
	label: 'PCAOB - Czech PCAOB - Czech'
},
{
	value: 37,
	label: 'PCAOB - Danish PCAOB - Danish'
},
{
	value: 38,
	label: 'PCAOB - Finnish PCAOB - Finnish'
},
{
	value: 39,
	label: 'PCAOB - German (Germany, Austria) PCAOB - German (Germany, Austria)'
},
{
	value: 40,
	label: 'PCAOB - Hungarian PCAOB - Hungarian'
},
{
	value: 41,
	label: 'PCAOB - Italian PCAOB - Italian'
},
{
	value: 42,
	label: 'PCAOB - Japanese (Japan) PCAOB - Japanese (Japan)'
},
{
	value: 43,
	label: 'PCAOB - Norwegian (Norway) PCAOB - Norwegian (Norway)'
},
{
	value: 44,
	label: 'PCAOB - Polish PCAOB - Polish'
},
{
	value: 45,
	label: 'PCAOB - Slovak PCAOB - Slovak'
},
{
	value: 46,
	label: 'PCAOB - Slovenian PCAOB - Slovenian'
},
{
	value: 47,
	label: 'PCAOB - Swedish PCAOB - Swedish'
},
{
	value: 48,
	label: 'PCAOB - Arabic PCAOB - Arabic'
},
{
	value: 49,
	label: 'PCAOB - Simplified Chinese (China) PCAOB - Simplified Chinese (China)'
},
{
	value: 50,
	label: 'PCAOB - Traditional Chinese (Taiwan) PCAOB - Traditional Chinese (Taiwan)'
},
{
	value: 51,
	label: 'PCAOB - Greek PCAOB - Greek'
},
{
	value: 52,
	label: 'PCAOB - Hebrew (Israel) PCAOB - Hebrew (Israel)'
},
{
	value: 53,
	label: 'PCAOB - Indonesian PCAOB - Indonesian'
},
{
	value: 54,
	label: 'PCAOB - Korean (Republic of Korea) PCAOB - Korean (Republic of Korea)'
},
{
	value: 55,
	label: 'PCAOB - Portuguese (Brazil) PCAOB - Portuguese (Brazil)'
},
{
	value: 56,
	label: 'PCAOB - Romanian PCAOB - Romanian'
},
{
	value: 57,
	label: 'PCAOB - Russian (Russia) PCAOB - Russian (Russia)'
},
{
	value: 58,
	label: 'PCAOB - Thai PCAOB - Thai'
},
{
	value: 59,
	label: 'PCAOB - Turkish PCAOB - Turkish'
},
{
	value: 60,
	label: 'PCAOB - Vietnamese PCAOB - Vietnamese'
}
];

export const KnowledgeCountry = [{
	value: 1,
	label: 'Майотта'
},
{
	value: 2,
	label: 'Британские Виргинские острова'
},
{
	value: 3,
	label: 'Испания'
},
{
	value: 4,
	label: 'Белиз'
},
{
	value: 5,
	label: 'Перу'
},

{
	value: 6,
	label: 'Словакия'
},
{
	value: 7,
	label: 'Венесуэла'
},
{
	value: 8,
	label: 'Норвегия'
},
{
	value: 9,
	label: 'Фолклендские (Мальвинские) острова'
},
{
	value: 10,
	label: 'Мозамбик'
},

{
	value: 11,
	label: 'Китай'
},
{
	value: 12,
	label: 'Судан'
},
{
	value: 13,
	label: 'Израиль'
},
{
	value: 14,
	label: 'Бельгия'
},
{
	value: 15,
	label: 'Саудовская Аравия'
},

{
	value: 16,
	label: 'Гибралтар'
},
{
	value: 17,
	label: 'Гуам'
},
{
	value: 18,
	label: 'Остров Норфолк'
},
{
	value: 19,
	label: 'Замбия'
},
{
	value: 20,
	label: 'Реюньон'
},

{
	value: 21,
	label: 'Азербайджан'
},
{
	value: 22,
	label: 'Остров Святой Елены'
},
{
	value: 23,
	label: 'Иран'
},
{
	value: 24,
	label: 'Монако'
},
{
	value: 25,
	label: 'Сен-Пьер и Микелон'
},

{
	value: 26,
	label: 'Новая Зеландия'
},
{
	value: 27,
	label: 'Острова Кука'
},
{
	value: 28,
	label: 'Сент-Люсия'
},
{
	value: 29,
	label: 'Зимбабве'
},
{
	value: 30,
	label: 'Ирак'
},

{
	value: 31,
	label: 'Тонга'
},
{
	value: 32,
	label: 'Американское Самоа'
},
{
	value: 33,
	label: 'Мальдивы'
},
{
	value: 34,
	label: 'Марокко'
},
{
	value: 35,
	label: 'Международные стандарты аудита (МСА)'
},

{
	value: 36,
	label: 'Албания'
},
{
	value: 37,
	label: 'Афганистан'
},
{
	value: 38,
	label: 'Гамбия'
},
{
	value: 39,
	label: 'Буркина-Фасо'
},
{
	value: 40,
	label: 'Токелау'
},

{
	value: 41,
	label: 'Ливия'
},
{
	value: 42,
	label: 'Канада:'
},
{
	value: 43,
	label: 'ОАЭ'
},
{
	value: 44,
	label: 'Корейская Народно-Демократическая Республика'
},
{
	value: 45,
	label: 'Монтсеррат'
},

{
	value: 46,
	label: 'Гренландия'
},
{
	value: 47,
	label: 'Руанда'
},
{
	value: 48,
	label: 'Фиджи'
},
{
	value: 49,
	label: 'Джибути'
},
{
	value: 50,
	label: 'Ботсвана'
},

{
	value: 51,
	label: 'Кувейт'
},
{
	value: 52,
	label: 'Мадагаскар'
},
{
	value: 53,
	label: 'Остров Мэн'
},
{
	value: 54,
	label: 'Венгрия'
},
{
	value: 55,
	label: 'Намибия'
},

{
	value: 56,
	label: 'Мальта'
},
{
	value: 57,
	label: 'Джерси'
},
{
	value: 58,
	label: 'Таиланд'
},
{
	value: 59,
	label: 'Сент-Китс и Невис'
},
{
	value: 60,
	label: 'Бутан'
},

{
	value: 61,
	label: 'Панама'
},
{
	value: 62,
	label: 'Сомали'
},
{
	value: 63,
	label: 'Бахрейн'
},
{
	value: 64,
	label: 'Босния и Герцеговина'
},
{
	value: 65,
	label: 'Франция'
},

{
	value: 66,
	label: 'Республика Корея'
},
{
	value: 67,
	label: 'Исландия'
},
{
	value: 68,
	label: 'Португалия'
},
{
	value: 69,
	label: 'Тунис'
},
{
	value: 70,
	label: 'Гана'
},

{
	value: 71,
	label: 'Камерун'
},
{
	value: 72,
	label: 'Греция'
},
{
	value: 73,
	label: 'Французские Южные территории'
},
{
	value: 74,
	label: 'Остров Херд и острова Макдональд'
},
{
	value: 75,
	label: 'Андорра'
},

{
	value: 76,
	label: 'Люксембург'
},
{
	value: 77,
	label: 'Самоа'
},
{
	value: 78,
	label: 'Ангилья'
},
{
	value: 79,
	label: 'Нидерланды'
},
{
	value: 80,
	label: 'Гвинея-Бисау'
},

{
	value: 81,
	label: 'Никарагуа'
},
{
	value: 82,
	label: 'Парагвай'
},
{
	value: 83,
	label: 'Антигуа и Барбуда'
},
{
	value: 84,
	label: 'Международные стандарты финансовой отчетности (МСФО)'
},
{
	value: 85,
	label: 'Нигер'
},

{
	value: 86,
	label: 'Египет'
},
{
	value: 87,
	label: 'Государство-город Ватикан'
},
{
	value: 88,
	label: 'Латвия'
},
{
	value: 89,
	label: 'Кипр'
},
{
	value: 90,
	label: 'Внешние малые острова США'
},

{
	value: 91,
	label: 'Россия'
},
{
	value: 92,
	label: 'Сент-Винсент и Гренадины'
},
{
	value: 93,
	label: 'Гернси'
},
{
	value: 94,
	label: 'Бурунди'
},
{
	value: 95,
	label: 'Куба'
},

{
	value: 96,
	label: 'Экваториальная Гвинея'
},
{
	value: 97,
	label: 'Британская Территория в Индийском Океане'
},
{
	value: 98,
	label: 'Швеция'
},
{
	value: 99,
	label: 'Уганда'
},
{
	value: 100,
	label: 'Бывшая югославская Республика Македония'
},

{
	value: 101,
	label: 'Свазиленд'
},
{
	value: 102,
	label: 'Сальвадор'
},
{
	value: 103,
	label: 'Кыргызстан'
},
{
	value: 104,
	label: 'Ирландия'
},
{
	value: 105,
	label: 'Казахстан'
},

{
	value: 106,
	label: 'Гондурас'
},
{
	value: 107,
	label: 'Уругвай'
},
{
	value: 108,
	label: 'Грузия'
},
{
	value: 109,
	label: 'Тринидад и Тобаго'
},
{
	value: 110,
	label: 'Палестинская автономия'
},

{
	value: 111,
	label: 'Мартиника'
},
{
	value: 112,
	label: 'Аландские острова'
},
{
	value: 113,
	label: 'Французская Полинезия'
},
{
	value: 114,
	label: "Кот-д'Ивуар"
},
{
	value: 115,
	label: 'Черногория'
},

{
	value: 116,
	label: 'ЮАР'
},
{
	value: 117,
	label: 'Южная Георгия и Южные Сандвичевы острова'
},
{
	value: 118,
	label: 'Йемен'
},
{
	value: 119,
	label: 'Гонконг (Китай)'
},
{
	value: 120,
	label: 'Кения'
},

{
	value: 121,
	label: 'Чад'
},
{
	value: 122,
	label: 'Колумбия'
},
{
	value: 123,
	label: 'Коста-Рика'
},
{
	value: 124,
	label: 'Ангола'
},
{
	value: 125,
	label: 'Литва'
},

{
	value: 126,
	label: 'Сирия'
},
{
	value: 127,
	label: 'Малайзия'
},
{
	value: 128,
	label: 'Сьерра-Леоне'
},
{
	value: 129,
	label: 'Сербия'
},
{
	value: 130,
	label: 'Польша'
},

{
	value: 131,
	label: 'Суринам'
},
{
	value: 132,
	label: 'Гаити'
},
{
	value: 133,
	label: 'Науру'
},
{
	value: 134,
	label: 'Сан-Томе и Принсипи'
},
{
	value: 135,
	label: 'Шпицберген и Ян-Майен'
},

{
	value: 136,
	label: 'Сингапур'
},
{
	value: 137,
	label: 'Молдова'
},
{
	value: 138,
	label: 'Тайвань'
},
{
	value: 139,
	label: 'Сенегал'
},
{
	value: 140,
	label: 'Габон'
},

{
	value: 141,
	label: 'Мексика'
},
{
	value: 142,
	label: 'Сейшельские острова'
},
{
	value: 143,
	label: 'Федеративные Штаты Микронезии'
},
{
	value: 144,
	label: 'Алжир'
},
{
	value: 145,
	label: 'Италия'
},

{
	value: 146,
	label: 'Сан-Марино'
},
{
	value: 147,
	label: 'Либерия'
},
{
	value: 148,
	label: 'Бразилия'
},
{
	value: 149,
	label: 'Хорватия'
},
{
	value: 150,
	label: 'Фарерские острова'
},

{
	value: 151,
	label: 'Палау'
},
{
	value: 152,
	label: 'Финляндия'
},
{
	value: 153,
	label: 'Филиппины'
},
{
	value: 154,
	label: 'Ямайка'
},
{
	value: 155,
	label: 'Французская Гвиана'
},

{
	value: 156,
	label: 'Кабо-Верде'
},
{
	value: 157,
	label: 'Мьянма'
},
{
	value: 158,
	label: 'Лесото'
},
{
	value: 159,
	label: 'Американские Виргинские острова'
},
{
	value: 160,
	label: 'Каймановы Острова'
},

{
	value: 161,
	label: 'Ниуэ'
},
{
	value: 162,
	label: 'Того'
},
{
	value: 163,
	label: 'Беларусь'
},
{
	value: 164,
	label: 'Доминика'
},
{
	value: 165,
	label: 'Индонезия'
},

{
	value: 166,
	label: 'Узбекистан'
},
{
	value: 167,
	label: 'Нигерия'
},
{
	value: 168,
	label: 'Уоллис и Футуна'
},
{
	value: 169,
	label: 'Барбадос'
},
{
	value: 170,
	label: 'Шри-Ланка'
},

{
	value: 171,
	label: 'Великобритания'
},
{
	value: 172,
	label: 'Эквадор'
},
{
	value: 173,
	label: 'Гваделупа'
},
{
	value: 174,
	label: 'Лаос'
},
{
	value: 175,
	label: 'Иордания'
},

{
	value: 176,
	label: 'Соломоновы острова'
},
{
	value: 177,
	label: 'Восточный Тимор'
},
{
	value: 178,
	label: 'Ливан'
},
{
	value: 179,
	label: 'Центральноафриканская Республика'
},
{
	value: 180,
	label: 'Индия'
},

{
	value: 181,
	label: 'Остров Рождества'
},
{
	value: 182,
	label: 'Вануату'
},
{
	value: 183,
	label: 'Бруней'
},
{
	value: 184,
	label: 'Бангладеш'
},
{
	value: 185,
	label: 'Антарктида'
},

{
	value: 186,
	label: 'Боливия'
},
{
	value: 187,
	label: 'Турция'
},
{
	value: 188,
	label: 'Багамские острова'
},
{
	value: 189,
	label: 'Коморские острова'
},
{
	value: 190,
	label: 'Западная Сахара'
},

{
	value: 191,
	label: 'Чехия'
},
{
	value: 192,
	label: 'Украина'
},
{
	value: 193,
	label: 'Эстония'
},
{
	value: 194,
	label: 'Болгария'
},
{
	value: 195,
	label: 'Мавритания'
},

{
	value: 196,
	label: 'Демократическая Республика Конго'
},
{
	value: 197,
	label: 'Лихтенштейн'
},
{
	value: 198,
	label: 'Острова Питкэрн'
},
{
	value: 199,
	label: 'Дания'
},
{
	value: 200,
	label: 'Маршалловы острова'
},

{
	value: 201,
	label: 'Япония'
},
{
	value: 202,
	label: 'Австрия'
},
{
	value: 203,
	label: 'Оман'
},
{
	value: 204,
	label: 'Монголия'
},
{
	value: 205,
	label: 'Таджикистан'
},

{
	value: 206,
	label: 'Швейцария'
},
{
	value: 207,
	label: 'Гватемала'
},
{
	value: 208,
	label: 'Эритрея'
},
{
	value: 209,
	label: 'Непал'
},
{
	value: 210,
	label: 'Мали'
},

{
	value: 211,
	label: 'Словения'
},
{
	value: 212,
	label: 'Северные Марианские острова'
},
{
	value: 213,
	label: '(Не применимо)'
},
{
	value: 214,
	label: 'Аруба'
},
{
	value: 215,
	label: 'Конго'
},

{
	value: 216,
	label: 'Катар'
},
{
	value: 217,
	label: 'Гвинея'
},
{
	value: 218,
	label: 'США'
},
{
	value: 219,
	label: 'Эфиопия'
},
{
	value: 220,
	label: 'Прочее'
},

{
	value: 221,
	label: 'Гайана'
},
{
	value: 222,
	label: 'Германия'
},
{
	value: 223,
	label: 'Бермудские острова'
},
{
	value: 224,
	label: 'Острова Теркс и Кайкос'
},
{
	value: 225,
	label: 'Австралия'
},

{
	value: 226,
	label: 'Кирибати'
},
{
	value: 227,
	label: 'Пуэрто-Рико'
},
{
	value: 228,
	label: 'Пакистан'
},
{
	value: 229,
	label: 'Маврикий'
},
{
	value: 230,
	label: 'Малави'
},

{
	value: 231,
	label: 'Туркменистан'
},
{
	value: 232,
	label: 'Камбоджа'
},
{
	value: 233,
	label: 'Чили'
},
{
	value: 234,
	label: 'Новая Каледония'
},
{
	value: 235,
	label: 'Папуа – Новая Гвинея'
},

{
	value: 236,
	label: 'Остров Буве'
},
{
	value: 237,
	label: 'Тувалу'
},
{
	value: 238,
	label: 'Кюрасао'
},
{
	value: 239,
	label: 'Доминиканская Республика'
},
{
	value: 240,
	label: 'Вьетнам'
},

{
	value: 241,
	label: 'Кокосовые острова (Килинг)'
},
{
	value: 242,
	label: 'Гренада'
},
{
	value: 243,
	label: 'Танзания'
},
{
	value: 244,
	label: 'Аргентина'
},
{
	value: 245,
	label: 'Макао (Китай)'
},

{
	value: 246,
	label: 'Бенин'
},
{
	value: 247,
	label: 'Румыния'
},
{
	value: 248,
	label: 'Армения'
},
{
	value: 249,
	label: 'Глобальный охват'
},
{
	value: 250,
	label: 'МСФО для компаний малого и среднего бизнеса'
},

{
	value: 251,
	label: 'ОПБУ США'
},
{
	value: 252,
	label: 'Концепция АИСПА по подготовке финансовой отчетности для компаний малого и среднего бизнеса'
},
{
	value: 253,
	label: 'Южный Судан'
}
];

export const pagingSvgHoverText = {
	first: 'Первая страница',
	previous: 'Предыдущая страница',
	next: 'Следующая страница',
	last: 'Последняя страница'
};

export const priorityTypesForDropdown = [{
	value: 1,
	label: 'Низкий',
	className: 'Low'
},
{
	value: 2,
	label: 'Средний',
	className: 'Medium'
},
{
	value: 3,
	label: 'Высокий',
	className: 'High'
},
{
	value: 4,
	label: 'Критичный',
	className: 'Critical'
}
];

export const reviewNoteFilterTypes = [{
	value: 0,
	label: 'Все'
},
{
	value: 1,
	label: 'Открыть'
},
{
	value: 2,
	label: 'Выполнено'
},
{
	value: 3,
	label: 'Закрытый'
}
];

export const reviewStatus = [{
	id: 1,
	name: 'Отрытый'
},
{
	id: 2,
	name: 'Выполнено'
},
{
	id: 3,
	name: 'Закрытый'
}
];

export const reviewNoteOpenStatusOption = [{
	value: 2,
	label: 'Исправить'
},
{
	value: 3,
	label: 'Закрыть'
}
];

export const reviewNoteClearedStatusOption = [{
	value: 1,
	label: 'Повторно открытый'
},
{
	value: 3,
	label: 'Закрыть'
}
];

export const reviewNoteBulkClearedStatusOption = [{
	value: 1,
	label: 'Повторно открытый'
},
{
	value: 2,
	label: 'Исправить'
},
{
	value: 3,
	label: 'Закрыть'
}
];

export const reviewNoteClosedStatusOption = [{
	value: 1,
	label: 'Повторно открытый'
},
{
	value: 4,
	label: 'Delete'
}
];

export const taskTypeBadge = {
	1: 'ПТЗ',
	2: 'БТЗ',
	3: 'СП',
	4: 'ТСК',
	5: 'ПППС',
	6: 'БППС',
	7: 'ЗР',
	8: 'ЗГ',
	9: 'PIC',
	10: 'EQR',
	11: 'PIC/EQR',
	22: 'ЗФЗС',
	23: 'UDP'
};

export const riskTypes = [
	{ id: 1, name: 'Significant risks Significant risks', abbrev: 'SR SR', label: 'Significant Significant', title: 'Significant risk Significant risk' },
	{ id: 2, name: 'Fraud risks Fraud risks', abbrev: 'FR FR', label: 'Fraud Fraud', title: 'Fraud risk Fraud risk' },
	{
		id: 3,
		name: 'Risk of material misstatement',
		abbrev: 'IR',
		label: 'Risk of material misstatement',
		title: 'Risk of material misstatement'
	}
];

export const estimateTypes = [
	{ id: 4, name: 'Very low risk estimate Very low risk estimate', abbrev: 'VLRE VLRE', label: 'Very Low Very Low', title: 'Very low risk estimate Very low risk estimate' },
	{ id: 5, name: 'Lower risk estimate Lower risk estimate', abbrev: 'LRE LRE', label: 'Lower Lower', title: 'Lower risk estimate Lower risk estimate' },
	{ id: 6, name: 'Higher risk estimate Higher risk estimate', abbrev: 'HRE HRE', label: 'Higher Higher', title: 'Higher risk estimate Higher risk estimate' },
	{ id: 7, name: 'Estimate - Not selected Estimate - Not selected', abbrev: 'NA NA', label: 'Not selected Not selected', title: 'Estimate - Not selected Estimate - Not selected' }
];

export const statementTypes = [{
	id: 1,
	name: 'Отчет о финансовых результатах'
},
{
	id: 2,
	name: 'Баланс'
},
{
	id: 3,
	name: 'Оба'
}
];

export const RbacErrors = {
	106: 'Недостаточно полномочий для редактирования содержания. Для получения дополнительных прав обратитесь к администратору задания.'
};

export const HelixProjectValidationErrors = {
	800: 'Вы использовали ЭЯ Хеликс ранее? Перейти',
	801: 'Вы не являетесь авторизованным членом команды по связанному проекту. Свяжитесь с администратором проекта в ЭЯ Хеликс для получения доступа.',
	901: 'Выбранный проект в ЭЯ Хеликс больше недоступен. Нажать на список проектов в ЭЯ Хеликс для создания нового проекта.',
	902: 'Выбранный проект в ЭЯ Хеликс отмечен для удаления. Нажать на список проектов в ЭЯ Хеликс для создания нового проекта.',
	903: 'Выбранный проект в ЭЯ Хеликс отмечен для хранения. Нажать на список проектов в ЭЯ Хеликс для создания нового проекта.',
	926: 'Выбранный анализатор недоступен в ЭЯ Хеликс. Обновите страницу и повторите попытку. Если проблему не удается устранить, обратитесь в службу технической поддержки.',
	927: 'Инструменты аналитики данных недоступны для связанного проекта. Перейти в ЭЯ Хеликс и завершить процедуры обработки данных и аналитические процедуры для продолжения. ',
	928: 'Анализатор является недействительным или отсутствует в ЭЯ Хеликс. Обновите страницу и повторите попытку. Если проблему не удается устранить, обратитесь в службу технической поддержки.',
	929: 'Произошла ошибка в связанном проекте ЭЯ Хеликс. Данные не могут быть импортированы.'
};

export const EngagementProfileRequirementErrors = {
	108: 'Профиль задания не заполнен.'
};

export const IndependenceRequirementErrors = {
	103: 'Отсутствует подтверждение о соблюдение требований к независимости пользователем задания.'
};

export const strategyTypes = [{
	id: 3,
	name: 'Входит в объем процедур'
},
{
	id: 4,
	name: 'Не входит в объем процедур'
}
];

export const itAppTypes = [{
	value: 0,
	label: 'ИТ-приложение'
},
{
	value: 1,
	label: 'Обслуживающая организация'
}
];

export const confidentialityLevels = {
	[confidentialityTypes.DEFAULT]: 'По умолчанию',
	[confidentialityTypes.LOW]: 'Низкий',
	[confidentialityTypes.MODERATE]: 'Средний',
	[confidentialityTypes.HIGH]: 'Высокий'

	// This has been disabled for release 2.5, uncomment if required,
	// [confidentialityTypes.CONFIDENTIAL]: 'Конфиденциально'
};

export const formBodyOptionRiskTypes = [
	{ id: 1, label: 'Significant RiskSignificant Risk' },
	{ id: 2, label: 'Fraud RiskFraud Risk' },
	{ id: 3, label: 'Risk of material misstatementRisk of material misstatement' }
];

export const formViewTypes = [{
	value: 0,
	label: 'Форма'
},
{
	value: 1,
	label: 'Изменения'
},
{
	value: 2,
	label: 'Подробная информация'
}
];

export const railFilterValidations = [{
	value: 0,
	label: 'Все'
},
{
	value: 1,
	label: 'Ответы не заполнены'
},
{
	value: 2,
	label: 'Незакрытые комментарии'
}
];

export const aresRiskTypes = [
	{ id: 1, name: 'Significant riskSignificant risk' },
	{ id: 2, name: 'Fraud riskFraud risk' },
	{ id: 3, name: 'Risk of material misstatementRisk of material misstatement' },
	{ id: 4, name: 'Very low risk estimateVery low risk estimate' },
	{ id: 5, name: 'Lower risk estimateLower risk estimate' },
	{ id: 6, name: 'Higher risk estimateHigher risk estimate' },
	{ id: 7, label: 'Estimate - Not selected Estimate - Not selected' }
];

export const materialityTypes = [{
	value: 1,
	label: 'Pretax income'
},
{
	value: 2,
	label: 'EBIT (Earnings before interest and taxes)'
},
{
	value: 3,
	label: 'EBITDA (Earnings before interest, taxes, depreciation, and amortization)'
},
{
	value: 4,
	label: 'Gross margin'
},
{
	value: 5,
	label: 'Revenues'
},
{
	value: 6,
	label: 'Operating expenses'
},
{
	value: 7,
	label: 'Equity'
},
{
	value: 8,
	label: 'Assets'
},
{
	value: 9,
	label: 'Activity based measures (Other)'
},
{
	value: 10,
	label: 'Pretax losses'
},
{
	value: 11,
	label: 'Capital based measures (Other)'
},
{
	value: 12,
	label: 'Earnings based measures (Other)'
}
];

export const helixCurrencyType = {
	[currencyType.Functional]: 'Функциональная',
	[currencyType.Reporting]: 'Валюта отчетности'
};

export const controlRiskType = [{
	id: 1,
	name: 'Полагаться'
},
{
	id: 2,
	name: 'Не полагаться'
},
{
	id: 3,
	name: 'Тестировать ПР'
}
];

export const inherentRiskType = [{
	id: 1,
	name: 'Повышенный'
},
{
	id: 2,
	name: 'Пониженный'
},
{
	id: 3,
	name: 'Very Low'
}
];

export const AlraInherentRiskType = [{
	id: 3,
	name: 'Not Relevant'
},
{
	id: 2,
	name: 'Lower'
},
{
	id: 1,
	name: 'Higher'
}
];

export const scotInherentRiskType = [{
	id: 1,
	name: 'Higher'
},
{
	id: 2,
	name: 'Lower'
},
{
	id: 3,
	name: 'Non-routine SCOT'
}
];

export const CRAStrings = {
	Minimal: 'Минимальный',
	Low: 'Низкий',
	'Low +SC': 'Низкий + СР',
	Moderate: 'Средний',
	High: 'Высокий',
	'High +SC': 'Высокий + СР'
};

export const priorityType = [{
	id: 1,
	name: 'Низкий',
	className: 'Low',
	label: 'Н'
},
{
	id: 2,
	name: 'Средний',
	className: 'Medium',
	label: 'С'
},
{
	id: 3,
	name: 'Высокий',
	className: 'High',
	label: 'В'
},
{
	id: 4,
	name: 'Критический',
	className: 'Critical',
	label: 'К'
}
];

export const kendoLabels = {
	alignLeft: 'Justify left',
	alignRight: 'Justify right',
	alignCenter: 'Justify center',
	alignFull: 'Justify full',
	addComment: 'Add comment',
	addColumnBefore: 'Add column left',
	addColumnAfter: 'Add column right',
	addRowAbove: 'Add row above',
	addRowBelow: 'Add row below',
	bulletList: 'Insert ordered list',
	bold: 'Bold',
	backColor: 'Highlight',
	createLink: 'Insert hyperlink',
	createTable: 'Create table',
	cleanFormatting: 'Clean formatting',
	deleteRow: 'Delete row',
	deleteColumn: 'Delete column',
	deleteTable: 'Delete table',
	fontSizeInherit: 'Font size',
	foreColor: 'Color',
	format: 'Format',
	fontSize: 'Font size',
	hyperlink: 'Insert web link',
	italic: 'Italic',
	indent: 'Indent',
	insertTableHint: 'Create a {0} by {1} table',
	'hyperlink-dialog-content-address': 'Web Address',
	'hyperlink-dialog-title': 'Insert hyperlink',
	'hyperlink-dialog-content-title': 'Title',
	'hyperlink-dialog-content-newwindow': 'Open link in new window',
	'hyperlink-dialog-cancel': 'Cancel',
	'hyperlink-dialog-insert': 'Insert',
	outdent: 'Outdent',
	orderedList: 'Insert unordered list',
	print: 'Print',
	pdf: 'Export to pdf',
	redo: 'Redo',
	strikethrough: 'Strikethrough',
	subscript: 'Subscript',
	superscript: 'Superscript',
	underline: 'Underline',
	undo: 'Undo',
	unlink: 'Unlink'
};

export const kendoFormatOptions = [{
	text: 'Paragraph',
	value: 'p'
},
{
	text: 'Heading 1',
	value: 'h1'
},
{
	text: 'Heading 2',
	value: 'h2'
},
{
	text: 'Heading 3',
	value: 'h3'
},
{
	text: 'Heading 4',
	value: 'h4'
},
{
	text: 'Heading 5',
	value: 'h5'
},
{
	text: 'Heading 6',
	value: 'h6'
}
];

export const kendoFontSize = [
	{
		text: '8',
		value: '8px'
	},
	{
		text: '9',
		value: '9px'
	},
	{
		text: '10',
		value: '10px'
	},
	{
		text: '11',
		value: '11px'
	},
	{
		text: '12',
		value: '12px'
	},
	{
		text: '14',
		value: '14px'
	},
	{
		text: '16',
		value: '16px'
	},
	{
		text: '18',
		value: '18px'
	},
	{
		text: '20',
		value: '20px'
	},
	{
		text: '22',
		value: '22px'
	},
	{
		text: '24',
		value: '24px'
	},
	{
		text: '26',
		value: '26px'
	},
	{
		text: '28',
		value: '28px'
	},
	{
		text: '36',
		value: '36px'
	},
	{
		text: '48',
		value: '48px'
	},
	{
		text: '72',
		value: '72px'
	}
];

export const ItFlowValidationLabels = {
	ITAppWithoutAtLeastOneRelatedITProcess: 'Несвязанное ИТ-приложение',
	ITGCHasNoRelatedITRiskOrIsRelatedToITRiskWhereHasNoITCGIsOne: 'Несвязанное ОКИС',
	ITSPHasNorelatedITRisk: 'Несвязанная ИТППС',
	ITProcessHasNoRelatedITApplication: 'Несвязанный ИТ-процесс',
	ITProcessWithNoITRiskWhereThereIsAITACOrITDMRelatedToITApplication: 'ИТ-риск отсутствует',
	ITRiskHasNoITGCIsZeroHasNoRelatedITGC: 'Нет ОКИС или отметки о его отсутствии',
	ITDMorITACWithNoRelatedITApplication: 'Прикладное/РЗИТ средство контроля без ИТ-приложения',
	ITSPNotDeletedWhenCorrespondingBodyIsNotDisplayed: 'ИТППС к удалению',
	ITGCNotDeletedWhenCorrespondingBodyIsNotDisplayed: 'ОКИС к удалению',
	ITRiskIsNotDeletedWhenCorrespondingBodyIsNotDisplayed: 'ИТ-риск к удалению',
	ITGCWithHasItControlTestingIsOneExistsWhenCorrespondingBodyIsNotDisplayed: 'ОКИС с неправильной стратегией тестирования',
	ITGCWithoutASelectedDesignEffectiveness: 'Отсутствует оценка методики ОКИС',
	SCOTWithoutITApplicationsWhereHasNoITApplicationIsZero: 'Несвязанные ЗКО',
	AnyITDMorITACWithHasControlTestingIsOneExistsAndFormBodyTypeId111IsNotDisplayed: 'Несоответствующий ответ на тестирование средств контроля',
	SCOTWithHasNoITApplicationHasITDMOrAppControls: 'Отсутствует ИТ-приложение в ЗКО'
};

export const ISA315ITFlowValidationTypeResourceMapping = [{
	validationId: validationTypes.ITAppWithoutAtLeastOneRelatedITProcess,
	label: ItFlowValidationLabels.ITAppWithoutAtLeastOneRelatedITProcess
},
{
	validationId: validationTypes.ITGCHasNoRelatedITRiskOrIsRelatedToITRiskWhereHasNoITCGIsOne,
	label: ItFlowValidationLabels.ITGCHasNoRelatedITRiskOrIsRelatedToITRiskWhereHasNoITCGIsOne
},
{
	validationId: validationTypes.ITSPHasNorelatedITRisk,
	label: ItFlowValidationLabels.ITSPHasNorelatedITRisk
},
{
	validationId: validationTypes.ITProcessHasNoRelatedITApplication,
	label: ItFlowValidationLabels.ITProcessHasNoRelatedITApplication
},
{
	validationId: validationTypes.ITProcessWithNoITRiskWhereThereIsAITACOrITDMRelatedToITApplication,
	label: ItFlowValidationLabels.ITProcessWithNoITRiskWhereThereIsAITACOrITDMRelatedToITApplication
},
{
	validationId: validationTypes.ITDMorITACWithNoRelatedITApplication,
	label: ItFlowValidationLabels.ITDMorITACWithNoRelatedITApplication
},
{
	validationId: validationTypes.ITSPNotDeletedWhenCorrespondingBodyIsNotDisplayed,
	label: ItFlowValidationLabels.ITSPNotDeletedWhenCorrespondingBodyIsNotDisplayed
},
{
	validationId: validationTypes.ITGCNotDeletedWhenCorrespondingBodyIsNotDisplayed,
	label: ItFlowValidationLabels.ITGCNotDeletedWhenCorrespondingBodyIsNotDisplayed
},
{
	validationId: validationTypes.ITRiskIsNotDeletedWhenCorrespondingBodyIsNotDisplayed,
	label: ItFlowValidationLabels.ITRiskIsNotDeletedWhenCorrespondingBodyIsNotDisplayed
},
{
	validationId: validationTypes.ITGCWithHasItControlTestingIsOneExistsWhenCorrespondingBodyIsNotDisplayed,
	label: ItFlowValidationLabels.ITGCWithHasItControlTestingIsOneExistsWhenCorrespondingBodyIsNotDisplayed
},
{
	validationId: validationTypes.ITGCWithoutASelectedDesignEffectiveness,
	label: ItFlowValidationLabels.ITGCWithoutASelectedDesignEffectiveness
},
{
	validationId: validationTypes.SCOTWithoutITApplicationsWhereHasNoITApplicationIsZero,
	label: ItFlowValidationLabels.SCOTWithoutITApplicationsWhereHasNoITApplicationIsZero
},
{
	validationId: validationTypes.AnyITDMorITACWithHasControlTestingIsOneExistsAndFormBodyTypeId111IsNotDisplayed,
	label: ItFlowValidationLabels.AnyITDMorITACWithHasControlTestingIsOneExistsAndFormBodyTypeId111IsNotDisplayed
},
{
	validationId: validationTypes.SCOTWithHasNoITApplicationHasITDMOrAppControls,
	label: ItFlowValidationLabels.SCOTWithHasNoITApplicationHasITDMOrAppControls
},
{
	validationId: validationTypes.ITRiskHasNoITGCIsZeroHasNoRelatedITGC,
	label: ItFlowValidationLabels.ITRiskHasNoITGCIsZeroHasNoRelatedITGC
}
];

/* Notes modal labels */

export const reviewNoteModalLabels = {
	/*Review Notes*/
	engagement: 'Задание',
	emptyReplyErrorMsg: 'Добавить текст для продолжения',
	lengthReplyErrorMsg: 'Ответ не может превышать 4000 символов.',
	documentLabel: 'Документ',
	task: 'Задача',
	allEngagementFilterLabel: 'Все остальные задания',
	otherEngagementComments: 'Прочие замечания по заданию',
	notesModalInstructionalText: 'Просмотреть и ответить на замечания для выбранных {0} ниже.',
	commentThread: 'Цепочка замечания',
	singleNoteInstructionalText: 'Просмотреть и ответить на выбранное замечание ниже.',
	emptyNoteDetailsMessage: 'Выберите замечание для просмотра подробной информации. Для использования средств контроля массивов данных выберите несколько замечаний по результатам проверки, используя клавишу управления или смены регистра. Для работы с отдельным замечанием выберите его из списка.',
	documentReviewNotesLabel: 'Замечания по документу',
	addNewReviewNoteButtonText: 'Добавить замечание',
	noNotesAssociatedWithDocumentLabel: 'RA RU Leave a note by using the inputs below. Assign the note to a user and specify the priority and due date.',
	noNotesFound: 'RA RU No notes found',
	noNotesAssociatedWithTaskLabel: 'Для данной задачи нет {0} замечаний.',
	allNotesLabel: 'Все замечания',
	charactersLabel: 'символы',
	myNotesLabel: 'Мои замечания',
	showClearedLabel: 'Показать отработанные',
	showClosedLabel: 'Показать закрытые',
	assignedToLabel: 'Распределено (кому)',

	ofLabel: 'из',
	enterNoteText: 'Ввести замечание',
	addNewNoteModalClose: 'Закрыть',
	addNewNoteModalTitleLabel: 'Добавить новое замечание',
	editNoteModalTitleLabel: 'Редактировать замечание',
	deleteIconHoverText: 'Удалить',
	deleteIconModalAcceptText: 'Удалить',
	deleteIconModalConfirmMessage: 'Удалить ваш ответ на данное замечание?',
	deleteIconModalConfirmMessageParent: 'Удалить выбранное замечание?',
	deleteIconModalTitleLabel: 'Удалить замечание',
	deleteReplyIconModalTitle: 'Удалить ответ',
	emptyRepliesMessage: 'Нет ответов',
	replyInputPlaceholder: 'Ответить на данное замечание',
	replyInputPlaceholderEdit: 'RA RU Edit reply with a note or a voice note',
	noteInputPlaceholderEdit: 'RA RU Edit with a note or a voice note',
	replyText: 'Текст ответа',
	editReplyModelTitle: 'Редактировать ответ',
	editReplyPlaceholder: 'Введите ответ',
	noteDueDateLabel: 'Срок выполнения наступил',

	priorityLabel: 'Очередность',
	dueDateLabel: 'Срок выполнения',
	dueLabel: 'Срок выполнения наступил',
	status: 'Cтатус',
	noteModifiedDateLabel: 'Модифицированное',
	cancelLabel: 'Отменить',
	saveLabel: 'Сохранить',
	clearedBy: 'Отработано (кем)',
	closedBy: 'Закрыто (кем)',
	reopenedBy: 'Повторно открыто (кем)',
	reply: 'Ответ',
	editIconHoverTextLabel: 'Редактировать',
	required: 'Требуется',
	closeTitle: 'Закрыть',
	otherEngagementNotes: 'Прочие примечания по заданию',
	closeLabel: 'Закрыть',
	showMore: 'Отобразить дополнительные опции',
	showLess: 'Скрыть дополнительные опции',
	showMoreEllipsis: 'Отобразить дополнительные опции...',
	showLessEllipsis: 'Скрыть дополнительные опции...',
	noResultFound: 'Результаты не обнаружены',
	engagementNameLabel: 'Наименование задания:',
	taskReviewNotesLabel: 'Замечания по задаче',
	fromUserLabel: 'с',
	toUserLabel: 'по',
	view: 'Просмотр',
	dueDateRequiredTextError: 'RA RU Due date is required'
};

export const notesFilterLabels = [{
	id: notesFilter.allNotes,
	label: 'Все замечания',
	value: notesFilter.allNotes
},
{
	id: notesFilter.myNotes,
	label: 'Мои замечания',
	value: notesFilter.myNotes
},
{
	id: notesFilter.authoredByMeNotes,
	label: 'Распределенные мне',
	value: notesFilter.authoredByMeNotes
}
];

export const reviewerAssignments = {
	taskLayoutHeaderAssignments: 'Assignments',
	manageAssigmentsStep2: 'Edit task assignment',
	editAssignment: 'Edit assignment',
	deleteAssignment: 'Delete assignment',
	manageAssigmentsStep3: 'Complete assignment',
	taskAssigmentStatusHeader: 'Assignment status',
	taskAssignmentName: 'Assignment',
	dueDateAssigment: 'Due',
	editDueDate: 'Optional: Edit days prior to end date',
	teamMemberAssigmentLabel: 'Team member',
	currentAssigmentLabel: 'Current',
	handOffToAssigmentLabel: 'Handed off to:',
	priorToEndDateLabel: 'prior to end date',
	noTimePhaseAssigmentLabel: 'No assigned time phase',
	closedByAssigmentLabel: 'Closed by ',
	onAssingmentLabel: 'on',
	preparerAssigmentOpenTitleTip: 'Hand off this task to close your task assignment',
	reviewerAssigmentOpenTitleTip: 'Mark task assignment as closed',
	reviewerAssigmentClosedTitleTip: 'Mark task assignment as open',
	AssigmentLabel: 'Hand off this task to close your task assignment',
	timePhaseName: 'Time Phase: ',
	timePhaseEndDate: 'End date: ',
	AssignmentType: [{
		id: 1,
		displayName: 'Preparer'
	},
	{
		id: 2,
		displayName: 'Detail reviewer'
	},
	{
		id: 3,
		displayName: 'General reviewer'
	},
	{
		id: 4,
		displayName: 'Partner'
	},
	{
		id: 5,
		displayName: 'EQR'
	},
	{
		id: 6,
		displayName: 'Other'
	}
	],
	AssignmentStatus: [
		{
			id: 1,
			displayName: 'Open'
		},
		{
			id: 2,
			displayName: 'In progress'
		},
		{
			id: 3,
			displayName: 'Closed'
		},
		{
			id: 4,
			displayName: 'Unassigned'
		}
	],
	assignmentTableColumnHeader: 'Assignment',
	teamMemberTableColumnHeader: 'Team member',
	dueDaysTableColumnHeader: 'Due',
	daysPriorToEndDate: 'days prior to end date',
	handoffButton: 'Hand-off'
};
/* Notes modal labels */

export const handOffModal = {
	title: 'Hand-off',
	description: 'Hand off this task to the next team member. To sign off on an evidence file, select from the options below.',
	dropdownLabel: 'Hand-off to',
	closeTitle: 'Cancel',
	confirmButton: 'Hand-off',
	evidence: 'Evidence',
	evidenceSignOffTitle: 'Sign off on all as:',
	existingSignOffs: 'Existing sign-offs',
	noDocumentsAvailable: 'No documents available'
};

// manage scot modal labels
export const manageSCOTModal = {
	title: 'Manage SCOTs',
	description: 'You can create, edit or delete existing SCOTs. Changes will be applied once saved.',
	addSCOTLink: 'Add SCOT'
};

export const deleteSCOTModal = {
	title: 'Delete SCOT',
	description: 'The following SCOT(s) will be deleted. The action cannot be undone.'
};

export const manageITAppModalLabels = {
	title: 'Manage IT applications',
	description: 'Create new IT applications or edit and delete existing IT applications below.',
	inputNameTitle: 'IT application name',
	deleteConfirmMessage: 'Are you sure you want to delete the IT application <b>{0}</b>? This cannot be undone.',
	addSuccessMessage: "Successfully created the IT application '{0}'",
	editSuccessMessage: "Successfully saved edits to the IT application '{0}'",
	deleteSuccessMessage: "'{0}' has been successfully deleted"
};

export const manageSOModalLabels = {
	title: 'Manage service organizations',
	description: 'Create new service organizations or edit and delete existing service organizations below.',
	inputNameTitle: 'Service organization name',
	deleteConfirmMessage: 'Are you sure you want to delete the Service organization <b>{0}</b>? This cannot be undone.',
	addSuccessMessage: "Successfully created the Service organization '{0}'",
	editSuccessMessage: "Successfully saved edits to the Service organization '{0}'",
	deleteSuccessMessage: "'{0}' has been successfully deleted",
	addServiceOrganization: 'Add Service organization',
	editServiceOrganization: 'Edit Service organization',
	deleteServiceOrganization: 'Delete Service organization'
};

export const customNameModal = {
	title: 'JE source name suffix',
	closeTitle: 'Cancel',
	save: 'Save',
	suffixRequired: 'Suffix required!',
	suffix: 'Suffix',
	addSuffix: 'Add suffix',
	editSuffix: 'Edit suffix'
};

export const GuidedWorkFlowLabels = {
	RiskFactorsUnrelatedToARiskOrMarkedAsNotAROMM: 'Unrelated events and conditions / risk of misstatement',
	RisksUnrelatedToAnAssertionForGuidedWorkflow: 'Unrelated risks',
	IncompleteMeasurementBasisForecastAmount: 'Incomplete basis',
	IncompleteMeasurementBasisForecastAmountRationale: 'Basis rationale required',
	IncompleteMeasurementBasisAdjustedAmount: 'Incomplete adjusted amount',
	IncompletePlanningMateriality: 'Incomplete PM',
	PlanningMaterialityGreaterThanMaximumAmount: 'PM too large',
	IncompletePlanningMaterialityRationale: 'PM rationale required',
	IncompleteTolerableError: 'Incomplete TE',
	TENotWithinRangeOfAllowedValues: 'Invalid TE percent',
	IncompleteTolerableErrorRationale: 'TE rationale required',
	IncompleteSAD: 'Incomplete SAD',
	SADGreaterThanMaximum: 'SAD too large',
	IncompleteSADRationale: 'SAD rationale required',
	IncompletePACESelection: 'Incomplete PACE',
	AccountWithoutIndividualRiskAssessmentForm: 'Account{0} missing document',
	EstimateWithoutIndividualEstimateForm: 'Estimate{0} missing document',
	AccountWithoutIndividualAnalyticForm: 'Account{0} missing document',
	MultiEntityWithoutIndividualProfileForm: 'Entity without Multi-Entity Individual Profile document',
	AccountAccountTypeIDDoesNotMatchAction: 'Inconsistent account designation selection',
	AccountHasEstimateDoesNotMatchAction: 'Inconsistent account estimate selection',
	AccountFormOptionHasRelatedRisksNotAssociatedToAccount: 'Risk without related account association',
	AccountHigherInherentRiskAssertionWithoutRelatedIsHigherRisk: 'Higher inherent risk assertion without risk',
	AccountMissingSubstantiveProcedure: 'Account/Entities with no substantive procedure',
	MultiEntityNotRelatedToALLPSTACTForRelatedAccount: 'Account/Entities require content update',
	ComponentWithoutGroupInvolvementForm: 'Component without a Group Involvement Form (Excluding Reference Only Components)',
	ComponentWithoutRelatedGroupAssessmentInstruction: 'Component without Group risk assessment instruction',
	IncompleteAssertionRiskLevel: 'Incomplete assertion risk level',
	EstimateAccountWithoutEsimatePSPIndex: 'Estimate account without estimate PSP index',
	AccountExecutedWithoutRelatedComponent: 'Group - Accounts (Executed in other engagements) without a related Full or Specific scope Component',
	MultiEntityAccountWithoutRelatedToAnyMultiEntity: 'Account without related entity',
	ChangeNotSubmittedMultiEntityFullProfile: 'Changes not submitted',
	ChangeNotSubmittedMultiEntityIndividualDocument: 'Changes not submitted',
	AccountTypeWithMissingInformation: 'Account missing information',
	DocumentUploadMissingRequiredPICEQRSignOffs: 'Evidence missing sign-off(s)',
	DocumentUploadMissingRequiredPICEQRSignOffRequirements: 'Evidence missing sign-off requirement(s)',
	DocumentUploadMissingPreparerOrReviewerSignOffs: 'Document upload - Missing Preparer or Reviewer Sign-offs',
	ITAppWithoutAtLeastOneRelatedITProcess: 'Unrelated IT application Unrelated IT application',
	ITProcessHasNoRelatedITApplication: 'Unrelated IT process Unrelated IT process',
	ITGCWithoutASelectedDesignEffectiveness: 'Missing ITGC design evaluation Missing ITGC design evaluation',
	ITGCHasNoRelatedITRiskOrIsRelatedToITRiskWhereHasNoITCGIsOne: 'Unrelated ITGC Unrelated ITGC',
	ITSPHasNorelatedITRisk: 'Unrelated ITSP Unrelated ITSP',
	ITRiskHasNoITGCIsZeroHasNoRelatedITGC: 'Missing ITGC or mark none exists Missing ITGC or mark none exists',
	EstimateWithoutAccountRelated: 'Estimate without account related Estimate without account related',
	EstimateHigherOrLowerRiskEstimateRelatedToNonEstimateAccount: 'Higher/lower risk estimate related to non-estimate account Higher/lower risk estimate related to non-estimate account',
	LowerorHigherRiskEstimateWithoutEstimateSCOT: 'Estimate without valid SCOT Estimate without valid SCOT',
	EstimateWithoutIndividualEstimateDocument: 'Estimate missing individual document Estimate missing individual document',
	EstimateAccountWithoutHigherOrLowerRiskEstimate: 'Account without valid estimate Account without valid estimate',
	RiskEstimateRiskTypeIDDoesNotMatchAction: "Estimate category response not aligned to designation in 'Edit estimate' Estimate category response not aligned to designation in 'Edit estimate'",
	EstimateAccountWithoutHigherOrLowerRiskEstimateEstimateSummary: 'Estimate account without Higher or Lower risk Estimate Estimate account without Higher or Lower risk Estimate',
	EstimateScotWithoutHigherOrLowerRiskEstimate: 'Estimate SCOT without Higher or Lower risk Estimate Estimate SCOT without Higher or Lower risk Estimate',
	HigherRiskEstimateWithoutRisk: 'Higher risk estimate without valid risk related Higher risk estimate without valid risk related',
	PICEQRSignOffRequirements: 'PIC or EQR Signoff requirement does not match response PIC or EQR Signoff requirement does not match response',
	AdjustmentsWithoutAnyEvidence: 'Adjustments without evidence Adjustments without evidence',
	AdjustmentsThatDoNotNet: 'Adjustments that do not net Adjustments that do not net',
	DocumentCheckedOutOrInTheProcessOfBeingCheckedOutForCollaboration: 'Document checked out or in the process of being checked out for collaboration Document checked out or in the process of being checked out for collaboration',
	NonEngagementWideTasksMissingEvidence: 'Non-Engagement wide tasks missing evidence Non-Engagement wide tasks missing evidence',
    EstimatesMustBeMarkedHigherRisk: 'Significant/Fraud risk related to an estimate that is not a Higher risk Significant/Fraud risk related to an estimate that is not a Higher risk'};

export const GuidedWorkFlowValidationTypeResourceMapping = [
	{
		validationId: validationTypes.RiskEstimateRiskTypeIDDoesNotMatchAction,
		label: GuidedWorkFlowLabels.RiskEstimateRiskTypeIDDoesNotMatchAction
	},
	{
		validationId: validationTypes.EstimatesMustBeMarkedHigherRisk,
		label: GuidedWorkFlowLabels.EstimatesMustBeMarkedHigherRisk
	},
	{
		validationId: validationTypes.EstimateAccountWithoutHigherOrLowerRiskEstimateEstimateSummary,
		label: GuidedWorkFlowLabels.EstimateAccountWithoutHigherOrLowerRiskEstimateEstimateSummary
	},
	{
		validationId: validationTypes.EstimateScotWithoutHigherOrLowerRiskEstimate,
		label: GuidedWorkFlowLabels.EstimateScotWithoutHigherOrLowerRiskEstimate
	},
	{
		validationId: validationTypes.HigherRiskEstimateWithoutRisk,
		label: GuidedWorkFlowLabels.HigherRiskEstimateWithoutRisk
	},
	{
		validationId: validationTypes.RiskFactorsUnrelatedToARiskOrMarkedAsNotAROMM,
		label: GuidedWorkFlowLabels.RiskFactorsUnrelatedToARiskOrMarkedAsNotAROMM
	},
	{
		validationId: validationTypes.EstimateAccountWithoutHigherOrLowerRiskEstimate,
		label: GuidedWorkFlowLabels.EstimateAccountWithoutHigherOrLowerRiskEstimate
	},
	{
		validationId: validationTypes.RisksUnrelatedToAnAssertionForGuidedWorkflow,
		label: GuidedWorkFlowLabels.RisksUnrelatedToAnAssertionForGuidedWorkflow
	},
	{
		validationId: validationTypes.IncompleteMeasurementBasisForecastAmount,
		label: GuidedWorkFlowLabels.IncompleteMeasurementBasisForecastAmount
	},
	{
		validationId: validationTypes.IncompleteMeasurementBasisForecastAmountRationale,
		label: GuidedWorkFlowLabels.IncompleteMeasurementBasisForecastAmountRationale
	},
	{
		validationId: validationTypes.IncompleteMeasurementBasisAdjustedAmount,
		label: GuidedWorkFlowLabels.IncompleteMeasurementBasisAdjustedAmount
	},
	{
		validationId: validationTypes.IncompletePlanningMateriality,
		label: GuidedWorkFlowLabels.IncompletePlanningMateriality
	},
	{
		validationId: validationTypes.PlanningMaterialityGreaterThanMaximumAmount,
		label: GuidedWorkFlowLabels.PlanningMaterialityGreaterThanMaximumAmount
	},
	{
		validationId: validationTypes.IncompletePlanningMaterialityRationale,
		label: GuidedWorkFlowLabels.IncompletePlanningMaterialityRationale
	},
	{
		validationId: validationTypes.IncompleteTolerableError,
		label: GuidedWorkFlowLabels.IncompleteTolerableError
	},
	{
		validationId: validationTypes.TENotWithinRangeOfAllowedValues,
		label: GuidedWorkFlowLabels.TENotWithinRangeOfAllowedValues
	},
	{
		validationId: validationTypes.IncompleteTolerableErrorRationale,
		label: GuidedWorkFlowLabels.IncompleteTolerableErrorRationale
	},
	{
		validationId: validationTypes.IncompleteSAD,
		label: GuidedWorkFlowLabels.IncompleteSAD
	},
	{
		validationId: validationTypes.SADGreaterThanMaximum,
		label: GuidedWorkFlowLabels.SADGreaterThanMaximum
	},
	{
		validationId: validationTypes.IncompleteSADRationale,
		label: GuidedWorkFlowLabels.IncompleteSADRationale
	},
	{
		validationId: validationTypes.IncompletePACESelection,
		label: GuidedWorkFlowLabels.IncompletePACESelection
	},
	{
		validationId: validationTypes.AccountWithoutIndividualRiskAssessmentForm,
		label: GuidedWorkFlowLabels.AccountWithoutIndividualRiskAssessmentForm
	},
	{
		validationId: validationTypes.EstimateWithoutIndividualEstimateForm,
		label: GuidedWorkFlowLabels.EstimateWithoutIndividualEstimateForm
	},
	{
		validationId: validationTypes.AccountWithoutIndividualAnalyticForm,
		label: GuidedWorkFlowLabels.AccountWithoutIndividualAnalyticForm
	},
	{
		validationId: validationTypes.MultiEntityWithoutIndividualProfileForm,
		label: GuidedWorkFlowLabels.MultiEntityWithoutIndividualProfileForm
	},
	{
		validationId: validationTypes.AccountAccountTypeIDDoesNotMatchAction,
		label: GuidedWorkFlowLabels.AccountAccountTypeIDDoesNotMatchAction
	},
	{
		validationId: validationTypes.AccountHasEstimateDoesNotMatchAction,
		label: GuidedWorkFlowLabels.AccountHasEstimateDoesNotMatchAction
	},
	{
		validationId: validationTypes.AccountFormOptionHasRelatedRisksNotAssociatedToAccount,
		label: GuidedWorkFlowLabels.AccountFormOptionHasRelatedRisksNotAssociatedToAccount
	},
	{
		validationId: validationTypes.AccountHigherInherentRiskAssertionWithoutRelatedIsHigherRisk,
		label: GuidedWorkFlowLabels.AccountHigherInherentRiskAssertionWithoutRelatedIsHigherRisk
	},
	{
		validationId: validationTypes.MultiEntityNotRelatedToALLPSTACTForRelatedAccount,
		label: GuidedWorkFlowLabels.MultiEntityNotRelatedToALLPSTACTForRelatedAccount
	},
	{
		validationId: validationTypes.AccountMissingSubstantiveProcedure,
		label: GuidedWorkFlowLabels.AccountMissingSubstantiveProcedure
	},
	{
		validationId: validationTypes.ComponentWithoutGroupInvolvementForm,
		label: GuidedWorkFlowLabels.ComponentWithoutGroupInvolvementForm
	},
	{
		validationId: validationTypes.ComponentWithoutRelatedGroupAssessmentInstruction,
		label: GuidedWorkFlowLabels.ComponentWithoutRelatedGroupAssessmentInstruction
	},
	{
		validationId: validationTypes.EstimateAccountWithoutEstimatePSPIndex,
		label: GuidedWorkFlowLabels.EstimateAccountWithoutEsimatePSPIndex
	},
	{
		validationId: validationTypes.AssertionInherentRiskWithoutRelatedHigherRisk,
		label: GuidedWorkFlowLabels.IncompleteAssertionRiskLevel
	},
	{
		validationId: validationTypes.AccountGroupWithoutAComponent,
		label: GuidedWorkFlowLabels.AccountExecutedWithoutRelatedComponent
	},
	{
		validationId: validationTypes.MultiEntityAccountWithoutRelatedToAnyMultiEntity,
		label: GuidedWorkFlowLabels.MultiEntityAccountWithoutRelatedToAnyMultiEntity
	},
	{
		validationId: validationTypes.ChangeNotSubmittedMultiEntityFullProfile,
		label: GuidedWorkFlowLabels.ChangeNotSubmittedMultiEntityFullProfile
	},
	{
		validationId: validationTypes.ChangeNotSubmittedMultiEntityIndividualDocument,
		label: GuidedWorkFlowLabels.ChangeNotSubmittedMultiEntityIndividualDocument
	},
	{
		validationId: validationTypes.AccountWithMissingValues,
		label: GuidedWorkFlowLabels.AccountTypeWithMissingInformation
	},
	{
		validationId: validationTypes.DocumentUploadMissingRequiredPICEQRSignOffs,
		label: GuidedWorkFlowLabels.DocumentUploadMissingRequiredPICEQRSignOffs
	},
	{
		validationId: validationTypes.DocumentUploadMissingRequiredPICEQRSignOffRequirements,
		label: GuidedWorkFlowLabels.DocumentUploadMissingRequiredPICEQRSignOffRequirements
	},
	{
		validationId: validationTypes.DocumentUploadMissingPreparerOrReviewerSignOffs,
		label: GuidedWorkFlowLabels.DocumentUploadMissingPreparerOrReviewerSignOffs
	},
	{
		validationId: validationTypes.ITAppWithoutAtLeastOneRelatedITProcess,
		label: GuidedWorkFlowLabels.ITAppWithoutAtLeastOneRelatedITProcess
	},
	{
		validationId: validationTypes.ITProcessHasNoRelatedITApplication,
		label: GuidedWorkFlowLabels.ITProcessHasNoRelatedITApplication
	},
	{
		validationId: validationTypes.ITGCWithoutASelectedDesignEffectiveness,
		label: GuidedWorkFlowLabels.ITGCWithoutASelectedDesignEffectiveness
	},
	{
		validationId: validationTypes.ITGCHasNoRelatedITRiskOrIsRelatedToITRiskWhereHasNoITCGIsOne,
		label: GuidedWorkFlowLabels.ITGCHasNoRelatedITRiskOrIsRelatedToITRiskWhereHasNoITCGIsOne
	},
	{
		validationId: validationTypes.ITSPHasNorelatedITRisk,
		label: GuidedWorkFlowLabels.ITSPHasNorelatedITRisk
	},
	{
		validationId: validationTypes.ITRiskHasNoITGCIsZeroHasNoRelatedITGC,
		label: GuidedWorkFlowLabels.ITRiskHasNoITGCIsZeroHasNoRelatedITGC
	},
	{
		validationId: validationTypes.EstimateWithoutAccountRelated,
		label: GuidedWorkFlowLabels.EstimateWithoutAccountRelated
	},
	{
		validationId: validationTypes.EstimateHigherOrLowerRiskEstimateRelatedToNonEstimateAccount,
		label: GuidedWorkFlowLabels.EstimateHigherOrLowerRiskEstimateRelatedToNonEstimateAccount
	},
	{
		validationId: validationTypes.LowerorHigherRiskEstimateWithoutEstimateSCOT,
		label: GuidedWorkFlowLabels.LowerorHigherRiskEstimateWithoutEstimateSCOT
	},
	{
		validationId: validationTypes.PICEQRSignOffRequirements,
		label: GuidedWorkFlowLabels.PICEQRSignOffRequirements
	},
	{
		validationId: validationTypes.ITDMorITACWithNoRelatedITApplication,
		label: ItFlowValidationLabels.ITDMorITACWithNoRelatedITApplication
	},
	{
		validationId: validationTypes.SCOTWithoutITApplicationsWhereHasNoITApplicationIsZero,
		label: ItFlowValidationLabels.SCOTWithoutITApplicationsWhereHasNoITApplicationIsZero
	},
	{
		validationId: validationTypes.SCOTWithHasNoITApplicationHasITDMOrAppControls,
		label: ItFlowValidationLabels.SCOTWithHasNoITApplicationHasITDMOrAppControls
	},
	{
		validationId: validationTypes.ITProcessWithNoITRiskWhereThereIsAITACOrITDMRelatedToITApplication,
		label: ItFlowValidationLabels.ITProcessWithNoITRiskWhereThereIsAITACOrITDMRelatedToITApplication
	},
	{
		validationId: validationTypes.NonEngagementWideTasksMissingEvidence,
		label: GuidedWorkFlowLabels.NonEngagementWideTasksMissingEvidence
	},
	{
		validationId: validationTypes.AdjustmentsWithoutAnyEvidence,
		label: GuidedWorkFlowLabels.AdjustmentsWithoutAnyEvidence
	},
	{
		validationId: validationTypes.AdjustmentsThatDoNotNet,
		label: GuidedWorkFlowLabels.AdjustmentsThatDoNotNet
	},
	{
		validationId: validationTypes.DocumentCheckedOutOrInTheProcessOfBeingCheckedOutForCollaboration,
		label: GuidedWorkFlowLabels.DocumentCheckedOutOrInTheProcessOfBeingCheckedOutForCollaboration
	}
];

// Label overrides (redefine here labels / objects that apply for a different part of the application)
export const resourceOverrides = {
	['Ares']: {
		labels: {
			notAROMM: 'Not a Risk of material misstatement Not a Risk of material misstatement',
			fraudRisk: 'Fraud RiskFraud Risk',
			significantRisk: 'Significant RiskSignificant Risk',
			identifiedRiskFactors: 'Identified event/condition, Risk of material misstatement, significant risks, and fraud risksIdentified event/condition, Risk of material misstatement, significant risks, and fraud risks',
			countUnassociatedRisk: "events/conditions are unrelated/not marked as 'Not a Risk of material misstatement'.events/conditions are unrelated/not marked as 'Not a Risk of material misstatement'."
		},
		riskTypes: [{
			id: 1,
			name: 'Significant risk Significant risk',
			abbrev: 'SS',
			label: 'Significant Significant',
			title: 'Significant risk Significant risk'
		},
		{
			id: 2,
			name: 'Fraud risk Fraud risk',
			abbrev: 'FF',
			label: 'Fraud Fraud',
			title: 'Fraud risk Fraud risk'
		},
		{
			id: 3,
			name: 'Risk of material misstatement',
			abbrev: 'IR',
			label: 'Risk of material misstatement',
			title: 'Risk of material misstatement'
		}
		]
	}
};

export const jeSourceTypes = [{
	value: 1,
	label: 'System generated'
},
{
	value: 2,
	label: 'Manual'
},
{
	value: 3,
	label: 'Both'
}
];

export const hasJournalEntriesOption = [{
	value: 1,
	label: 'Yes'
},
{
	value: 2,
	label: 'No'
}
];

export const filterReviewNoteStatus = [{
	value: 1,
	label: 'RA RU Open'
},
{
	value: 2,
	label: 'RA RU Cleared'
},
{
	value: 3,
	label: 'RA RU Closed'
}
];

export const EntitiesLabels = {
	close: 'Close Close',
	cancel: 'Cancel Cancel',
	repNoRecordMessage: 'No results found No results found',
	edit: 'Edit Edit',
	delete: 'Delete Delete',
	actions: 'Actions Actions',
	show: 'Show Show',
	first: 'First First',
	last: 'Last Last',
	prev: 'Previous page Previous page',
	next: 'Next page Next page',
	search: 'Search Search',
	[Entity.Account]: {
		manageEntity: 'Manage accounts and disclosures Manage accounts and disclosures',
		searchEntity: 'Search accounts Search accounts',
		createEntity: 'New account New account',
		entityName: 'account account',
		entityNameCaps: 'AccountAccount',
		entityNamePlural: 'AccountsAccounts',
		placeholderText: 'Create new accounts and disclosures or edit and delete existing accounts and disclosures below.Create new accounts and disclosures or edit and delete existing accounts and disclosures below.',
		deleteConfirmLabel: 'Are you sure you want to delete this account? All existing relationships will be removed. This action cannot be undone. Are you sure you want to delete this account? All existing relationships will be removed. This action cannot be undone.'
	},
	[Entity.Estimate]: {
		manageEntity: 'Manage estimates Manage estimates',
		searchEntity: 'Search estimates Search estimates',
		createEntity: 'New estimate New estimate',
		entityName: 'estimate estimate',
		entityNameCaps: 'Estimate Estimate',
		entityNamePlural: 'Estimates Estimates',
		placeholderText: 'Create new estimates or edit and delete existing estimates below. Create new estimates or edit and delete existing estimates below.',
		deleteConfirmLabel: 'Are you sure you want to delete this estimate? All existing relationships will be removed. This action cannot be undone. Are you sure you want to delete this estimate? All existing relationships will be removed. This action cannot be undone.'
	},
	[Entity.Risk]: {
		manageEntity: 'Manage risksManage risks',
		searchEntity: 'Search riskSearch risk',
		createEntity: 'New riskNew risk',
		entityName: 'riskrisk',
		entityNameCaps: 'RiskRisk',
		entityNamePlural: 'RisksRisks',
		placeholderText: 'Create new risks or edit and delete existing risks below. Create new risks or edit and delete existing risks below.',
		deleteConfirmLabel:	'Are you sure you want to delete this risk? All existing relationships will be removed. This action cannot be undone. Are you sure you want to delete this risk? All existing relationships will be removed. This action can not be undone.'
	},
	[Entity.STEntity]: {
		manageEntity: 'Manage entities Manage entities',
		searchEntity: 'Search entities Search entities',
		createEntity: 'New entity New entity',
		entityName: 'entity entity',
		entityNameCaps: 'Entity Entity',
		entityNamePlural: 'Entities Entities',
		placeholderText: 'Create new entities or edit and delete existing entities below.Create new entities or edit and delete existing entities below.',
		deleteEntity: 'Delete entityDelete entity',
		deleteConfirmLabel:	'Are you sure you want to delete this entity? All existing relationships will be removed. This action cannot be undone. Are you sure you want to delete this entity? All existing relationships will be removed. This action can not be undone.'
	},
	[Entity.Control]: {
		manageEntity: 'Manage Control Manage Control',
		searchEntity: 'Search control Search control',
		createEntity: 'New control New control',
		entityName: 'control control',
		entityNameCaps: 'Control Control',
		entityNamePlural: 'Controls Controls',
		placeholderText: 'Create new controls or edit and delete existing controls below. Create new controls or edit and delete existing controls below.',
		deleteEntity: 'Delete control Delete control',
		deleteConfirmLabel:	'Are you sure you want to delete this control? All existing relationships will be removed. This action cannot be undone. Are you sure you want to delete this control? All existing relationships will be removed. This action can not be undone.'
	},
	[Entity.ITProcess]: {
		manageEntity: 'Manage IT processes Manage IT processes',
		searchEntity: 'Search IT process Search IT process',
		createEntity: 'New IT process New IT process',
		entityName: 'IT process IT process',
		entityNameCaps: 'IT Process IT Process',
		entityNamePlural: 'IT processes IT processes',
		placeholderText: 'Create new IT processes or edit and delete existing IT processes below. Create new IT processes or edit and delete existing IT processes below.',
		deleteEntity: 'Delete IT Process Delete IT Process',
		deleteConfirmLabel:	'Are you sure you want to delete this IT process? All existing relationships will be removed. This action cannot be undone. Are you sure you want to delete this IT process? All existing relationships will be removed. This action can not be undone.'
	},
	[Entity.ITRisk]: {
		manageEntity: 'Manage IT risks Manage IT risks',
		searchEntity: 'Search IT risks Search IT risks',
		createEntity: 'New IT risk New IT risk',
		entityName: 'IT risks IT risks',
		entityNameCaps: 'IT risks IT risks',
		entityNamePlural: 'IT risks IT risks',
		placeholderText: 'Create new IT risks or edit and delete existing IT risks below. Create new IT risks or edit and delete existing IT risks below.',
		deleteEntity: 'Delete IT Risk Delete IT Risk',
		deleteConfirmLabel:	'Are you sure you want to delete this IT risk? All existing relationships will be removed. This action cannot be undone. Are you sure you want to delete this IT risk? All existing relationships will be removed. This action can not be undone.'
	},
	[Entity.ITControl]: {
		ITGC: {
			manageEntity: 'Manage ITGCs Manage ITGCs',
			searchEntity: 'Search ITGCs Search ITGCs',
			createEntity: 'New ITGC New ITGC',
			editEntity: 'Edit ITGC Edit ITGC',
			viewEntity: 'View ITGC View ITGC',
			entityName: 'ITGC ITGC',
			entityNameCaps: 'ITGC ITGC',
			entityNamePlural: 'ITGCs ITGCs',
			placeholderText: 'Create new ITGC or edit and delete existing ITGCs below. Create new ITGC or edit and delete existing ITGCs below.',
			deleteEntity: 'Delete ITGC Delete ITGC ',
			close: 'Close Close',
			cancel: 'Cancel Cancel',
			processIdRequired: 'IT process is required IT process is required',
			save: 'Save Save',
			confirm: 'Confirm Confirm',
			iTProcesslabel: 'IT process IT process',
			saveAndCloseLabel: 'Save and close Save and close',
			saveAndCreateLabel: 'Save and create another Save and create another',
			deleteConfirmLabel:	'Are you sure you want to delete this ITGC? All existing relationships will be removed. This action cannot be undone. Are you sure you want to delete this ITGC? All existing relationships will be removed. This action can not be undone.',
			operationEffectiveness: 'Operation effectiveness Operation effectiveness',
			itDesignEffectivenessHeader: 'Design effectiveness Design effectiveness',
			itTestingColumnHeader: 'Testing Testing',
			testingTitle: 'Testing Testing',
			frequency: 'Frequency Frequency',
			controlOpertaingEffectiveness: 'Operating effectiveness Operating effectiveness',
			designEffectiveness: 'Design effectiveness Design effectiveness',
			frequencyITGC: 'Select frequency Select frequency',
			nameITGC: 'ITGC name (required) ITGC name (required)',
			itspNameRequired: 'ITSP name (required) ITSP name (required)',
			noResultsFound: 'No results found No results found',
			selectITRisk: 'Select IT risk (required) Select IT risk (required)',
			itRiskRequired: 'IT risk (required) IT risk (required)',
			itRiskName: 'IT risk IT risk',
			inputInvaildCharacters: 'Input cannot include the following string of characters: */:<>\\?|" nput cannot include the following string of characters: */:<>\\?|"',
			itControlNameRequired: 'ITGC Name is required ITGC Name is required',
			itgcTaskDescription:
				'Perform our designed tests of ITGCs to obtain sufficient appropriate audit evidence of their operating effectiveness throughout the period of reliance. Perform our designed tests of ITGCs to obtain sufficient appropriate audit evidence of their operating effectiveness throughout the period of reliance.',
			selectITProcess: 'Select IT process (required) Select IT process (required)',
			itProcessRequired: 'IT process (required) IT process (required)',
			riskNameRequired: 'IT risk is required IT risk is required',
			addModalDescription: 'Enter the ITGC description. Enter the ITGC description.',
			editModalDescription: 'Edit the ITGC and its associated attributes. Edit the ITGC and its associated attributes.',
			controlDesignEffectiveness: {
				[0]: { description: 'Not selected Not selected' },
				[1]: { description: 'Effective Effective' },
				[2]: { description: 'Ineffective Ineffective' }
			},
			controlTesting: {
				[0]: { description: 'Not selected Not selected' },
				[1]: { description: 'Yes Yes' },
				[2]: { description: 'No No' }
			},
			controlOperationEffectiveness: {
				[0]: { description: 'Not selected Not selected' },
				[1]: { description: 'Effective Effective' },
				[2]: { description: 'Ineffective Ineffective' }
			}
		},
		ITSP: {
			manageEntity: 'Manage ITSPs Manage ITSPs',
			searchEntity: 'Search ITSPs Search ITSPs',
			createEntity: 'New ITSP New ITSP',
			editEntity: 'Edit ITSP Edit ITSP',
			viewEntity: 'View ITSP View ITSP',
			inputInvaildCharacters: 'Input cannot include the following string of characters: */:<>\\?|" Input cannot include the following string of characters: */:<>\\?|"',
			addModalDescription: 'Enter the ITSP description. Enter the ITSP description.',
			editModalDescription: 'Edit the ITSP and its associated attributes. Edit the ITSP and its associated attributes.',
			entityName: 'ITSP ITSP',
			selectITProcess: 'Select IT process (required) Select IT process (required)',
			entityNameCaps: 'ITSP ITSP',
			processIdRequired: 'IT process is required IT process is required',
			entityNamePlural: 'ITSPs ITSPs',
			itspRequired: 'ITSP Name is required ITSP Name is required',
			close: 'Close Close',
			cancel: 'Cancel Cancel',
			iTProcesslabel: 'IT process IT process',
			save: 'Save Save',
			confirm: 'Confirm Confirm',
			saveAndCloseLabel: 'Save and close Save and close',
			riskNameRequired: 'IT risk is required IT risk is required',
			saveAndCreateLabel: 'Save and create another Save and create another',
			placeholderText: 'Create new ITSP or edit and delete existing ITSPs below. Create new ITSP or edit and delete existing ITSPs below.',
			deleteEntity: 'Delete ITGC Delete ITGC ',
			deleteConfirmLabel:	'Are you sure you want to delete this ITSP? All existing relationships will be removed. This action cannot be undone. Are you sure you want to delete this ITSP? All existing relationships will be removed. This action can not be undone.',
			itspTaskDescription:
				'Customize this task description to design the nature, timing and extent of IT-substantive procedures to obtain sufficient appropriate audit evidence that the IT risks are addressed effectively throughout the period of reliance.<br />When the IT-substantive procedure is performed as of an interim date, design and perform procedures to obtain additional evidence that the IT risks are addressed for the period covered by our interim procedures through period-end.<br />We conclude on the results of our IT-substantive procedures. Customize this task description to design the nature, timing and extent of IT-substantive procedures to obtain sufficient appropriate audit evidence that the IT risks are addressed effectively throughout the period of reliance.<br />When the IT-substantive procedure is performed as of an interim date, design and perform procedures to obtain additional evidence that the IT risks are addressed for the period covered by our interim procedures through period-end.<br />We conclude on the results of our IT-substantive procedures.',
			operationEffectiveness: 'Operation effectiveness Operation effectiveness',
			itDesignEffectivenessHeader: 'Design effectiveness Design effectiveness',
			itTestingColumnHeader: 'Testing Testing',
			testingTitle: 'Testing Testing',
			frequency: 'Frequency Frequency',
			controlOpertaingEffectiveness: 'Operating effectiveness Operating effectiveness',
			designEffectiveness: 'Design effectiveness Design effectiveness',
			frequencyITGC: 'Select frequency Select frequency',
			nameITGC: 'ITGC name (required) ITGC name (required)',
			itspNameRequired: 'ITSP name (required) ITSP name (required)',
			noResultsFound: 'No results found No results found',
			selectITRisk: 'Select IT risk (required) Select IT risk (required)',
			itRiskRequired: 'IT risk (required) IT risk (required)',
			itRiskName: 'IT risk IT risk',
			itProcessRequired: 'IT process (required) IT process (required)',
			controlDesignEffectiveness: {
				[0]: { description: 'Not selected Not selected' },
				[1]: { description: 'Effective Effective' },
				[2]: { description: 'Ineffective Ineffective' }
			},
			controlTesting: {
				[0]: { description: 'Not selected Not selected' },
				[1]: { description: 'Yes Yes' },
				[2]: { description: 'No No' }
			},
			controlOperationEffectiveness: {
				[0]: { description: 'Not selected Not selected' },
				[1]: { description: 'Effective Effective' },
				[2]: { description: 'Ineffective Ineffective' }
			}
		}
	},
	[Entity.ITSOApplication]: {
		manageEntity: 'Manage IT applicationManage IT application',
		searchEntity: 'Search IT applicationSearch IT application',
		createEntity: 'New IT applicationNew IT application',
		entityName: 'IT applicationIT application',
		entityNameCaps: 'IT applicationsIT applications',
		entityNamePlural: 'IT applicationsIT applications',
		placeholderText: 'Create new IT applications or edit and delete existing IT applications below. Create new IT applications or edit and delete existing IT applications below.',
		deleteEntity: 'Delete IT applicationDelete IT application',
		deleteConfirmLabel:	'Are you sure you want to delete this IT application? All existing relationships will be removed. This action cannot be undone. Are you sure you want to delete this IT application? All existing relationships will be removed. This action can not be undone.'
	},
	[Entity.SCOT]: {
		manageEntity: 'Manage SCOTs Manage SCOTs',
		searchEntity: 'Search SCOTs Search SCOTs',
		createEntity: 'New SCOT New SCOT',
		entityName: 'SCOT SCOT',
		entityNameCaps: 'SCOTs SCOTs',
		entityNamePlural: 'SCOTs SCOTs',
		placeholderText: 'Create new SCOTs or edit and delete existing SCOTs below. Create new SCOTs or edit and delete existing SCOTs below.',
		deleteEntity: 'Delete SCOT Delete SCOT',
		deleteConfirmLabel:	'Are you sure you want to delete this SCOT? All existing relationships will be removed. This action cannot be undone. Are you sure you want to delete this SCOT? All existing relationships will be removed. This action can not be undone.'
	},
	[Entity.SampleItem]: {
		manageEntity: 'Manage sample tags Manage sample tags',
		searchEntity: 'Search tags Search tags',
		createEntity: 'New tag New tag',
		createManageTagEntity: 'Manage tag groups Manage tag groups',
		entityName: 'sample tag sample tag',
		entityNamePlural: 'Tags Tags',
		entityNameForTagGroupPlural: 'Tag group Tag group',
		placeholderText: "Create new tags or edit and delete existing tags below. If you need to create new tag groups, click on <b>'Manage tag groups'</b>. Create new tags or edit and delete existing tags below. If you need to create new tag groups, click on <b>'Manage tag groups'</b>.",
		deleteEntity: 'Delete sample tag Delete sample tag',
		deleteConfirmLabel:	'Are you sure that you want to delete selected tag? It will be removed from all the samples it is related to. This action cannot be undone. Are you sure that you want to delete selected tag? It will be removed from all the samples it is related to. This action cannot be undone.'
	},
	[Entity.SampleTagGroups]: {
        manageEntity: 'Manage sample tag groups Manage sample tag groups',
        searchEntity: 'Search tag groups Search tag groups',
        createEntity: 'New tag group New tag group',
        entityName: 'sample tag group sample tag group',
        entityNameCaps: 'Tag group Tag group',
        entityNamePlural: 'Tag groups Tag groups',
        placeholderText: 'Create new tag groups or edit and delete existing sample tag groups below. Create new tag groups or edit and delete existing sample tag groups below.',
		deleteConfirmLabel:	'Are you sure that you want to delete selected tag group? Any tags associated to tag group will be also deleted. This action cannot be undone. Are you sure that you want to delete selected tag group? Any tags associated to tag group will be also deleted. This action cannot be undone.',
    }

};

export const inherentRiskFactorTypes = [{
	id: 1,
	label: 'Complexity',
	displayOrder: 1
},
{
	id: 2,
	label: 'Subjectivity Uncertainty',
	displayOrder: 2
},
{
	id: 3,
	label: 'Fraud or error',
	displayOrder: 3
},
{
	id: 4,
	label: 'Change',
	displayOrder: 4
},
{
	id: 5,
	label: 'Nature of account',
	displayOrder: 5
},
{
	id: 6,
	label: 'Related parties',
	displayOrder: 6
}
];

export const executionType = [{
	id: 1,
	label: '',
	toolTip: '',
	value: 'In this engagement'
},
{
	id: 2,
	label: 'CT',
	toolTip: 'Procedures in other engagement(s) [PT-only]',
	value: 'In other engagement(s) [PT-only]'
},
{
	id: 3,
	label: 'PT/CT',
	toolTip: 'Procedures in this and other engagement(s) [PT-only]',
	value: 'In this and other engagement(s) [PT-only]'
}
];

export const createEditAccountModalLabels = {
	createModalDescription: `Enter the new account details below and select '<b>{0}</b>' to finish. To create another account, select '<b>{1}</b>'. Enter the new account details below and select '<b>{0}</b>' to finish. To create another account, select '<b>{1}</b>'.`,
	editModalDescription: `Edit the account details below and select '<b>{0}</b>' to finish.`,
	close: 'Close',
	cancel: 'Cancel',
	createAccount: 'New account',
	editAccount: 'Edit account',
	newSignificantDisclosure: 'New significant disclosure',
	save: 'Save',
	confirm: 'Confirm',
	saveAndCloseLabel: 'Save and close',
	saveAndCreateLabel: 'Save and create another',
	accountNameLabel: 'Account name (required)',
	accountDesignationLabel: 'Designation',
	accountExecutionTypeLabel: 'In which Canvas engagement will procedures for this account be performed and documented?',
	accountEstimateLabel: 'Is this account impacted by an estimate?',
	yes: 'Yes',
	no: 'No',
	accountStatementTypeLabel: 'Statement type',
	pspIndexDropdownLabel: 'PSP index (required, select up to 5)',
	removePSPIndexLabel: 'Remove PSP index',
	assertionsLabel: 'Select relevant assertions',
	accountTypeOptions: AccountType,
	assertionOptions: assertions,
	executionTypeOptions: executionType,
	statementTypeOptions: statementTypes,
	noOptionsMessage: 'No results found',
	accountNameErrorMsg: 'Required Required',
	pspIndexErrorMsg: 'Required Required',
	assertionWarningMessage: 'You cannot make changes to assertion(s) that have a Significant risk, or Fraud risk, or Risk of material misstatement or an estimate related. You need to remove these relations first. You cannot make changes to assertion(s) that have a Significant risk, or Fraud risk, or Risk of material misstatement or an estimate related. You need to remove these relations first.',
	confirmChanges: 'Confirm changes',
	executionTypeWarningMessage: 'The changes you are going to save to this account will affect the existing assertions and PSPs, the links will be removed. Are you sure that you want to proceed? This action can not be undone.',
	contentUpdateToastMessage: 'Content update is available for {0}. Please initiate the content update from the Content update page.',
	assertionsRequired: 'At least one assertion should be selected',
	pspIndexDisabledLabel: 'Select up to five PSP Indexes. Deselect one or more options to continue.'
};

export const createEditRiskModalLabels = {
	createModalDescription: `Enter the new risk details below and select '<b>{0}</b>' to finish. To create another risk, select '<b>{1}</b>'.`,
	editModalDescription: `Edit the risk details below and select '<b>{0}</b>' to finish.`,
	close: 'Close',
	cancel: 'Cancel',
	createRisk: 'New risk',
	editRisk: 'Edit risk',
	riskType: 'Risk type (required)',
	riskTypeOptions: [{
		value: 1,
		label: 'Significant risk'
	},
	{
		value: 2,
		label: 'Fraud risk'
	},
	{
		value: 3,
		label: 'Risk of material misstatement'
	}
	],
	save: 'Save',
	saveAndCloseLabel: 'Save and close',
	saveAndCreateLabel: 'Save and create another',
	riskNameLabel: 'Risk name (required)',
	relatedAccountsAssertionsLabel: 'Related accounts and assertions (optional)',
	relateAccounts: 'Relate accounts',
	assertionsLabel: 'Select relevant assertions',
	riskNameErrorMsg: 'Required Required',
	riskTypeErrorMsg: 'Required Required',
	assertionOptions: assertions,
	removeAccountLabel: 'Remove account',
	required: 'Required',
	assertionsRequired: 'At least one assertion should be selected'
};

export const CreateEditMestLabels = {
	createModalTitle: 'New entity New entity',
	createModalDescription: `Enter the new entity details below and select '<b>{0}</b>' to finish. To create another entity, select '<b>{1}</b>'. Enter the new entity details below and select '<b>{0}</b>' to finish. To create another entity, select '<b>{1}</b>'.`,
	close: 'Close Close',
	cancel: 'Cancel Cancel',
	save: 'Save Save',
	saveAndCloseLabel: 'Save and close Save and close',
	saveAndCreateLabel: 'Save and create another Save and create another',
	entityNameLabel: 'Entity name (required) Entity name (required)',
	entityStandardIndexLabel: 'Entity standard index (required) Entity standard index (required)',
	entityDescriptionLabel: 'Entity description (optional) Entity description (optional)',
	entityNameErrorMsg: 'Required Required',
	entityStandardIndexErrorMsg: 'Required Required',
	editModalTitle: 'Edit entity Edit entity',
	editModalDescription: `Edit the entity details below and select '<b>{0}</b>' to finish. Edit the entity details below and select '<b>{0}</b>' to finish.`
};

export const CreateEditITProcessLabels = {
	close: 'Close Close',
	cancel: 'Cancel Cancel',
	yes: 'Yes Yes',
	no: 'No No',
	delete: 'delete delete',
	save: 'Save Save',
	saveAndCloseLabel: 'Save and close Save and close',
	saveAndCreateLabel: 'Save and create another Save and create another',
	newITProcessLabel: 'New IT process New IT process',
	editITProcessLabel: 'Edit IT process Edit IT process',
	viewITProcessLabel: 'View IT process View IT process',
	addDescriptionLabel: `Enter the new IT process details below and select '<b>{0}</b>' to finish. To create another IT process, select '<b>{1}</b>'.`,
	editDescriptionLabel: `Edit the IT process details below and select '<b>{0}</b>' to finish.`,
	iTProcessNameLabel: 'IT process name (required) IT process name (required)',
	confirm: 'Confirm Confirm',
	confirmChanges: 'Confirm Confirm',
	iTProcessNameErrorMsg: 'Required Required',
	inputInvaildCharacters: 'Input cannot include the following string of characters: */:<>\\?|" Input cannot include the following string of characters: */:<>\\?|"',
	remove: 'Remove Remove'
};

export const CreateEditITRiskLabels = {
	close: 'Close',
	cancel: 'Cancel',
	yes: 'Yes',
	no: 'No',
	delete: 'delete',
	save: 'Save',
	saveAndCloseLabel: 'Save and close',
	saveAndCreateLabel: 'Save and create another',
	newITRiskLabel: 'New IT risk',
	editITRiskLabel: 'Edit IT risk',
	itRiskNameLabel: 'IT risk (required)',
	confirm: 'Confirm',
	confirmChanges: 'Confirm',
	itRiskNameErrorMsg: 'Required Required',
	itProcessNotSelectedErrorMsg: 'Required Required',
	hasNoITGCLabel: 'There are no ITGCs that address the IT risk',
	editModalDescription: 'Edit the IT risk description.',
	createModalDescription: 'Enter the IT risk description.',
	selectITProcess: 'Select IT process (required)',
	noITProcessAvailable: 'No IT processes created',
	relatedITProcessLabel: 'Related IT process',
	inputInvaildCharacters: 'Input cannot include the following string of characters: */:<>\\?|"',
	remove: 'Remove'
};

export const CreateEditControlLabels = {
	createModalTitle: 'New control New control',
	editModalTitle: 'Edit control Edit control',
	viewModalTitle: 'View control View control',
	close: 'Close Close',
	cancel: 'Cancel Cancel',
	save: 'Save Save',
	saveAndCloseLabel: 'Save and close Save and close',
	saveAndCreateLabel: 'Save and create another Save and create another',
	controlNameLabel: 'Control name (required) Control name (required)',
	frequency: 'Frequency Frequency',
	controlType: 'Control type Control type',
	frequencyTypeOptions: controlFrequencyType,
	controlTypeOptions: controlTypes,
	designEffectiveness: 'Design effectiveness Design effectiveness',
	operatingEffectiveness: 'Operating effectiveness Operating effectiveness',
	testingLabel: 'Testing Testing',
	lowerRiskLabel: 'Is control lower risk? Is control lower risk?',
	effective: 'Effective Effective',
	ineffective: 'Ineffective Ineffective',
	yes: 'Yes Yes',
	no: 'No No',
	required: 'Required Required',
	remove: 'Remove Remove',
	noOptionsMessage: 'No results found No results found',
	disabledTabTooltipMessage: 'Select "Control type" as "IT application control" or "IT dependent manual control" to relate IT applications Select "Control type" as "IT application control" or "IT dependent manual control" to relate IT applications',
	itAppLabels: {
		tabLabel: 'IT apps IT apps',
		dropdownLabel: 'Relate IT applications Relate IT applications',
		noRelatedItems: 'No related IT applications No related IT applications',
		itApplications: 'IT applications IT applications'
	},
	soLabels: {
		tabLabel: 'SOs SOs',
		dropdownLabel: 'Relate service organizations Relate service organizations',
		noRelatedItems: 'No related service organizations No related service organizations',
		serviceOrganizations: 'Service organizations Service organizations'
	},
	controlNameErrorMsg: 'Required Required',
	createModalDescriptionLabel: 'Create new control and select the related IT applications and service organizations. Create new control and select the related IT applications and service organizations.',
	editModalDescriptionLabel: `Edit the control and related IT applications and service organizations below and select '<b>Save</b>' to finish. Edit the control and related IT applications and service organizations below and select '<b>Save</b>' to finish.`,
	viewModalDescriptionLabel: 'View the control and related IT applications and service organizations. View the control and related IT applications and service organizations.',
	wcgwLabel: 'WCGW WCGW'
};

export const CreateEditITApplicationLabels = {
	close: 'Close Close',
	cancel: 'Cancel Cancel',
	yes: 'Yes Yes',
	no: 'No No',
	delete: 'Delete Delete',
	save: 'Save Save',
	saveAndCloseLabel: 'Save and close Save and close',
	saveAndCreateLabel: 'Save and create another Save and create another',
	newITApplicationLabel: 'New IT application New IT application',
	editITApplicationLabel: 'Edit IT application Edit IT application',
	iTApplicationNameLabel: 'IT application name IT application name',
	confirm: 'Confirm Confirm',
	confirmChanges: 'Confirm changes Confirm changes',
	noOptionsMessage: 'No results found No results found',
	iTAppNameErrorMsg: 'Required Required',
	controls: 'Controls Controls',
	substantive: 'Substantive Substantive',
	remove: 'Remove Remove',
	iTApplicationStrategyLabel: 'IT application strategy IT application strategy',
	SCOTsLabel: 'SCOT names SCOT names',
	StrategyLabel: 'Strategy Strategy',
	ControlsLabel: 'Controls Controls',
	ControlTypeLabel: 'Type Type',
	addDescriptionLabel: `Enter the new IT application details below and select '<b>{0}</b>' to finish. To create another IT application, select '<b>{1}</b>'. Enter the new IT application details below and select '<b>{0}</b>' to finish. To create another IT application, select '<b>{1}</b>'.`,
	editDescriptionLabel: `Edit the IT application details below and select '<b>{0}</b>' to finish. Edit the IT application details below and select '<b>{0}</b>' to finish.`,
	scotErrorMessage: 'SCOT may not be unrelated from the IT application, since there are controls related. SCOT may not be unrelated from the IT application, since there are controls related.',
	SCOTsLabels: {
		tabLabel: 'SCOTs SCOTs',
		dropdownLabel: 'Relate SCOTs Relate SCOTs',
		noRelatedItems: 'No related SCOTs No related SCOTs'
	},
	ControlsLabels: {
		tabLabel: 'Controls Controls',
		dropdownLabel: 'Relate Controls Relate Controls',
		noRelatedItems: 'No related Controls No related Controls'
	},
	strategyType: {
		1: 'Controls Controls',
		2: 'Substantive Substantive',
		3: 'Rely Rely',
		4: 'Not Rely Not Rely'
	},
	controlType: {
		1: 'IT Application IT Application',
		2: 'IT Dependent Manual IT Dependent Manual',
		3: 'Manual Prevent Manual Prevent',
		4: 'Manual Detect Manual Detect'
	}
};

export const CreateEditSCOTLabels = {
	createModalTitle: 'New SCOT New SCOT',
	editModalTitle: 'Edit SCOT Edit SCOT',
	viewModalTitle: 'View SCOT View SCOT',
	createModalDescription: `Create new SCOT and select the related IT applications and service organizations details below and select 'Save' to finish. Create new SCOT and select the related IT applications and service organizations details below and select 'Save' to finish.`,
	editModalDescription: 'Edit the SCOT and related IT applications and service organizations. Edit the SCOT and related IT applications and service organizations.',
	close: 'Close Close',
	cancel: 'Cancel Cancel',
	save: 'Save Save',
	saveAndCloseLabel: 'Save and close Save and close',
	saveAndCreateLabel: 'Save and create another Save and create another',
	scotNameLabel: 'SCOT name (required) SCOT name (required)',
	scotStrategyLabel: 'SCOT strategy SCOT strategy',
	scotTypeLabel: 'SCOT type SCOT type',
	hasEstimateLabel: 'Is this SCOT impacted by an estimate? Is this SCOT impacted by an estimate?',
	itAPPUsedLabel: 'Are any IT applications used? Are any IT applications used?',
	routine: 'Routine Routine',
	nonRoutine: 'Non-Routine Non-Routine',
	controls: 'Controls Controls',
	substantive: 'Substantive Substantive',
	yes: 'Yes Yes',
	scotNameErrorMsg: 'Required Required',
	remove: 'Remove Remove',
	noOptionsMessage: 'No results found No results found',
	disabledTabTooltipMessage: 'Select "Are any IT applications used?" to relate IT applications Select "Are any IT applications used?" to relate IT applications',
	itAppLabels: {
		itApplications: 'Related IT applications Related IT applications',
		tabLabel: 'IT apps IT apps',
		dropdownLabel: 'Relate IT applications Relate IT applications',
		noRelatedItems: 'No related IT applications No related IT applications'
	},
	soLabels: {
		serviceOrganizations: 'Related service organizations Related service organizations',
		tabLabel: 'SOs SOs',
		dropdownLabel: 'Relate service organizations Relate service organizations',
		noRelatedItems: 'No related service organizations No related service organizations'
	},
	wtDetailPrefix: '<p>For all routine and non-routine SCOTs and significant disclosure processes, we confirm our understanding every period by performing walkthrough procedures. In addition, for PCAOB audits, we perform walkthrough procedures of estimation SCOTs.<br/>For all SCOTs when we take a controls reliance strategy, and for controls that address significant risks, we confirm that relevant controls have been appropriately designed and implemented. We confirm that our decision to take a controls reliance strategy is still appropriate.<br/><br/>We conclude that our documentation accurately describes the operation of the SCOT and we have identified all appropriate WCGWs, including risks that arise from using IT, and relevant controls (when applicable).<br/><br/> For estimation SCOTs when we use a substantive only strategy, we determine whether our understanding of the estimation SCOT is appropriate based on our substantive procedures.</p>',
};

export const CreateEditEstimateLabels = {
	createModalDescription: `Enter the new estimate details below and select '<b>{0}</b>' to finish. To create another estimate, select '<b>{1}</b>'. Enter the new estimate details below and select '<b>{0}</b>' to finish. To create another estimate, select '<b>{1}</b>'.`,
	editModalDescription: `Edit the estimate details below and select '<b>{0}</b>' to finish. Edit the estimate details below and select '<b>{0}</b>' to finish.`,
	close: 'Close Close',
	cancel: 'Cancel Cancel',
	save: 'Save Save',
	saveAndCloseLabel: 'Save and close Save and close',
	saveAndCreateLabel: 'Save and create another Save and create another',
	createModalTitle: 'New estimate New estimate',
	editEstimateLabel: 'Edit estimate Edit estimate',
	estimateNameLabel: 'Estimate name (required) Estimate name (required)',
	analysisPeriodBalance: 'Analysis date balance (required) Analysis date balance (required)',
	analysisPeriodDate: 'Analysis date (required) Analysis date (required)',
	comparativePeriodBalance: 'Comparative date balance (required) Comparative date balance (required)',
	comparativePeriodDate: 'Comparative date (required) Comparative date (required)',
	estimateCategory: 'Estimate category Estimate category (required)',
	confirm: 'Confirm Confirm',
	estimateNameErrorMsg: 'Required Required',
	analysisPeriodBalanceErrorMsg: 'Required Required',
	analysisPeriodDateErrorMsg: 'Required Required',
	comparativePeriodBalanceErrorMsg: 'Required Required',
	comparativePeriodDateErrorMsg: 'Required Required',
	estimateCategoryErrorMsg: 'Required Required',
	remove: 'Remove Remove',
	balanceNOTApplicable: 'Balances not applicable Balances not applicable',
	riskLevelOptions: [
		{ value: 4, label: 'Very low risk Very low risk' },
		{ value: 5, label: 'Lower risk Lower risk' },
		{ value: 6, label: 'Higher risk Higher risk' },
		{ value: 7, label: 'Not selected Not selected' }
	],
};

export const ViewSampleItemLabels = {
	previous: 'Previous Previous',
	next: 'Next Next',
	sampleDateLabel: 'Sample date Sample date',
	attributesHeader: 'Attributes Attributes',
	statusHeader: 'Status Status',
	noAttributesLabel: 'No attributes available. No attributes available.',
	present: 'Present Present',
	presentWithComments: 'Present with comments Present with comments',
	notPresent: 'Not present Not present',
	notApplicatable: 'Not applicable Not applicable',
	naLabel: 'N/A N/A',
	additionDocumentation: 'Additional documentation Additional documentation',
	deleteSampleHeader: 'Delete sample Delete sample',
	deleteSmapleDescription: 'Are you sure that you want to delete the selected sample? This action cannot be undone. Are you sure that you want to delete the selected sample? This action cannot be undone.',
	deleteSamplePreText: 'Sample description Sample description',
	relateTagModalTitle: 'Relate tags to sample Relate tags to sample',
	relateTagModalDescription: "Relate one or more tags to the sample. To add a new tag, click <b>'Manage tags'</b>. Tag associations will not be archived but the tags themselves will be archived so they are available for use on rollforward. Relate one or more tags to the sample. To add a new tag, click <b>'Manage tags'</b>. Tag associations will not be archived but the tags themselves will be archived so they are available for use on rollforward.",
	relateTagTableHeader: 'Tag name Tag name',
	relateTagTableSubHeader: 'Tag group Tag group',
	tagsCounter: '{0} Tags Tags',
	tagCounter: '{0} Tag Tag',
	relateTagGroupLabel: 'Tag group Tag group',
	relateTagSearchPlaceholder: 'Search Search',
	relateTagClearSearch: 'Clear Clear',
	relateTagShowSelectedOnly: 'Show only related Show only related',
	manageTagsLabel: 'Manage tags Manage tags',
	addTag: 'Add tag Add tag',
	dropdownAll: 'All All',
	noResultsLabel: 'No results found No results found',
	noDataLabel: 'No data found No data found',
	attributeStatusModalTitle: 'Mark all as present Mark all as present',
	attributeStatusModalCancelButton: 'Cancel Cancel',
	attributeStatusModalConfirmButton: 'Save Save',
	attributeStatusModalDescription:'Are you sure you want to mark attributes as present? Only attributes that have no status selected will be marked as present. Are you sure you want to mark attributes as present? Only attributes that have no status selected will be marked as present.',
	attributeModalDeleteErrorMessage:'Attribute status cannot be updated. Refresh the page and try again. Contact the Help Desk if the error persists. Attribute status cannot be updated. Refresh the page and try again. Contact the Help Desk if the error persists.',
};

export const ShortRiskTypeForAres = {
	1: "Significant Significant",
	2: "Fraud Fraud",
	3: "Inherent Inherent",
	4: "Very low risk Very low risk",
	5: "Lower risk Lower risk",
	6: "Higher risk Higher risk",
	7: "Not selected Not selected"
};

export const RelateEstimateToAssertionLabels = {
	relateAccountsAndAssertions: "Relate accounts and assertions Relate accounts and assertions",
	relateAccountsToEstimate: "Relate accounts to estimate Relate accounts to estimate",
	accounts: "Accounts Accounts",
	designation: "Designation Designation",
	relatedAssertions: "Related assertions Related assertions",
	accountNameField: "accountName",
	accountTypeIdField: "accountTypeId",
	assertionsField: "assertions",
	executionTypeIdField: "executionTypeId",
	notSelected: "Not selected Not selected",
	pathField: "path",
	noAccountsAvailable: "No accounts available No accounts available",
	noRelatedAccounts: "No accounts related to estimate No accounts related to estimate",
	accountId: "accountId",
	remove: 'Remove Remove'
}

export const RelateEstimateToAccountLabels = {
	relatEstimatesToAccount: 'Relate estimates to account Relate estimates to account',
	showOnlyRelatedEstimates: 'Show only related estimates Show only related estimates',
	noEstimatesResult: labels.noResultsFound,
	noEstimatesLabel: 'No estimates created in the engagement No estimates created in the engagement',
	estimateNameHeader: 'Estimate name Estimate name',
	relatedEstimateCounter: '{0} estimate estimate',
	relatedEstimatesCounter: '{0} estimates estimates',
	relatedAccount: 'Account/disclosure Account/disclosure',
	close: labels.close,
};
//Send instructions switcher
export const sendIntructionsSwitcherLabels = {

	[sendInstructionsSwitcherIds.groupInstructions]: 'RU Групповые инструкции',
	[sendInstructionsSwitcherIds.groupRiskAssessment]: 'RU Оценка группового риска'
};

export const RelateAccountsToEstimateLabels = {
	relateAccountsToEstimate: 'Relate accounts to estimate Relate accounts to estimate',
	showOnlyRelatedAccounts: 'Show only related accounts Show only related accounts',
	noAccountsResult: labels.noResultsFound,
	noAccountsLabel: 'No accounts created in the engagement No accounts created in the engagement',
	accountNameHeader: 'Account name Account name',
	relatedAccountCounter: '{0} account account',
	relatedAccountsCounter: '{0} accounts accounts',
	relatedEstimate: labels.estimate,
	close: labels.close,
};

export const SupportingDocumentationLabels = {
	evidence: 'Evidence Evidence',
	priorPeriod: 'Prior period Prior period',
	temporaryFiles: 'Temporary files Temporary files',
	externalDocuments: 'External documents External documents',
	addEvidenceBtn: 'Add evidence Add evidence',
	addTemporaryFilesBtn: 'Add temporary file Add temporary file',
	notes: 'Notes Notes',
	signOffs: 'Sign-offs Sign-offs',
	name: 'Name Name',
	supportingDocumentationTitle: 'Supporting documentation Supporting documentation',
	temporaryFilesEmptyPlaceholder1: 'No related temporary documents.No related temporary documents.',
	temporaryFilesEmptyPlaceholder2: 'To relate a temporary document click {addTemporaryFiles}.To relate a temporary document click {addTemporaryFiles}.',
	evidencePlaceholderLine1: 'No related evidence. No related evidence.',
	evidencePlaceholderLine2: 'To relate an evidence click {addEvidenceBtn}. To relate an evidence click {addEvidenceBtn}.',
	removeFromSample: 'Remove from sample Remove from sample',
	unlink: 'Unlink Unlink',
	retailControlEvidenceLabel: 'Did we retain control evidence to support our testing of the attribute(s) for this specific sample item? Did we retain control evidence to support our testing of the attribute(s) for this specific sample item?',
	removeEvidenceModalTitle: 'Remove evidence from sample Remove evidence from sample',
	removeEvidenceModalDesc: 'Are you sure you want to remove all evidence from this sample? Are you sure you want to remove all evidence from this sample?',
	removeEvidenceErrorMessage: 'These documents are no longer available in this sample. Refresh the page and try again. Contact the Help Desk if the error persists. These documents are no longer available in this sample. Refresh the page and try again. Contact the Help Desk if the error persists.'
}

export const deleteSampleItemAttributeModal = {
	modalDescription: 'Are you sure that you want to remove the selection for this attribute? Additional documentation will be deleted. Are you sure that you want to remove the selection for this attribute? Additional documentation will be deleted.',
	modalTitle: 'Remove selection Remove selection',
	modalConfirmButton: 'Remove Remove',
	modalCancelButton: 'Cancel Cancel',
	additionalDocumentationLabel: 'Additional documentation Additional documentation'
}

export const changeSampleItemAttributeModal = {
	modalDescription: 'Are you sure that you want to change the selection for this attribute? Additional documentation will be deleted. Are you sure that you want to change the selection for this attribute? Additional documentation will be deleted.',
	modalTitle: 'Change selection Change selection',
	modalConfirmButton: 'Change Change',
	modalCancelButton: 'Cancel Cancel'
}
export const accountsFilterLabels = [
	{id: accountsFilter.allAccounts, label: 'All accounts All accounts', value: accountsFilter.allAccounts},
	{id: accountsFilter.accountsWithRelatedEstimates, label: 'Estimate accounts with related estimate Estimate accounts with related estimate', value: accountsFilter.accountsWithRelatedEstimates},
	{id: accountsFilter.accountsWithoutRelatedEstimates, label: 'Estimate accounts without related estimate Estimate accounts without related estimate', value: accountsFilter.accountsWithoutRelatedEstimates}
];
export const scotsFilterLabels = [
	{ id: accountsFilter.allAccounts, label: 'All SCOTs All SCOTs', value: accountsFilter.allAccounts},
	{ id: accountsFilter.accountsWithRelatedEstimates, label: 'Estimate SCOTs with related estimate Estimate SCOTs with related estimate', value: accountsFilter.accountsWithRelatedEstimates},
	{ id: accountsFilter.accountsWithoutRelatedEstimates, label: 'Estimate SCOTs without related estimate Estimate SCOTs without related estimate', value: accountsFilter.accountsWithoutRelatedEstimates}
];

export const CreateEditTagGroupLabels = {
    createModalTitle: 'New sample tag group New sample tag group',
    editModalTitle: 'Edit sample tag group Edit sample tag group',
    createModalDescription: `Enter tag group details below and select <b>\'Save and close\'</b> to finish. To create another tag group, select <b>\'Save and create another\'</b>. Enter tag group details below and select <b>\'Save and close\'</b> to finish. To create another tag group, select <b>\'Save and create another\'</b>.`,
    editModalDescription: `Edit tag group details below and select '<b>{0}</b>' to finish.Edit tag group details below and select '<b>{0}</b>' to finish.`,
    close: 'Close Close',
    cancel: 'Cancel Cancel',
    save: 'Save Save',
    saveAndCloseLabel: 'Save and close Save and close',
    saveAndCreateLabel: 'Save and create another Save and create another',
    tagGroupNameLabel: 'Tag group name (required) Tag group name (required)',
    required: 'Required Required',
};

export const CreateEditTagLabels = {
	createModalTitle: 'New sample tag New sample tag',
	editModalTitle: 'Edit sample tag Edit sample tag',
	createModalDescription:
		"Enter tag details below and select '<b>Save and close</b>' to finish. To create another tag, select '<b>Save and create another</b>'. Enter tag details below and select '<b>Save and close</b>' to finish. To create another tag, select '<b>Save and create another</b>'.",
	editModalDescription: `Edit the tag details below and select '<b>{0}</b>' to finish.Edit the tag details below and select '<b>{0}</b>' to finish.`,
	tagNameLabel: 'Tag name (required) Tag name (required)',
	tagGroupNameLabel: 'Tag group name (required) Tag group name (required)',
	tagColorLabel: 'Color (required) Color (required)',
	saveAndCloseLabel: 'Save and close Save and close',
	saveAndCreateLabel: 'Save and create another Save and create another',
	cancelLabel: 'Cancel Cancel',
	required: 'Required Required',
	save: 'Save Save',
	noresultsLabel: 'No tag groups available No tag groups available',
	tagColors: [
		{text: 'Red Red', color: 'red'},
		{text: 'Orange Orange', color: 'orange'},
		{text: 'Teal Teal', color: 'teal'},
		{text: 'Blue Blue', color: 'blue'},
		{text: 'Purple Purple', color: 'purple'},
		{text: 'Green Green', color: 'green'}
	]
};
